import { InjectionToken, Injectable, Optional, Inject, EventEmitter, Component, Input, Output, ViewChild, forwardRef, NgModule, ChangeDetectionStrategy, ViewEncapsulation, Directive, ElementRef, Renderer2, ɵɵdefineInjectable, ɵɵinject, ContentChildren, isDevMode, ChangeDetectorRef, Injector, Pipe, ViewContainerRef, TemplateRef, HostBinding, ContentChild, HostListener, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent, ReplaySubject, Subject, Observable } from 'rxjs';
import { HttpParams, HttpClient, HttpClientModule } from '@angular/common/http';
import { map, tap, finalize, share, filter, takeUntil } from 'rxjs/operators';
import { CommonModule, Location, DatePipe } from '@angular/common';
import { NG_VALUE_ACCESSOR, FormsModule, NG_VALIDATORS, ReactiveFormsModule, NgControl } from '@angular/forms';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { InputMaskModule } from 'primeng/inputmask';
import { DomSanitizer } from '@angular/platform-browser';
import { ButtonModule } from 'primeng/button';
import { TRANSLOCO_CONFIG, translocoConfig, TRANSLOCO_LOADER, TranslocoModule, TranslocoService, TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { Calendar, CalendarModule } from 'primeng/calendar';
import { PrimeNGConfig, ConfirmationService, MessageService, SharedModule, FilterService } from 'primeng/api';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { NavigationEnd, Router, RouterModule, ActivatedRoute } from '@angular/router';
import { ObjectUtils } from 'primeng/utils';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToastModule } from 'primeng/toast';
import { FocusMonitor } from '@angular/cdk/a11y';
import { RadioButtonModule } from 'primeng/radiobutton';
import { get, keys, union, flatten, isEqual, orderBy } from 'lodash';
import { MenubarModule } from 'primeng/menubar';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { TooltipModule, Tooltip } from 'primeng/tooltip';
import { SkeletonModule } from 'primeng/skeleton';
import { PaginatorModule } from 'primeng/paginator';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { PanelModule } from 'primeng/panel';
import { TabViewModule } from 'primeng/tabview';
import { trigger, transition, animate, style } from '@angular/animations';
import { DomHandler } from 'primeng/dom';
import { InputSwitch, InputSwitchModule } from 'primeng/inputswitch';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'primeng/autocomplete';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@angular/platform-browser';
import * as ɵngcc6 from 'primeng/button';
import * as ɵngcc7 from '@ngneat/transloco';
import * as ɵngcc8 from 'primeng/api';
import * as ɵngcc9 from 'primeng/calendar';
import * as ɵngcc10 from 'primeng/checkbox';
import * as ɵngcc11 from 'primeng/confirmdialog';
import * as ɵngcc12 from 'primeng/dropdown';
import * as ɵngcc13 from 'primeng/inputtext';
import * as ɵngcc14 from 'primeng/inputmask';
import * as ɵngcc15 from '@angular/router';
import * as ɵngcc16 from 'primeng/multiselect';
import * as ɵngcc17 from 'primeng/toast';
import * as ɵngcc18 from '@angular/cdk/a11y';
import * as ɵngcc19 from 'primeng/table';
import * as ɵngcc20 from 'primeng/tooltip';
import * as ɵngcc21 from 'primeng/menubar';
import * as ɵngcc22 from 'primeng/skeleton';
import * as ɵngcc23 from 'primeng/inputtextarea';
import * as ɵngcc24 from 'primeng/panel';

function DsMiastoComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 6);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r0.iconLeft, " ds-input-icon-left");
    ɵngcc0.ɵɵproperty("title", ctx_r0.iconLeftTitle);
} }
function DsMiastoComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 7);
    ɵngcc0.ɵɵlistener("click", function DsMiastoComponent_i_5_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.clear(); })("keydown.enter", function DsMiastoComponent_i_5_Template_i_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("icon-right", ctx_r1.iconRight)("is-disabled", ctx_r1.isDisabled)("is-readonly", ctx_r1.readonly);
    ɵngcc0.ɵɵpropertyInterpolate("tabindex", ctx_r1.isDisabled || ctx_r1.readonly ? "-1" : "0");
} }
function DsMiastoComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 8);
    ɵngcc0.ɵɵlistener("click", function DsMiastoComponent_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.focus(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r2.iconRight, " ds-input-icon-right");
    ɵngcc0.ɵɵproperty("title", ctx_r2.iconRightTitle);
} }
function DsUlicaComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 6);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r0.iconLeft, " ds-input-icon-left");
    ɵngcc0.ɵɵproperty("title", ctx_r0.iconLeftTitle);
} }
function DsUlicaComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 7);
    ɵngcc0.ɵɵlistener("click", function DsUlicaComponent_i_5_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.clear(); })("keydown.enter", function DsUlicaComponent_i_5_Template_i_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("icon-right", ctx_r1.iconRight)("is-disabled", ctx_r1.isDisabled)("is-readonly", ctx_r1.readonly);
    ɵngcc0.ɵɵpropertyInterpolate("tabindex", ctx_r1.isDisabled || ctx_r1.readonly ? "-1" : "0");
} }
function DsUlicaComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 8);
    ɵngcc0.ɵɵlistener("click", function DsUlicaComponent_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.focus(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r2.iconRight, " ds-input-icon-right");
    ɵngcc0.ɵɵproperty("title", ctx_r2.iconRightTitle);
} }
const _c0 = function (a0) { return { "width": a0 }; };
function DsKodPocztowyComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 6);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r0.iconLeft, " ds-input-icon-left");
    ɵngcc0.ɵɵproperty("title", ctx_r0.iconLeftTitle);
} }
function DsKodPocztowyComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 7);
    ɵngcc0.ɵɵlistener("click", function DsKodPocztowyComponent_i_5_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.clear(); })("keydown.enter", function DsKodPocztowyComponent_i_5_Template_i_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("icon-right", ctx_r1.iconRight)("is-disabled", ctx_r1.isDisabled)("is-readonly", ctx_r1.readonly);
    ɵngcc0.ɵɵpropertyInterpolate("tabindex", ctx_r1.isDisabled || ctx_r1.readonly ? "-1" : "0");
} }
function DsKodPocztowyComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 8);
    ɵngcc0.ɵɵlistener("click", function DsKodPocztowyComponent_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.focus(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r2.iconRight, " ds-input-icon-right");
    ɵngcc0.ɵɵproperty("title", ctx_r2.iconRightTitle);
} }
function DsWojewodztwoComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 6);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r0.iconLeft, " ds-input-icon-left");
    ɵngcc0.ɵɵproperty("title", ctx_r0.iconLeftTitle);
} }
function DsWojewodztwoComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 7);
    ɵngcc0.ɵɵlistener("click", function DsWojewodztwoComponent_i_5_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.clear(); })("keydown.enter", function DsWojewodztwoComponent_i_5_Template_i_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("icon-right", ctx_r1.iconRight)("is-disabled", ctx_r1.isDisabled)("is-readonly", ctx_r1.readonly);
    ɵngcc0.ɵɵpropertyInterpolate("tabindex", ctx_r1.isDisabled || ctx_r1.readonly ? "-1" : "0");
} }
function DsWojewodztwoComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 8);
    ɵngcc0.ɵɵlistener("click", function DsWojewodztwoComponent_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.focus(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r2.iconRight, " ds-input-icon-right");
    ɵngcc0.ɵɵproperty("title", ctx_r2.iconRightTitle);
} }
function DsPowiatComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 6);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r0.iconLeft, " ds-input-icon-left");
    ɵngcc0.ɵɵproperty("title", ctx_r0.iconLeftTitle);
} }
function DsPowiatComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 7);
    ɵngcc0.ɵɵlistener("click", function DsPowiatComponent_i_5_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.clear(); })("keydown.enter", function DsPowiatComponent_i_5_Template_i_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("icon-right", ctx_r1.iconRight)("is-disabled", ctx_r1.isDisabled)("is-readonly", ctx_r1.readonly);
    ɵngcc0.ɵɵpropertyInterpolate("tabindex", ctx_r1.isDisabled || ctx_r1.readonly ? "-1" : "0");
} }
function DsPowiatComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 8);
    ɵngcc0.ɵɵlistener("click", function DsPowiatComponent_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.focus(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r2.iconRight, " ds-input-icon-right");
    ɵngcc0.ɵɵproperty("title", ctx_r2.iconRightTitle);
} }
function DsGminaComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 6);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r0.iconLeft, " ds-input-icon-left");
    ɵngcc0.ɵɵproperty("title", ctx_r0.iconLeftTitle);
} }
function DsGminaComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 7);
    ɵngcc0.ɵɵlistener("click", function DsGminaComponent_i_5_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.clear(); })("keydown.enter", function DsGminaComponent_i_5_Template_i_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("icon-right", ctx_r1.iconRight)("is-disabled", ctx_r1.isDisabled)("is-readonly", ctx_r1.readonly);
    ɵngcc0.ɵɵpropertyInterpolate("tabindex", ctx_r1.isDisabled || ctx_r1.readonly ? "-1" : "0");
} }
function DsGminaComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 8);
    ɵngcc0.ɵɵlistener("click", function DsGminaComponent_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.focus(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r2.iconRight, " ds-input-icon-right");
    ɵngcc0.ɵɵproperty("title", ctx_r2.iconRightTitle);
} }
function DsAlertComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "uppercase");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r0.etykieta));
} }
function DsAlertComponent_ng_container_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const line_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(line_r5);
} }
function DsAlertComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsAlertComponent_ng_container_2_span_1_Template, 2, 1, "span", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.text);
} }
function DsAlertComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} }
const _c1 = function (a0, a1, a2, a3) { return { "p-inline-message-info": a0, "p-inline-message-warn": a1, "p-inline-message-error": a2, "p-inline-message-success": a3 }; };
const _c2 = ["*"];
function DsAutocompleteComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 9);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r0.iconLeft, " ds-input-icon-left");
    ɵngcc0.ɵɵproperty("title", ctx_r0.iconLeftTitle);
} }
const _c3 = function (a0) { return { "p-mr-5": a0 }; };
function DsAutocompleteComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 10);
    ɵngcc0.ɵɵlistener("click", function DsAutocompleteComponent_i_5_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.clear(); })("keydown.enter", function DsAutocompleteComponent_i_5_Template_i_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("icon-right", ctx_r1.iconRight)("is-disabled", ctx_r1.isDisabled)("is-readonly", ctx_r1.readonly);
    ɵngcc0.ɵɵpropertyInterpolate("tabindex", ctx_r1.isDisabled || ctx_r1.readonly ? "-1" : "0");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c3, ctx_r1.dropdown));
} }
function DsAutocompleteComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 11);
    ɵngcc0.ɵɵlistener("click", function DsAutocompleteComponent_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.focus(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r2.iconRight, " ds-input-icon-right");
    ɵngcc0.ɵɵproperty("title", ctx_r2.iconRightTitle);
} }
function DsAutocompleteComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", "visible");
    ɵngcc0.ɵɵclassProp("counter-inside", ctx_r3.counterInside);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.counter + "/" + ctx_r3.maxlength, " ");
} }
function DsAutocompleteComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 13);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r4.safeHtml(ctx_r4.errorMessage), ɵngcc0.ɵɵsanitizeHtml);
} }
function DsCalendarComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 7);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r0.iconLeft, " ds-input-icon-left");
    ɵngcc0.ɵɵproperty("title", ctx_r0.iconLeftTitle);
} }
function DsCalendarComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 8);
    ɵngcc0.ɵɵlistener("click", function DsCalendarComponent_i_5_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.clear(); })("keydown.enter", function DsCalendarComponent_i_5_Template_i_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("icon-right", ctx_r1.iconRight)("is-disabled", ctx_r1.disabled);
    ɵngcc0.ɵɵpropertyInterpolate("tabindex", ctx_r1.disabled ? "-1" : "0");
} }
function DsCalendarComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 9);
    ɵngcc0.ɵɵlistener("click", function DsCalendarComponent_i_6_Template_i_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.focus($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r2.iconRight, " ds-input-icon-right");
    ɵngcc0.ɵɵproperty("title", ctx_r2.iconRightTitle);
} }
function DsCalendarComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 10);
} }
const _c4 = function (a0) { return { width: a0 }; };
function DsDropdownComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", "visible");
    ɵngcc0.ɵɵclassProp("counter-inside", ctx_r0.counterInside);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.valueLength + "/" + ctx_r0.maxLength, " ");
} }
const _c5 = ["inputElement"];
function DsInputComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 10);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r0.iconLeft, " ds-input-icon-left");
    ɵngcc0.ɵɵproperty("title", ctx_r0.iconLeftTitle);
} }
function DsInputComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 11);
    ɵngcc0.ɵɵlistener("click", function DsInputComponent_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.clear(); })("keydown.enter", function DsInputComponent_i_6_Template_i_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("icon-right", ctx_r2.iconRight)("is-disabled", ctx_r2.isDisabled)("is-readonly", ctx_r2.readonly);
    ɵngcc0.ɵɵpropertyInterpolate("tabindex", ctx_r2.isDisabled || ctx_r2.readonly ? "-1" : "0");
} }
function DsInputComponent_i_7_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 12);
    ɵngcc0.ɵɵlistener("click", function DsInputComponent_i_7_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.focus(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r3.iconRight, " ds-input-icon-right");
    ɵngcc0.ɵɵproperty("title", ctx_r3.iconRightTitle);
} }
function DsInputComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 13);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r4.safeHtml(ctx_r4.errorMessage), ɵngcc0.ɵɵsanitizeHtml);
} }
function DsInputComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r5.isFocused ? "visible" : "hidden");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r5.ngModel ? ctx_r5.ngModel.length : 0) + "/" + ctx_r5.maxLength, " ");
} }
function DsInputmaskComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 8);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r0.iconLeft, " ds-input-icon-left");
    ɵngcc0.ɵɵproperty("title", ctx_r0.iconLeftTitle);
} }
function DsInputmaskComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 9);
    ɵngcc0.ɵɵlistener("click", function DsInputmaskComponent_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.clear(); })("keydown.enter", function DsInputmaskComponent_i_6_Template_i_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("icon-right", ctx_r2.iconRight)("is-disabled", ctx_r2.isDisabled)("is-readonly", ctx_r2.readonly);
    ɵngcc0.ɵɵpropertyInterpolate("tabindex", ctx_r2.isDisabled || ctx_r2.readonly ? "-1" : "0");
} }
function DsInputmaskComponent_i_7_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 10);
    ɵngcc0.ɵɵlistener("click", function DsInputmaskComponent_i_7_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.focus(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r3.iconRight, " ds-input-icon-right");
    ɵngcc0.ɵɵproperty("title", ctx_r3.iconRightTitle);
} }
function DsInputmaskComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "transloco");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r4.errorMessage));
} }
const _c6 = ["kodKrajuInput"];
function DsKontoBankoweComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 11);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r1.iconLeft, " ds-input-icon-left");
    ɵngcc0.ɵɵproperty("title", ctx_r1.iconLeftTitle);
} }
function DsKontoBankoweComponent_i_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 12);
    ɵngcc0.ɵɵlistener("click", function DsKontoBankoweComponent_i_9_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.clear(); })("keydown.enter", function DsKontoBankoweComponent_i_9_Template_i_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("icon-right", ctx_r3.iconRight)("is-disabled", ctx_r3.isDisabled)("is-readonly", ctx_r3.readonly);
    ɵngcc0.ɵɵpropertyInterpolate("tabindex", ctx_r3.isDisabled || ctx_r3.readonly ? "-1" : "0");
} }
function DsKontoBankoweComponent_i_10_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 13);
    ɵngcc0.ɵɵlistener("click", function DsKontoBankoweComponent_i_10_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.focus(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r4.iconRight, " ds-input-icon-right");
    ɵngcc0.ɵɵproperty("title", ctx_r4.iconRightTitle);
} }
function DsKontoBankoweComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "transloco");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r5.errorMessage));
} }
function DsKrsComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 8);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r0.iconLeft, " ds-input-icon-left");
    ɵngcc0.ɵɵproperty("title", ctx_r0.iconLeftTitle);
} }
function DsKrsComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 9);
    ɵngcc0.ɵɵlistener("click", function DsKrsComponent_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.clear(); })("keydown.enter", function DsKrsComponent_i_6_Template_i_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("icon-right", ctx_r2.iconRight)("is-disabled", ctx_r2.isDisabled)("is-readonly", ctx_r2.readonly);
    ɵngcc0.ɵɵpropertyInterpolate("tabindex", ctx_r2.isDisabled || ctx_r2.readonly ? "-1" : "0");
} }
function DsKrsComponent_i_7_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 10);
    ɵngcc0.ɵɵlistener("click", function DsKrsComponent_i_7_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.focus(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r3.iconRight, " ds-input-icon-right");
    ɵngcc0.ɵɵproperty("title", ctx_r3.iconRightTitle);
} }
const _c7 = function () { return { name: "KRS", length: "10" }; };
function DsMenuComponent_ng_container_1_ng_container_1_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 4);
    ɵngcc0.ɵɵlistener("hoverItem", function DsMenuComponent_ng_container_1_ng_container_1_li_1_Template_li_hoverItem_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(3); return ctx_r5.onHoverItem($event); })("toggleSubMenu", function DsMenuComponent_ng_container_1_ng_container_1_li_1_Template_li_toggleSubMenu_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(3); return ctx_r7.onToggleSubMenu($event); })("selectItem", function DsMenuComponent_ng_container_1_ng_container_1_li_1_Template_li_selectItem_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(3); return ctx_r8.onSelectItem($event); })("itemClick", function DsMenuComponent_ng_container_1_ng_container_1_li_1_Template_li_itemClick_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(3); return ctx_r9.onItemClick($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("menu-group", item_r1.group);
    ɵngcc0.ɵɵproperty("menuItem", item_r1);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r4.ariaLabel);
} }
function DsMenuComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsMenuComponent_ng_container_1_ng_container_1_li_1_Template, 1, 4, "li", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r1.hidden);
} }
function DsMenuComponent_ng_container_1_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c8 = function (a0) { return { $implicit: a0 }; };
function DsMenuComponent_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsMenuComponent_ng_container_1_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.liTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c8, item_r1));
} }
function DsMenuComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsMenuComponent_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, DsMenuComponent_ng_container_1_ng_container_2_Template, 2, 4, "ng-container", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.liTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.liTemplate);
} }
const _c9 = ["container"];
const _c10 = ["dsMenuItem", ""];
function DsMenuItemComponent_a_1_ng_template_1_Template(rf, ctx) { }
function DsMenuItemComponent_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 5);
    ɵngcc0.ɵɵlistener("click", function DsMenuItemComponent_a_1_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); $event.preventDefault(); return ctx_r6.onToggleSubMenu(ctx_r6.menuItem); });
    ɵngcc0.ɵɵtemplate(1, DsMenuItemComponent_a_1_ng_template_1_Template, 0, 0, "ng-template", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵclassProp("active", ctx_r0.menuItem.selected);
    ɵngcc0.ɵɵattribute("target", ctx_r0.menuItem.target)("title", ctx_r0.menuItem.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function DsMenuItemComponent_ng_container_2_a_1_ng_template_1_Template(rf, ctx) { }
const _c11 = function () { return { exact: true }; };
function DsMenuItemComponent_ng_container_2_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 9);
    ɵngcc0.ɵɵlistener("click", function DsMenuItemComponent_ng_container_2_a_1_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.onItemClick(ctx_r12.menuItem); });
    ɵngcc0.ɵɵtemplate(1, DsMenuItemComponent_ng_container_2_a_1_ng_template_1_Template, 0, 0, "ng-template", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    const _r2 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵclassProp("active", ctx_r8.menuItem.selected);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r8.menuItem.link)("routerLinkActiveOptions", ɵngcc0.ɵɵpureFunction0(10, _c11))("queryParams", ctx_r8.menuItem.queryParams)("fragment", ctx_r8.menuItem.fragment)("skipLocationChange", ctx_r8.menuItem.skipLocationChange);
    ɵngcc0.ɵɵattribute("target", ctx_r8.menuItem.target)("title", ctx_r8.menuItem.tooltip ? ctx_r8.menuItem.tooltip : ctx_r8.menuItem.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function DsMenuItemComponent_ng_container_2_a_2_ng_template_1_Template(rf, ctx) { }
function DsMenuItemComponent_ng_container_2_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 10);
    ɵngcc0.ɵɵlistener("click", function DsMenuItemComponent_ng_container_2_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.onSelectItem(ctx_r15.menuItem); });
    ɵngcc0.ɵɵtemplate(1, DsMenuItemComponent_ng_container_2_a_2_ng_template_1_Template, 0, 0, "ng-template", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    const _r2 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵclassProp("active", ctx_r9.menuItem.selected);
    ɵngcc0.ɵɵattribute("href", ctx_r9.menuItem.url, ɵngcc0.ɵɵsanitizeUrl)("target", ctx_r9.menuItem.target)("title", ctx_r9.menuItem.tooltip ? ctx_r9.menuItem.tooltip : ctx_r9.menuItem.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function DsMenuItemComponent_ng_container_2_a_3_ng_template_1_Template(rf, ctx) { }
function DsMenuItemComponent_ng_container_2_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 10);
    ɵngcc0.ɵɵlistener("click", function DsMenuItemComponent_ng_container_2_a_3_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); $event.preventDefault(); return ctx_r18.onItemClick(ctx_r18.menuItem); });
    ɵngcc0.ɵɵtemplate(1, DsMenuItemComponent_ng_container_2_a_3_ng_template_1_Template, 0, 0, "ng-template", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    const _r2 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵclassProp("active", ctx_r10.menuItem.selected);
    ɵngcc0.ɵɵattribute("target", ctx_r10.menuItem.target)("title", ctx_r10.menuItem.tooltip ? ctx_r10.menuItem.tooltip : ctx_r10.menuItem.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function DsMenuItemComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsMenuItemComponent_ng_container_2_a_1_Template, 2, 11, "a", 7);
    ɵngcc0.ɵɵtemplate(2, DsMenuItemComponent_ng_container_2_a_2_Template, 2, 6, "a", 8);
    ɵngcc0.ɵɵtemplate(3, DsMenuItemComponent_ng_container_2_a_3_Template, 2, 5, "a", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.menuItem.link && !ctx_r1.menuItem.url);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.menuItem.url && !ctx_r1.menuItem.link);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.menuItem.link && !ctx_r1.menuItem.url);
} }
function DsMenuItemComponent_ng_template_3_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 14);
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r20.getExpandStateIcon());
} }
function DsMenuItemComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 11);
    ɵngcc0.ɵɵelementStart(1, "span", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DsMenuItemComponent_ng_template_3_i_3_Template, 1, 1, "i", 13);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r3.menuItem.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.menuItem.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.menuItem.children);
} }
function DsMenuItemComponent_ul_5_ng_container_2_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 19);
    ɵngcc0.ɵɵlistener("hoverItem", function DsMenuItemComponent_ul_5_ng_container_2_li_1_Template_li_hoverItem_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(3); return ctx_r25.onHoverItem($event); })("toggleSubMenu", function DsMenuItemComponent_ul_5_ng_container_2_li_1_Template_li_toggleSubMenu_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r27 = ɵngcc0.ɵɵnextContext(3); return ctx_r27.onToggleSubMenu($event); })("selectItem", function DsMenuItemComponent_ul_5_ng_container_2_li_1_Template_li_selectItem_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r28 = ɵngcc0.ɵɵnextContext(3); return ctx_r28.onSelectItem($event); })("itemClick", function DsMenuItemComponent_ul_5_ng_container_2_li_1_Template_li_itemClick_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r29 = ɵngcc0.ɵɵnextContext(3); return ctx_r29.onItemClick($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r23 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassProp("menu-group", item_r23.group);
    ɵngcc0.ɵɵproperty("menuItem", item_r23);
} }
function DsMenuItemComponent_ul_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsMenuItemComponent_ul_5_ng_container_2_li_1_Template, 1, 3, "li", 18);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r23 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r23.hidden);
} }
const _c12 = function (a0) { return { "height": a0 }; };
function DsMenuItemComponent_ul_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 15, 16);
    ɵngcc0.ɵɵtemplate(2, DsMenuItemComponent_ul_5_ng_container_2_Template, 2, 1, "ng-container", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("collapsed", !(ctx_r4.menuItem.children && ctx_r4.menuItem.expanded))("expanded", ctx_r4.menuItem.expanded);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(6, _c12, (ctx_r4.menuItem.expanded ? ctx_r4.maxHeight : 0) + "px"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.menuItem.children);
} }
const _c13 = ["pMultiSelect"];
function DsMultiselectComponent_ng_template_4_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementStart(3, "i", 9);
    ɵngcc0.ɵɵlistener("click", function DsMultiselectComponent_ng_template_4_ng_container_0_div_1_Template_i_click_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const val_r8 = ctx.$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(3); return ctx_r9.removeElement($event, val_r8); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const val_r8 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", val_r8[ctx_r6.optionLabel] || val_r8, " ");
} }
function DsMultiselectComponent_ng_template_4_ng_container_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.defaultLabel);
} }
function DsMultiselectComponent_ng_template_4_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsMultiselectComponent_ng_template_4_ng_container_0_div_1_Template, 4, 1, "div", 6);
    ɵngcc0.ɵɵtemplate(2, DsMultiselectComponent_ng_template_4_ng_container_0_span_2_Template, 2, 1, "span", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const value_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", value_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !value_r2 || value_r2.length === 0);
} }
function DsMultiselectComponent_ng_template_4_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate("Wybrano " + value_r2.length + " element" + (value_r2.length >= 5 ? "\u00F3w" : 2 <= value_r2.length && value_r2.length <= 4 ? "y" : ""));
} }
function DsMultiselectComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DsMultiselectComponent_ng_template_4_ng_container_0_Template, 3, 2, "ng-container", 4);
    ɵngcc0.ɵɵtemplate(1, DsMultiselectComponent_ng_template_4_ng_template_1_Template, 2, 1, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const value_r2 = ctx.$implicit;
    const _r4 = ɵngcc0.ɵɵreference(2);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", !value_r2 || value_r2.length <= ctx_r1.maxSelectedLabels)("ngIfElse", _r4);
} }
function DsNipComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 8);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r0.iconLeft, " ds-input-icon-left");
    ɵngcc0.ɵɵproperty("title", ctx_r0.iconLeftTitle);
} }
function DsNipComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 9);
    ɵngcc0.ɵɵlistener("click", function DsNipComponent_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.clear(); })("keydown.enter", function DsNipComponent_i_6_Template_i_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("icon-right", ctx_r2.iconRight)("is-disabled", ctx_r2.isDisabled)("is-readonly", ctx_r2.readonly);
    ɵngcc0.ɵɵpropertyInterpolate("tabindex", ctx_r2.isDisabled || ctx_r2.readonly ? "-1" : "0");
} }
function DsNipComponent_i_7_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 10);
    ɵngcc0.ɵɵlistener("click", function DsNipComponent_i_7_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.focus(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r3.iconRight, " ds-input-icon-right");
    ɵngcc0.ɵɵproperty("title", ctx_r3.iconRightTitle);
} }
const _c14 = function () { return { name: "NIP", length: "10" }; };
function DsNotificationComponent_ng_template_1_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 8);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.icon);
} }
function DsNotificationComponent_ng_template_1_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "ds-button", 11);
    ɵngcc0.ɵɵlistener("click", function DsNotificationComponent_ng_template_1_div_5_Template_ds_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.confirm(); });
    ɵngcc0.ɵɵtext(3, "Tak");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 10);
    ɵngcc0.ɵɵelementStart(5, "ds-button", 12);
    ɵngcc0.ɵɵlistener("click", function DsNotificationComponent_ng_template_1_div_5_Template_ds_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.reject(); });
    ɵngcc0.ɵɵtext(6, "Nie");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DsNotificationComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵtemplate(2, DsNotificationComponent_ng_template_1_i_2_Template, 1, 1, "i", 4);
    ɵngcc0.ɵɵelement(3, "div", 5);
    ɵngcc0.ɵɵelement(4, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, DsNotificationComponent_ng_template_1_div_5_Template, 7, 0, "div", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", message_r1.summary, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", message_r1.detail, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.actionButtons);
} }
function DsPeselComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 8);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r0.iconLeft, " ds-input-icon-left");
    ɵngcc0.ɵɵproperty("title", ctx_r0.iconLeftTitle);
} }
function DsPeselComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 9);
    ɵngcc0.ɵɵlistener("click", function DsPeselComponent_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.clear(); })("keydown.enter", function DsPeselComponent_i_6_Template_i_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("icon-right", ctx_r2.iconRight)("is-disabled", ctx_r2.isDisabled)("is-readonly", ctx_r2.readonly);
    ɵngcc0.ɵɵpropertyInterpolate("tabindex", ctx_r2.isDisabled || ctx_r2.readonly ? "-1" : "0");
} }
function DsPeselComponent_i_7_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 10);
    ɵngcc0.ɵɵlistener("click", function DsPeselComponent_i_7_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.focus(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r3.iconRight, " ds-input-icon-right");
    ɵngcc0.ɵɵproperty("title", ctx_r3.iconRightTitle);
} }
const _c15 = function () { return { name: "PESEL", length: "11" }; };
function DsPeselComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "transloco");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r4.errorMessage, ɵngcc0.ɵɵpureFunction0(4, _c15)), " ");
} }
const _c16 = ["input"];
const _c17 = function (a0) { return { "ds-radio-label--disabled": a0 }; };
const _c18 = function (a0, a1) { return { "ds-radio-outer-circle--checked": a0, "ds-radio-outer-circle--focused": a1 }; };
const _c19 = function (a0) { return { "ds-radio-inner-circle--checked": a0 }; };
const _c20 = ["rb"];
const _c21 = function (a1, a2, a3) { return { "p-radiobutton-label": true, "p-radiobutton-label-active": a1, "p-disabled": a2, "p-radiobutton-label-focus": a3 }; };
function DsRadioComponent_label_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "label", 7);
    ɵngcc0.ɵɵlistener("click", function DsRadioComponent_label_6_Template_label_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); const _r0 = ɵngcc0.ɵɵreference(3); return ctx_r2.select($event, _r0); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵclassMap(ctx_r1.labelStyleClass);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(5, _c21, _r0.checked, ctx_r1.disabled, ctx_r1.focused));
    ɵngcc0.ɵɵattribute("for", ctx_r1.inputId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.label);
} }
const _c22 = function (a1, a2, a3) { return { "p-radiobutton p-component": true, "p-radiobutton-checked": a1, "p-radiobutton-disabled": a2, "p-radiobutton-focused": a3 }; };
const _c23 = function (a1, a2, a3) { return { "p-radiobutton-box": true, "p-highlight": a1, "p-disabled": a2, "p-focus": a3 }; };
function DsRegonComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 8);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r0.iconLeft, " ds-input-icon-left");
    ɵngcc0.ɵɵproperty("title", ctx_r0.iconLeftTitle);
} }
function DsRegonComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 9);
    ɵngcc0.ɵɵlistener("click", function DsRegonComponent_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.clear(); })("keydown.enter", function DsRegonComponent_i_6_Template_i_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("icon-right", ctx_r2.iconRight)("is-disabled", ctx_r2.isDisabled)("is-readonly", ctx_r2.readonly);
    ɵngcc0.ɵɵpropertyInterpolate("tabindex", ctx_r2.isDisabled || ctx_r2.readonly ? "-1" : "0");
} }
function DsRegonComponent_i_7_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 10);
    ɵngcc0.ɵɵlistener("click", function DsRegonComponent_i_7_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.focus(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pi ", ctx_r3.iconRight, " ds-input-icon-right");
    ɵngcc0.ɵɵproperty("title", ctx_r3.iconRightTitle);
} }
const _c24 = function () { return { name: "REGON", length: "9 lub 14" }; };
const _c25 = ["dt"];
const _c26 = ["table"];
function DsTableComponent_4_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "span", 12);
    ɵngcc0.ɵɵelementStart(2, "ds-input", 13);
    ɵngcc0.ɵɵlistener("input", function DsTableComponent_4_ng_template_0_Template_ds_input_input_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); ɵngcc0.ɵɵnextContext(2); const _r1 = ɵngcc0.ɵɵreference(3); return _r1.filterGlobal($event.target.value, "contains"); });
    ɵngcc0.ɵɵpipe(3, "transloco");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(3, 1, "wyszukaj"));
} }
function DsTableComponent_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DsTableComponent_4_ng_template_0_Template, 4, 3, "ng-template", 10);
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_container_1_th_1_p_sortIcon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p-sortIcon", 24);
} if (rf & 2) {
    const col_r19 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("field", col_r19.field);
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_container_1_th_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵtext(1, ".");
    ɵngcc0.ɵɵelementEnd();
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_container_1_th_1_p_columnFilter_5_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c27 = function (a0) { return { col: a0 }; };
function DsTableComponent_ng_template_5_ng_container_1_ng_container_1_th_1_p_columnFilter_5_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DsTableComponent_ng_template_5_ng_container_1_ng_container_1_th_1_p_columnFilter_5_ng_template_1_ng_container_0_Template, 1, 0, "ng-container", 28);
} if (rf & 2) {
    const col_r19 = ɵngcc0.ɵɵnextContext(4).$implicit;
    ɵngcc0.ɵɵnextContext(2);
    const _r8 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r8)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c27, col_r19));
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_container_1_th_1_p_columnFilter_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-columnFilter", 26);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_container_1_ng_container_1_th_1_p_columnFilter_5_ng_template_1_Template, 1, 4, "ng-template", 27);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("showMatchModes", false)("showOperator", false)("showAddButton", false);
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_container_1_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 20);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_container_1_ng_container_1_th_1_p_sortIcon_1_Template, 1, 1, "p-sortIcon", 21);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_5_ng_container_1_ng_container_1_th_1_span_2_Template, 2, 0, "span", 22);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "transloco");
    ɵngcc0.ɵɵtemplate(5, DsTableComponent_ng_template_5_ng_container_1_ng_container_1_th_1_p_columnFilter_5_Template, 2, 3, "p-columnFilter", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r19 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("pSortableColumn", col_r19.field)("width", col_r19.width)("ngClass", col_r19.cssClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r19.sortable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !col_r19.header);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 7, col_r19.header), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", (col_r19.filter == null ? null : col_r19.filter.mode) == "icon");
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_container_1_ng_template_2_p_sortIcon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p-sortIcon", 24);
} if (rf & 2) {
    const col_r19 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("field", col_r19.field);
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_container_1_ng_template_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵtext(1, ".");
    ɵngcc0.ɵɵelementEnd();
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_container_1_ng_template_2_p_columnFilter_5_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_container_1_ng_template_2_p_columnFilter_5_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DsTableComponent_ng_template_5_ng_container_1_ng_container_1_ng_template_2_p_columnFilter_5_ng_template_1_ng_container_0_Template, 1, 0, "ng-container", 28);
} if (rf & 2) {
    const col_r19 = ɵngcc0.ɵɵnextContext(4).$implicit;
    ɵngcc0.ɵɵnextContext(2);
    const _r8 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r8)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c27, col_r19));
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_container_1_ng_template_2_p_columnFilter_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-columnFilter", 26);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_container_1_ng_container_1_ng_template_2_p_columnFilter_5_ng_template_1_Template, 1, 4, "ng-template", 27);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("showMatchModes", false)("showOperator", false)("showAddButton", false);
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 29);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_container_1_ng_container_1_ng_template_2_p_sortIcon_1_Template, 1, 1, "p-sortIcon", 21);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_5_ng_container_1_ng_container_1_ng_template_2_span_2_Template, 2, 0, "span", 22);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "transloco");
    ɵngcc0.ɵɵtemplate(5, DsTableComponent_ng_template_5_ng_container_1_ng_container_1_ng_template_2_p_columnFilter_5_Template, 2, 3, "p-columnFilter", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r19 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("pSortableColumn", col_r19.field)("width", col_r19.width)("ngClass", col_r19.cssClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r19.sortable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !col_r19.header);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 7, col_r19.header), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", (col_r19.filter == null ? null : col_r19.filter.mode) == "icon");
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_container_1_ng_container_1_th_1_Template, 6, 9, "th", 18);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_5_ng_container_1_ng_container_1_ng_template_2_Template, 6, 9, "ng-template", null, 19, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r24 = ɵngcc0.ɵɵreference(3);
    const ctx_r20 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!ctx_r20.sterownik.resizableColumns)("ngIfElse", _r24);
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_template_2_th_0_p_sortIcon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p-sortIcon", 24);
} if (rf & 2) {
    const col_r19 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("field", col_r19.field);
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_template_2_th_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵtext(1, ".");
    ɵngcc0.ɵɵelementEnd();
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_template_2_th_0_p_columnFilter_5_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_template_2_th_0_p_columnFilter_5_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DsTableComponent_ng_template_5_ng_container_1_ng_template_2_th_0_p_columnFilter_5_ng_template_1_ng_container_0_Template, 1, 0, "ng-container", 28);
} if (rf & 2) {
    const col_r19 = ɵngcc0.ɵɵnextContext(4).$implicit;
    ɵngcc0.ɵɵnextContext(2);
    const _r8 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r8)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c27, col_r19));
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_template_2_th_0_p_columnFilter_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-columnFilter", 26);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_container_1_ng_template_2_th_0_p_columnFilter_5_ng_template_1_Template, 1, 4, "ng-template", 27);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("showMatchModes", false)("showOperator", false)("showAddButton", false);
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_template_2_th_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 31);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_container_1_ng_template_2_th_0_p_sortIcon_1_Template, 1, 1, "p-sortIcon", 21);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_5_ng_container_1_ng_template_2_th_0_span_2_Template, 2, 0, "span", 22);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "transloco");
    ɵngcc0.ɵɵtemplate(5, DsTableComponent_ng_template_5_ng_container_1_ng_template_2_th_0_p_columnFilter_5_Template, 2, 3, "p-columnFilter", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r19 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("width", col_r19.width)("ngClass", col_r19.cssClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r19.sortable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !col_r19.header);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 6, col_r19.header), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", (col_r19.filter == null ? null : col_r19.filter.mode) == "icon");
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_template_2_ng_template_1_p_sortIcon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p-sortIcon", 24);
} if (rf & 2) {
    const col_r19 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("field", col_r19.field);
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_template_2_ng_template_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵtext(1, ".");
    ɵngcc0.ɵɵelementEnd();
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_template_2_ng_template_1_p_columnFilter_5_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_template_2_ng_template_1_p_columnFilter_5_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DsTableComponent_ng_template_5_ng_container_1_ng_template_2_ng_template_1_p_columnFilter_5_ng_template_1_ng_container_0_Template, 1, 0, "ng-container", 28);
} if (rf & 2) {
    const col_r19 = ɵngcc0.ɵɵnextContext(4).$implicit;
    ɵngcc0.ɵɵnextContext(2);
    const _r8 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r8)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c27, col_r19));
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_template_2_ng_template_1_p_columnFilter_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-columnFilter", 26);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_container_1_ng_template_2_ng_template_1_p_columnFilter_5_ng_template_1_Template, 1, 4, "ng-template", 27);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("showMatchModes", false)("showOperator", false)("showAddButton", false);
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_template_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 32);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_container_1_ng_template_2_ng_template_1_p_sortIcon_1_Template, 1, 1, "p-sortIcon", 21);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_5_ng_container_1_ng_template_2_ng_template_1_span_2_Template, 2, 0, "span", 22);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "transloco");
    ɵngcc0.ɵɵtemplate(5, DsTableComponent_ng_template_5_ng_container_1_ng_template_2_ng_template_1_p_columnFilter_5_Template, 2, 3, "p-columnFilter", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r19 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("width", col_r19.width)("ngClass", col_r19.cssClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r19.sortable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !col_r19.header);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 6, col_r19.header), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", (col_r19.filter == null ? null : col_r19.filter.mode) == "icon");
} }
function DsTableComponent_ng_template_5_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DsTableComponent_ng_template_5_ng_container_1_ng_template_2_th_0_Template, 6, 8, "th", 30);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_container_1_ng_template_2_ng_template_1_Template, 6, 8, "ng-template", null, 19, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r43 = ɵngcc0.ɵɵreference(2);
    const ctx_r22 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngIf", !!ctx_r22.sterownik.resizableColumns)("ngIfElse", _r43);
} }
function DsTableComponent_ng_template_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_container_1_ng_container_1_Template, 4, 2, "ng-container", 15);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_5_ng_container_1_ng_template_2_Template, 3, 2, "ng-template", null, 17, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r19 = ctx.$implicit;
    const _r21 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r19.sortable)("ngIfElse", _r21);
} }
function DsTableComponent_ng_template_5_ng_container_2_ng_container_1_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 36);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "transloco");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r64 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("ngClass", (ctx_r64.sterownik == null ? null : ctx_r64.sterownik.rowButtonActionHeaderStyleClass) || "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r64.sterownik == null ? null : ctx_r64.sterownik.rowButtonActionHeader) ? ctx_r64.sterownik == null ? null : ctx_r64.sterownik.rowButtonActionHeader : ɵngcc0.ɵɵpipeBind1(2, 2, "Akcje"), " ");
} }
function DsTableComponent_ng_template_5_ng_container_2_ng_container_1_th_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 37);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "transloco");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r65 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c0, ctx_r65.sterownik.rowButtonActionWidth))("ngClass", (ctx_r65.sterownik == null ? null : ctx_r65.sterownik.rowButtonActionHeaderStyleClass) || "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r65.sterownik.rowButtonActionHeader ? ctx_r65.sterownik.rowButtonActionHeader : ɵngcc0.ɵɵpipeBind1(2, 3, "Akcje"), " ");
} }
function DsTableComponent_ng_template_5_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_container_2_ng_container_1_th_1_Template, 3, 4, "th", 34);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_5_ng_container_2_ng_container_1_th_2_Template, 3, 7, "th", 35);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r61 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r61.sterownik.rowButtonActionWidth === undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r61.sterownik.rowButtonActionWidth !== undefined);
} }
function DsTableComponent_ng_template_5_ng_container_2_th_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "th", 38);
} }
function DsTableComponent_ng_template_5_ng_container_2_th_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 38);
    ɵngcc0.ɵɵelementStart(1, "span", 25);
    ɵngcc0.ɵɵtext(2, ".");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DsTableComponent_ng_template_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_container_2_ng_container_1_Template, 3, 2, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_5_ng_container_2_th_2_Template, 1, 0, "th", 33);
    ɵngcc0.ɵɵtemplate(3, DsTableComponent_ng_template_5_ng_container_2_th_3_Template, 3, 0, "th", 33);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.sterownik.rowButtonAction && ctx_r15.sterownik.rowButtonAction.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.sterownik.rowActions && ctx_r15.sterownik.rowActions.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.sterownik.rowExpansion);
} }
function DsTableComponent_ng_template_5_ng_template_3_ng_container_0_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 42);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "transloco");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r69 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("ngClass", (ctx_r69.sterownik == null ? null : ctx_r69.sterownik.rowButtonActionHeaderStyleClass) || "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r69.sterownik.rowButtonActionHeader ? ctx_r69.sterownik.rowButtonActionHeader : ɵngcc0.ɵɵpipeBind1(2, 2, "Akcje"), " ");
} }
function DsTableComponent_ng_template_5_ng_template_3_ng_container_0_th_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 43);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "transloco");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r70 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c0, ctx_r70.sterownik.rowButtonActionWidth))("ngClass", (ctx_r70.sterownik == null ? null : ctx_r70.sterownik.rowButtonActionHeaderStyleClass) || "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r70.sterownik.rowButtonActionHeader ? ctx_r70.sterownik.rowButtonActionHeader : ɵngcc0.ɵɵpipeBind1(2, 3, "Akcje"), " ");
} }
function DsTableComponent_ng_template_5_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_template_3_ng_container_0_th_1_Template, 3, 4, "th", 40);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_5_ng_template_3_ng_container_0_th_2_Template, 3, 7, "th", 41);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r66 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r66.sterownik.rowButtonActionWidth === undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r66.sterownik.rowButtonActionWidth !== undefined);
} }
function DsTableComponent_ng_template_5_ng_template_3_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "th", 44);
} }
function DsTableComponent_ng_template_5_ng_template_3_th_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 44);
    ɵngcc0.ɵɵelementStart(1, "span", 25);
    ɵngcc0.ɵɵtext(2, ".");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DsTableComponent_ng_template_5_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DsTableComponent_ng_template_5_ng_template_3_ng_container_0_Template, 3, 2, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_template_3_th_1_Template, 1, 0, "th", 39);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_5_ng_template_3_th_2_Template, 3, 0, "th", 39);
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r17.sterownik.rowButtonAction && ctx_r17.sterownik.rowButtonAction.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r17.sterownik.rowActions && ctx_r17.sterownik.rowActions.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r17.sterownik.rowExpansion);
} }
function DsTableComponent_ng_template_5_tr_5_th_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DsTableComponent_ng_template_5_tr_5_th_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_tr_5_th_1_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 28);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r75 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵnextContext(3);
    const _r8 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r8)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c27, col_r75));
} }
function DsTableComponent_ng_template_5_tr_5_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th");
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_tr_5_th_1_ng_container_1_Template, 2, 4, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r75 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r75.filter && (!col_r75.filter.mode || col_r75.filter.mode === "bar"));
} }
function DsTableComponent_ng_template_5_tr_5_th_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "th");
} }
function DsTableComponent_ng_template_5_tr_5_th_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "th", 44);
} }
function DsTableComponent_ng_template_5_tr_5_th_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 44);
    ɵngcc0.ɵɵelementStart(1, "span", 25);
    ɵngcc0.ɵɵtext(2, ".");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DsTableComponent_ng_template_5_tr_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_tr_5_th_1_Template, 2, 1, "th", 14);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_5_tr_5_th_2_Template, 1, 0, "th", 3);
    ɵngcc0.ɵɵtemplate(3, DsTableComponent_ng_template_5_tr_5_th_3_Template, 1, 0, "th", 39);
    ɵngcc0.ɵɵtemplate(4, DsTableComponent_ng_template_5_tr_5_th_4_Template, 3, 0, "th", 39);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r13 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r18 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", columns_r13);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r18.sterownik.rowButtonAction && ctx_r18.sterownik.rowButtonAction.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r18.sterownik.rowActions && ctx_r18.sterownik.rowActions.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r18.sterownik.rowExpansion);
} }
function DsTableComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_5_ng_container_1_Template, 4, 2, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_5_ng_container_2_Template, 4, 3, "ng-container", 15);
    ɵngcc0.ɵɵtemplate(3, DsTableComponent_ng_template_5_ng_template_3_Template, 3, 3, "ng-template", null, 16, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, DsTableComponent_ng_template_5_tr_5_Template, 5, 4, "tr", 3);
} if (rf & 2) {
    const columns_r13 = ctx.$implicit;
    const _r16 = ɵngcc0.ɵɵreference(4);
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", columns_r13);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!ctx_r3.sterownik.resizableColumns)("ngIfElse", _r16);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.anyFilter);
} }
function DsTableComponent_ng_template_6_ng_container_0_tr_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵelement(2, "ds-skeleton");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DsTableComponent_ng_template_6_ng_container_0_tr_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_6_ng_container_0_tr_1_ng_container_1_Template, 3, 0, "ng-container", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r80 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", columns_r80);
} }
const _c28 = function () { return [1, 2, 3]; };
function DsTableComponent_ng_template_6_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_6_ng_container_0_tr_1_Template, 2, 1, "tr", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpureFunction0(1, _c28));
} }
function DsTableComponent_ng_template_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "tr");
    ɵngcc0.ɵɵelement(2, "td", 45);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const columns_r80 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r82 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r82.emptyMessage, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵattribute("colspan", columns_r80.length);
} }
function DsTableComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DsTableComponent_ng_template_6_ng_container_0_Template, 2, 2, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_6_ng_container_1_Template, 3, 2, "ng-container", 3);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.loading);
} }
function DsTableComponent_ng_template_7_ng_container_1_td_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵelementStart(1, "div", 50);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "transloco");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 51);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "autoFormat");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r97 = ɵngcc0.ɵɵnextContext().$implicit;
    const rowData_r90 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r99 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, col_r97.header));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind3(6, 4, rowData_r90[col_r97.field], col_r97.dataType, ctx_r99.sterownik.placeholder));
} }
function DsTableComponent_ng_template_7_ng_container_1_td_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DsTableComponent_ng_template_7_ng_container_1_td_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_7_ng_container_1_td_2_ng_container_1_Template, 1, 0, "ng-container", 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r97 = ɵngcc0.ɵɵnextContext().$implicit;
    const rowData_r90 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r100 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r100.columnTemplates[col_r97.field])("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c8, rowData_r90));
} }
function DsTableComponent_ng_template_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_7_ng_container_1_td_1_Template, 7, 8, "td", 3);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_7_ng_container_1_td_2_Template, 2, 4, "td", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r97 = ctx.$implicit;
    const ctx_r93 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r93.columnTemplates[col_r97.field]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r93.columnTemplates[col_r97.field]);
} }
function DsTableComponent_ng_template_7_td_2_ds_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r111 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ds-button", 55);
    ɵngcc0.ɵɵlistener("onClick", function DsTableComponent_ng_template_7_td_2_ds_button_1_Template_ds_button_onClick_0_listener() { ɵngcc0.ɵɵrestoreView(_r111); const action_r108 = ctx.$implicit; const rowData_r90 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r109 = ɵngcc0.ɵɵnextContext(); return ctx_r109.emitRowAction(action_r108.action, rowData_r90); });
    ɵngcc0.ɵɵpipe(1, "transloco");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r108 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("label", action_r108.label)("icon", action_r108.icon)("styleClass", action_r108.styleClass)("severity", action_r108.severity)("pTooltip", ɵngcc0.ɵɵpipeBind1(1, 7, action_r108.tooltip))("disabled", action_r108.disabled ? action_r108.disabled : false)("readonly", action_r108.readonly ? action_r108.readonly : false);
} }
function DsTableComponent_ng_template_7_td_2_ds_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r115 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ds-button", 56);
    ɵngcc0.ɵɵlistener("onClick", function DsTableComponent_ng_template_7_td_2_ds_button_2_Template_ds_button_onClick_0_listener() { ɵngcc0.ɵɵrestoreView(_r115); const action_r112 = ctx.$implicit; const rowData_r90 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r113 = ɵngcc0.ɵɵnextContext(); return ctx_r113.emitRowAction(action_r112.action, rowData_r90); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r112 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("label", action_r112.tooltip)("styleClass", action_r112.styleClass)("severity", "border")("disabled", action_r112.disabled ? action_r112.disabled : false)("readonly", action_r112.readonly ? action_r112.readonly : false);
} }
function DsTableComponent_ng_template_7_td_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 52);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_7_td_2_ds_button_1_Template, 2, 9, "ds-button", 53);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_7_td_2_ds_button_2_Template, 1, 5, "ds-button", 54);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r94 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r94.sterownik.rowButtonAction);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r94.sterownik.rowButtonAction);
} }
function DsTableComponent_ng_template_7_td_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 57);
    ɵngcc0.ɵɵelement(1, "p-menubar", 58);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r90 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r95 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("model", ctx_r95.rowsMenuModel[rowData_r90[ctx_r95.sterownik.key]]);
} }
function DsTableComponent_ng_template_7_td_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 59);
    ɵngcc0.ɵɵelement(1, "ds-button", 60);
    ɵngcc0.ɵɵelement(2, "ds-button", 61);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r117 = ɵngcc0.ɵɵnextContext();
    const rowData_r90 = ctx_r117.$implicit;
    const expanded_r91 = ctx_r117.expanded;
    ɵngcc0.ɵɵproperty("pRowToggler", rowData_r90);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", expanded_r91 ? "pi pi-chevron-up" : "pi pi-chevron-down")("label", "rozwi\u0144 zwi\u0144 wiersz")("styleClass", "p-button-label-display-none");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("label", expanded_r91 ? "Ukryj wszystkie odpowiedzi" : "Pobierz wszystkie odpowiedzi");
} }
function DsTableComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r119 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr", 46);
    ɵngcc0.ɵɵlistener("dblclick", function DsTableComponent_ng_template_7_Template_tr_dblclick_0_listener() { ɵngcc0.ɵɵrestoreView(_r119); const rowData_r90 = ctx.$implicit; const ctx_r118 = ɵngcc0.ɵɵnextContext(); return ctx_r118.emitRowDbClick.emit(rowData_r90); })("keyup.space", function DsTableComponent_ng_template_7_Template_tr_keyup_space_0_listener() { ɵngcc0.ɵɵrestoreView(_r119); const rowData_r90 = ctx.$implicit; const ctx_r120 = ɵngcc0.ɵɵnextContext(); return ctx_r120.emitRowDbClick.emit(rowData_r90); });
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_7_ng_container_1_Template, 3, 2, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_7_td_2_Template, 3, 2, "td", 47);
    ɵngcc0.ɵɵtemplate(3, DsTableComponent_ng_template_7_td_3_Template, 2, 1, "td", 48);
    ɵngcc0.ɵɵtemplate(4, DsTableComponent_ng_template_7_td_4_Template, 3, 5, "td", 49);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r90 = ctx.$implicit;
    const columns_r92 = ctx.columns;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("dbl-click-listener", ctx_r5.doubleClickActive);
    ɵngcc0.ɵɵproperty("ngClass", rowData_r90["dsRowClassNames"] ? rowData_r90["dsRowClassNames"] : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", columns_r92);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.sterownik.rowButtonAction && ctx_r5.sterownik.rowButtonAction.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.sterownik.rowActions && ctx_r5.sterownik.rowActions.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.sterownik.rowExpansion);
} }
function DsTableComponent_ng_template_8_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c29 = function (a0, a1, a2) { return { "rowData": a0, "columns": a1, "colSpan": a2 }; };
function DsTableComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DsTableComponent_ng_template_8_ng_container_0_Template, 1, 0, "ng-container", 28);
} if (rf & 2) {
    const rowData_r121 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r6.rozwijakTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(6, _c8, ɵngcc0.ɵɵpureFunction3(2, _c29, rowData_r121, ctx_r6.sterownik.columns, ctx_r6.rowExpansionColSpan)));
} }
function DsTableComponent_div_9_ds_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r129 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ds-button", 69);
    ɵngcc0.ɵɵlistener("click", function DsTableComponent_div_9_ds_button_2_Template_ds_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r129); ɵngcc0.ɵɵnextContext(2); const _r1 = ɵngcc0.ɵɵreference(3); return _r1.exportCSV(); });
    ɵngcc0.ɵɵelementEnd();
} }
function DsTableComponent_div_9_ds_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r131 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ds-button", 70);
    ɵngcc0.ɵɵlistener("click", function DsTableComponent_div_9_ds_button_3_Template_ds_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r131); const ctx_r130 = ɵngcc0.ɵɵnextContext(2); return ctx_r130.exportExcel(); });
    ɵngcc0.ɵɵelementEnd();
} }
function DsTableComponent_div_9_ds_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r133 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ds-button", 71);
    ɵngcc0.ɵɵlistener("click", function DsTableComponent_div_9_ds_button_4_Template_ds_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r133); const ctx_r132 = ɵngcc0.ɵɵnextContext(2); return ctx_r132.exportPdf(); });
    ɵngcc0.ɵɵelementEnd();
} }
const _c30 = function () { return {}; };
function DsTableComponent_div_9_ds_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r136 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ds-button", 72);
    ɵngcc0.ɵɵlistener("click", function DsTableComponent_div_9_ds_button_5_Template_ds_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r136); const action_r134 = ctx.$implicit; const ctx_r135 = ɵngcc0.ɵɵnextContext(2); return ctx_r135.emitTableAction(action_r134.action, action_r134.disabled || false); });
    ɵngcc0.ɵɵpipe(1, "transloco");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r134 = ctx.$implicit;
    ɵngcc0.ɵɵstyleMap(action_r134.style || ɵngcc0.ɵɵpureFunction0(8, _c30));
    ɵngcc0.ɵɵproperty("severity", action_r134.severity ? action_r134.severity : action_r134.dsType)("label", ɵngcc0.ɵɵpipeBind1(1, 6, action_r134.label))("disabled", action_r134.disabled ? action_r134.disabled : false)("styleClass", action_r134.styleClass || "");
} }
function DsTableComponent_div_9_div_6_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 86);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r137 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r137.currentPageReportText, " ");
} }
const _c31 = function (a0) { return { "p-highlight": a0 }; };
function DsTableComponent_div_9_div_6_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r144 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 87);
    ɵngcc0.ɵɵlistener("click", function DsTableComponent_div_9_div_6_button_11_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r144); const pageObj_r141 = ctx.$implicit; const ctx_r143 = ɵngcc0.ɵɵnextContext(3); return ctx_r143.onPage({ first: (pageObj_r141.value - 1) * ctx_r143.rows, rows: ctx_r143.rows }); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const pageObj_r141 = ctx.$implicit;
    const ctx_r138 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c31, pageObj_r141.value - 1 === ctx_r138.page));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", pageObj_r141.value, " ");
} }
function DsTableComponent_div_9_div_6_ng_container_12_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 90);
    ɵngcc0.ɵɵtext(1, " ... ");
    ɵngcc0.ɵɵelementEnd();
} }
function DsTableComponent_div_9_div_6_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r147 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_div_9_div_6_ng_container_12_button_1_Template, 2, 0, "button", 88);
    ɵngcc0.ɵɵelementStart(2, "button", 89);
    ɵngcc0.ɵɵlistener("click", function DsTableComponent_div_9_div_6_ng_container_12_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r147); const ctx_r146 = ɵngcc0.ɵɵnextContext(3); return ctx_r146.onPage({ first: (ctx_r146.pageCount - 1) * ctx_r146.rows, rows: ctx_r146.rows }); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r139 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r139.page < ctx_r139.pageCount - (ctx_r139.paginatorLastElems + 1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c31, ctx_r139.pageCount === ctx_r139.page));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r139.pageCount, " ");
} }
function DsTableComponent_div_9_div_6_p_dropdown_21_Template(rf, ctx) { if (rf & 1) {
    const _r149 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-dropdown", 91);
    ɵngcc0.ɵɵlistener("ngModelChange", function DsTableComponent_div_9_div_6_p_dropdown_21_Template_p_dropdown_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r149); const ctx_r148 = ɵngcc0.ɵɵnextContext(3); return ctx_r148.rows = $event; })("keydown.enter", function DsTableComponent_div_9_div_6_p_dropdown_21_Template_p_dropdown_keydown_enter_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r149); const ctx_r150 = ɵngcc0.ɵɵnextContext(3); return ctx_r150.onPage({ first: 0, rows: $event.value }); })("ngModelChange", function DsTableComponent_div_9_div_6_p_dropdown_21_Template_p_dropdown_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r149); const ctx_r151 = ɵngcc0.ɵɵnextContext(3); return ctx_r151.onPage({ first: 0, rows: $event.value }); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r140 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("options", ctx_r140.rowsPerPageOptionsObjects)("ngModel", ctx_r140.rows);
} }
const _c32 = function (a0) { return { "p-disabled": a0 }; };
function DsTableComponent_div_9_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r153 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 73);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_div_9_div_6_span_1_Template, 2, 1, "span", 74);
    ɵngcc0.ɵɵelementStart(2, "button", 75);
    ɵngcc0.ɵɵlistener("click", function DsTableComponent_div_9_div_6_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r153); const ctx_r152 = ɵngcc0.ɵɵnextContext(2); return ctx_r152.onPage({ first: 0, rows: ctx_r152.rows }); });
    ɵngcc0.ɵɵelementStart(3, "span", 76);
    ɵngcc0.ɵɵelementStart(4, "span", 25);
    ɵngcc0.ɵɵtext(5, "Pocz\u0105tek");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "button", 77);
    ɵngcc0.ɵɵlistener("click", function DsTableComponent_div_9_div_6_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r153); const ctx_r154 = ɵngcc0.ɵɵnextContext(2); return ctx_r154.onPage({ first: ctx_r154.first - ctx_r154.rows, rows: ctx_r154.rows }); });
    ɵngcc0.ɵɵelementStart(7, "span", 78);
    ɵngcc0.ɵɵelementStart(8, "span", 25);
    ɵngcc0.ɵɵtext(9, "Wstecz");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "span", 79);
    ɵngcc0.ɵɵtemplate(11, DsTableComponent_div_9_div_6_button_11_Template, 2, 4, "button", 80);
    ɵngcc0.ɵɵtemplate(12, DsTableComponent_div_9_div_6_ng_container_12_Template, 4, 5, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "button", 81);
    ɵngcc0.ɵɵlistener("click", function DsTableComponent_div_9_div_6_Template_button_click_13_listener() { ɵngcc0.ɵɵrestoreView(_r153); const ctx_r155 = ɵngcc0.ɵɵnextContext(2); return ctx_r155.onPage({ first: ctx_r155.first + ctx_r155.rows, rows: ctx_r155.rows }); });
    ɵngcc0.ɵɵelementStart(14, "span", 82);
    ɵngcc0.ɵɵelementStart(15, "span", 25);
    ɵngcc0.ɵɵtext(16, "Wprz\u00F3d");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "button", 83);
    ɵngcc0.ɵɵlistener("click", function DsTableComponent_div_9_div_6_Template_button_click_17_listener() { ɵngcc0.ɵɵrestoreView(_r153); const ctx_r156 = ɵngcc0.ɵɵnextContext(2); return ctx_r156.onPage({ first: ctx_r156.pageCount * ctx_r156.rows - ctx_r156.rows, rows: ctx_r156.rows }); });
    ɵngcc0.ɵɵelementStart(18, "span", 84);
    ɵngcc0.ɵɵelementStart(19, "span", 25);
    ɵngcc0.ɵɵtext(20, "Koniec");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(21, DsTableComponent_div_9_div_6_p_dropdown_21_Template, 1, 2, "p-dropdown", 85);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r127 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r127.currentPageReportTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(12, _c32, ctx_r127.page === 0))("disabled", ctx_r127.page === 0);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(14, _c32, ctx_r127.page === 0))("disabled", ctx_r127.page === 0);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r127.paginatorPages);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r127.pageCount > ctx_r127.paginatorButtonsCount + 1 && ctx_r127.page < ctx_r127.pageCount - ctx_r127.paginatorLastElems);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(16, _c32, ctx_r127.page + 1 === ctx_r127.pageCount))("disabled", ctx_r127.page + 1 === ctx_r127.pageCount);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(18, _c32, ctx_r127.page + 1 === ctx_r127.pageCount))("disabled", ctx_r127.page + 1 === ctx_r127.pageCount);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r127.sterownik.paginator == null ? null : ctx_r127.sterownik.paginator.rowsPerPageOptions);
} }
function DsTableComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 62);
    ɵngcc0.ɵɵelementStart(1, "div", 63);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_div_9_ds_button_2_Template, 1, 0, "ds-button", 64);
    ɵngcc0.ɵɵtemplate(3, DsTableComponent_div_9_ds_button_3_Template, 1, 0, "ds-button", 65);
    ɵngcc0.ɵɵtemplate(4, DsTableComponent_div_9_ds_button_4_Template, 1, 0, "ds-button", 66);
    ɵngcc0.ɵɵtemplate(5, DsTableComponent_div_9_ds_button_5_Template, 2, 9, "ds-button", 67);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DsTableComponent_div_9_div_6_Template, 22, 20, "div", 68);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.exportToCsv);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.exportToExcel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.exportToPdf);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.sterownik.tableActions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r7.hidePagination && ctx_r7.pageCount > 0);
} }
function DsTableComponent_ng_template_10_ds_dropdown_1_Template(rf, ctx) { if (rf & 1) {
    const _r162 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ds-dropdown", 96);
    ɵngcc0.ɵɵlistener("onChange", function DsTableComponent_ng_template_10_ds_dropdown_1_Template_ds_dropdown_onChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r162); const col_r157 = ɵngcc0.ɵɵnextContext().col; ɵngcc0.ɵɵnextContext(); const _r1 = ɵngcc0.ɵɵreference(3); return _r1.filter($event.value ? $event.value.value : null, col_r157.field, col_r157.filter.matchMode || "equals"); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r157 = ɵngcc0.ɵɵnextContext().col;
    ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("placeholder", col_r157.filter.placeholder || "")("options", col_r157.filter.options)("ngModel", _r1.filters[col_r157.field] == null ? null : _r1.filters[col_r157.field].value)("autoDisplayFirst", false)("showClear", col_r157.filter.showClear)("filter", col_r157.filter.showFilter);
} }
function DsTableComponent_ng_template_10_ds_multiselect_2_Template(rf, ctx) { if (rf & 1) {
    const _r166 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ds-multiselect", 97);
    ɵngcc0.ɵɵlistener("onChange", function DsTableComponent_ng_template_10_ds_multiselect_2_Template_ds_multiselect_onChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r166); const col_r157 = ɵngcc0.ɵɵnextContext().col; ɵngcc0.ɵɵnextContext(); const _r1 = ɵngcc0.ɵɵreference(3); return _r1.filter($event.value || $event, col_r157.field, col_r157.filter.matchMode || "in"); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r157 = ɵngcc0.ɵɵnextContext().col;
    ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("filterPlaceholder", col_r157.filter.placeholder || "")("ngModel", _r1.filters[col_r157.field] == null ? null : _r1.filters[col_r157.field].value)("options", col_r157.filter.options)("defaultLabel", col_r157.filter.placeholder || "")("showHeader", col_r157.filter.showFilter);
} }
function DsTableComponent_ng_template_10_ds_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r170 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ds-input", 98);
    ɵngcc0.ɵɵlistener("input", function DsTableComponent_ng_template_10_ds_input_3_Template_ds_input_input_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r170); const col_r157 = ɵngcc0.ɵɵnextContext().col; ɵngcc0.ɵɵnextContext(); const _r1 = ɵngcc0.ɵɵreference(3); return _r1.filter($event == null ? null : $event.target == null ? null : $event.target.value, col_r157.field, col_r157.filter.matchMode || "contains"); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r157 = ɵngcc0.ɵɵnextContext().col;
    ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("ngModel", _r1.filters[col_r157.field] == null ? null : _r1.filters[col_r157.field].value)("placeholder", col_r157.filter.placeholder || "")("showClear", col_r157.filter.showClear);
} }
function DsTableComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 92);
    ɵngcc0.ɵɵtemplate(1, DsTableComponent_ng_template_10_ds_dropdown_1_Template, 1, 6, "ds-dropdown", 93);
    ɵngcc0.ɵɵtemplate(2, DsTableComponent_ng_template_10_ds_multiselect_2_Template, 1, 5, "ds-multiselect", 94);
    ɵngcc0.ɵɵtemplate(3, DsTableComponent_ng_template_10_ds_input_3_Template, 1, 3, "ds-input", 95);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r157 = ctx.col;
    ɵngcc0.ɵɵproperty("ngSwitch", col_r157.filter.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "ds-dropdown");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "ds-multiselect");
} }
function DsTagComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span");
} }
function DsTextareaComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 6);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r1.safeHtml(ctx_r1.errorMessage), ɵngcc0.ɵɵsanitizeHtml);
} }
function DsTextareaComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r2.counterAlwaysVisible ? "visible" : ctx_r2.isFocused ? "visible" : "hidden");
    ɵngcc0.ɵɵclassProp("counter-inside", ctx_r2.counterInside);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r2.ngModel ? ctx_r2.ngModel.length : 0) + "/" + ctx_r2.maxLength, " ");
} }
function DsBreadcrumbComponent_ng_container_2_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵlistener("click", function DsBreadcrumbComponent_ng_container_2_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const item_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.navigateTo(item_r1.path); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r1.label, "");
} }
function DsBreadcrumbComponent_ng_container_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r1.label, "");
} }
function DsBreadcrumbComponent_ng_container_2_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r1.label, "");
} }
function DsBreadcrumbComponent_ng_container_2_li_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelement(1, "span", 11);
    ɵngcc0.ɵɵelementEnd();
} }
function DsBreadcrumbComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 3);
    ɵngcc0.ɵɵtemplate(2, DsBreadcrumbComponent_ng_container_2_a_2_Template, 2, 1, "a", 4);
    ɵngcc0.ɵɵtemplate(3, DsBreadcrumbComponent_ng_container_2_span_3_Template, 2, 1, "span", 5);
    ɵngcc0.ɵɵtemplate(4, DsBreadcrumbComponent_ng_container_2_span_4_Template, 2, 1, "span", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, DsBreadcrumbComponent_ng_container_2_li_5_Template, 2, 0, "li", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const last_r2 = ctx.last;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !last_r2 && item_r1.path);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !last_r2 && !item_r1.path);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", last_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !last_r2);
} }
const _c33 = [[["ds-layout-header"]], [["ds-layout-sidebar"]], [["ds-layout-subheader"]], [["ds-layout-content"]], [["ds-layout-footer"]]];
const _c34 = ["ds-layout-header", "ds-layout-sidebar", "ds-layout-subheader", "ds-layout-content", "ds-layout-footer"];
const _c35 = ["panelContent"];
function DsPanelComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 1);
} }
function DsPanelComponent_p_header_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-header");
    ɵngcc0.ɵɵprojection(1, 2);
    ɵngcc0.ɵɵelementEnd();
} }
function DsPanelComponent_p_footer_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-footer");
    ɵngcc0.ɵɵprojection(1, 3);
    ɵngcc0.ɵɵelementEnd();
} }
const _c36 = ["*", [["ds-panel-buttons"]], [["ds-panel-header"]], [["ds-panel-footer"]]];
const _c37 = function (a0) { return { "p-pt-3": a0 }; };
const _c38 = ["*", "ds-panel-buttons", "ds-panel-header", "ds-panel-footer"];
function DsTabLabelComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function DsTabBodyComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function DsTabViewComponent_li_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DsTabViewComponent_li_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DsTabViewComponent_li_1_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tabItem_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", tabItem_r3.tabLabelComponent.tabLabelContent);
} }
function DsTabViewComponent_li_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tabItem_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", tabItem_r3.label, " ");
} }
function DsTabViewComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 5);
    ɵngcc0.ɵɵlistener("click", function DsTabViewComponent_li_1_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const tabItem_r3 = ctx.$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.setActiveTab(tabItem_r3); })("keyup.space", function DsTabViewComponent_li_1_Template_li_keyup_space_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const tabItem_r3 = ctx.$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.setActiveTab(tabItem_r3); });
    ɵngcc0.ɵɵtemplate(1, DsTabViewComponent_li_1_ng_container_1_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵtemplate(2, DsTabViewComponent_li_1_ng_container_2_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tabItem_r3 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("is-active", tabItem_r3.isActive)("is-disabled", tabItem_r3.disabled)("primary", tabItem_r3.labelSize === "primary")("secondary", tabItem_r3.labelSize === "secondary");
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.ariaLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", tabItem_r3 == null ? null : tabItem_r3.tabLabelComponent == null ? null : tabItem_r3.tabLabelComponent.tabLabelContent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(tabItem_r3 == null ? null : tabItem_r3.tabLabelComponent) && tabItem_r3.label);
} }
function DsTabViewComponent_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DsTabViewComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtemplate(1, DsTabViewComponent_div_2_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.actionSectionTemplate);
} }
function DsTabViewComponent_ng_container_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DsTabViewComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵtemplate(2, DsTabViewComponent_ng_container_4_ng_container_2_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tabItem_r13 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !tabItem_r13.isActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", tabItem_r13.tabBodyComponent.tabBodyContent);
} }
const _c39 = ["modal"];
const _c40 = ["modalContentContainer"];
function DsModalComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} }
function DsModalComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵelementEnd();
} }
const _c41 = function (a0) { return { "p-mt-3": a0 }; };
function DsModalComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11, 12);
    ɵngcc0.ɵɵprojection(2, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c41, ctx_r4.modalDate || ctx_r4.modalTitle))("ngStyle", ctx_r4.modalContentStyle);
} }
function DsModalComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1, 2);
    ɵngcc0.ɵɵlistener("@showModal.start", function DsModalComponent_div_0_Template_div_animation_showModal_start_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.startAnimation($event); })("@showModal.done", function DsModalComponent_div_0_Template_div_animation_showModal_done_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.doneAnimation($event); });
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "ds-panel", 4);
    ɵngcc0.ɵɵelementStart(4, "span", 5);
    ɵngcc0.ɵɵlistener("click", function DsModalComponent_div_0_Template_span_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.disableModal(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, DsModalComponent_div_0_div_5_Template, 2, 0, "div", 6);
    ɵngcc0.ɵɵtemplate(6, DsModalComponent_div_0_div_6_Template, 2, 0, "div", 7);
    ɵngcc0.ɵɵtemplate(7, DsModalComponent_div_0_div_7_Template, 3, 4, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@showModal", undefined);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r0.ngStyle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("showHeader", false);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.modalDate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.modalTitle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.modalContent);
} }
const _c42 = [[["", "dsModalDate", ""]], [["", "dsModalTitle", ""]], [["", "dsModalContent", ""]]];
const _c43 = ["[dsModalDate]", "[dsModalTitle]", "[dsModalContent]"];
const _c44 = function (a1, a2, a3) { return { "ds-inputswitch p-component": true, "p-inputswitch-checked": a1, "p-disabled": a2, "p-focus": a3 }; };
const TERYT_API_URL = new InjectionToken('teryt-api-url');

class AutocompleteUtils {
    static replaceDiacriticCharacters(word) {
        const substitutes = {
            'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ź': 'z', 'ż': 'z',
            'Ą': 'A', 'Ć': 'C', 'Ę': 'E', 'Ł': 'L', 'Ń': 'N', 'Ó': 'O', 'Ś': 'S', 'Ź': 'Z', 'Ż': 'Z',
        };
        return word.replace(/[ąćęłńóśźż]/gi, m => substitutes[m]);
    }
    static normalize(word) {
        const normalizedWord = this.replaceDiacriticCharacters(word.toLowerCase());
        return normalizedWord;
    }
    static filterSuggestions(list, filterBy) {
        let filtered = [];
        if (!list) {
            return [];
        }
        for (let i = 0; i < list.length; i++) {
            let element = list[i];
            if (this.normalize(element).includes(this.normalize(filterBy))) {
                filtered.push(element);
            }
        }
        return filtered.sort((a, b) => {
            return this.sortByStartsWithThenAlphabetically(a, b, filterBy);
        });
    }
    static sortByStartsWithThenAlphabetically(a, b, currentQuery) {
        const indexA = this.normalize(a).indexOf(this.normalize(currentQuery));
        const indexB = this.normalize(b).indexOf(this.normalize(currentQuery));
        if ((indexA == 0 && indexB == 0) || (indexA != 0 && indexB != 0)) {
            return 0;
        }
        if (indexA == 0) {
            return -1;
        }
        if (indexB == 0) {
            return 1;
        }
        return 0;
    }
}

class AdresService {
    constructor(terytApiUrl, httpClient) {
        this.terytApiUrl = terytApiUrl;
        this.httpClient = httpClient;
        this.loadingCities$ = new BehaviorSubject(false);
        this.loadingStreets$ = new BehaviorSubject(false);
        this.loadingPostalCodes$ = new BehaviorSubject(false);
        this.loadingVoivodeships$ = new BehaviorSubject(false);
        this.loadingCounties$ = new BehaviorSubject(false);
        this.loadingBoroughs$ = new BehaviorSubject(false);
        this.cities$ = new BehaviorSubject([]);
        this.streets$ = new BehaviorSubject([]);
        this.postalCodes$ = new BehaviorSubject([]);
        this.voivodeships$ = new BehaviorSubject([]);
        this.counties$ = new BehaviorSubject([]);
        this.boroughs$ = new BehaviorSubject([]);
        this.prevSearchCityQuery = null;
        this.prevSearchStreetQuery = null;
        this.prevCityFormControlValue = null;
        this.prevStreetFormControlValue = null;
        this.prevVoivodeshipFormControlValue = null;
        this.prevCountyFormControlValue = null;
        this.filterSuggestionsPipe = (filterBy) => (source) => {
            return source.pipe(map((suggestions) => AutocompleteUtils.filterSuggestions(suggestions, filterBy)));
        };
    }
    filterCities(query) {
        return (this.isNewQuery(query, this.prevSearchCityQuery) ? this.fetchCities(query) : this.getCitiesObs())
            .pipe(this.filterSuggestionsPipe(query));
    }
    getCitiesObs() {
        return this.cities$.asObservable();
    }
    getLoadingCitiesObs() {
        return this.loadingCities$.asObservable();
    }
    updateLoadingCities(value) {
        this.loadingCities$.next(value);
    }
    updateCitiesObs(value) {
        this.cities$.next(value);
    }
    fetchCities(query) {
        this.updateLoadingCities(true);
        let queryStringParams = new HttpParams()
            .set('NazwaMiasta', query);
        if (this.voivodeshipFormControlValue !== '' && this.voivodeshipFormControlValue !== undefined) {
            queryStringParams = queryStringParams.append('Wojewodztwo', this.voivodeshipFormControlValue);
        }
        if (this.countyFormControlValue !== '' && this.countyFormControlValue !== undefined) {
            queryStringParams = queryStringParams.append('Powiat', this.countyFormControlValue);
        }
        if (this.boroughFormControlValue !== '' && this.boroughFormControlValue !== undefined) {
            queryStringParams = queryStringParams.append('Gmina', this.boroughFormControlValue);
        }
        return this.httpClient.get(`${this.terytApiUrl}/Teryt/GetCities`, { params: queryStringParams })
            .pipe(tap(() => this.prevSearchCityQuery = query), tap((value) => this.updateCitiesObs(value)), finalize(() => this.updateLoadingCities(false)));
    }
    filterStreets(query) {
        return (this.isNewQuery(query, this.prevSearchStreetQuery) ? this.fetchStreets(query) : this.getStreetsObs())
            .pipe(this.filterSuggestionsPipe(query));
    }
    getStreetsObs() {
        return this.streets$.asObservable();
    }
    getLoadingStreetsObs() {
        return this.loadingStreets$.asObservable();
    }
    updateLoadingStreets(value) {
        this.loadingStreets$.next(value);
    }
    updateStreetsObs(value) {
        this.streets$.next(value);
    }
    fetchStreets(query) {
        this.updateLoadingStreets(true);
        const queryStringParams = new HttpParams()
            .set('NazwaUlicy', query)
            .set('NazwaMiasta', this.cityFormControlValue ? this.cityFormControlValue : '');
        return this.httpClient.get(`${this.terytApiUrl}/Teryt/GetStreets`, { params: queryStringParams })
            .pipe(tap(() => this.prevSearchStreetQuery = query), tap((value) => this.updateStreetsObs(value)), finalize(() => this.updateLoadingStreets(false)));
    }
    filterPostalCodes(query) {
        return (this.isNewQueryPostalCodes(this.cityFormControlValue, this.streetFormControlValue, this.prevCityFormControlValue, this.prevStreetFormControlValue)
            ? this.fetchPostalCodes() : this.getPostalCodesObs())
            .pipe(this.filterSuggestionsPipe(query));
    }
    getPostalCodesObs() {
        return this.postalCodes$.asObservable();
    }
    getLoadingPostalCodesObs() {
        return this.loadingPostalCodes$.asObservable();
    }
    updateLoadingPostalCodes(value) {
        this.loadingPostalCodes$.next(value);
    }
    updatePostalCodesObs(value) {
        this.postalCodes$.next(value);
    }
    fetchPostalCodes() {
        this.updateLoadingPostalCodes(true);
        const queryStringParams = new HttpParams()
            .set('NazwaMiasta', this.cityFormControlValue ? this.cityFormControlValue : '')
            .set('NazwaUlicy', this.streetFormControlValue ? this.streetFormControlValue : '');
        return this.httpClient.get(`${this.terytApiUrl}/Teryt/GetPostalCodes`, { params: queryStringParams })
            .pipe(tap(() => this.updatePrevFormControlValues(this.cityFormControlValue, this.streetFormControlValue)), tap((value) => this.updatePostalCodesObs(value)), finalize(() => this.updateLoadingPostalCodes(false)));
    }
    filterVoivodeships(query) {
        return (this.voivodeships$.getValue().length === 0 ? this.fetchVoivodeships() : this.getVoivodeshipsObs())
            .pipe(this.filterSuggestionsPipe(query));
    }
    getVoivodeshipsObs() {
        return this.voivodeships$.asObservable();
    }
    getLoadingVoivodeshipsObs() {
        return this.loadingVoivodeships$.asObservable();
    }
    updateLoadingVoivodeships(value) {
        this.loadingVoivodeships$.next(value);
    }
    updateVoivodeshipsObs(value) {
        this.voivodeships$.next(value);
    }
    fetchVoivodeships() {
        this.updateLoadingVoivodeships(true);
        const dajListeAdmReq = {
            kategoria: 'województwo'
        };
        return this.httpClient.post(`${this.terytApiUrl}/Teryt/DajListeAdm`, dajListeAdmReq)
            .pipe(tap((value) => this.updateVoivodeshipsObs(value)), finalize(() => this.updateLoadingVoivodeships(false)));
    }
    filterCounties(query) {
        return (this.voivodeshipFormControlValue !== this.prevVoivodeshipFormControlValue ? this.fetchCounties() : this.getCountiesObs())
            .pipe(this.filterSuggestionsPipe(query));
    }
    getCountiesObs() {
        return this.counties$.asObservable();
    }
    getLoadingCountiesObs() {
        return this.loadingCounties$.asObservable();
    }
    updateLoadingCounties(value) {
        this.loadingCounties$.next(value);
    }
    updateCountiesObs(value) {
        this.counties$.next(value);
    }
    fetchCounties() {
        this.updateLoadingCounties(true);
        const dajListeAdmReq = {
            kategoria: 'powiat',
            twardyFiltr: {
                wojewodztwo: this.voivodeshipFormControlValue
            }
        };
        return this.httpClient.post(`${this.terytApiUrl}/Teryt/DajListeAdm`, dajListeAdmReq)
            .pipe(tap((value) => this.updateCountiesObs(value)), tap(() => this.prevVoivodeshipFormControlValue = this.voivodeshipFormControlValue), finalize(() => this.updateLoadingCounties(false)));
    }
    filterBoroughs(query) {
        return (this.countyFormControlValue !== this.prevCountyFormControlValue ? this.fetchBoroughs() : this.getBoroughsObs())
            .pipe(this.filterSuggestionsPipe(query));
    }
    getBoroughsObs() {
        return this.boroughs$.asObservable();
    }
    getLoadingBoroughsObs() {
        return this.loadingBoroughs$.asObservable();
    }
    updateLoadingBoroughs(value) {
        this.loadingBoroughs$.next(value);
    }
    updateBoroughsObs(value) {
        this.boroughs$.next(value);
    }
    fetchBoroughs() {
        this.updateLoadingBoroughs(true);
        const dajListeAdmReq = {
            kategoria: 'gmina',
            twardyFiltr: {
                wojewodztwo: this.voivodeshipFormControlValue,
                powiat: this.countyFormControlValue
            }
        };
        return this.httpClient.post(`${this.terytApiUrl}/Teryt/DajListeAdm`, dajListeAdmReq)
            .pipe(tap((value) => this.updateBoroughsObs(value)), tap(() => this.prevCountyFormControlValue = this.countyFormControlValue), finalize(() => this.updateLoadingBoroughs(false)));
    }
    dajAdmPoMiasto(city) {
        const queryStringParams = new HttpParams()
            .set('city', city ? city : '');
        return this.httpClient.get(`${this.terytApiUrl}/Teryt/DajAdmPoMiasto`, { params: queryStringParams });
    }
    checkAdress(checkAdressReq) {
        return this.httpClient.post(`${this.terytApiUrl}/Teryt/CheckAdress`, checkAdressReq);
    }
    updatePrevFormControlValues(prevCity, prevStreet) {
        this.prevCityFormControlValue = prevCity;
        this.prevStreetFormControlValue = prevStreet;
    }
    set _cityFormControlValue(value) {
        this.cityFormControlValue = value;
    }
    set _streetFormControlValue(value) {
        this.streetFormControlValue = value;
    }
    set _voivodeshipFormControlValue(value) {
        this.voivodeshipFormControlValue = value;
    }
    set _countyFormControlValue(value) {
        this.countyFormControlValue = value;
    }
    set _boroughFormControlValue(value) {
        this.boroughFormControlValue = value;
    }
    isNewQuery(currentQuery, prevQuery) {
        return prevQuery ? !(currentQuery.includes(prevQuery) && currentQuery.indexOf(prevQuery) === 0) && currentQuery.length >= 2 : currentQuery.length >= 2;
    }
    isNewQueryPostalCodes(currentCityValue, currentStreetValue, prevCityValue, prevStreetValue) {
        return prevCityValue !== null && prevStreetValue !== null ? !(currentCityValue === prevCityValue && currentStreetValue === prevStreetValue) : true;
    }
}
AdresService.ɵfac = function AdresService_Factory(t) { return new (t || AdresService)(ɵngcc0.ɵɵinject(TERYT_API_URL, 8), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
AdresService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AdresService, factory: AdresService.ɵfac });
AdresService.ctorParameters = () => [
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [TERYT_API_URL,] }] },
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AdresService, [{
        type: Injectable
    }], function () { return [{ type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [TERYT_API_URL]
            }] }, { type: ɵngcc1.HttpClient }]; }, null); })();

// TODO refactor -> remove
class Utils {
    static wygenerujLosoweId() {
        const ran = Math.trunc(Math.random() * 100000000);
        return ran.toString();
    }
    /**
     * Marks all controls in a form group as touched
     * @param formGroup - The form group to touch
     * [stackoverflow source](https://stackoverflow.com/a/44150793/10167645)
     */
    static markFormGroupTouched(formGroup) {
        Object.values(formGroup.controls).forEach(control => {
            control.markAsTouched();
            if (control.controls) {
                this.markFormGroupTouched(control);
            }
        });
    }
    static normalizeToUpper(value) {
        const beforeSubs = {
            'ß': 'ẞ',
        };
        // const afterSubs = {
        //   'Μ': 'μ'
        // };
        return value ? value
            .replace(/ß/g, m => beforeSubs[m])
            .toUpperCase()
            // .replace(/Μ/g, m => afterSubs[m]) 
            : value;
    }
}

class AdresControlBase {
    constructor() {
        /**
        * Określa szerokość komponentu.
        * @type string
        * @default '100%'
        * */
        this.width = '100%';
        /**
         * Etykieta znajdująca się nad inputem.
         * @type string
         * @default empty string
         * */
        this.label = '';
        /**
         * Maksymalna wysokość panelu sugestii.
         * @type string
         * @default '200px'
         */
        this.scrollHeight = '200px';
        /**
         * Wyświetla przycisk do rozwinięcia panelu sugestii obok pola wprowadzania danych, gdy jest włączony.
         * @type boolean
         * @default false
         */
        this.dropdown = false;
        /**
         * Określa, czy można wybrać wiele wartości.
         * @type boolean
         * @default false
         */
        this.multiple = false;
        /**
         * Klasa ikony w przycisku dropdownu.
         * @type string
         * @default 'pi pi-chevron-down'
         */
        this.dropdownIcon = 'pi pi-chevron-down';
        /**
         * Minimalna liczba znaków do rozpoczęcia wyszukiwania.
         * @type number
         * @default 1
         */
        this.minLength = 1;
        /**
         * Opóźnienie w [ms] między naciśnięciami klawiszy, zanim zostanie wysłane zapytanie.
         * @type number
         * @default 300
         */
        this.delay = 300;
        /**
         * Czy uruchomić zapytanie, gdy wejście otrzyma fokus.
         * @type boolean
         * @default false
         */
        this.completeOnFocus = false;
        /**
         * Wbudowany styl nadany elementowi.
         * @type string
         * @default null
         */
        this.style = null;
        /**
         * Wbudowany styl dla inputu.
         * @type string
         * @default null
         */
        this.inputStyle = null;
        /**
         * Wbudowany styl dla panelu sugestii.
         * @type string
         * @default null
         */
        this.panelStyle = null;
        /**
         * Określa klasę stylu dla elementu.
         * @type string
         * @default null
         */
        this.styleClass = null;
        /**
         * Klasa stylistyczna komponentu.
         * @type string
         * @default null
         */
        this.inputStyleClass = null;
        /**
         * Klasa stylistyczna panelu sugestii.
         * @type string
         * @default null
         */
        this.panelStyleClass = null;
        /**
         * Określa jakie ID ma być nadane inputowi.
         * Jeśli zostawione puste to będzie nadane wygenerowane ID.
         * @type string
         * @default null
         */
        this.inputId = null;
        /**
         * Określa nazwę inputu
         * @type string
         * @default null
         */
        this.name = null;
        /**
         * Określa podpowiedź do tego, jakiej wartości spodziewamy się w inpucie
         * @type string
         * @default null
         */
        this.placeholder = null;
        /**
         * Określa, czy input ma być tylko do odczytu
         * @type boolean
         * @default false
         */
        this.readonly = false;
        /**
         * Maksymalna liczba znaków dozwolona w polu wejściowym.
         * @type number
         * @default null
         */
        this.maxlength = null;
        /**
         * Określa tab index elementu
         * @type number
         * @default null
         */
        this.tabindex = null;
        /**
         * Parametr umożliwiający jednoznaczną identyfikację wartości w opcjach.
         * @type string
         * @default null
         */
        this.dataKey = null;
        /**
         * Po włączeniu, domyślnie zaznacza pierwszą pozycję na liście.
         * @type boolean
         * @default false
         */
        this.autoHighlight = false;
        /**
         * Typ wejścia.
         * @type string
         * @default 'text'
         */
        this.type = 'text';
        /**
         * Komunikat do wyświetlania, gdy nie ma wyników dla zapytania.
         * @type string
         * @default null
         */
        this.emptyMessage = null;
        /**
         * Określa, czy input jest wymagany aby przesłać formularz
         * @type boolean
         * @default false
         */
        this.required = false;
        /**
         * Określa, czy input ma dostać automatycznie focus po załadowaniu się strony
         * @type boolean
         * @default false
         */
        this.autofocus = false;
        /**
         * Gdy jest włączone, autouzupełnianie skasuje ręcznie wprowadzone dane, jeśli nie odpowiadają one sugestiom, aby wymusić akceptowanie jedynie wartości z sugestii.
         * @type boolean
         * @default false
         */
        this.forceSelection = false;
        /**
         * Określa zachowanie przycisku dropdownu. 'blank' - jako zapytanie wysyła pusty napis, 'current' - wysyła aktualną wartość na wejściu.
         * @type 'blank' | 'current'
         * @default 'current'
         */
        this.dropdownMode = 'current';
        /**
         * Określa bazowy zIndex do użycia przy warstwowaniu.
         * @type number
         * @default 0
         */
        this.baseZIndex = 0;
        /**
         * Określa czy automatycznie zarządzać warstwowaniem
         * @type boolean
         * @default true
         * */
        this.autoZIndex = true;
        /**
         * Animacja przejścia, która jest przy pojawianiu się panelu kalendarza.
         * @type string
         * @default '.12s cubic-bezier(0, 0, 0.2, 1)'
         */
        this.showTransitionOptions = '.12s cubic-bezier(0, 0, 0.2, 1)';
        /**
         * Animacja przejścia, która jest przy chowaniu się panelu sugestii.
         * @type string
         * @default '.1s linear'
         */
        this.hideTransitionOptions = '.1s linear';
        /**
         * Definiuje napis oznaczający element pod kątem dostępności.
         * @type string
         * @default null
         */
        this.ariaLabel = null;
        /**
         * Określa jeden lub więcej ID w DOM, które oznaczają pole wprowadzania danych.
         * @type string
         * @default null
         */
        this.ariaLabelledBy = null;
        /**
         * Zapewnia niepowtarzalność wybranych elementów w trybie wielokrotnego wyboru.
         * @type boolean
         * @default true
         */
        this.unique = true;
        /**
         * Określa napis, który ma wypełniać automatycznie input.
         * @type string
         * @default null
         */
        this.autocomplete = null;
        /**
         * Określa, czy w inpucie po prawej stronie ma być ikona X, która po kliknięciu usuwa tekst w inpucie
         * @type boolean
         * @default true
         * */
        this.showClear = false;
        /**
         * Określa, czy dostępne opcje w dropdown i wybrana opcja jest wprowadzana wielkimi literami
         * @type boolean
         * @default false
         */
        this.capitalize = false;
        this.ngModelChange = new EventEmitter();
        this.onFocus = new EventEmitter();
        this.onBlur = new EventEmitter();
        this.onKeyUp = new EventEmitter();
        this.onSelect = new EventEmitter();
        this.onUnselect = new EventEmitter();
        this.onDropdownClick = new EventEmitter();
        this.onClear = new EventEmitter();
        this.onShow = new EventEmitter();
        this.onHide = new EventEmitter();
        this.isDisabled = false;
        this.subscriptions = [];
        this.onChange = () => { };
        this.onTouch = () => { };
    }
    clear() {
        if (this.isDisabled)
            return;
        this.ngModel = null;
        this.onChange(null);
        this.ngModelChange.emit(null);
    }
    focus() {
        this.autoCompleteComponent.focusInput();
    }
    ngAfterViewInit() {
        if (this.itemTemplateRef)
            this.autoCompleteComponent.itemTemplate = this.itemTemplateRef;
        if (this.selectedItemTemplateRef)
            this.autoCompleteComponent.selectedItemTemplate = this.selectedItemTemplateRef;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    writeValue(obj) {
        this.ngModel = obj;
    }
    _onFocus($event) {
        this.onFocus.emit($event);
    }
    ;
    _onBlur($event) {
        this.onBlur.emit($event);
    }
    _onKeyUp($event) {
        this.onKeyUp.emit($event);
    }
    _onSelect($event) {
        this.onSelect.emit($event);
    }
    _onUnselect($event) {
        this.onUnselect.emit($event);
    }
    _onDropdownClick($event) {
        this.onDropdownClick.emit($event);
    }
    _onClear($event) {
        this.onClear.emit($event);
    }
    _onShow($event) {
        this.onShow.emit($event);
    }
    _onHide($event) {
        this.onHide.emit($event);
    }
    set addSubscription(subscription) {
        this.subscriptions.push(subscription);
    }
    ngOnDestroy() {
        this.subscriptions
            .map(s => s.unsubscribe());
    }
    capitalizeInput(value) {
        return Utils.normalizeToUpper(value);
    }
}
AdresControlBase.ɵfac = function AdresControlBase_Factory(t) { return new (t || AdresControlBase)(); };
AdresControlBase.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AdresControlBase, selectors: [["ng-component"]], viewQuery: function AdresControlBase_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(AutoComplete, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.autoCompleteComponent = _t.first);
    } }, inputs: { width: "width", label: "label", scrollHeight: "scrollHeight", dropdown: "dropdown", multiple: "multiple", dropdownIcon: "dropdownIcon", minLength: "minLength", delay: "delay", completeOnFocus: "completeOnFocus", style: "style", inputStyle: "inputStyle", panelStyle: "panelStyle", styleClass: "styleClass", inputStyleClass: "inputStyleClass", panelStyleClass: "panelStyleClass", inputId: "inputId", name: "name", placeholder: "placeholder", readonly: "readonly", maxlength: "maxlength", tabindex: "tabindex", dataKey: "dataKey", autoHighlight: "autoHighlight", type: "type", emptyMessage: "emptyMessage", required: "required", autofocus: "autofocus", forceSelection: "forceSelection", dropdownMode: "dropdownMode", baseZIndex: "baseZIndex", autoZIndex: "autoZIndex", showTransitionOptions: "showTransitionOptions", hideTransitionOptions: "hideTransitionOptions", ariaLabel: "ariaLabel", ariaLabelledBy: "ariaLabelledBy", unique: "unique", autocomplete: "autocomplete", showClear: "showClear", capitalize: "capitalize", isDisabled: ["disabled", "isDisabled"], ngModel: "ngModel", iconRightTitle: "iconRightTitle", iconLeftTitle: "iconLeftTitle", iconLeft: "iconLeft", iconRight: "iconRight", itemTemplateRef: "itemTemplateRef", selectedItemTemplateRef: "selectedItemTemplateRef" }, outputs: { ngModelChange: "ngModelChange", onFocus: "onFocus", onBlur: "onBlur", onKeyUp: "onKeyUp", onSelect: "onSelect", onUnselect: "onUnselect", onDropdownClick: "onDropdownClick", onClear: "onClear", onShow: "onShow", onHide: "onHide" }, decls: 0, vars: 0, template: function AdresControlBase_Template(rf, ctx) { }, encapsulation: 2 });
AdresControlBase.ctorParameters = () => [];
AdresControlBase.propDecorators = {
    width: [{ type: Input }],
    label: [{ type: Input }],
    scrollHeight: [{ type: Input }],
    dropdown: [{ type: Input }],
    multiple: [{ type: Input }],
    dropdownIcon: [{ type: Input }],
    minLength: [{ type: Input }],
    delay: [{ type: Input }],
    completeOnFocus: [{ type: Input }],
    style: [{ type: Input }],
    inputStyle: [{ type: Input }],
    panelStyle: [{ type: Input }],
    styleClass: [{ type: Input }],
    inputStyleClass: [{ type: Input }],
    panelStyleClass: [{ type: Input }],
    inputId: [{ type: Input }],
    name: [{ type: Input }],
    placeholder: [{ type: Input }],
    readonly: [{ type: Input }],
    maxlength: [{ type: Input }],
    tabindex: [{ type: Input }],
    dataKey: [{ type: Input }],
    autoHighlight: [{ type: Input }],
    type: [{ type: Input }],
    emptyMessage: [{ type: Input }],
    required: [{ type: Input }],
    autofocus: [{ type: Input }],
    forceSelection: [{ type: Input }],
    dropdownMode: [{ type: Input }],
    baseZIndex: [{ type: Input }],
    autoZIndex: [{ type: Input }],
    showTransitionOptions: [{ type: Input }],
    hideTransitionOptions: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    ariaLabelledBy: [{ type: Input }],
    unique: [{ type: Input }],
    autocomplete: [{ type: Input }],
    showClear: [{ type: Input }],
    iconRightTitle: [{ type: Input }],
    iconLeftTitle: [{ type: Input }],
    iconLeft: [{ type: Input }],
    iconRight: [{ type: Input }],
    capitalize: [{ type: Input }],
    itemTemplateRef: [{ type: Input }],
    selectedItemTemplateRef: [{ type: Input }],
    ngModel: [{ type: Input }],
    ngModelChange: [{ type: Output }],
    onFocus: [{ type: Output }],
    onBlur: [{ type: Output }],
    onKeyUp: [{ type: Output }],
    onSelect: [{ type: Output }],
    onUnselect: [{ type: Output }],
    onDropdownClick: [{ type: Output }],
    onClear: [{ type: Output }],
    onShow: [{ type: Output }],
    onHide: [{ type: Output }],
    autoCompleteComponent: [{ type: ViewChild, args: [AutoComplete, { static: true },] }],
    isDisabled: [{ type: Input, args: ['disabled',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AdresControlBase, [{
        type: Component,
        args: [{ template: '' }]
    }], function () { return []; }, { width: [{
            type: Input
        }], label: [{
            type: Input
        }], scrollHeight: [{
            type: Input
        }], dropdown: [{
            type: Input
        }], multiple: [{
            type: Input
        }], dropdownIcon: [{
            type: Input
        }], minLength: [{
            type: Input
        }], delay: [{
            type: Input
        }], completeOnFocus: [{
            type: Input
        }], style: [{
            type: Input
        }], inputStyle: [{
            type: Input
        }], panelStyle: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], inputStyleClass: [{
            type: Input
        }], panelStyleClass: [{
            type: Input
        }], inputId: [{
            type: Input
        }], name: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], readonly: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], dataKey: [{
            type: Input
        }], autoHighlight: [{
            type: Input
        }], type: [{
            type: Input
        }], emptyMessage: [{
            type: Input
        }], required: [{
            type: Input
        }], autofocus: [{
            type: Input
        }], forceSelection: [{
            type: Input
        }], dropdownMode: [{
            type: Input
        }], baseZIndex: [{
            type: Input
        }], autoZIndex: [{
            type: Input
        }], showTransitionOptions: [{
            type: Input
        }], hideTransitionOptions: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], ariaLabelledBy: [{
            type: Input
        }], unique: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], showClear: [{
            type: Input
        }], capitalize: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], onFocus: [{
            type: Output
        }], onBlur: [{
            type: Output
        }], onKeyUp: [{
            type: Output
        }], onSelect: [{
            type: Output
        }], onUnselect: [{
            type: Output
        }], onDropdownClick: [{
            type: Output
        }], onClear: [{
            type: Output
        }], onShow: [{
            type: Output
        }], onHide: [{
            type: Output
        }], isDisabled: [{
            type: Input,
            args: ['disabled']
        }], ngModel: [{
            type: Input
        }], iconRightTitle: [{
            type: Input
        }], iconLeftTitle: [{
            type: Input
        }], iconLeft: [{
            type: Input
        }], iconRight: [{
            type: Input
        }], itemTemplateRef: [{
            type: Input
        }], selectedItemTemplateRef: [{
            type: Input
        }], autoCompleteComponent: [{
            type: ViewChild,
            args: [AutoComplete, { static: true }]
        }] }); })();

const MIASTO_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => DsMiastoComponent),
};
class DsMiastoComponent extends AdresControlBase {
    constructor(adresService) {
        super();
        this.adresService = adresService;
        this.cities = [];
    }
    ngOnInit() {
        if (this.inputId == null)
            this.inputId = Utils.wygenerujLosoweId();
        this.addSubscription = this.adresService
            .getLoadingCitiesObs()
            .subscribe(value => this.isLoading = value);
    }
    filter(event) {
        this.addSubscription = this.adresService
            .filterCities(event.query)
            .subscribe(response => this.cities = response);
    }
    onChangeValue(value) {
        if (this.capitalize) {
            value = this.capitalizeInput(value);
        }
        this.onChange(value);
        this.ngModel = value;
        this.adresService._cityFormControlValue = value;
    }
}
DsMiastoComponent.ɵfac = function DsMiastoComponent_Factory(t) { return new (t || DsMiastoComponent)(ɵngcc0.ɵɵdirectiveInject(AdresService)); };
DsMiastoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsMiastoComponent, selectors: [["ds-miasto"]], hostAttrs: [1, "ds-autocomplete"], hostVars: 2, hostBindings: function DsMiastoComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([MIASTO_VALUE_ACCESSOR]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 54, consts: [[1, "ds-autocomplete-label", 3, "for"], [1, "ds-autocomplete-wrapper"], [3, "title", "class", 4, "ngIf"], [3, "suggestions", "scrollHeight", "dropdown", "multiple", "dropdownIcon", "minLength", "delay", "completeOnFocus", "inputStyle", "panelStyle", "styleClass", "inputStyleClass", "panelStyleClass", "inputId", "name", "placeholder", "readonly", "disabled", "maxlength", "tabindex", "dataKey", "autoHighlight", "type", "emptyMessage", "required", "autofocus", "forceSelection", "dropdownMode", "baseZIndex", "autoZIndex", "showTransitionOptions", "hideTransitionOptions", "ariaLabel", "ariaLabelledBy", "unique", "autocomplete", "ngModel", "ngModelChange", "completeMethod", "onFocus", "onBlur", "onKeyUp", "onSelect", "onUnselect", "onDropdownClick", "onClear", "onShow", "onHide"], ["class", "pi pi-times ds-input-show-clear", 3, "tabindex", "icon-right", "is-disabled", "is-readonly", "click", "keydown.enter", 4, "ngIf"], [3, "class", "title", "click", 4, "ngIf"], [3, "title"], [1, "pi", "pi-times", "ds-input-show-clear", 3, "tabindex", "click", "keydown.enter"], [3, "title", "click"]], template: function DsMiastoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DsMiastoComponent_i_3_Template, 1, 4, "i", 2);
        ɵngcc0.ɵɵelementStart(4, "p-autoComplete", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsMiastoComponent_Template_p_autoComplete_ngModelChange_4_listener($event) { return ctx.onChangeValue($event); })("completeMethod", function DsMiastoComponent_Template_p_autoComplete_completeMethod_4_listener($event) { return ctx.filter($event); })("onFocus", function DsMiastoComponent_Template_p_autoComplete_onFocus_4_listener($event) { return ctx._onFocus($event); })("onBlur", function DsMiastoComponent_Template_p_autoComplete_onBlur_4_listener($event) { return ctx._onBlur($event); })("onKeyUp", function DsMiastoComponent_Template_p_autoComplete_onKeyUp_4_listener($event) { return ctx._onKeyUp($event); })("onSelect", function DsMiastoComponent_Template_p_autoComplete_onSelect_4_listener($event) { return ctx._onSelect($event); })("onUnselect", function DsMiastoComponent_Template_p_autoComplete_onUnselect_4_listener($event) { return ctx._onUnselect($event); })("onDropdownClick", function DsMiastoComponent_Template_p_autoComplete_onDropdownClick_4_listener($event) { return ctx._onDropdownClick($event); })("onClear", function DsMiastoComponent_Template_p_autoComplete_onClear_4_listener($event) { return ctx._onClear($event); })("onShow", function DsMiastoComponent_Template_p_autoComplete_onShow_4_listener($event) { return ctx._onShow($event); })("onHide", function DsMiastoComponent_Template_p_autoComplete_onHide_4_listener($event) { return ctx._onHide($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DsMiastoComponent_i_5_Template, 1, 7, "i", 4);
        ɵngcc0.ɵɵtemplate(6, DsMiastoComponent_i_6_Template, 1, 4, "i", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly)("has-left-icon", ctx.iconLeft)("has-right-icon", ctx.iconRight)("has-clear-icon", ctx.showClear)("is-disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("suggestions", ctx.cities)("scrollHeight", ctx.scrollHeight)("dropdown", ctx.dropdown)("multiple", ctx.multiple)("dropdownIcon", ctx.dropdownIcon)("minLength", ctx.minLength)("delay", ctx.delay)("completeOnFocus", ctx.completeOnFocus)("inputStyle", ctx.inputStyle)("panelStyle", ctx.panelStyle)("styleClass", ctx.styleClass)("inputStyleClass", ctx.inputStyleClass)("panelStyleClass", ctx.panelStyleClass)("inputId", ctx.inputId)("name", ctx.name)("placeholder", ctx.placeholder)("readonly", ctx.readonly)("disabled", ctx.isDisabled)("maxlength", ctx.maxlength)("tabindex", ctx.tabindex)("dataKey", ctx.dataKey)("autoHighlight", ctx.autoHighlight)("type", ctx.type)("emptyMessage", ctx.emptyMessage)("required", ctx.required)("autofocus", ctx.autofocus)("forceSelection", ctx.forceSelection)("dropdownMode", ctx.dropdownMode)("baseZIndex", ctx.baseZIndex)("autoZIndex", ctx.autoZIndex)("showTransitionOptions", ctx.showTransitionOptions)("hideTransitionOptions", ctx.hideTransitionOptions)("ariaLabel", ctx.ariaLabel)("ariaLabelledBy", ctx.ariaLabelledBy)("unique", ctx.unique)("autocomplete", ctx.autocomplete)("ngModel", ctx.ngModel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.AutoComplete, ɵngcc4.MaxLengthValidator, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], encapsulation: 2 });
DsMiastoComponent.ctorParameters = () => [
    { type: AdresService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsMiastoComponent, [{
        type: Component,
        args: [{
                selector: 'ds-miasto',
                template: `
      <label class="ds-autocomplete-label" [for]="inputId">{{label}}</label>
      <div class="ds-autocomplete-wrapper">
          <i
                  [title]="iconLeftTitle"
                  *ngIf="iconLeft"
                  class="pi {{iconLeft}} ds-input-icon-left"
          >
          </i>
          <p-autoComplete
                  [suggestions]="cities"
                  [scrollHeight]="scrollHeight"
                  [dropdown]="dropdown"
                  [multiple]="multiple"
                  [dropdownIcon]="dropdownIcon"
                  [minLength]="minLength"
                  [delay]="delay"
                  [completeOnFocus]="completeOnFocus"
                  [style]="style"
                  [inputStyle]="inputStyle"
                  [panelStyle]="panelStyle"
                  [styleClass]="styleClass"
                  [inputStyleClass]="inputStyleClass"
                  [panelStyleClass]="panelStyleClass"
                  [inputId]="inputId"
                  [name]="name"
                  [placeholder]="placeholder"
                  [readonly]="readonly"
                  [disabled]="isDisabled"
                  [maxlength]="maxlength"
                  [tabindex]="tabindex"
                  [dataKey]="dataKey"
                  [autoHighlight]="autoHighlight"
                  [type]="type"
                  [emptyMessage]="emptyMessage"
                  [required]="required"
                  [autofocus]="autofocus"
                  [forceSelection]="forceSelection"
                  [dropdownMode]="dropdownMode"
                  [baseZIndex]="baseZIndex"
                  [autoZIndex]="autoZIndex"
                  [showTransitionOptions]="showTransitionOptions"
                  [hideTransitionOptions]="hideTransitionOptions"
                  [ariaLabel]="ariaLabel"
                  [ariaLabelledBy]="ariaLabelledBy"
                  [unique]="unique"
                  [autocomplete]="autocomplete"
                  [ngModel]="ngModel"
                  [class.is-readonly]="readonly"
                  [class.has-left-icon]="iconLeft"
                  [class.has-right-icon]="iconRight"
                  [class.has-clear-icon]="showClear"
                  [class.is-disabled]="isDisabled"
                  (ngModelChange)="onChangeValue($event)"
                  (completeMethod)="filter($event)"
                  (onFocus)="_onFocus($event)"
                  (onBlur)="_onBlur($event)"
                  (onKeyUp)="_onKeyUp($event)"
                  (onSelect)="_onSelect($event)"
                  (onUnselect)="_onUnselect($event)"
                  (onDropdownClick)="_onDropdownClick($event)"
                  (onClear)="_onClear($event)"
                  (onShow)="_onShow($event)"
                  (onHide)="_onHide($event)"
          >
          </p-autoComplete>
          <i
                  class="pi pi-times ds-input-show-clear"
                  tabindex="{{ isDisabled || readonly ? '-1' : '0' }}"
                  *ngIf="showClear"
                  (click)="clear()"
                  (keydown.enter)="clear()"
                  [class.icon-right]="iconRight"
                  [class.is-disabled]="isDisabled"
                  [class.is-readonly]="readonly"
          >
          </i>
          <i
                  *ngIf="iconRight"
                  class="pi {{iconRight}} ds-input-icon-right"
                  [title]="iconRightTitle"
                  (click)="focus()"
          >
          </i>
      </div>
  `,
                host: {
                    'class': 'ds-autocomplete',
                    '[class.is-readonly]': 'readonly'
                },
                providers: [MIASTO_VALUE_ACCESSOR]
            }]
    }], function () { return [{ type: AdresService }]; }, null); })();

const ULICA_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => DsUlicaComponent),
};
class DsUlicaComponent extends AdresControlBase {
    constructor(adresService) {
        super();
        this.adresService = adresService;
        this.streets = [];
    }
    ngOnInit() {
        if (this.inputId == null)
            this.inputId = Utils.wygenerujLosoweId();
        this.addSubscription = this.adresService
            .getLoadingStreetsObs()
            .subscribe(value => this.isLoading = value);
    }
    filter(event) {
        this.addSubscription = this.adresService
            .filterStreets(event.query)
            .pipe(map(response => response.map(street => this.capitalize ? Utils.normalizeToUpper(street) : street)))
            .subscribe(response => this.streets = response);
    }
    onChangeValue(value) {
        if (this.capitalize) {
            value = this.capitalizeInput(value);
        }
        this.onChange(value);
        this.ngModel = value;
        this.adresService._streetFormControlValue = value;
    }
    ;
}
DsUlicaComponent.ɵfac = function DsUlicaComponent_Factory(t) { return new (t || DsUlicaComponent)(ɵngcc0.ɵɵdirectiveInject(AdresService)); };
DsUlicaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsUlicaComponent, selectors: [["ds-ulica"]], hostAttrs: [1, "ds-autocomplete"], hostVars: 2, hostBindings: function DsUlicaComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            ULICA_VALUE_ACCESSOR
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 57, consts: [[1, "ds-autocomplete-label", 3, "for"], [1, "ds-autocomplete-wrapper"], [3, "title", "class", 4, "ngIf"], [3, "suggestions", "scrollHeight", "dropdown", "multiple", "dropdownIcon", "minLength", "delay", "completeOnFocus", "inputStyle", "panelStyle", "styleClass", "inputStyleClass", "panelStyleClass", "inputId", "name", "placeholder", "readonly", "disabled", "maxlength", "tabindex", "dataKey", "autoHighlight", "type", "emptyMessage", "required", "autofocus", "forceSelection", "dropdownMode", "baseZIndex", "autoZIndex", "showTransitionOptions", "hideTransitionOptions", "ariaLabel", "ariaLabelledBy", "unique", "autocomplete", "ngModel", "ngStyle", "ngModelChange", "completeMethod", "onFocus", "onBlur", "onKeyUp", "onSelect", "onUnselect", "onDropdownClick", "onClear", "onShow", "onHide"], ["class", "pi pi-times ds-input-show-clear", 3, "tabindex", "icon-right", "is-disabled", "is-readonly", "click", "keydown.enter", 4, "ngIf"], [3, "class", "title", "click", 4, "ngIf"], [3, "title"], [1, "pi", "pi-times", "ds-input-show-clear", 3, "tabindex", "click", "keydown.enter"], [3, "title", "click"]], template: function DsUlicaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DsUlicaComponent_i_3_Template, 1, 4, "i", 2);
        ɵngcc0.ɵɵelementStart(4, "p-autoComplete", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsUlicaComponent_Template_p_autoComplete_ngModelChange_4_listener($event) { return ctx.onChangeValue($event); })("completeMethod", function DsUlicaComponent_Template_p_autoComplete_completeMethod_4_listener($event) { return ctx.filter($event); })("onFocus", function DsUlicaComponent_Template_p_autoComplete_onFocus_4_listener($event) { return ctx._onFocus($event); })("onBlur", function DsUlicaComponent_Template_p_autoComplete_onBlur_4_listener($event) { return ctx._onBlur($event); })("onKeyUp", function DsUlicaComponent_Template_p_autoComplete_onKeyUp_4_listener($event) { return ctx._onKeyUp($event); })("onSelect", function DsUlicaComponent_Template_p_autoComplete_onSelect_4_listener($event) { return ctx._onSelect($event); })("onUnselect", function DsUlicaComponent_Template_p_autoComplete_onUnselect_4_listener($event) { return ctx._onUnselect($event); })("onDropdownClick", function DsUlicaComponent_Template_p_autoComplete_onDropdownClick_4_listener($event) { return ctx._onDropdownClick($event); })("onClear", function DsUlicaComponent_Template_p_autoComplete_onClear_4_listener($event) { return ctx._onClear($event); })("onShow", function DsUlicaComponent_Template_p_autoComplete_onShow_4_listener($event) { return ctx._onShow($event); })("onHide", function DsUlicaComponent_Template_p_autoComplete_onHide_4_listener($event) { return ctx._onHide($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DsUlicaComponent_i_5_Template, 1, 7, "i", 4);
        ɵngcc0.ɵɵtemplate(6, DsUlicaComponent_i_6_Template, 1, 4, "i", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly)("has-left-icon", ctx.iconLeft)("has-right-icon", ctx.iconRight)("has-clear-icon", ctx.showClear)("is-disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("suggestions", ctx.streets)("scrollHeight", ctx.scrollHeight)("dropdown", ctx.dropdown)("multiple", ctx.multiple)("dropdownIcon", ctx.dropdownIcon)("minLength", ctx.minLength)("delay", ctx.delay)("completeOnFocus", ctx.completeOnFocus)("inputStyle", ctx.inputStyle)("panelStyle", ctx.panelStyle)("styleClass", ctx.styleClass)("inputStyleClass", ctx.inputStyleClass)("panelStyleClass", ctx.panelStyleClass)("inputId", ctx.inputId)("name", ctx.name)("placeholder", ctx.placeholder)("readonly", ctx.readonly)("disabled", ctx.isDisabled)("maxlength", ctx.maxlength)("tabindex", ctx.tabindex)("dataKey", ctx.dataKey)("autoHighlight", ctx.autoHighlight)("type", ctx.type)("emptyMessage", ctx.emptyMessage)("required", ctx.required)("autofocus", ctx.autofocus)("forceSelection", ctx.forceSelection)("dropdownMode", ctx.dropdownMode)("baseZIndex", ctx.baseZIndex)("autoZIndex", ctx.autoZIndex)("showTransitionOptions", ctx.showTransitionOptions)("hideTransitionOptions", ctx.hideTransitionOptions)("ariaLabel", ctx.ariaLabel)("ariaLabelledBy", ctx.ariaLabelledBy)("unique", ctx.unique)("autocomplete", ctx.autocomplete)("ngModel", ctx.ngModel)("ngStyle", ɵngcc0.ɵɵpureFunction1(55, _c0, ctx.width));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.AutoComplete, ɵngcc4.MaxLengthValidator, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc2.NgStyle], encapsulation: 2 });
DsUlicaComponent.ctorParameters = () => [
    { type: AdresService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsUlicaComponent, [{
        type: Component,
        args: [{
                selector: 'ds-ulica',
                template: `
      <label class="ds-autocomplete-label" [for]="inputId">{{label}}</label>
      <div class="ds-autocomplete-wrapper">
          <i
                  [title]="iconLeftTitle"
                  *ngIf="iconLeft"
                  class="pi {{iconLeft}} ds-input-icon-left"
          >
          </i>
          <p-autoComplete
                  [suggestions]="streets"
                  [scrollHeight]="scrollHeight"
                  [dropdown]="dropdown"
                  [multiple]="multiple"
                  [dropdownIcon]="dropdownIcon"
                  [minLength]="minLength"
                  [delay]="delay"
                  [completeOnFocus]="completeOnFocus"
                  [style]="style"
                  [inputStyle]="inputStyle"
                  [panelStyle]="panelStyle"
                  [styleClass]="styleClass"
                  [inputStyleClass]="inputStyleClass"
                  [panelStyleClass]="panelStyleClass"
                  [inputId]="inputId"
                  [name]="name"
                  [placeholder]="placeholder"
                  [readonly]="readonly"
                  [disabled]="isDisabled"
                  [maxlength]="maxlength"
                  [tabindex]="tabindex"
                  [dataKey]="dataKey"
                  [autoHighlight]="autoHighlight"
                  [type]="type"
                  [emptyMessage]="emptyMessage"
                  [required]="required"
                  [autofocus]="autofocus"
                  [forceSelection]="forceSelection"
                  [dropdownMode]="dropdownMode"
                  [baseZIndex]="baseZIndex"
                  [autoZIndex]="autoZIndex"
                  [showTransitionOptions]="showTransitionOptions"
                  [hideTransitionOptions]="hideTransitionOptions"
                  [ariaLabel]="ariaLabel"
                  [ariaLabelledBy]="ariaLabelledBy"
                  [unique]="unique"
                  [autocomplete]="autocomplete"
                  [ngModel]="ngModel"
                  [class.is-readonly]="readonly"
                  [class.has-left-icon]="iconLeft"
                  [class.has-right-icon]="iconRight"
                  [class.has-clear-icon]="showClear"
                  [class.is-disabled]="isDisabled"
                  (ngModelChange)="onChangeValue($event)"
                  (completeMethod)="filter($event)"
                  (onFocus)="_onFocus($event)"
                  (onBlur)="_onBlur($event)"
                  (onKeyUp)="_onKeyUp($event)"
                  (onSelect)="_onSelect($event)"
                  (onUnselect)="_onUnselect($event)"
                  (onDropdownClick)="_onDropdownClick($event)"
                  (onClear)="_onClear($event)"
                  (onShow)="_onShow($event)"
                  (onHide)="_onHide($event)"
                  [ngStyle]="{'width': width}"
          >
          </p-autoComplete>
          <i
                  class="pi pi-times ds-input-show-clear"
                  tabindex="{{ isDisabled || readonly ? '-1' : '0' }}"
                  *ngIf="showClear"
                  (click)="clear()"
                  (keydown.enter)="clear()"
                  [class.icon-right]="iconRight"
                  [class.is-disabled]="isDisabled"
                  [class.is-readonly]="readonly"
          >
          </i>
          <i
                  *ngIf="iconRight"
                  class="pi {{iconRight}} ds-input-icon-right"
                  [title]="iconRightTitle"
                  (click)="focus()"
          >
          </i>
      </div>
  `,
                host: {
                    'class': 'ds-autocomplete',
                    '[class.is-readonly]': 'readonly'
                },
                providers: [
                    ULICA_VALUE_ACCESSOR
                ]
            }]
    }], function () { return [{ type: AdresService }]; }, null); })();

const KOD_POCZTOWY_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => DsKodPocztowyComponent),
};
class DsKodPocztowyComponent extends AdresControlBase {
    constructor(adresService) {
        super();
        this.adresService = adresService;
        this.postalCodes = [];
    }
    ngOnInit() {
        if (this.inputId == undefined)
            this.inputId = Utils.wygenerujLosoweId();
        this.addSubscription = this.adresService
            .getLoadingPostalCodesObs()
            .subscribe(value => this.isLoading = value);
    }
    filter(event) {
        this.addSubscription = this.adresService
            .filterPostalCodes(event.query)
            .subscribe(response => this.postalCodes = response);
    }
    onChangeValue(value) {
        this.onChange(value);
        this.ngModel = value;
    }
}
DsKodPocztowyComponent.ɵfac = function DsKodPocztowyComponent_Factory(t) { return new (t || DsKodPocztowyComponent)(ɵngcc0.ɵɵdirectiveInject(AdresService)); };
DsKodPocztowyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsKodPocztowyComponent, selectors: [["ds-kod-pocztowy"]], hostAttrs: [1, "ds-autocomplete"], hostVars: 2, hostBindings: function DsKodPocztowyComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            KOD_POCZTOWY_VALUE_ACCESSOR
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 54, consts: [[1, "ds-autocomplete-label", 3, "for"], [1, "ds-autocomplete-wrapper"], [3, "title", "class", 4, "ngIf"], [3, "suggestions", "scrollHeight", "dropdown", "multiple", "dropdownIcon", "minLength", "delay", "completeOnFocus", "inputStyle", "panelStyle", "styleClass", "inputStyleClass", "panelStyleClass", "inputId", "name", "placeholder", "readonly", "disabled", "maxlength", "tabindex", "dataKey", "autoHighlight", "type", "emptyMessage", "required", "autofocus", "forceSelection", "dropdownMode", "baseZIndex", "autoZIndex", "showTransitionOptions", "hideTransitionOptions", "ariaLabel", "ariaLabelledBy", "unique", "autocomplete", "ngModel", "ngModelChange", "completeMethod", "onFocus", "onBlur", "onKeyUp", "onSelect", "onUnselect", "onDropdownClick", "onClear", "onShow", "onHide"], ["class", "pi pi-times ds-input-show-clear", 3, "tabindex", "icon-right", "is-disabled", "is-readonly", "click", "keydown.enter", 4, "ngIf"], [3, "class", "title", "click", 4, "ngIf"], [3, "title"], [1, "pi", "pi-times", "ds-input-show-clear", 3, "tabindex", "click", "keydown.enter"], [3, "title", "click"]], template: function DsKodPocztowyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DsKodPocztowyComponent_i_3_Template, 1, 4, "i", 2);
        ɵngcc0.ɵɵelementStart(4, "p-autoComplete", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsKodPocztowyComponent_Template_p_autoComplete_ngModelChange_4_listener($event) { return ctx.onChangeValue($event); })("completeMethod", function DsKodPocztowyComponent_Template_p_autoComplete_completeMethod_4_listener($event) { return ctx.filter($event); })("onFocus", function DsKodPocztowyComponent_Template_p_autoComplete_onFocus_4_listener($event) { return ctx._onFocus($event); })("onBlur", function DsKodPocztowyComponent_Template_p_autoComplete_onBlur_4_listener($event) { return ctx._onBlur($event); })("onKeyUp", function DsKodPocztowyComponent_Template_p_autoComplete_onKeyUp_4_listener($event) { return ctx._onKeyUp($event); })("onSelect", function DsKodPocztowyComponent_Template_p_autoComplete_onSelect_4_listener($event) { return ctx._onSelect($event); })("onUnselect", function DsKodPocztowyComponent_Template_p_autoComplete_onUnselect_4_listener($event) { return ctx._onUnselect($event); })("onDropdownClick", function DsKodPocztowyComponent_Template_p_autoComplete_onDropdownClick_4_listener($event) { return ctx._onDropdownClick($event); })("onClear", function DsKodPocztowyComponent_Template_p_autoComplete_onClear_4_listener($event) { return ctx._onClear($event); })("onShow", function DsKodPocztowyComponent_Template_p_autoComplete_onShow_4_listener($event) { return ctx._onShow($event); })("onHide", function DsKodPocztowyComponent_Template_p_autoComplete_onHide_4_listener($event) { return ctx._onHide($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DsKodPocztowyComponent_i_5_Template, 1, 7, "i", 4);
        ɵngcc0.ɵɵtemplate(6, DsKodPocztowyComponent_i_6_Template, 1, 4, "i", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly)("has-left-icon", ctx.iconLeft)("has-right-icon", ctx.iconRight)("has-clear-icon", ctx.showClear)("is-disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("suggestions", ctx.postalCodes)("scrollHeight", ctx.scrollHeight)("dropdown", ctx.dropdown)("multiple", ctx.multiple)("dropdownIcon", ctx.dropdownIcon)("minLength", ctx.minLength)("delay", ctx.delay)("completeOnFocus", ctx.completeOnFocus)("inputStyle", ctx.inputStyle)("panelStyle", ctx.panelStyle)("styleClass", ctx.styleClass)("inputStyleClass", ctx.inputStyleClass)("panelStyleClass", ctx.panelStyleClass)("inputId", ctx.inputId)("name", ctx.name)("placeholder", ctx.placeholder)("readonly", ctx.readonly)("disabled", ctx.isDisabled)("maxlength", ctx.maxlength)("tabindex", ctx.tabindex)("dataKey", ctx.dataKey)("autoHighlight", ctx.autoHighlight)("type", ctx.type)("emptyMessage", ctx.emptyMessage)("required", ctx.required)("autofocus", ctx.autofocus)("forceSelection", ctx.forceSelection)("dropdownMode", ctx.dropdownMode)("baseZIndex", ctx.baseZIndex)("autoZIndex", ctx.autoZIndex)("showTransitionOptions", ctx.showTransitionOptions)("hideTransitionOptions", ctx.hideTransitionOptions)("ariaLabel", ctx.ariaLabel)("ariaLabelledBy", ctx.ariaLabelledBy)("unique", ctx.unique)("autocomplete", ctx.autocomplete)("ngModel", ctx.ngModel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.AutoComplete, ɵngcc4.MaxLengthValidator, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], encapsulation: 2 });
DsKodPocztowyComponent.ctorParameters = () => [
    { type: AdresService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsKodPocztowyComponent, [{
        type: Component,
        args: [{
                selector: 'ds-kod-pocztowy',
                template: `
      <label class="ds-autocomplete-label" [for]="inputId">{{label}}</label>
      <div class="ds-autocomplete-wrapper">
          <i
                  [title]="iconLeftTitle"
                  *ngIf="iconLeft"
                  class="pi {{iconLeft}} ds-input-icon-left"
          >
          </i>
          <p-autoComplete
                  [suggestions]="postalCodes"
                  [scrollHeight]="scrollHeight"
                  [dropdown]="dropdown"
                  [multiple]="multiple"
                  [dropdownIcon]="dropdownIcon"
                  [minLength]="minLength"
                  [delay]="delay"
                  [completeOnFocus]="completeOnFocus"
                  [style]="style"
                  [inputStyle]="inputStyle"
                  [panelStyle]="panelStyle"
                  [styleClass]="styleClass"
                  [inputStyleClass]="inputStyleClass"
                  [panelStyleClass]="panelStyleClass"
                  [inputId]="inputId"
                  [name]="name"
                  [placeholder]="placeholder"
                  [readonly]="readonly"
                  [disabled]="isDisabled"
                  [maxlength]="maxlength"
                  [tabindex]="tabindex"
                  [dataKey]="dataKey"
                  [autoHighlight]="autoHighlight"
                  [type]="type"
                  [emptyMessage]="emptyMessage"
                  [required]="required"
                  [autofocus]="autofocus"
                  [forceSelection]="forceSelection"
                  [dropdownMode]="dropdownMode"
                  [baseZIndex]="baseZIndex"
                  [autoZIndex]="autoZIndex"
                  [showTransitionOptions]="showTransitionOptions"
                  [hideTransitionOptions]="hideTransitionOptions"
                  [ariaLabel]="ariaLabel"
                  [ariaLabelledBy]="ariaLabelledBy"
                  [unique]="unique"
                  [autocomplete]="autocomplete"
                  [ngModel]="ngModel"
                  [class.is-readonly]="readonly"
                  [class.has-left-icon]="iconLeft"
                  [class.has-right-icon]="iconRight"
                  [class.has-clear-icon]="showClear"
                  [class.is-disabled]="isDisabled"
                  (ngModelChange)="onChangeValue($event)"
                  (completeMethod)="filter($event)"
                  (onFocus)="_onFocus($event)"
                  (onBlur)="_onBlur($event)"
                  (onKeyUp)="_onKeyUp($event)"
                  (onSelect)="_onSelect($event)"
                  (onUnselect)="_onUnselect($event)"
                  (onDropdownClick)="_onDropdownClick($event)"
                  (onClear)="_onClear($event)"
                  (onShow)="_onShow($event)"
                  (onHide)="_onHide($event)"
          >
          </p-autoComplete>
          <i
                  class="pi pi-times ds-input-show-clear"
                  tabindex="{{ isDisabled || readonly ? '-1' : '0' }}"
                  *ngIf="showClear"
                  (click)="clear()"
                  (keydown.enter)="clear()"
                  [class.icon-right]="iconRight"
                  [class.is-disabled]="isDisabled"
                  [class.is-readonly]="readonly"
          >
          </i>
          <i
                  *ngIf="iconRight"
                  class="pi {{iconRight}} ds-input-icon-right"
                  [title]="iconRightTitle"
                  (click)="focus()"
          >
          </i>
      </div>
  `,
                host: {
                    'class': 'ds-autocomplete',
                    '[class.is-readonly]': 'readonly'
                },
                providers: [
                    KOD_POCZTOWY_VALUE_ACCESSOR
                ]
            }]
    }], function () { return [{ type: AdresService }]; }, null); })();

const WOJEWODZTWO_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => DsWojewodztwoComponent),
};
class DsWojewodztwoComponent extends AdresControlBase {
    constructor(adresService) {
        super();
        this.adresService = adresService;
        this.voivodeships = [];
    }
    ngOnInit() {
        if (this.inputId == null)
            this.inputId = Utils.wygenerujLosoweId();
        this.addSubscription = this.adresService
            .getLoadingVoivodeshipsObs()
            .subscribe(value => this.isLoading = value);
    }
    filter(event) {
        this.addSubscription = this.adresService
            .filterVoivodeships(event.query)
            .pipe(map(response => response.map(voivodeship => this.capitalize ? Utils.normalizeToUpper(voivodeship) : voivodeship)))
            .subscribe(response => this.voivodeships = response);
    }
    onChangeValue(value) {
        if (this.capitalize) {
            value = this.capitalizeInput(value);
        }
        this.onChange(value);
        this.ngModel = value;
        this.adresService._voivodeshipFormControlValue = value;
    }
    ;
}
DsWojewodztwoComponent.ɵfac = function DsWojewodztwoComponent_Factory(t) { return new (t || DsWojewodztwoComponent)(ɵngcc0.ɵɵdirectiveInject(AdresService)); };
DsWojewodztwoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsWojewodztwoComponent, selectors: [["ds-wojewodztwo"]], hostAttrs: [1, "ds-autocomplete"], hostVars: 2, hostBindings: function DsWojewodztwoComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            WOJEWODZTWO_VALUE_ACCESSOR
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 54, consts: [[1, "ds-autocomplete-label", 3, "for"], [1, "ds-autocomplete-wrapper"], [3, "title", "class", 4, "ngIf"], [3, "suggestions", "scrollHeight", "dropdown", "multiple", "dropdownIcon", "minLength", "delay", "completeOnFocus", "inputStyle", "panelStyle", "styleClass", "inputStyleClass", "panelStyleClass", "inputId", "name", "placeholder", "readonly", "disabled", "maxlength", "tabindex", "dataKey", "autoHighlight", "type", "emptyMessage", "required", "autofocus", "forceSelection", "dropdownMode", "baseZIndex", "autoZIndex", "showTransitionOptions", "hideTransitionOptions", "ariaLabel", "ariaLabelledBy", "unique", "autocomplete", "ngModel", "ngModelChange", "completeMethod", "onFocus", "onBlur", "onKeyUp", "onSelect", "onUnselect", "onDropdownClick", "onClear", "onShow", "onHide"], ["class", "pi pi-times ds-input-show-clear", 3, "tabindex", "icon-right", "is-disabled", "is-readonly", "click", "keydown.enter", 4, "ngIf"], [3, "class", "title", "click", 4, "ngIf"], [3, "title"], [1, "pi", "pi-times", "ds-input-show-clear", 3, "tabindex", "click", "keydown.enter"], [3, "title", "click"]], template: function DsWojewodztwoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DsWojewodztwoComponent_i_3_Template, 1, 4, "i", 2);
        ɵngcc0.ɵɵelementStart(4, "p-autoComplete", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsWojewodztwoComponent_Template_p_autoComplete_ngModelChange_4_listener($event) { return ctx.onChangeValue($event); })("completeMethod", function DsWojewodztwoComponent_Template_p_autoComplete_completeMethod_4_listener($event) { return ctx.filter($event); })("onFocus", function DsWojewodztwoComponent_Template_p_autoComplete_onFocus_4_listener($event) { return ctx._onFocus($event); })("onBlur", function DsWojewodztwoComponent_Template_p_autoComplete_onBlur_4_listener($event) { return ctx._onBlur($event); })("onKeyUp", function DsWojewodztwoComponent_Template_p_autoComplete_onKeyUp_4_listener($event) { return ctx._onKeyUp($event); })("onSelect", function DsWojewodztwoComponent_Template_p_autoComplete_onSelect_4_listener($event) { return ctx._onSelect($event); })("onUnselect", function DsWojewodztwoComponent_Template_p_autoComplete_onUnselect_4_listener($event) { return ctx._onUnselect($event); })("onDropdownClick", function DsWojewodztwoComponent_Template_p_autoComplete_onDropdownClick_4_listener($event) { return ctx._onDropdownClick($event); })("onClear", function DsWojewodztwoComponent_Template_p_autoComplete_onClear_4_listener($event) { return ctx._onClear($event); })("onShow", function DsWojewodztwoComponent_Template_p_autoComplete_onShow_4_listener($event) { return ctx._onShow($event); })("onHide", function DsWojewodztwoComponent_Template_p_autoComplete_onHide_4_listener($event) { return ctx._onHide($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DsWojewodztwoComponent_i_5_Template, 1, 7, "i", 4);
        ɵngcc0.ɵɵtemplate(6, DsWojewodztwoComponent_i_6_Template, 1, 4, "i", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly)("has-left-icon", ctx.iconLeft)("has-right-icon", ctx.iconRight)("has-clear-icon", ctx.showClear)("is-disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("suggestions", ctx.voivodeships)("scrollHeight", ctx.scrollHeight)("dropdown", ctx.dropdown)("multiple", ctx.multiple)("dropdownIcon", ctx.dropdownIcon)("minLength", ctx.minLength)("delay", ctx.delay)("completeOnFocus", ctx.completeOnFocus)("inputStyle", ctx.inputStyle)("panelStyle", ctx.panelStyle)("styleClass", ctx.styleClass)("inputStyleClass", ctx.inputStyleClass)("panelStyleClass", ctx.panelStyleClass)("inputId", ctx.inputId)("name", ctx.name)("placeholder", ctx.placeholder)("readonly", ctx.readonly)("disabled", ctx.isDisabled)("maxlength", ctx.maxlength)("tabindex", ctx.tabindex)("dataKey", ctx.dataKey)("autoHighlight", ctx.autoHighlight)("type", ctx.type)("emptyMessage", ctx.emptyMessage)("required", ctx.required)("autofocus", ctx.autofocus)("forceSelection", ctx.forceSelection)("dropdownMode", ctx.dropdownMode)("baseZIndex", ctx.baseZIndex)("autoZIndex", ctx.autoZIndex)("showTransitionOptions", ctx.showTransitionOptions)("hideTransitionOptions", ctx.hideTransitionOptions)("ariaLabel", ctx.ariaLabel)("ariaLabelledBy", ctx.ariaLabelledBy)("unique", ctx.unique)("autocomplete", ctx.autocomplete)("ngModel", ctx.ngModel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.AutoComplete, ɵngcc4.MaxLengthValidator, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], encapsulation: 2 });
DsWojewodztwoComponent.ctorParameters = () => [
    { type: AdresService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsWojewodztwoComponent, [{
        type: Component,
        args: [{
                selector: 'ds-wojewodztwo',
                template: `
      <label class="ds-autocomplete-label" [for]="inputId">{{label}}</label>
      <div class="ds-autocomplete-wrapper">
          <i
                  [title]="iconLeftTitle"
                  *ngIf="iconLeft"
                  class="pi {{iconLeft}} ds-input-icon-left"
          >
          </i>
          <p-autoComplete
                  [suggestions]="voivodeships"
                  [scrollHeight]="scrollHeight"
                  [dropdown]="dropdown"
                  [multiple]="multiple"
                  [dropdownIcon]="dropdownIcon"
                  [minLength]="minLength"
                  [delay]="delay"
                  [completeOnFocus]="completeOnFocus"
                  [style]="style"
                  [inputStyle]="inputStyle"
                  [panelStyle]="panelStyle"
                  [styleClass]="styleClass"
                  [inputStyleClass]="inputStyleClass"
                  [panelStyleClass]="panelStyleClass"
                  [inputId]="inputId"
                  [name]="name"
                  [placeholder]="placeholder"
                  [readonly]="readonly"
                  [disabled]="isDisabled"
                  [maxlength]="maxlength"
                  [tabindex]="tabindex"
                  [dataKey]="dataKey"
                  [autoHighlight]="autoHighlight"
                  [type]="type"
                  [emptyMessage]="emptyMessage"
                  [required]="required"
                  [autofocus]="autofocus"
                  [forceSelection]="forceSelection"
                  [dropdownMode]="dropdownMode"
                  [baseZIndex]="baseZIndex"
                  [autoZIndex]="autoZIndex"
                  [showTransitionOptions]="showTransitionOptions"
                  [hideTransitionOptions]="hideTransitionOptions"
                  [ariaLabel]="ariaLabel"
                  [ariaLabelledBy]="ariaLabelledBy"
                  [unique]="unique"
                  [autocomplete]="autocomplete"
                  [ngModel]="ngModel"
                  [class.is-readonly]="readonly"
                  [class.has-left-icon]="iconLeft"
                  [class.has-right-icon]="iconRight"
                  [class.has-clear-icon]="showClear"
                  [class.is-disabled]="isDisabled"
                  (ngModelChange)="onChangeValue($event)"
                  (completeMethod)="filter($event)"
                  (onFocus)="_onFocus($event)"
                  (onBlur)="_onBlur($event)"
                  (onKeyUp)="_onKeyUp($event)"
                  (onSelect)="_onSelect($event)"
                  (onUnselect)="_onUnselect($event)"
                  (onDropdownClick)="_onDropdownClick($event)"
                  (onClear)="_onClear($event)"
                  (onShow)="_onShow($event)"
                  (onHide)="_onHide($event)"
          >
          </p-autoComplete>
          <i
                  class="pi pi-times ds-input-show-clear"
                  tabindex="{{ isDisabled || readonly ? '-1' : '0' }}"
                  *ngIf="showClear"
                  (click)="clear()"
                  (keydown.enter)="clear()"
                  [class.icon-right]="iconRight"
                  [class.is-disabled]="isDisabled"
                  [class.is-readonly]="readonly"
          >
          </i>
          <i
                  *ngIf="iconRight"
                  class="pi {{iconRight}} ds-input-icon-right"
                  [title]="iconRightTitle"
                  (click)="focus()"
          >
          </i>
      </div>
  `,
                host: {
                    'class': 'ds-autocomplete',
                    '[class.is-readonly]': 'readonly'
                },
                providers: [
                    WOJEWODZTWO_VALUE_ACCESSOR
                ]
            }]
    }], function () { return [{ type: AdresService }]; }, null); })();

const POWIAT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => DsPowiatComponent),
};
class DsPowiatComponent extends AdresControlBase {
    constructor(adresService) {
        super();
        this.adresService = adresService;
        this.counties = [];
    }
    ngOnInit() {
        if (this.inputId == null)
            this.inputId = Utils.wygenerujLosoweId();
        this.addSubscription = this.adresService
            .getLoadingCountiesObs()
            .subscribe(value => this.isLoading = value);
    }
    filter(event) {
        this.addSubscription = this.adresService
            .filterCounties(event.query)
            .pipe(map(response => response.map(county => this.capitalize ? Utils.normalizeToUpper(county) : county)))
            .subscribe(response => this.counties = response);
    }
    onChangeValue(value) {
        if (this.capitalize) {
            value = this.capitalizeInput(value);
        }
        this.onChange(value);
        this.ngModel = value;
        this.adresService._countyFormControlValue = value;
    }
    ;
}
DsPowiatComponent.ɵfac = function DsPowiatComponent_Factory(t) { return new (t || DsPowiatComponent)(ɵngcc0.ɵɵdirectiveInject(AdresService)); };
DsPowiatComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsPowiatComponent, selectors: [["ds-powiat"]], hostAttrs: [1, "ds-autocomplete"], hostVars: 2, hostBindings: function DsPowiatComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            POWIAT_VALUE_ACCESSOR
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 54, consts: [[1, "ds-autocomplete-label", 3, "for"], [1, "ds-autocomplete-wrapper"], [3, "title", "class", 4, "ngIf"], [3, "suggestions", "scrollHeight", "dropdown", "multiple", "dropdownIcon", "minLength", "delay", "completeOnFocus", "inputStyle", "panelStyle", "styleClass", "inputStyleClass", "panelStyleClass", "inputId", "name", "placeholder", "readonly", "disabled", "maxlength", "tabindex", "dataKey", "autoHighlight", "type", "emptyMessage", "required", "autofocus", "forceSelection", "dropdownMode", "baseZIndex", "autoZIndex", "showTransitionOptions", "hideTransitionOptions", "ariaLabel", "ariaLabelledBy", "unique", "autocomplete", "ngModel", "ngModelChange", "completeMethod", "onFocus", "onBlur", "onKeyUp", "onSelect", "onUnselect", "onDropdownClick", "onClear", "onShow", "onHide"], ["class", "pi pi-times ds-input-show-clear", 3, "tabindex", "icon-right", "is-disabled", "is-readonly", "click", "keydown.enter", 4, "ngIf"], [3, "class", "title", "click", 4, "ngIf"], [3, "title"], [1, "pi", "pi-times", "ds-input-show-clear", 3, "tabindex", "click", "keydown.enter"], [3, "title", "click"]], template: function DsPowiatComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DsPowiatComponent_i_3_Template, 1, 4, "i", 2);
        ɵngcc0.ɵɵelementStart(4, "p-autoComplete", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsPowiatComponent_Template_p_autoComplete_ngModelChange_4_listener($event) { return ctx.onChangeValue($event); })("completeMethod", function DsPowiatComponent_Template_p_autoComplete_completeMethod_4_listener($event) { return ctx.filter($event); })("onFocus", function DsPowiatComponent_Template_p_autoComplete_onFocus_4_listener($event) { return ctx._onFocus($event); })("onBlur", function DsPowiatComponent_Template_p_autoComplete_onBlur_4_listener($event) { return ctx._onBlur($event); })("onKeyUp", function DsPowiatComponent_Template_p_autoComplete_onKeyUp_4_listener($event) { return ctx._onKeyUp($event); })("onSelect", function DsPowiatComponent_Template_p_autoComplete_onSelect_4_listener($event) { return ctx._onSelect($event); })("onUnselect", function DsPowiatComponent_Template_p_autoComplete_onUnselect_4_listener($event) { return ctx._onUnselect($event); })("onDropdownClick", function DsPowiatComponent_Template_p_autoComplete_onDropdownClick_4_listener($event) { return ctx._onDropdownClick($event); })("onClear", function DsPowiatComponent_Template_p_autoComplete_onClear_4_listener($event) { return ctx._onClear($event); })("onShow", function DsPowiatComponent_Template_p_autoComplete_onShow_4_listener($event) { return ctx._onShow($event); })("onHide", function DsPowiatComponent_Template_p_autoComplete_onHide_4_listener($event) { return ctx._onHide($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DsPowiatComponent_i_5_Template, 1, 7, "i", 4);
        ɵngcc0.ɵɵtemplate(6, DsPowiatComponent_i_6_Template, 1, 4, "i", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly)("has-left-icon", ctx.iconLeft)("has-right-icon", ctx.iconRight)("has-clear-icon", ctx.showClear)("is-disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("suggestions", ctx.counties)("scrollHeight", ctx.scrollHeight)("dropdown", ctx.dropdown)("multiple", ctx.multiple)("dropdownIcon", ctx.dropdownIcon)("minLength", ctx.minLength)("delay", ctx.delay)("completeOnFocus", ctx.completeOnFocus)("inputStyle", ctx.inputStyle)("panelStyle", ctx.panelStyle)("styleClass", ctx.styleClass)("inputStyleClass", ctx.inputStyleClass)("panelStyleClass", ctx.panelStyleClass)("inputId", ctx.inputId)("name", ctx.name)("placeholder", ctx.placeholder)("readonly", ctx.readonly)("disabled", ctx.isDisabled)("maxlength", ctx.maxlength)("tabindex", ctx.tabindex)("dataKey", ctx.dataKey)("autoHighlight", ctx.autoHighlight)("type", ctx.type)("emptyMessage", ctx.emptyMessage)("required", ctx.required)("autofocus", ctx.autofocus)("forceSelection", ctx.forceSelection)("dropdownMode", ctx.dropdownMode)("baseZIndex", ctx.baseZIndex)("autoZIndex", ctx.autoZIndex)("showTransitionOptions", ctx.showTransitionOptions)("hideTransitionOptions", ctx.hideTransitionOptions)("ariaLabel", ctx.ariaLabel)("ariaLabelledBy", ctx.ariaLabelledBy)("unique", ctx.unique)("autocomplete", ctx.autocomplete)("ngModel", ctx.ngModel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.AutoComplete, ɵngcc4.MaxLengthValidator, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], encapsulation: 2 });
DsPowiatComponent.ctorParameters = () => [
    { type: AdresService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsPowiatComponent, [{
        type: Component,
        args: [{
                selector: 'ds-powiat',
                template: `
      <label class="ds-autocomplete-label" [for]="inputId">{{label}}</label>
      <div class="ds-autocomplete-wrapper">
          <i
                  [title]="iconLeftTitle"
                  *ngIf="iconLeft"
                  class="pi {{iconLeft}} ds-input-icon-left"
          >
          </i>
          <p-autoComplete
                  [suggestions]="counties"
                  [scrollHeight]="scrollHeight"
                  [dropdown]="dropdown"
                  [multiple]="multiple"
                  [dropdownIcon]="dropdownIcon"
                  [minLength]="minLength"
                  [delay]="delay"
                  [completeOnFocus]="completeOnFocus"
                  [style]="style"
                  [inputStyle]="inputStyle"
                  [panelStyle]="panelStyle"
                  [styleClass]="styleClass"
                  [inputStyleClass]="inputStyleClass"
                  [panelStyleClass]="panelStyleClass"
                  [inputId]="inputId"
                  [name]="name"
                  [placeholder]="placeholder"
                  [readonly]="readonly"
                  [disabled]="isDisabled"
                  [maxlength]="maxlength"
                  [tabindex]="tabindex"
                  [dataKey]="dataKey"
                  [autoHighlight]="autoHighlight"
                  [type]="type"
                  [emptyMessage]="emptyMessage"
                  [required]="required"
                  [autofocus]="autofocus"
                  [forceSelection]="forceSelection"
                  [dropdownMode]="dropdownMode"
                  [baseZIndex]="baseZIndex"
                  [autoZIndex]="autoZIndex"
                  [showTransitionOptions]="showTransitionOptions"
                  [hideTransitionOptions]="hideTransitionOptions"
                  [ariaLabel]="ariaLabel"
                  [ariaLabelledBy]="ariaLabelledBy"
                  [unique]="unique"
                  [autocomplete]="autocomplete"
                  [ngModel]="ngModel"
                  [class.is-readonly]="readonly"
                  [class.has-left-icon]="iconLeft"
                  [class.has-right-icon]="iconRight"
                  [class.has-clear-icon]="showClear"
                  [class.is-disabled]="isDisabled"
                  (ngModelChange)="onChangeValue($event)"
                  (completeMethod)="filter($event)"
                  (onFocus)="_onFocus($event)"
                  (onBlur)="_onBlur($event)"
                  (onKeyUp)="_onKeyUp($event)"
                  (onSelect)="_onSelect($event)"
                  (onUnselect)="_onUnselect($event)"
                  (onDropdownClick)="_onDropdownClick($event)"
                  (onClear)="_onClear($event)"
                  (onShow)="_onShow($event)"
                  (onHide)="_onHide($event)"
          >
          </p-autoComplete>
          <i
                  class="pi pi-times ds-input-show-clear"
                  tabindex="{{ isDisabled || readonly ? '-1' : '0' }}"
                  *ngIf="showClear"
                  (click)="clear()"
                  (keydown.enter)="clear()"
                  [class.icon-right]="iconRight"
                  [class.is-disabled]="isDisabled"
                  [class.is-readonly]="readonly"
          >
          </i>
          <i
                  *ngIf="iconRight"
                  class="pi {{iconRight}} ds-input-icon-right"
                  [title]="iconRightTitle"
                  (click)="focus()"
          >
          </i>
      </div>
  `,
                host: {
                    'class': 'ds-autocomplete',
                    '[class.is-readonly]': 'readonly'
                },
                providers: [
                    POWIAT_VALUE_ACCESSOR
                ]
            }]
    }], function () { return [{ type: AdresService }]; }, null); })();

const GMINA_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => DsGminaComponent),
};
class DsGminaComponent extends AdresControlBase {
    constructor(adresService) {
        super();
        this.adresService = adresService;
        this.boroughs = [];
    }
    ngOnInit() {
        if (this.inputId == null)
            this.inputId = Utils.wygenerujLosoweId();
        this.addSubscription = this.adresService
            .getLoadingBoroughsObs()
            .subscribe(value => this.isLoading = value);
    }
    filter(event) {
        this.addSubscription = this.adresService
            .filterBoroughs(event.query)
            .pipe(map(response => response.map(borough => this.capitalize ? Utils.normalizeToUpper(borough) : borough)))
            .subscribe(response => this.boroughs = response);
    }
    onChangeValue(value) {
        if (this.capitalize) {
            value = this.capitalizeInput(value);
        }
        this.onChange(value);
        this.ngModel = value;
        this.adresService._boroughFormControlValue = value;
    }
    ;
}
DsGminaComponent.ɵfac = function DsGminaComponent_Factory(t) { return new (t || DsGminaComponent)(ɵngcc0.ɵɵdirectiveInject(AdresService)); };
DsGminaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsGminaComponent, selectors: [["ds-gmina"]], hostAttrs: [1, "ds-autocomplete"], hostVars: 2, hostBindings: function DsGminaComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            GMINA_VALUE_ACCESSOR
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 54, consts: [[1, "ds-autocomplete-label", 3, "for"], [1, "ds-autocomplete-wrapper"], [3, "title", "class", 4, "ngIf"], [3, "suggestions", "scrollHeight", "dropdown", "multiple", "dropdownIcon", "minLength", "delay", "completeOnFocus", "inputStyle", "panelStyle", "styleClass", "inputStyleClass", "panelStyleClass", "inputId", "name", "placeholder", "readonly", "disabled", "maxlength", "tabindex", "dataKey", "autoHighlight", "type", "emptyMessage", "required", "autofocus", "forceSelection", "dropdownMode", "baseZIndex", "autoZIndex", "showTransitionOptions", "hideTransitionOptions", "ariaLabel", "ariaLabelledBy", "unique", "autocomplete", "ngModel", "ngModelChange", "completeMethod", "onFocus", "onBlur", "onKeyUp", "onSelect", "onUnselect", "onDropdownClick", "onClear", "onShow", "onHide"], ["class", "pi pi-times ds-input-show-clear", 3, "tabindex", "icon-right", "is-disabled", "is-readonly", "click", "keydown.enter", 4, "ngIf"], [3, "class", "title", "click", 4, "ngIf"], [3, "title"], [1, "pi", "pi-times", "ds-input-show-clear", 3, "tabindex", "click", "keydown.enter"], [3, "title", "click"]], template: function DsGminaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DsGminaComponent_i_3_Template, 1, 4, "i", 2);
        ɵngcc0.ɵɵelementStart(4, "p-autoComplete", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsGminaComponent_Template_p_autoComplete_ngModelChange_4_listener($event) { return ctx.onChangeValue($event); })("completeMethod", function DsGminaComponent_Template_p_autoComplete_completeMethod_4_listener($event) { return ctx.filter($event); })("onFocus", function DsGminaComponent_Template_p_autoComplete_onFocus_4_listener($event) { return ctx._onFocus($event); })("onBlur", function DsGminaComponent_Template_p_autoComplete_onBlur_4_listener($event) { return ctx._onBlur($event); })("onKeyUp", function DsGminaComponent_Template_p_autoComplete_onKeyUp_4_listener($event) { return ctx._onKeyUp($event); })("onSelect", function DsGminaComponent_Template_p_autoComplete_onSelect_4_listener($event) { return ctx._onSelect($event); })("onUnselect", function DsGminaComponent_Template_p_autoComplete_onUnselect_4_listener($event) { return ctx._onUnselect($event); })("onDropdownClick", function DsGminaComponent_Template_p_autoComplete_onDropdownClick_4_listener($event) { return ctx._onDropdownClick($event); })("onClear", function DsGminaComponent_Template_p_autoComplete_onClear_4_listener($event) { return ctx._onClear($event); })("onShow", function DsGminaComponent_Template_p_autoComplete_onShow_4_listener($event) { return ctx._onShow($event); })("onHide", function DsGminaComponent_Template_p_autoComplete_onHide_4_listener($event) { return ctx._onHide($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DsGminaComponent_i_5_Template, 1, 7, "i", 4);
        ɵngcc0.ɵɵtemplate(6, DsGminaComponent_i_6_Template, 1, 4, "i", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly)("has-left-icon", ctx.iconLeft)("has-right-icon", ctx.iconRight)("has-clear-icon", ctx.showClear)("is-disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("suggestions", ctx.boroughs)("scrollHeight", ctx.scrollHeight)("dropdown", ctx.dropdown)("multiple", ctx.multiple)("dropdownIcon", ctx.dropdownIcon)("minLength", ctx.minLength)("delay", ctx.delay)("completeOnFocus", ctx.completeOnFocus)("inputStyle", ctx.inputStyle)("panelStyle", ctx.panelStyle)("styleClass", ctx.styleClass)("inputStyleClass", ctx.inputStyleClass)("panelStyleClass", ctx.panelStyleClass)("inputId", ctx.inputId)("name", ctx.name)("placeholder", ctx.placeholder)("readonly", ctx.readonly)("disabled", ctx.isDisabled)("maxlength", ctx.maxlength)("tabindex", ctx.tabindex)("dataKey", ctx.dataKey)("autoHighlight", ctx.autoHighlight)("type", ctx.type)("emptyMessage", ctx.emptyMessage)("required", ctx.required)("autofocus", ctx.autofocus)("forceSelection", ctx.forceSelection)("dropdownMode", ctx.dropdownMode)("baseZIndex", ctx.baseZIndex)("autoZIndex", ctx.autoZIndex)("showTransitionOptions", ctx.showTransitionOptions)("hideTransitionOptions", ctx.hideTransitionOptions)("ariaLabel", ctx.ariaLabel)("ariaLabelledBy", ctx.ariaLabelledBy)("unique", ctx.unique)("autocomplete", ctx.autocomplete)("ngModel", ctx.ngModel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.AutoComplete, ɵngcc4.MaxLengthValidator, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], encapsulation: 2 });
DsGminaComponent.ctorParameters = () => [
    { type: AdresService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsGminaComponent, [{
        type: Component,
        args: [{
                selector: 'ds-gmina',
                template: `
      <label class="ds-autocomplete-label" [for]="inputId">{{label}}</label>
      <div class="ds-autocomplete-wrapper">
          <i
                  [title]="iconLeftTitle"
                  *ngIf="iconLeft"
                  class="pi {{iconLeft}} ds-input-icon-left"
          >
          </i>
          <p-autoComplete
                  [suggestions]="boroughs"
                  [scrollHeight]="scrollHeight"
                  [dropdown]="dropdown"
                  [multiple]="multiple"
                  [dropdownIcon]="dropdownIcon"
                  [minLength]="minLength"
                  [delay]="delay"
                  [completeOnFocus]="completeOnFocus"
                  [style]="style"
                  [inputStyle]="inputStyle"
                  [panelStyle]="panelStyle"
                  [styleClass]="styleClass"
                  [inputStyleClass]="inputStyleClass"
                  [panelStyleClass]="panelStyleClass"
                  [inputId]="inputId"
                  [name]="name"
                  [placeholder]="placeholder"
                  [readonly]="readonly"
                  [disabled]="isDisabled"
                  [maxlength]="maxlength"
                  [tabindex]="tabindex"
                  [dataKey]="dataKey"
                  [autoHighlight]="autoHighlight"
                  [type]="type"
                  [emptyMessage]="emptyMessage"
                  [required]="required"
                  [autofocus]="autofocus"
                  [forceSelection]="forceSelection"
                  [dropdownMode]="dropdownMode"
                  [baseZIndex]="baseZIndex"
                  [autoZIndex]="autoZIndex"
                  [showTransitionOptions]="showTransitionOptions"
                  [hideTransitionOptions]="hideTransitionOptions"
                  [ariaLabel]="ariaLabel"
                  [ariaLabelledBy]="ariaLabelledBy"
                  [unique]="unique"
                  [autocomplete]="autocomplete"
                  [ngModel]="ngModel"
                  [class.is-readonly]="readonly"
                  [class.has-left-icon]="iconLeft"
                  [class.has-right-icon]="iconRight"
                  [class.has-clear-icon]="showClear"
                  [class.is-disabled]="isDisabled"
                  (ngModelChange)="onChangeValue($event)"
                  (completeMethod)="filter($event)"
                  (onFocus)="_onFocus($event)"
                  (onBlur)="_onBlur($event)"
                  (onKeyUp)="_onKeyUp($event)"
                  (onSelect)="_onSelect($event)"
                  (onUnselect)="_onUnselect($event)"
                  (onDropdownClick)="_onDropdownClick($event)"
                  (onClear)="_onClear($event)"
                  (onShow)="_onShow($event)"
                  (onHide)="_onHide($event)"
          >
          </p-autoComplete>
          <i
                  class="pi pi-times ds-input-show-clear"
                  tabindex="{{ isDisabled || readonly ? '-1' : '0' }}"
                  *ngIf="showClear"
                  (click)="clear()"
                  (keydown.enter)="clear()"
                  [class.icon-right]="iconRight"
                  [class.is-disabled]="isDisabled"
                  [class.is-readonly]="readonly"
          >
          </i>
          <i
                  *ngIf="iconRight"
                  class="pi {{iconRight}} ds-input-icon-right"
                  [title]="iconRightTitle"
                  (click)="focus()"
          >
          </i>
      </div>
  `,
                host: {
                    'class': 'ds-autocomplete',
                    '[class.is-readonly]': 'readonly'
                },
                providers: [
                    GMINA_VALUE_ACCESSOR
                ]
            }]
    }], function () { return [{ type: AdresService }]; }, null); })();

const COMPONENTS = [
    DsMiastoComponent,
    DsUlicaComponent,
    DsKodPocztowyComponent,
    DsWojewodztwoComponent,
    DsPowiatComponent,
    DsGminaComponent
];
class DsAdresModule {
    static forRoot(terytApiUrl) {
        return {
            ngModule: DsAdresModule,
            providers: [
                {
                    provide: TERYT_API_URL,
                    useValue: terytApiUrl
                }
            ]
        };
    }
}
DsAdresModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsAdresModule });
DsAdresModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsAdresModule_Factory(t) { return new (t || DsAdresModule)(); }, imports: [[
            CommonModule,
            AutoCompleteModule,
            FormsModule,
            HttpClientModule,
            InputMaskModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsAdresModule, { declarations: function () { return [DsMiastoComponent, DsUlicaComponent, DsKodPocztowyComponent, DsWojewodztwoComponent, DsPowiatComponent, DsGminaComponent]; }, imports: function () { return [CommonModule,
        AutoCompleteModule,
        FormsModule,
        HttpClientModule,
        InputMaskModule]; }, exports: function () { return [DsMiastoComponent, DsUlicaComponent, DsKodPocztowyComponent, DsWojewodztwoComponent, DsPowiatComponent, DsGminaComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsAdresModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ...COMPONENTS,
                ],
                imports: [
                    CommonModule,
                    AutoCompleteModule,
                    FormsModule,
                    HttpClientModule,
                    InputMaskModule
                ],
                exports: [
                    ...COMPONENTS,
                ]
            }]
    }], null, null); })();

class DsAlertComponent {
    constructor() {
        /**
         * Określa wagę/nasilenie/rodzaj alertu.
         * Zmienia kolor nagłówka i obramowania.
         * @type 'info' | 'warn' | 'error' | 'success'
         * @default 'info'
         * */
        this.severity = 'info';
        /**
         * Nagłówek alertu. Zawsze wyświetlany wielkimi literami.
         * Nagłówek, który jest pusty nie jest renderowany.
         * @type: string
         * @default: null
         * */
        this.etykieta = null;
    }
    ngOnInit() {
        if (typeof this.text == 'string') {
            this.text = [this.text];
        }
    }
}
DsAlertComponent.ɵfac = function DsAlertComponent_Factory(t) { return new (t || DsAlertComponent)(); };
DsAlertComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsAlertComponent, selectors: [["ds-alert"]], inputs: { severity: "severity", etykieta: "etykieta", text: "text" }, ngContentSelectors: _c2, decls: 5, vars: 9, consts: [["aria-live", "polite", 1, "p-inline-message", "p-component", 3, "ngClass"], ["class", "etykieta", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["elseBlock", ""], [1, "etykieta"], ["class", "p-inline-message-text", 4, "ngFor", "ngForOf"], [1, "p-inline-message-text"]], template: function DsAlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DsAlertComponent_span_1_Template, 3, 3, "span", 1);
        ɵngcc0.ɵɵtemplate(2, DsAlertComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(3, DsAlertComponent_ng_template_3_Template, 2, 0, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(4, _c1, ctx.severity === "info", ctx.severity === "warn", ctx.severity === "error", ctx.severity === "success"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !!ctx.etykieta);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.text)("ngIfElse", _r2);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc2.NgForOf], pipes: [ɵngcc2.UpperCasePipe], encapsulation: 2, changeDetection: 0 });
DsAlertComponent.propDecorators = {
    severity: [{ type: Input }],
    text: [{ type: Input }],
    etykieta: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsAlertComponent, [{
        type: Component,
        args: [{
                selector: 'ds-alert',
                template: `
    <div aria-live="polite" class="p-inline-message p-component"
         [ngClass]="{'p-inline-message-info': (severity === 'info'),
                'p-inline-message-warn': (severity === 'warn'),
                'p-inline-message-error': (severity === 'error'),
                'p-inline-message-success': (severity === 'success')}">
      <span *ngIf="!!etykieta" class="etykieta">{{etykieta | uppercase}}</span>
      <ng-container *ngIf="text; else elseBlock">
        <span *ngFor="let line of text" class="p-inline-message-text">{{line}}</span>
      </ng-container>
      <ng-template #elseBlock>
        <span class="p-inline-message-text">
          <ng-content></ng-content>
        </span>
      </ng-template>
    </div>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { severity: [{
            type: Input
        }], etykieta: [{
            type: Input
        }], text: [{
            type: Input
        }] }); })();

class DsAlertModule {
}
DsAlertModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsAlertModule });
DsAlertModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsAlertModule_Factory(t) { return new (t || DsAlertModule)(); }, imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsAlertModule, { declarations: function () { return [DsAlertComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DsAlertComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsAlertModule, [{
        type: NgModule,
        args: [{
                declarations: [DsAlertComponent],
                imports: [
                    CommonModule,
                ],
                exports: [DsAlertComponent]
            }]
    }], null, null); })();

const DS_INPUT_COMPONENT_CUSTOM_VALIDATOR = new InjectionToken('DS-INPUT-COMPONENT-CUSTOM-VALIDATOR');
const DS_TEXTAREA_COMPONENT_CUSTOM_VALIDATOR = new InjectionToken('DS-TEXTAREA-COMPONENT-CUSTOM-VALIDATOR');
const DS_AUTOCOMPLETE_COMPONENT_CUSTOM_VALIDATOR = new InjectionToken('DS-AUTOCOMPLETE-COMPONENT-CUSTOM-VALIDATOR');

class CustomValidatorUtils {
    executeValidate(component, formControl, customValidatorService) {
        if (Array.isArray(customValidatorService)) {
            for (let ii = 0; ii < customValidatorService.length; ii++) {
                const result = customValidatorService[ii].validate(component, formControl);
                if (result) {
                    return result;
                }
            }
        }
        else {
            return customValidatorService.validate(component, formControl);
        }
    }
}

class DsAutocompleteUpperDirective {
    constructor(host) {
        this.host = host;
        this.dsAutocompleteUpper = false;
    }
    ngOnDestroy() {
        if (this.unSub) {
            this.unSub.unsubscribe();
            this.unSub = null;
        }
    }
    ngAfterViewInit() {
        if (this.host.inputEL && this.dsAutocompleteUpper) {
            this.unSub = fromEvent(this.host.inputEL.nativeElement, 'input')
                .subscribe((e) => {
                let value = this.host.inputEL.nativeElement.value;
                const start = this.host.inputEL.nativeElement.selectionStart;
                const end = this.host.inputEL.nativeElement.selectionEnd;
                value = Utils.normalizeToUpper(value);
                this.host.onModelChange(value);
                this.host.inputEL.nativeElement.value = value;
                this.host.inputEL.nativeElement.setSelectionRange(start, end);
            });
        }
    }
}
DsAutocompleteUpperDirective.ɵfac = function DsAutocompleteUpperDirective_Factory(t) { return new (t || DsAutocompleteUpperDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.AutoComplete)); };
DsAutocompleteUpperDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DsAutocompleteUpperDirective, selectors: [["", "dsAutocompleteUpper", ""]], inputs: { dsAutocompleteUpper: "dsAutocompleteUpper" } });
DsAutocompleteUpperDirective.ctorParameters = () => [
    { type: AutoComplete }
];
DsAutocompleteUpperDirective.propDecorators = {
    dsAutocompleteUpper: [{ type: Input, args: ['dsAutocompleteUpper',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsAutocompleteUpperDirective, [{
        type: Directive,
        args: [{
                selector: '[dsAutocompleteUpper]'
            }]
    }], function () { return [{ type: ɵngcc3.AutoComplete }]; }, { dsAutocompleteUpper: [{
            type: Input,
            args: ['dsAutocompleteUpper']
        }] }); })();
class DsAutocompleteComponent extends CustomValidatorUtils {
    constructor(sanitizer, customValidatorService) {
        super();
        this.sanitizer = sanitizer;
        this.suggestions = null;
        this.field = null;
        this.scrollHeight = '200px';
        this.dropdown = false;
        this.multiple = false;
        this.dropdownIcon = 'pi pi-chevron-down';
        this.minLength = 1;
        this.delay = 300;
        this.completeOnFocus = false;
        this.style = null;
        this.inputStyle = null;
        this.panelStyle = null;
        this.styleClass = null;
        this.inputStyleClass = null;
        this.panelStyleClass = null;
        this.inputId = null;
        this.name = null;
        this.placeholder = null;
        this.readonly = false;
        this.size = null;
        this.appendTo = null;
        this.tabindex = null;
        this.dataKey = null;
        this.autoHighlight = false;
        this.type = 'text';
        this.emptyMessage = null;
        this.required = false;
        this.autofocus = false;
        this.forceSelection = false;
        this.dropdownMode = 'blank';
        this.baseZIndex = 0;
        this.autoZIndex = true;
        this.showTransitionOptions = '.12s cubic-bezier(0, 0, 0.2, 1)';
        this.hideTransitionOptions = '.1s linear';
        this.ariaLabel = null;
        this.ariaLabelledBy = null;
        this.unique = true;
        this.autocomplete = null;
        /**
         * Określa, czy w inpucie po prawej stronie ma być ikona X, która po kliknięciu usuwa tekst w inpucie
         * @type boolean
         * @default true
         * */
        this.showClear = false;
        /**
         * Określa czy licznik znaków jest widoczny
         * @type boolean
         * @default false
         * */
        this.showCounter = false;
        /**
         * Określa, czy licznik znaków znajduje się wewnątrz textarea
         * @type boolean
         * @default false
         */
        this.counterInside = false;
        this.maxlength = '524288';
        this.capitalize = false;
        /**
         * Określa czy uruchomić dodatkowy walidator
         * @type boolean
         * @default true
         */
        this.isCustomValidatorRun = true;
        this.ngModelChange = new EventEmitter();
        this.completeMethod = new EventEmitter();
        this.onFocus = new EventEmitter();
        this.onBlur = new EventEmitter();
        this.onKeyUp = new EventEmitter();
        this.onSelect = new EventEmitter();
        this.onUnselect = new EventEmitter();
        this.onDropdownClick = new EventEmitter();
        this.onClear = new EventEmitter();
        this.onShow = new EventEmitter();
        this.onHide = new EventEmitter();
        this.isDisabled = false;
        this.counter = 0;
        this.onChange = () => {
        };
        this.onTouch = () => {
        };
        this.customValidatorService = customValidatorService;
    }
    ngOnInit() {
        if (this.inputId == undefined)
            this.inputId = Utils.wygenerujLosoweId();
    }
    clear() {
        if (this.isDisabled)
            return;
        this.ngModel = null;
        this.onChange(null);
        this.ngModelChange.emit(null);
    }
    focus() {
        this.autoCompleteComponent.focusInput();
    }
    ngAfterViewInit() {
        if (this.itemTemplateRef)
            this.autoCompleteComponent.itemTemplate = this.itemTemplateRef;
        if (this.selectedItemTemplateRef)
            this.autoCompleteComponent.selectedItemTemplate = this.selectedItemTemplateRef;
    }
    writeValue(value) {
        var _a;
        this.ngModel = value;
        if (value) {
            this.counter = ((_a = value[this.field]) === null || _a === void 0 ? void 0 : _a.length) || value.length || 0;
        }
        else {
            this.counter = 0;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    onChangeWrapper($event) {
        this.onChange($event);
        this.writeValue($event);
    }
    safeHtml(v) {
        return this.sanitizer.bypassSecurityTrustHtml(v);
    }
    validate(formControl) {
        if (this.isCustomValidatorRun === true && this.customValidatorService) {
            return this.executeValidate(this, formControl, this.customValidatorService);
        }
        return null;
    }
}
DsAutocompleteComponent.ɵfac = function DsAutocompleteComponent_Factory(t) { return new (t || DsAutocompleteComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(DS_AUTOCOMPLETE_COMPONENT_CUSTOM_VALIDATOR, 8)); };
DsAutocompleteComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsAutocompleteComponent, selectors: [["ds-autocomplete"]], viewQuery: function DsAutocompleteComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(AutoComplete, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.autoCompleteComponent = _t.first);
    } }, hostAttrs: [1, "ds-autocomplete"], hostVars: 2, hostBindings: function DsAutocompleteComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly);
    } }, inputs: { suggestions: "suggestions", field: "field", scrollHeight: "scrollHeight", dropdown: "dropdown", multiple: "multiple", dropdownIcon: "dropdownIcon", minLength: "minLength", delay: "delay", completeOnFocus: "completeOnFocus", style: "style", inputStyle: "inputStyle", panelStyle: "panelStyle", styleClass: "styleClass", inputStyleClass: "inputStyleClass", panelStyleClass: "panelStyleClass", inputId: "inputId", name: "name", placeholder: "placeholder", readonly: "readonly", size: "size", appendTo: "appendTo", tabindex: "tabindex", dataKey: "dataKey", autoHighlight: "autoHighlight", type: "type", emptyMessage: "emptyMessage", required: "required", autofocus: "autofocus", forceSelection: "forceSelection", dropdownMode: "dropdownMode", baseZIndex: "baseZIndex", autoZIndex: "autoZIndex", showTransitionOptions: "showTransitionOptions", hideTransitionOptions: "hideTransitionOptions", ariaLabel: "ariaLabel", ariaLabelledBy: "ariaLabelledBy", unique: "unique", autocomplete: "autocomplete", showClear: "showClear", showCounter: "showCounter", counterInside: "counterInside", maxlength: "maxlength", capitalize: "capitalize", isCustomValidatorRun: "isCustomValidatorRun", customValidatorService: "customValidatorService", ngModel: "ngModel", label: "label", itemTemplateRef: "itemTemplateRef", selectedItemTemplateRef: "selectedItemTemplateRef", iconRightTitle: "iconRightTitle", iconLeftTitle: "iconLeftTitle", iconLeft: "iconLeft", iconRight: "iconRight", errorMessage: "errorMessage" }, outputs: { ngModelChange: "ngModelChange", completeMethod: "completeMethod", onFocus: "onFocus", onBlur: "onBlur", onKeyUp: "onKeyUp", onSelect: "onSelect", onUnselect: "onUnselect", onDropdownClick: "onDropdownClick", onClear: "onClear", onShow: "onShow", onHide: "onHide" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DsAutocompleteComponent),
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: DsAutocompleteComponent,
                multi: true
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 11, vars: 62, consts: [[1, "ds-autocomplete-label", 3, "for"], [1, "ds-autocomplete-wrapper"], [3, "title", "class", 4, "ngIf"], [3, "dsAutocompleteUpper", "suggestions", "field", "scrollHeight", "dropdown", "multiple", "dropdownIcon", "minLength", "delay", "completeOnFocus", "inputStyle", "panelStyle", "styleClass", "inputStyleClass", "panelStyleClass", "inputId", "name", "placeholder", "readonly", "disabled", "maxlength", "size", "appendTo", "tabindex", "dataKey", "autoHighlight", "type", "emptyMessage", "required", "autofocus", "forceSelection", "dropdownMode", "baseZIndex", "autoZIndex", "showTransitionOptions", "hideTransitionOptions", "ariaLabel", "ariaLabelledBy", "unique", "autocomplete", "ngModel", "ngModelChange", "completeMethod", "onFocus", "onBlur", "onKeyUp", "onSelect", "onUnselect", "onDropdownClick", "onClear", "onShow", "onHide"], ["class", "pi pi-times ds-input-show-clear", 3, "ngClass", "tabindex", "icon-right", "is-disabled", "is-readonly", "click", "keydown.enter", 4, "ngIf"], [3, "class", "title", "click", 4, "ngIf"], [1, "ds-autocomplete-flex-wrapper"], ["class", "ds-autocomplete-chars-counter", 3, "counter-inside", "visibility", 4, "ngIf"], ["class", "ds-autocomplete-error-message", 3, "innerHTML", 4, "ngIf"], [3, "title"], [1, "pi", "pi-times", "ds-input-show-clear", 3, "ngClass", "tabindex", "click", "keydown.enter"], [3, "title", "click"], [1, "ds-autocomplete-chars-counter"], [1, "ds-autocomplete-error-message", 3, "innerHTML"]], template: function DsAutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DsAutocompleteComponent_i_3_Template, 1, 4, "i", 2);
        ɵngcc0.ɵɵelementStart(4, "p-autoComplete", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsAutocompleteComponent_Template_p_autoComplete_ngModelChange_4_listener($event) { return ctx.onChangeWrapper($event); })("completeMethod", function DsAutocompleteComponent_Template_p_autoComplete_completeMethod_4_listener($event) { return ctx.completeMethod.emit($event); })("onFocus", function DsAutocompleteComponent_Template_p_autoComplete_onFocus_4_listener($event) { return ctx.onFocus.emit($event); })("onBlur", function DsAutocompleteComponent_Template_p_autoComplete_onBlur_4_listener($event) { return ctx.onBlur.emit($event); })("onKeyUp", function DsAutocompleteComponent_Template_p_autoComplete_onKeyUp_4_listener($event) { return ctx.onKeyUp.emit($event); })("onSelect", function DsAutocompleteComponent_Template_p_autoComplete_onSelect_4_listener($event) { return ctx.onSelect.emit($event); })("onUnselect", function DsAutocompleteComponent_Template_p_autoComplete_onUnselect_4_listener($event) { return ctx.onUnselect.emit($event); })("onDropdownClick", function DsAutocompleteComponent_Template_p_autoComplete_onDropdownClick_4_listener($event) { return ctx.onDropdownClick.emit($event); })("onClear", function DsAutocompleteComponent_Template_p_autoComplete_onClear_4_listener($event) { return ctx.onClear.emit($event); })("onShow", function DsAutocompleteComponent_Template_p_autoComplete_onShow_4_listener($event) { return ctx.onShow.emit($event); })("onHide", function DsAutocompleteComponent_Template_p_autoComplete_onHide_4_listener($event) { return ctx.onHide.emit($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DsAutocompleteComponent_i_5_Template, 1, 10, "i", 4);
        ɵngcc0.ɵɵtemplate(6, DsAutocompleteComponent_i_6_Template, 1, 4, "i", 5);
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵtemplate(8, DsAutocompleteComponent_span_8_Template, 2, 5, "span", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div");
        ɵngcc0.ɵɵtemplate(10, DsAutocompleteComponent_span_10_Template, 1, 1, "span", 8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly)("has-left-icon", ctx.iconLeft)("has-right-icon", ctx.iconRight)("has-clear-icon", ctx.showClear)("has-counter-inside", ctx.counterInside)("is-disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("dsAutocompleteUpper", ctx.capitalize)("suggestions", ctx.suggestions)("field", ctx.field)("scrollHeight", ctx.scrollHeight)("dropdown", ctx.dropdown)("multiple", ctx.multiple)("dropdownIcon", ctx.dropdownIcon)("minLength", ctx.minLength)("delay", ctx.delay)("completeOnFocus", ctx.completeOnFocus)("inputStyle", ctx.inputStyle)("panelStyle", ctx.panelStyle)("styleClass", ctx.styleClass)("inputStyleClass", ctx.inputStyleClass)("panelStyleClass", ctx.panelStyleClass)("inputId", ctx.inputId)("name", ctx.name)("placeholder", ctx.placeholder)("readonly", ctx.readonly)("disabled", ctx.isDisabled)("maxlength", ctx.maxlength)("size", ctx.size)("appendTo", ctx.appendTo)("tabindex", ctx.tabindex)("dataKey", ctx.dataKey)("autoHighlight", ctx.autoHighlight)("type", ctx.type)("emptyMessage", ctx.emptyMessage)("required", ctx.required)("autofocus", ctx.autofocus)("forceSelection", ctx.forceSelection)("dropdownMode", ctx.dropdownMode)("baseZIndex", ctx.baseZIndex)("autoZIndex", ctx.autoZIndex)("showTransitionOptions", ctx.showTransitionOptions)("hideTransitionOptions", ctx.hideTransitionOptions)("ariaLabel", ctx.ariaLabel)("ariaLabelledBy", ctx.ariaLabelledBy)("unique", ctx.unique)("autocomplete", ctx.autocomplete)("ngModel", ctx.ngModel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClear && ctx.ngModel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCounter && !ctx.isDisabled && !ctx.readonly && ctx.maxlength);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorMessage && !ctx.isDisabled);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.AutoComplete, DsAutocompleteUpperDirective, ɵngcc4.MaxLengthValidator, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc2.NgClass], encapsulation: 2 });
DsAutocompleteComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_AUTOCOMPLETE_COMPONENT_CUSTOM_VALIDATOR,] }] }
];
DsAutocompleteComponent.propDecorators = {
    suggestions: [{ type: Input }],
    field: [{ type: Input }],
    scrollHeight: [{ type: Input }],
    dropdown: [{ type: Input }],
    multiple: [{ type: Input }],
    dropdownIcon: [{ type: Input }],
    minLength: [{ type: Input }],
    delay: [{ type: Input }],
    completeOnFocus: [{ type: Input }],
    style: [{ type: Input }],
    inputStyle: [{ type: Input }],
    panelStyle: [{ type: Input }],
    styleClass: [{ type: Input }],
    inputStyleClass: [{ type: Input }],
    panelStyleClass: [{ type: Input }],
    inputId: [{ type: Input }],
    name: [{ type: Input }],
    placeholder: [{ type: Input }],
    readonly: [{ type: Input }],
    size: [{ type: Input }],
    appendTo: [{ type: Input }],
    tabindex: [{ type: Input }],
    dataKey: [{ type: Input }],
    autoHighlight: [{ type: Input }],
    type: [{ type: Input }],
    emptyMessage: [{ type: Input }],
    required: [{ type: Input }],
    autofocus: [{ type: Input }],
    forceSelection: [{ type: Input }],
    dropdownMode: [{ type: Input }],
    baseZIndex: [{ type: Input }],
    autoZIndex: [{ type: Input }],
    showTransitionOptions: [{ type: Input }],
    hideTransitionOptions: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    ariaLabelledBy: [{ type: Input }],
    unique: [{ type: Input }],
    autocomplete: [{ type: Input }],
    label: [{ type: Input }],
    itemTemplateRef: [{ type: Input }],
    selectedItemTemplateRef: [{ type: Input }],
    showClear: [{ type: Input }],
    iconRightTitle: [{ type: Input }],
    iconLeftTitle: [{ type: Input }],
    iconLeft: [{ type: Input }],
    iconRight: [{ type: Input }],
    showCounter: [{ type: Input }],
    counterInside: [{ type: Input }],
    maxlength: [{ type: Input }],
    ngModel: [{ type: Input }],
    errorMessage: [{ type: Input }],
    capitalize: [{ type: Input }],
    isCustomValidatorRun: [{ type: Input }],
    customValidatorService: [{ type: Input }],
    ngModelChange: [{ type: Output }],
    completeMethod: [{ type: Output }],
    onFocus: [{ type: Output }],
    onBlur: [{ type: Output }],
    onKeyUp: [{ type: Output }],
    onSelect: [{ type: Output }],
    onUnselect: [{ type: Output }],
    onDropdownClick: [{ type: Output }],
    onClear: [{ type: Output }],
    onShow: [{ type: Output }],
    onHide: [{ type: Output }],
    autoCompleteComponent: [{ type: ViewChild, args: [AutoComplete, { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsAutocompleteComponent, [{
        type: Component,
        args: [{
                selector: 'ds-autocomplete',
                template: `
      <label class="ds-autocomplete-label" [for]="inputId">{{label}}</label>
      <div class="ds-autocomplete-wrapper">
          <i
                  [title]="iconLeftTitle"
                  *ngIf="iconLeft"
                  class="pi {{iconLeft}} ds-input-icon-left"
          >
          </i>
          <p-autoComplete
                  [dsAutocompleteUpper]="capitalize"
                  [suggestions]="suggestions"
                  [field]="field"
                  [scrollHeight]="scrollHeight"
                  [dropdown]="dropdown"
                  [multiple]="multiple"
                  [dropdownIcon]="dropdownIcon"
                  [minLength]="minLength"
                  [delay]="delay"
                  [completeOnFocus]="completeOnFocus"
                  [style]="style"
                  [inputStyle]="inputStyle"
                  [panelStyle]="panelStyle"
                  [styleClass]="styleClass"
                  [inputStyleClass]="inputStyleClass"
                  [panelStyleClass]="panelStyleClass"
                  [inputId]="inputId"
                  [name]="name"
                  [placeholder]="placeholder"
                  [readonly]="readonly"
                  [disabled]="isDisabled"
                  [maxlength]="maxlength"
                  [size]="size"
                  [appendTo]="appendTo"
                  [tabindex]="tabindex"
                  [dataKey]="dataKey"
                  [autoHighlight]="autoHighlight"
                  [type]="type"
                  [emptyMessage]="emptyMessage"
                  [required]="required"
                  [autofocus]="autofocus"
                  [forceSelection]="forceSelection"
                  [dropdownMode]="dropdownMode"
                  [baseZIndex]="baseZIndex"
                  [autoZIndex]="autoZIndex"
                  [showTransitionOptions]="showTransitionOptions"
                  [hideTransitionOptions]="hideTransitionOptions"
                  [ariaLabel]="ariaLabel"
                  [ariaLabelledBy]="ariaLabelledBy"
                  [unique]="unique"
                  [autocomplete]="autocomplete"
                  [ngModel]="ngModel"
                  [class.is-readonly]="readonly"
                  [class.has-left-icon]="iconLeft"
                  [class.has-right-icon]="iconRight"
                  [class.has-clear-icon]="showClear"
                  [class.has-counter-inside]="counterInside"
                  [class.is-disabled]="isDisabled"
                  (ngModelChange)="onChangeWrapper($event)"
                  (completeMethod)="completeMethod.emit($event)"
                  (onFocus)="onFocus.emit($event)"
                  (onBlur)="onBlur.emit($event)"
                  (onKeyUp)="onKeyUp.emit($event)"
                  (onSelect)="onSelect.emit($event)"
                  (onUnselect)="onUnselect.emit($event)"
                  (onDropdownClick)="onDropdownClick.emit($event)"
                  (onClear)="onClear.emit($event)"
                  (onShow)="onShow.emit($event)"
                  (onHide)="onHide.emit($event)"
          >
          </p-autoComplete>
          <i
                  class="pi pi-times ds-input-show-clear"
                  [ngClass]="{'p-mr-5': dropdown}"
                  tabindex="{{ isDisabled || readonly ? '-1' : '0' }}"
                  *ngIf="showClear && ngModel"
                  (click)="clear()"
                  (keydown.enter)="clear()"
                  [class.icon-right]="iconRight"
                  [class.is-disabled]="isDisabled"
                  [class.is-readonly]="readonly"
          >
          </i>
          <i
                  *ngIf="iconRight"
                  class="pi {{iconRight}} ds-input-icon-right"
                  [title]="iconRightTitle"
                  (click)="focus()"
          >
          </i>
          <div class="ds-autocomplete-flex-wrapper">
              <span
                class="ds-autocomplete-chars-counter" [class.counter-inside]="counterInside"
                *ngIf="showCounter && !isDisabled && !readonly && maxlength"
                [style.visibility]="'visible'"
              >
                  {{ counter + '/' + maxlength }}
                </span>
          </div>
      </div>
      <div>
          <span
            class="ds-autocomplete-error-message"
            *ngIf="errorMessage && !isDisabled"
            [innerHTML]="safeHtml(errorMessage)"
          >
          </span>
      </div>
  `,
                host: {
                    'class': 'ds-autocomplete',
                    '[class.is-readonly]': 'readonly'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DsAutocompleteComponent),
                        multi: true
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: DsAutocompleteComponent,
                        multi: true
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc5.DomSanitizer }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_AUTOCOMPLETE_COMPONENT_CUSTOM_VALIDATOR]
            }] }]; }, { suggestions: [{
            type: Input
        }], field: [{
            type: Input
        }], scrollHeight: [{
            type: Input
        }], dropdown: [{
            type: Input
        }], multiple: [{
            type: Input
        }], dropdownIcon: [{
            type: Input
        }], minLength: [{
            type: Input
        }], delay: [{
            type: Input
        }], completeOnFocus: [{
            type: Input
        }], style: [{
            type: Input
        }], inputStyle: [{
            type: Input
        }], panelStyle: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], inputStyleClass: [{
            type: Input
        }], panelStyleClass: [{
            type: Input
        }], inputId: [{
            type: Input
        }], name: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], readonly: [{
            type: Input
        }], size: [{
            type: Input
        }], appendTo: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], dataKey: [{
            type: Input
        }], autoHighlight: [{
            type: Input
        }], type: [{
            type: Input
        }], emptyMessage: [{
            type: Input
        }], required: [{
            type: Input
        }], autofocus: [{
            type: Input
        }], forceSelection: [{
            type: Input
        }], dropdownMode: [{
            type: Input
        }], baseZIndex: [{
            type: Input
        }], autoZIndex: [{
            type: Input
        }], showTransitionOptions: [{
            type: Input
        }], hideTransitionOptions: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], ariaLabelledBy: [{
            type: Input
        }], unique: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], showClear: [{
            type: Input
        }], showCounter: [{
            type: Input
        }], counterInside: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], capitalize: [{
            type: Input
        }], isCustomValidatorRun: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], completeMethod: [{
            type: Output
        }], onFocus: [{
            type: Output
        }], onBlur: [{
            type: Output
        }], onKeyUp: [{
            type: Output
        }], onSelect: [{
            type: Output
        }], onUnselect: [{
            type: Output
        }], onDropdownClick: [{
            type: Output
        }], onClear: [{
            type: Output
        }], onShow: [{
            type: Output
        }], onHide: [{
            type: Output
        }], customValidatorService: [{
            type: Input
        }], ngModel: [{
            type: Input
        }], label: [{
            type: Input
        }], itemTemplateRef: [{
            type: Input
        }], selectedItemTemplateRef: [{
            type: Input
        }], iconRightTitle: [{
            type: Input
        }], iconLeftTitle: [{
            type: Input
        }], iconLeft: [{
            type: Input
        }], iconRight: [{
            type: Input
        }], errorMessage: [{
            type: Input
        }], autoCompleteComponent: [{
            type: ViewChild,
            args: [AutoComplete, { static: true }]
        }] }); })();

class DsAutocompleteModule {
}
DsAutocompleteModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsAutocompleteModule });
DsAutocompleteModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsAutocompleteModule_Factory(t) { return new (t || DsAutocompleteModule)(); }, imports: [[
            CommonModule,
            AutoCompleteModule,
            FormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsAutocompleteModule, { declarations: function () { return [DsAutocompleteComponent, DsAutocompleteUpperDirective]; }, imports: function () { return [CommonModule,
        AutoCompleteModule,
        FormsModule]; }, exports: function () { return [DsAutocompleteComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsAutocompleteModule, [{
        type: NgModule,
        args: [{
                declarations: [DsAutocompleteComponent, DsAutocompleteUpperDirective],
                exports: [DsAutocompleteComponent],
                imports: [
                    CommonModule,
                    AutoCompleteModule,
                    FormsModule
                ]
            }]
    }], null, null); })();

class DsButtonDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        /**
         * Określa styl przycisku
         * @type 'primary' | 'primary-icon' | 'border' | 'border-icon' | 'link' | 'link-icon' | 'dotted' | 'dotted-icon'
         * @default 'primary'
         * */
        this.styleType = 'primary';
        this.renderer.addClass(this.el.nativeElement, 'ds-button');
        this.renderer.addClass(this.el.nativeElement, 'p-component');
        this.renderer.addClass(this.el.nativeElement, 'p-ripple');
    }
    ngOnInit() {
        if (this.styleType == 'border' || this.styleType == 'border-icon') {
            this.renderer.addClass(this.el.nativeElement, 'ds-button-border');
        }
        if (this.styleType == 'link' || this.styleType == 'link-icon') {
            this.renderer.addClass(this.el.nativeElement, 'ds-button-link');
        }
        if (this.styleType == 'dotted' || this.styleType == 'dotted-icon') {
            this.renderer.addClass(this.el.nativeElement, 'ds-button-dotted');
        }
        if (this.styleType.includes('-icon')) {
            this.renderer.addClass(this.el.nativeElement, 'ds-button-icon-only');
        }
    }
}
DsButtonDirective.ɵfac = function DsButtonDirective_Factory(t) { return new (t || DsButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
DsButtonDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DsButtonDirective, selectors: [["button", "ds-button", ""], ["a", "ds-button", ""]], inputs: { styleType: "styleType" } });
DsButtonDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
DsButtonDirective.propDecorators = {
    styleType: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'button[ds-button], a[ds-button]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { styleType: [{
            type: Input
        }] }); })();
class DsButtonComponent {
    constructor() {
        /**
         * Określa, czy w środku przycisku jest wskaźnik ładowania.
         * Kiedy <loading> ma wartość true przycisk jest nieaktywny
         * @type boolean
         * @default false
         * */
        this.loading = false;
        /**
         * Określa, czy przycisk jest nieaktywny
         * @type boolean
         * @default false
         * */
        this.disabled = false;
        /**
         * Etykieta, napis wewnątrz przycisku.
         * @type string
         * @default undefined
         * */
        this.label = undefined;
        /**
         * Typ przycisku.
         * @type 'submit' | 'button'
         * @default 'button'
         * */
        this.type = 'button';
        /**
         * Klasa określająca ikonę.
         * Jedna z primeicons: https://www.primefaces.org/primeng/v9.1.4-lts/#/icons
         * np. 'pi pi-check'
         * @default null
         * */
        this.icon = null;
        /**
         * Określa, z której strony ma się znajdować ikona określona w parametrze icon.
         * @type 'left' | 'right'
         * @default 'left'
         * */
        this.iconPos = 'left';
        /**
         * Dodatkowa klasa nadawana wewnętrznemu elementowi <button>
         * @type string
         * @default ''
         */
        this.styleClass = '';
        this.onClick = new EventEmitter();
        this.onFocus = new EventEmitter();
        this.onBlur = new EventEmitter();
        this.buttonSeverity = '';
    }
    /**
     * Określa typ buttonu
     * @type ButtonSeverity
     * @default primary
     */
    set severity(buttonSeverity) {
        this.setButtonTypeStyleClass(buttonSeverity);
    }
    ;
    ngOnInit() { }
    setButtonTypeStyleClass(type) {
        switch (type) {
            case 'border':
                this.buttonSeverity = 'p-button-outlined';
                return;
            case 'link':
                this.buttonSeverity = 'p-button-text';
                return;
            case 'dotted':
                this.buttonSeverity = 'p-button-raised';
                return;
            default:
                return;
        }
    }
}
DsButtonComponent.ɵfac = function DsButtonComponent_Factory(t) { return new (t || DsButtonComponent)(); };
DsButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsButtonComponent, selectors: [["ds-button"]], inputs: { loading: "loading", disabled: "disabled", label: "label", type: "type", icon: "icon", iconPos: "iconPos", styleClass: "styleClass", severity: "severity", style: "style", badge: "badge", badgeClass: "badgeClass", ariaLabel: "ariaLabel" }, outputs: { onClick: "onClick", onFocus: "onFocus", onBlur: "onBlur" }, decls: 2, vars: 15, consts: [[3, "type", "label", "disabled", "icon", "iconPos", "badge", "badgeClass", "styleClass", "onBlur", "onClick", "onFocus"]], template: function DsButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-button", 0);
        ɵngcc0.ɵɵlistener("onBlur", function DsButtonComponent_Template_p_button_onBlur_0_listener($event) { return ctx.onBlur.emit($event); })("onClick", function DsButtonComponent_Template_p_button_onClick_0_listener($event) { return ctx.onClick.emit($event); })("onFocus", function DsButtonComponent_Template_p_button_onFocus_0_listener($event) { return ctx.onFocus.emit($event); });
        ɵngcc0.ɵɵpipe(1, "transloco");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("spinner", ctx.loading);
        ɵngcc0.ɵɵproperty("type", ctx.type)("label", ɵngcc0.ɵɵpipeBind1(1, 13, ctx.label))("disabled", ctx.disabled || ctx.loading)("icon", ctx.icon)("iconPos", ctx.iconPos)("badge", ctx.badge)("badgeClass", ctx.badgeClass)("styleClass", ctx.buttonSeverity + " " + ctx.styleClass);
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
    } }, directives: [ɵngcc6.Button], pipes: [ɵngcc7.TranslocoPipe], encapsulation: 2 });
DsButtonComponent.ctorParameters = () => [];
DsButtonComponent.propDecorators = {
    loading: [{ type: Input }],
    disabled: [{ type: Input }],
    label: [{ type: Input }],
    type: [{ type: Input }],
    icon: [{ type: Input }],
    iconPos: [{ type: Input }],
    style: [{ type: Input }],
    styleClass: [{ type: Input }],
    severity: [{ type: Input }],
    badge: [{ type: Input }],
    badgeClass: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    onClick: [{ type: Output }],
    onFocus: [{ type: Output }],
    onBlur: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsButtonComponent, [{
        type: Component,
        args: [{
                selector: 'ds-button',
                template: `
    <p-button
      [type]="type"
      [label]="label | transloco"
      [class.spinner]="loading"
      [disabled]="disabled || loading"
      [icon]="icon"
      [iconPos]="iconPos"
      [badge]="badge"
      [badgeClass]="badgeClass"
      [style]="style"
      [styleClass]="buttonSeverity + ' ' + styleClass"
      (onBlur)="onBlur.emit($event)"
      (onClick)="onClick.emit($event)"
      (onFocus)="onFocus.emit($event)"
      [attr.aria-label]="ariaLabel"
    ></p-button>
  `
            }]
    }], function () { return []; }, { loading: [{
            type: Input
        }], disabled: [{
            type: Input
        }], label: [{
            type: Input
        }], type: [{
            type: Input
        }], icon: [{
            type: Input
        }], iconPos: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], onClick: [{
            type: Output
        }], onFocus: [{
            type: Output
        }], onBlur: [{
            type: Output
        }], severity: [{
            type: Input
        }], style: [{
            type: Input
        }], badge: [{
            type: Input
        }], badgeClass: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }] }); })();

class TranslocoHttpLoader {
    constructor(http) {
        this.http = http;
    }
    getTranslation(lang) {
        return this.http.get(`/assets/i18n/${lang}.json`);
    }
}
TranslocoHttpLoader.ɵfac = function TranslocoHttpLoader_Factory(t) { return new (t || TranslocoHttpLoader)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
TranslocoHttpLoader.ɵprov = ɵɵdefineInjectable({ factory: function TranslocoHttpLoader_Factory() { return new TranslocoHttpLoader(ɵɵinject(HttpClient)); }, token: TranslocoHttpLoader, providedIn: "root" });
TranslocoHttpLoader.ctorParameters = () => [
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TranslocoHttpLoader, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();
class TranslocoRootModule {
    static forRoot(options, translocoHttpLoader) {
        return {
            ngModule: TranslocoRootModule,
            providers: [
                {
                    provide: TRANSLOCO_CONFIG,
                    useValue: translocoConfig({
                        availableLangs: (options === null || options === void 0 ? void 0 : options.availableLangs) || ['pl'],
                        defaultLang: (options === null || options === void 0 ? void 0 : options.defaultLang) || 'pl',
                        reRenderOnLangChange: (options === null || options === void 0 ? void 0 : options.reRenderOnLangChange) || true,
                        prodMode: (options === null || options === void 0 ? void 0 : options.prodMode) || true,
                        missingHandler: {
                            allowEmpty: (options === null || options === void 0 ? void 0 : options.allowEmpty) || true,
                            logMissingKey: (options === null || options === void 0 ? void 0 : options.logMissingKey) || false
                        },
                    })
                },
                {
                    provide: TRANSLOCO_LOADER,
                    useClass: translocoHttpLoader || TranslocoHttpLoader,
                }
            ]
        };
    }
}
TranslocoRootModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TranslocoRootModule });
TranslocoRootModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TranslocoRootModule_Factory(t) { return new (t || TranslocoRootModule)(); }, imports: [TranslocoModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TranslocoRootModule, { exports: function () { return [TranslocoModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TranslocoRootModule, [{
        type: NgModule,
        args: [{
                exports: [TranslocoModule]
            }]
    }], null, null); })();

class DsButtonModule {
}
DsButtonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsButtonModule });
DsButtonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsButtonModule_Factory(t) { return new (t || DsButtonModule)(); }, imports: [[
            ButtonModule,
            CommonModule,
            TranslocoRootModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsButtonModule, { declarations: function () { return [DsButtonComponent, DsButtonDirective]; }, imports: function () { return [ButtonModule,
        CommonModule, TranslocoRootModule]; }, exports: function () { return [DsButtonComponent, DsButtonDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [DsButtonComponent, DsButtonDirective],
                imports: [
                    ButtonModule,
                    CommonModule,
                    TranslocoRootModule
                ],
                exports: [DsButtonComponent, DsButtonDirective]
            }]
    }], null, null); })();

class DsCalendarComponent {
    constructor(primengconfig, translocoService) {
        this.primengconfig = primengconfig;
        this.translocoService = translocoService;
        /**
         * Określa domyślną datę w inpucie.
         * @type Date
         * @default null
         */
        this.defaultDate = null;
        /**
         * Określa mnogość wyboru.
         * @type 'single' | 'multiple' | 'range'
         * @default 'single'
         */
        this.selectionMode = 'single';
        /**
         * Wbudowany styl nadany elementowi.
         * @type string
         * @default null
         */
        this.style = null;
        /**
         * Określa klasę stylu dla elementu.
         * @type string
         * @default null
         */
        this.styleClass = null;
        /**
         * Wbudowany styl dla inputu.
         * @type string
         * @default null
         */
        this.inputStyle = null;
        /**
         * Określa klasę stylu dla inputu.
         * @type string
         * @default null
         */
        this.inputStyleClass = null;
        /**
         * Określa jakie ID ma być nadane inputowi.
         * Jeśli zostawione puste to będzie nadane wygenerowane ID.
         * @type string
         * @default null
         */
        this.inputId = null;
        /**
         * Określa nazwę inputu.
         * @type string
         * @default null
         */
        this.name = null;
        /**
         * Określa podpowiedź do tego, jakiej wartości spodziewamy się w inpucie.
         * @type string
         * @default null
         */
        this.placeholder = null;
        /**
         * Określa czy input ma być nieaktywny.
         * @type boolean
         * @default false
         */
        this.disabled = false;
        /**
         * Format daty wyświetlany w inpucie.
         * d - dzień miesiąca (bez wiodącego zera)
         * dd - dzień miesiąca (dwie cyfry)
         * o - dzień roku (bez wiodących zer)
         * oo - dzień roku (trzy cyfry)
         * D - skrót nazwy dnia
         * DD - długa nazwa dnia
         * m - miesiąc (bez wiodącego zera)
         * mm - miesiąc (dwie cyfry)
         * M - krótka nazwa miesiąca
         * MM - długa nazwa miesiąca
         * y - rok (dwie cyfry)
         * yy - rok (cztery cyfry)
         * @ - Unix timestamp (ms od 01/01/1970)
         * ! - Windows ticks (100ns od 01/01/0001)
         * '...' - dosłowny tekst
         * '' - apostrof
         * wszystko inne - dosłowny tekst
         * @type string
         * @default 'yy-mm-dd'
         */
        this.dateFormat = 'yy-mm-dd';
        /**
         * Określa, czy ma być wyświetlany input czy sam kalendarz.
         * True - wyświetlany jest kalendarz na stałe.
         * False - na stałe wyświetlany jest input, a kalendarz jest pop-upem.
         * @type boolean
         * @default false
         */
        this.inline = false;
        /**
         * Czy mają być pokazane dni z sąsiadujących miesięcy na początku i na końcu kalendarza.
         * Czy wyświetlać dni z sąsiednich miesięcy (nie do wyboru) na początku i na końcu bieżącego miesiąca.
         * Aby umożliwić wybieranie tych dni, należy użyć selectOtherMonths.
         * @type boolean
         * @default true
         */
        this.showOtherMonths = true;
        /**
         * Określa czy dni z sąsiednich miesięcy są możliwe do wyboru.
         * Działa tylko wtedy, gdy parametr showOtherMonths jest ustawiony na true.
         * @type boolean
         * @default true
         */
        this.selectOtherMonths = true;
        /**
         * Po włączeniu wyświetlany jest przycisk z ikoną obok inputu.
         * @type boolean
         * @default false
         */
        this.showIcon = false;
        /**
         * Po wyłączeniu kalendarz nie będzie się pojawiać przy ustawieniu focusu na input.
         * Panel kalendarza pojawi się po kliknięciu przycisku, który włącza się parametrem [showIcon]
         * @type boolean
         * @default true
         */
        this.showOnFocus = true;
        /**
         * Ikona przycisku kalendarza, kiedy parametr showIcon będzie ustawiony na true.
         * @type string
         * @default 'pi pi-calendar'
         */
        this.icon = 'pi pi-calendar';
        // /** zakomentowane, bo nie działa
        //  * Element docelowy, do którego będzie dołączony panel kalendarza.
        //  * Poprawnymi wartościami są 'body' lub lokalna zmienna ng-template innego elementu, np. [appendTo]="myDiv" dla elementu posiadającego #myDiv jako nazwę zmiennej
        //  * @type any
        //  * @default null
        //  */
        this.appendTo = null;
        /**
         * Kiedy ustawione na true, zapobiega ręcznemu wpisaniu daty za pomocą klawiatury.
         * @type boolean
         * @default null
         */
        this.readonlyInput = null;
        /** Określa ostatni rok stulecia, na którym operuje kalendarz, kiedy format roku jest dwucyfrowy.
         * Przy domyślnej wartości (+10), dla roku 2020, kalendarz operuje na stuleciu trwającym w latach 1931 - 2030
         * @type string
         * @default '+10'
         */
        this.shortYearCutoff = '+10';
        /**
         * Określa najmniejszą datę możliwą do wybrania.
         * @type Date
         * @default null
         */
        this.minDate = null;
        /**
         * Określa największą datę możliwą do wybrania
         * @type Date
         * @default null
         */
        this.maxDate = null;
        /**
         * Lista dat, które mają być nieaktywne
         * @type Array<date>
         * @default null
         */
        this.disabledDates = null;
        /**
         * Tablica z numerami dni tygodnia, które powinny być nieaktywne (nie do wyboru).
         * Numeracja dni tygodnia zaczyna się od 1.
         * @type Array<number>
         * @default null
         */
        this.disabledDays = null;
        /**
         * Zakres lat w dropdownie do wyboru roku, kiedy włączony jest parametr {yearNavigator}.
         * Napis przyjmuje format nnnn:nnnn, np. '2000:2020'
         * @type string
         * @default null
         */
        this.yearRange = null;
        /**
         * Czy wyświetlać zegar do wyboru czasu.
         * @type boolean
         * @default false
         */
        this.showTime = false;
        /**
         * Określa format czasu na 12- lub 24-godzinny.
         * @type string
         * @default '24'
         */
        this.hourFormat = '24';
        /**
         * Czy wyświetlać tylko zegar do wyboru czasu.
         * @type boolean
         * @default false
         */
        this.timeOnly = false;
        /**
         * Znak oddzielający godziny od minut.
         * @type string
         * @default ':'
         */
        this.timeSeparator = ':';
        /**
         * Typ wartości zapisywanej do ngModel.
         * @type 'date' | 'string'
         * @default 'date'
         */
        this.dataType = 'date';
        /**
         * Określa tab index elementu.
         * @type number
         * @default null
         */
        this.tabindex = null;
        /**
         * Ustanawia relację między komponentem a etykietą(-ami). Ta wartość powinna być ID elementu.
         * @type string
         * @default null
         */
        this.ariaLabelledBy = null;
        /**
         * Czy pokazać sekundy w zegarze do wyboru czasu.
         * @type boolean
         * @default false
         */
        this.showSeconds = false;
        /**
         * Krok zmiany godzin.
         * @type number
         * @default 1
         */
        this.stepHour = 1;
        /**
         * Krok zmiany minut.
         * @type number
         * @default 1
         */
        this.stepMinute = 1;
        /**
         * Krok zmiany sekund.
         * @type number
         * @default 1
         */
        this.stepSecond = 1;
        /**
         * Maksymalna liczba dat, które można wybrać, kiedy [selectionMode]="'multiple'".
         * @type number
         * @default null
         */
        this.maxDateCount = null;
        /**
         * Czy wyświetlić przyciski w stopce kalendarza do wyczyszczenia wartości i wybrania dzisiejszego dnia.
         * @type boolean
         * @default false
         */
        this.showButtonBar = true;
        /**
         * Określa styl klasy przycisku do wybierania dzisiejszej daty.
         * @type string
         * @default 'p-secondary-button'
         */
        this.todayButtonStyleClass = 'p-secondary-button';
        /**
         * Określa styl klasy przycisku do czyszczenia wybranych dat.
         * @type string
         * @default 'p-secondary-button'
         */
        this.clearButtonStyleClass = 'p-secondary-button';
        /**
         * Określa bazowy zIndex do użycia przy warstwowaniu.
         * @type number
         * @default 0
         */
        this.baseZIndex = 0;
        /**
         * Określa czy automatycznie zarządzać warstwowaniem.
         * @type boolean
         * @default true
         */
        this.autoZIndex = true;
        /**
         * Klasa stylu panelu kalendarza i zegara.
         * @type string
         * @default null
         */
        this.panelStyleClass = null;
        /**
         * Wbudowany styl panelu kalendarza i zegara.
         * @type object
         * @default null
         */
        this.panelStyle = null;
        /**
         * Czy zachować niepoprawną wartość, kiedy input straci focus.
         * @type boolean
         * @default false
         */
        this.keepInvalid = false;
        /**
         * Czy schować panel kalendarza po wybraniu daty.
         * @type boolean
         * @default true
         */
        this.hideOnDateTimeSelect = true;
        /**
         * Liczba miesięcy do wyświetlenia w panelu kalendarza.
         * Początkowo wyświetlany jest aktualny i przyszłe miesiące.
         * @type number
         * @default 1
         */
        this.numberOfMonths = 1;
        /**
         * Tryb widoku do wybierania.
         * 'date' - wybór daty dziennej, 'month' - wybór miesiąca
         * @type 'date' | 'month'
         * @default 'date'
         */
        this.view = 'date';
        /**
         * Separator dat kiedy [selectionMode]="'multiple'"
         * @type string
         * @default ','
         */
        this.multipleSeparator = ',';
        /**
         * Separator dat kiedy [selectionMode]="'range'"
         * @type string
         * @default '-'
         */
        this.rangeSeparator = '-';
        /**
         * Po włączeniu tej funkcji panel kalendarza jest wyświetlany jako zoptymalizowany dla urządzeń z ekranem dotykowym.
         * Panel kalendarza jest wyświetlany jako modal oraz ma dodaną klasę p-datepicker-touch-ui.
         * @type boolean
         * @default false
         */
        this.touchUI = false;
        /**
         * Czy focus ma przechodzić tylko pomiędzy elementami w panelu kalendarza.
         * @type boolean
         * @default true
         */
        this.focusTrap = true;
        /**
         * Animacja przejścia, która jest przy pojawianiu się panelu kalendarza.
         * @type string
         * @default '.12s cubic-bezier(0, 0, 0.2, 1)'
         */
        this.showTransitionOptions = '.12s cubic-bezier(0, 0, 0.2, 1)';
        /**
         * Animacja przejścia, która jest przy chowaniu się panelu kalendarza.
         * @type string
         * @default '.1s linear'
         */
        this.hideTransitionOptions = '.1s linear';
        /**
         * Określa, czy w inpucie po prawej stronie ma być ikona X, która po kliknięciu usuwa tekst w inpucie
         * @type boolean
         * @default true
         * */
        this.showClear = false;
        /**
         * Wyświetla więcej informacji po najechaniu myszką na ikonę
         * @type string
         * @default 'Wybierz datę'
         * */
        this.iconRightTitle = 'Wybierz datę';
        /**
         * Określa jaka ikona ma się wyświetlać w buttonie. Dostępne ikony znajdują się na stronie [PrimeNG/Icons]{@link https://www.primefaces.org/primeng/v9.1.4-lts/#/icons}
         * np. 'pi-search'
         * @type string
         * @default undefined
         * */
        this.disablePDatepickerToday = false;
        /**
         * Okresla od którego dnia tygodnia ma startować tydzień
         * np. '1'
         * @type string
         * @default 1
         * */
        this.firstDayOfWeek = '1';
        /**
         * Okresla czy przycisk "Today" ma być widoczny
         * np. '1'
         * @type boolean
         * @default false
         * */
        this.hideTodayButton = false;
        this.ngModelChange = new EventEmitter();
        this.onSelect = new EventEmitter();
        this.onBlur = new EventEmitter();
        this.onFocus = new EventEmitter();
        this.onClose = new EventEmitter();
        this.onShow = new EventEmitter();
        this.onClickOutside = new EventEmitter();
        this.onInput = new EventEmitter();
        this.onTodayClick = new EventEmitter();
        this.onClearClick = new EventEmitter();
        this.onMonthChange = new EventEmitter();
        this.onYearChange = new EventEmitter();
        this.onClear = new EventEmitter();
        this.onChange = () => {
        };
        this.onTouch = () => {
        };
        this.primengconfig.setTranslation(this.translocoService.translateObject('primeng'));
    }
    ngOnInit() {
        this.pl = {
            firstDayOfWeek: 1,
            dayNames: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
            dayNamesShort: ["Nie", "Pon", "Wt", "Śr", "Czw", "Pt", "Sob"],
            dayNamesMin: ["Nie", "Pon", "Wt", "Śr", "Czw", "Pt", "Sob"],
            monthNames: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
            monthNamesShort: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
            today: 'Dziś',
            clear: 'Wyczyść',
            dateFormat: 'yyyy-MM-dd',
            weekHeader: 'Tydz.'
        };
        if (this.inputId == undefined) {
            this.inputId = Utils.wygenerujLosoweId();
        }
        if (this.hideTodayButton) {
            this.todayButtonStyleClass = 'visibility-hidden';
        }
    }
    clear() {
        if (this.disabled)
            return;
        this.ngModel = null;
        this.onChange(null);
        this.ngModelChange.emit(null);
        this.onClear.emit();
    }
    focus(event) {
        this.calendar.toggle();
        event.stopPropagation();
    }
    writeValue(value) {
        this.ngModel = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    onChangeWrapper(date) {
        this.ngModel = date;
        this.onChange(date);
    }
}
DsCalendarComponent.ɵfac = function DsCalendarComponent_Factory(t) { return new (t || DsCalendarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc8.PrimeNGConfig), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.TranslocoService)); };
DsCalendarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsCalendarComponent, selectors: [["ds-calendar"]], viewQuery: function DsCalendarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(Calendar, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.calendar = _t.first);
    } }, hostAttrs: [1, "ds-calendar"], inputs: { defaultDate: "defaultDate", selectionMode: "selectionMode", style: "style", styleClass: "styleClass", inputStyle: "inputStyle", inputStyleClass: "inputStyleClass", inputId: "inputId", name: "name", placeholder: "placeholder", disabled: "disabled", dateFormat: "dateFormat", inline: "inline", showOtherMonths: "showOtherMonths", selectOtherMonths: "selectOtherMonths", showIcon: "showIcon", showOnFocus: "showOnFocus", icon: "icon", appendTo: "appendTo", readonlyInput: "readonlyInput", shortYearCutoff: "shortYearCutoff", minDate: "minDate", maxDate: "maxDate", disabledDates: "disabledDates", disabledDays: "disabledDays", yearRange: "yearRange", showTime: "showTime", hourFormat: "hourFormat", timeOnly: "timeOnly", timeSeparator: "timeSeparator", dataType: "dataType", tabindex: "tabindex", ariaLabelledBy: "ariaLabelledBy", showSeconds: "showSeconds", stepHour: "stepHour", stepMinute: "stepMinute", stepSecond: "stepSecond", maxDateCount: "maxDateCount", showButtonBar: "showButtonBar", todayButtonStyleClass: "todayButtonStyleClass", clearButtonStyleClass: "clearButtonStyleClass", baseZIndex: "baseZIndex", autoZIndex: "autoZIndex", panelStyleClass: "panelStyleClass", panelStyle: "panelStyle", keepInvalid: "keepInvalid", hideOnDateTimeSelect: "hideOnDateTimeSelect", numberOfMonths: "numberOfMonths", view: "view", multipleSeparator: "multipleSeparator", rangeSeparator: "rangeSeparator", touchUI: "touchUI", focusTrap: "focusTrap", showTransitionOptions: "showTransitionOptions", hideTransitionOptions: "hideTransitionOptions", showClear: "showClear", iconRightTitle: "iconRightTitle", disablePDatepickerToday: "disablePDatepickerToday", firstDayOfWeek: "firstDayOfWeek", hideTodayButton: "hideTodayButton", ngModel: "ngModel", label: "label", showWeek: "showWeek", monthNavigator: "monthNavigator", yearNavigator: "yearNavigator", required: "required", iconLeftTitle: "iconLeftTitle", iconLeft: "iconLeft", iconRight: "iconRight", ariaLabel: "ariaLabel" }, outputs: { ngModelChange: "ngModelChange", onSelect: "onSelect", onBlur: "onBlur", onFocus: "onFocus", onClose: "onClose", onShow: "onShow", onClickOutside: "onClickOutside", onInput: "onInput", onTodayClick: "onTodayClick", onClearClick: "onClearClick", onMonthChange: "onMonthChange", onYearChange: "onYearChange", onClear: "onClear" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => DsCalendarComponent)
            },
        ])], decls: 8, vars: 80, consts: [[1, "ds-calendar-label", 3, "for"], [1, "ds-calendar-wrapper"], [3, "title", "class", 4, "ngIf"], [3, "defaultDate", "selectionMode", "styleClass", "inputStyle", "inputStyleClass", "inputId", "name", "placeholder", "disabled", "dateFormat", "inline", "showOtherMonths", "selectOtherMonths", "showIcon", "showOnFocus", "showWeek", "icon", "readonlyInput", "shortYearCutoff", "minDate", "maxDate", "disabledDates", "disabledDays", "monthNavigator", "yearNavigator", "yearRange", "showTime", "hourFormat", "locale", "timeOnly", "timeSeparator", "dataType", "required", "tabindex", "ariaLabelledBy", "showSeconds", "stepHour", "stepMinute", "stepSecond", "maxDateCount", "showButtonBar", "todayButtonStyleClass", "clearButtonStyleClass", "baseZIndex", "autoZIndex", "panelStyleClass", "panelStyle", "keepInvalid", "hideOnDateTimeSelect", "numberOfMonths", "view", "multipleSeparator", "rangeSeparator", "touchUI", "focusTrap", "showTransitionOptions", "hideTransitionOptions", "ngModel", "appendTo", "firstDayOfWeek", "ngModelChange"], ["class", "pi pi-times ds-input-show-clear", 3, "tabindex", "icon-right", "is-disabled", "click", "keydown.enter", 4, "ngIf"], [3, "class", "title", "click", 4, "ngIf"], ["class", "ds-input-error-message", 4, "ngIf"], [3, "title"], [1, "pi", "pi-times", "ds-input-show-clear", 3, "tabindex", "click", "keydown.enter"], [3, "title", "click"], [1, "ds-input-error-message"]], template: function DsCalendarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DsCalendarComponent_i_3_Template, 1, 4, "i", 2);
        ɵngcc0.ɵɵelementStart(4, "p-calendar", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsCalendarComponent_Template_p_calendar_ngModelChange_4_listener($event) { return ctx.onChangeWrapper($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DsCalendarComponent_i_5_Template, 1, 5, "i", 4);
        ɵngcc0.ɵɵtemplate(6, DsCalendarComponent_i_6_Template, 1, 4, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, DsCalendarComponent_span_7_Template, 1, 0, "span", 6);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("is-readonly", false)("has-left-icon", ctx.iconLeft)("has-right-icon", ctx.iconRight)("has-clear-icon", ctx.showClear)("is-disabled", ctx.disabled);
        ɵngcc0.ɵɵproperty("defaultDate", ctx.defaultDate)("selectionMode", ctx.selectionMode)("styleClass", ctx.styleClass)("inputStyle", ctx.inputStyle)("inputStyleClass", ctx.inputStyleClass)("inputId", ctx.inputId)("name", ctx.name)("placeholder", ctx.placeholder)("disabled", ctx.disabled)("dateFormat", ctx.dateFormat)("inline", ctx.inline)("showOtherMonths", ctx.showOtherMonths)("selectOtherMonths", ctx.selectOtherMonths)("showIcon", ctx.showIcon)("showOnFocus", ctx.showOnFocus)("showWeek", ctx.showWeek)("icon", ctx.icon)("readonlyInput", ctx.readonlyInput)("shortYearCutoff", ctx.shortYearCutoff)("minDate", ctx.minDate)("maxDate", ctx.maxDate)("disabledDates", ctx.disabledDates)("disabledDays", ctx.disabledDays)("monthNavigator", ctx.monthNavigator)("yearNavigator", ctx.yearNavigator)("yearRange", ctx.yearRange)("showTime", ctx.showTime)("hourFormat", ctx.hourFormat)("locale", ctx.pl)("timeOnly", ctx.timeOnly)("timeSeparator", ctx.timeSeparator)("dataType", ctx.dataType)("required", ctx.required)("tabindex", ctx.tabindex)("ariaLabelledBy", ctx.ariaLabelledBy)("showSeconds", ctx.showSeconds)("stepHour", ctx.stepHour)("stepMinute", ctx.stepMinute)("stepSecond", ctx.stepSecond)("maxDateCount", ctx.maxDateCount)("showButtonBar", ctx.showButtonBar)("todayButtonStyleClass", ctx.todayButtonStyleClass)("clearButtonStyleClass", ctx.clearButtonStyleClass)("baseZIndex", ctx.baseZIndex)("autoZIndex", ctx.autoZIndex)("panelStyleClass", ctx.panelStyleClass)("panelStyle", ctx.panelStyle)("keepInvalid", ctx.keepInvalid)("hideOnDateTimeSelect", ctx.hideOnDateTimeSelect)("numberOfMonths", ctx.numberOfMonths)("view", ctx.view)("multipleSeparator", ctx.multipleSeparator)("rangeSeparator", ctx.rangeSeparator)("touchUI", ctx.touchUI)("focusTrap", ctx.focusTrap)("showTransitionOptions", ctx.showTransitionOptions)("hideTransitionOptions", ctx.hideTransitionOptions)("ngModel", ctx.ngModel)("appendTo", ctx.appendTo)("firstDayOfWeek", ctx.firstDayOfWeek);
        ɵngcc0.ɵɵattribute("disablePDatepickerToday", ctx.disablePDatepickerToday ? "" : null)("aria-label", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.disabled);
    } }, directives: [ɵngcc2.NgIf, ɵngcc9.Calendar, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], encapsulation: 2 });
DsCalendarComponent.ctorParameters = () => [
    { type: PrimeNGConfig },
    { type: TranslocoService }
];
DsCalendarComponent.propDecorators = {
    label: [{ type: Input }],
    defaultDate: [{ type: Input }],
    selectionMode: [{ type: Input }],
    style: [{ type: Input }],
    styleClass: [{ type: Input }],
    inputStyle: [{ type: Input }],
    inputStyleClass: [{ type: Input }],
    inputId: [{ type: Input }],
    name: [{ type: Input }],
    placeholder: [{ type: Input }],
    disabled: [{ type: Input }],
    dateFormat: [{ type: Input }],
    inline: [{ type: Input }],
    showOtherMonths: [{ type: Input }],
    selectOtherMonths: [{ type: Input }],
    showIcon: [{ type: Input }],
    showOnFocus: [{ type: Input }],
    showWeek: [{ type: Input }],
    icon: [{ type: Input }],
    appendTo: [{ type: Input }],
    readonlyInput: [{ type: Input }],
    shortYearCutoff: [{ type: Input }],
    minDate: [{ type: Input }],
    maxDate: [{ type: Input }],
    disabledDates: [{ type: Input }],
    disabledDays: [{ type: Input }],
    monthNavigator: [{ type: Input }],
    yearNavigator: [{ type: Input }],
    yearRange: [{ type: Input }],
    showTime: [{ type: Input }],
    hourFormat: [{ type: Input }],
    timeOnly: [{ type: Input }],
    timeSeparator: [{ type: Input }],
    dataType: [{ type: Input }],
    required: [{ type: Input }],
    tabindex: [{ type: Input }],
    ariaLabelledBy: [{ type: Input }],
    showSeconds: [{ type: Input }],
    stepHour: [{ type: Input }],
    stepMinute: [{ type: Input }],
    stepSecond: [{ type: Input }],
    maxDateCount: [{ type: Input }],
    showButtonBar: [{ type: Input }],
    todayButtonStyleClass: [{ type: Input }],
    clearButtonStyleClass: [{ type: Input }],
    baseZIndex: [{ type: Input }],
    autoZIndex: [{ type: Input }],
    panelStyleClass: [{ type: Input }],
    panelStyle: [{ type: Input }],
    keepInvalid: [{ type: Input }],
    hideOnDateTimeSelect: [{ type: Input }],
    numberOfMonths: [{ type: Input }],
    view: [{ type: Input }],
    multipleSeparator: [{ type: Input }],
    rangeSeparator: [{ type: Input }],
    touchUI: [{ type: Input }],
    focusTrap: [{ type: Input }],
    showTransitionOptions: [{ type: Input }],
    hideTransitionOptions: [{ type: Input }],
    showClear: [{ type: Input }],
    iconRightTitle: [{ type: Input }],
    iconLeftTitle: [{ type: Input }],
    iconLeft: [{ type: Input }],
    iconRight: [{ type: Input }],
    disablePDatepickerToday: [{ type: Input }],
    firstDayOfWeek: [{ type: Input }],
    hideTodayButton: [{ type: Input }],
    ngModel: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    ngModelChange: [{ type: Output }],
    onSelect: [{ type: Output }],
    onBlur: [{ type: Output }],
    onFocus: [{ type: Output }],
    onClose: [{ type: Output }],
    onShow: [{ type: Output }],
    onClickOutside: [{ type: Output }],
    onInput: [{ type: Output }],
    onTodayClick: [{ type: Output }],
    onClearClick: [{ type: Output }],
    onMonthChange: [{ type: Output }],
    onYearChange: [{ type: Output }],
    onClear: [{ type: Output }],
    calendar: [{ type: ViewChild, args: [Calendar,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsCalendarComponent, [{
        type: Component,
        args: [{
                selector: 'ds-calendar',
                template: `
      <label class="ds-calendar-label" [for]="inputId">{{label}}</label>
      <div class="ds-calendar-wrapper">
          <i
                  [title]="iconLeftTitle"
                  *ngIf="iconLeft"
                  class="pi {{iconLeft}} ds-input-icon-left"
          >
          </i>
          <p-calendar
                  [defaultDate]="defaultDate"
                  [selectionMode]="selectionMode"
                  [style]="style"
                  [styleClass]="styleClass"
                  [inputStyle]="inputStyle"
                  [inputStyleClass]="inputStyleClass"
                  [inputId]="inputId"
                  [name]="name"
                  [placeholder]="placeholder"
                  [disabled]="disabled"
                  [dateFormat]="dateFormat"
                  [inline]="inline"
                  [showOtherMonths]="showOtherMonths"
                  [selectOtherMonths]="selectOtherMonths"
                  [showIcon]="showIcon"
                  [showOnFocus]="showOnFocus"
                  [showWeek]="showWeek"
                  [icon]="icon"
                  [readonlyInput]="readonlyInput"
                  [shortYearCutoff]="shortYearCutoff"
                  [minDate]="minDate"
                  [maxDate]="maxDate"
                  [disabledDates]="disabledDates"
                  [disabledDays]="disabledDays"
                  [monthNavigator]="monthNavigator"
                  [yearNavigator]="yearNavigator"
                  [yearRange]="yearRange"
                  [showTime]="showTime"
                  [hourFormat]="hourFormat"
                  [locale]="pl"
                  [timeOnly]="timeOnly"
                  [timeSeparator]="timeSeparator"
                  [dataType]="dataType"
                  [required]="required"
                  [tabindex]="tabindex"
                  [ariaLabelledBy]="ariaLabelledBy"
                  [showSeconds]="showSeconds"
                  [stepHour]="stepHour"
                  [stepMinute]="stepMinute"
                  [stepSecond]="stepSecond"
                  [maxDateCount]="maxDateCount"
                  [showButtonBar]="showButtonBar"
                  [todayButtonStyleClass]="todayButtonStyleClass"
                  [clearButtonStyleClass]="clearButtonStyleClass"
                  [baseZIndex]="baseZIndex"
                  [autoZIndex]="autoZIndex"
                  [panelStyleClass]="panelStyleClass"
                  [panelStyle]="panelStyle"
                  [keepInvalid]="keepInvalid"
                  [hideOnDateTimeSelect]="hideOnDateTimeSelect"
                  [numberOfMonths]="numberOfMonths"
                  [view]="view"
                  [multipleSeparator]="multipleSeparator"
                  [rangeSeparator]="rangeSeparator"
                  [touchUI]="touchUI"
                  [focusTrap]="focusTrap"
                  [showTransitionOptions]="showTransitionOptions"
                  [hideTransitionOptions]="hideTransitionOptions"
                  [ngModel]="ngModel"
                  [class.is-readonly]="false"
                  [class.has-left-icon]="iconLeft"
                  [class.has-right-icon]="iconRight"
                  [class.has-clear-icon]="showClear"
                  [class.is-disabled]="disabled"
                  [attr.disablePDatepickerToday]="disablePDatepickerToday ? '' : null"
                  [appendTo]="appendTo"
                  (ngModelChange)="onChangeWrapper($event)"
                  [attr.aria-label]="ariaLabel"
                  [firstDayOfWeek]="firstDayOfWeek"
          >
          </p-calendar>
          <i
                  class="pi pi-times ds-input-show-clear"
                  tabindex="{{ disabled ? '-1' : '0' }}"
                  *ngIf="showClear"
                  (click)="clear()"
                  (keydown.enter)="clear()"
                  [class.icon-right]="iconRight"
                  [class.is-disabled]="disabled"
          >
          </i>
          <i
                  *ngIf="iconRight"
                  class="pi {{iconRight}} ds-input-icon-right"
                  [title]="iconRightTitle"
                  (click)="focus($event)"
          >
          </i>
      </div>
      <span
              class="ds-input-error-message"
              *ngIf="!this.disabled"
      >
      </span>
  `,
                host: {
                    'class': 'ds-calendar'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => DsCalendarComponent)
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc8.PrimeNGConfig }, { type: ɵngcc7.TranslocoService }]; }, { defaultDate: [{
            type: Input
        }], selectionMode: [{
            type: Input
        }], style: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], inputStyle: [{
            type: Input
        }], inputStyleClass: [{
            type: Input
        }], inputId: [{
            type: Input
        }], name: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], disabled: [{
            type: Input
        }], dateFormat: [{
            type: Input
        }], inline: [{
            type: Input
        }], showOtherMonths: [{
            type: Input
        }], selectOtherMonths: [{
            type: Input
        }], showIcon: [{
            type: Input
        }], showOnFocus: [{
            type: Input
        }], icon: [{
            type: Input
        }], appendTo: [{
            type: Input
        }], readonlyInput: [{
            type: Input
        }], shortYearCutoff: [{
            type: Input
        }], minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], disabledDates: [{
            type: Input
        }], disabledDays: [{
            type: Input
        }], yearRange: [{
            type: Input
        }], showTime: [{
            type: Input
        }], hourFormat: [{
            type: Input
        }], timeOnly: [{
            type: Input
        }], timeSeparator: [{
            type: Input
        }], dataType: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], ariaLabelledBy: [{
            type: Input
        }], showSeconds: [{
            type: Input
        }], stepHour: [{
            type: Input
        }], stepMinute: [{
            type: Input
        }], stepSecond: [{
            type: Input
        }], maxDateCount: [{
            type: Input
        }], showButtonBar: [{
            type: Input
        }], todayButtonStyleClass: [{
            type: Input
        }], clearButtonStyleClass: [{
            type: Input
        }], baseZIndex: [{
            type: Input
        }], autoZIndex: [{
            type: Input
        }], panelStyleClass: [{
            type: Input
        }], panelStyle: [{
            type: Input
        }], keepInvalid: [{
            type: Input
        }], hideOnDateTimeSelect: [{
            type: Input
        }], numberOfMonths: [{
            type: Input
        }], view: [{
            type: Input
        }], multipleSeparator: [{
            type: Input
        }], rangeSeparator: [{
            type: Input
        }], touchUI: [{
            type: Input
        }], focusTrap: [{
            type: Input
        }], showTransitionOptions: [{
            type: Input
        }], hideTransitionOptions: [{
            type: Input
        }], showClear: [{
            type: Input
        }], iconRightTitle: [{
            type: Input
        }], disablePDatepickerToday: [{
            type: Input
        }], firstDayOfWeek: [{
            type: Input
        }], hideTodayButton: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], onSelect: [{
            type: Output
        }], onBlur: [{
            type: Output
        }], onFocus: [{
            type: Output
        }], onClose: [{
            type: Output
        }], onShow: [{
            type: Output
        }], onClickOutside: [{
            type: Output
        }], onInput: [{
            type: Output
        }], onTodayClick: [{
            type: Output
        }], onClearClick: [{
            type: Output
        }], onMonthChange: [{
            type: Output
        }], onYearChange: [{
            type: Output
        }], onClear: [{
            type: Output
        }], ngModel: [{
            type: Input
        }], label: [{
            type: Input
        }], showWeek: [{
            type: Input
        }], monthNavigator: [{
            type: Input
        }], yearNavigator: [{
            type: Input
        }], required: [{
            type: Input
        }], iconLeftTitle: [{
            type: Input
        }], iconLeft: [{
            type: Input
        }], iconRight: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], calendar: [{
            type: ViewChild,
            args: [Calendar]
        }] }); })();

class DsCalendarModule {
}
DsCalendarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsCalendarModule });
DsCalendarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsCalendarModule_Factory(t) { return new (t || DsCalendarModule)(); }, imports: [[
            CommonModule,
            CalendarModule,
            FormsModule,
            ReactiveFormsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsCalendarModule, { declarations: function () { return [DsCalendarComponent]; }, imports: function () { return [CommonModule,
        CalendarModule,
        FormsModule,
        ReactiveFormsModule]; }, exports: function () { return [DsCalendarComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsCalendarModule, [{
        type: NgModule,
        args: [{
                declarations: [DsCalendarComponent],
                imports: [
                    CommonModule,
                    CalendarModule,
                    FormsModule,
                    ReactiveFormsModule,
                ],
                exports: [
                    DsCalendarComponent
                ]
            }]
    }], null, null); })();

class DsCheckboxComponent {
    constructor() {
        /**
         * Określa nazwę checkboxa
         * @type string
         * @default null
         * */
        this.name = null;
        /**
         * Określa wartość checkboxa inputu przy jego wczytaniu na stronie
         * @type any
         * @default null
         * */
        this.value = null;
        /**
         * Etykieta znajdująca się obok checkboxa
         * @type string
         * @default null
         * */
        this.label = null;
        /**
         * Pozwala wybrać wartość boolean zamiast kilku wartości
         * @type boolean
         * @default false
         * */
        this.binary = false;
        /**
         * Określa tab index elementu
         * @type number
         * @default null
         * */
        this.tabindex = null;
        /**
         * ID elementu.
         * @type string
         * @default null
         * */
        this.inputId = null;
        /**
         * Ustanawia relację między komponentem a etykietą(-ami). Ta wartość powinna być ID elementu
         * @type string
         * @default null
         * */
        this.ariaLabelledBy = null;
        /**
         * Wbudowany styl nadany elementowi.
         * @type string
         * @default null
         * */
        this.style = null;
        /**
         * Określa klasę stylu dla elementu.
         * @type string
         * @default null
         * */
        this.styleClass = null;
        /**
         * Określa klasę dla stylów dla etykiet checkboxa
         * @type string
         * @default null
         * */
        this.labelStyleClass = null;
        /**
         * Określa, jaka ikona ma sie pokazywać w checkboxie kiedy jest on zaznaczony
         * @type string
         * @default 'pi pi-check'
         * */
        this.checkboxIcon = 'pi pi-check';
        /**
         * Określa, czy checkbox ma być tylko do odczytu
         * @type boolean
         * @default false
         * */
        this.readonly = false;
        /**
         * Określa, czy wymagane jest wypełnienie checkboxa w formularzu (w podejściu opartym na szablonach)
         * @type boolean
         * @default false
         * */
        this.required = false;
        this.ngModelChange = new EventEmitter();
        this.disabled = false;
        this.onChange = () => {
        };
        this.onTouch = () => {
        };
    }
    ngOnInit() {
        if (this.inputId == undefined) {
            this.inputId = Utils.wygenerujLosoweId();
        }
        if (this.label == null) {
            this.label = 'checkbox';
            this.labelStyleClass = this.labelStyleClass + ' p-checkbox-label-display-none';
        }
    }
    writeValue(value) {
        this.binary = true;
        this.ngModel = value;
        if (typeof this.ngModel == 'object' && this.ngModel) {
            this.readonly = this.ngModel.readonly;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
DsCheckboxComponent.ɵfac = function DsCheckboxComponent_Factory(t) { return new (t || DsCheckboxComponent)(); };
DsCheckboxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsCheckboxComponent, selectors: [["ds-checkbox"]], inputs: { name: "name", value: "value", label: "label", binary: "binary", tabindex: "tabindex", inputId: "inputId", ariaLabelledBy: "ariaLabelledBy", style: "style", styleClass: "styleClass", labelStyleClass: "labelStyleClass", checkboxIcon: "checkboxIcon", readonly: "readonly", required: "required", ngModel: "ngModel", ariaLabel: "ariaLabel" }, outputs: { ngModelChange: "ngModelChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => DsCheckboxComponent)
            },
        ])], decls: 1, vars: 17, consts: [[3, "name", "value", "label", "disabled", "binary", "tabindex", "inputId", "ariaLabelledBy", "styleClass", "labelStyleClass", "checkboxIcon", "readonly", "required", "ngModel", "ngModelChange"]], template: function DsCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-checkbox", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsCheckboxComponent_Template_p_checkbox_ngModelChange_0_listener($event) { return ctx.onChange($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵproperty("name", ctx.name)("value", ctx.value)("label", ctx.label)("disabled", ctx.disabled)("binary", ctx.binary)("tabindex", ctx.tabindex)("inputId", ctx.inputId)("ariaLabelledBy", ctx.ariaLabelledBy)("styleClass", ctx.styleClass)("labelStyleClass", ctx.labelStyleClass)("checkboxIcon", ctx.checkboxIcon)("readonly", ctx.readonly)("required", ctx.required)("ngModel", ctx.ngModel);
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
    } }, directives: [ɵngcc10.Checkbox, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], encapsulation: 2 });
DsCheckboxComponent.ctorParameters = () => [];
DsCheckboxComponent.propDecorators = {
    name: [{ type: Input }],
    value: [{ type: Input }],
    label: [{ type: Input }],
    binary: [{ type: Input }],
    tabindex: [{ type: Input }],
    inputId: [{ type: Input }],
    ariaLabelledBy: [{ type: Input }],
    style: [{ type: Input }],
    styleClass: [{ type: Input }],
    labelStyleClass: [{ type: Input }],
    checkboxIcon: [{ type: Input }],
    readonly: [{ type: Input }],
    required: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    ngModel: [{ type: Input }],
    ngModelChange: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsCheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'ds-checkbox',
                template: `
    <p-checkbox
      [name]="name"
      [value]="value"
      [label]="label"
      [disabled]="disabled"
      [binary]="binary"
      [tabindex]="tabindex"
      [inputId]="inputId"
      [ariaLabelledBy]="ariaLabelledBy"
      [style]="style"
      [styleClass]="styleClass"
      [labelStyleClass]="labelStyleClass"
      [checkboxIcon]="checkboxIcon"
      [readonly]="readonly"
      [required]="required"
      [ngModel]="ngModel"
      (ngModelChange)="onChange($event)"
      [attr.aria-label]="ariaLabel"
    ></p-checkbox>
  `,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => DsCheckboxComponent)
                    },
                ]
            }]
    }], function () { return []; }, { name: [{
            type: Input
        }], value: [{
            type: Input
        }], label: [{
            type: Input
        }], binary: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], inputId: [{
            type: Input
        }], ariaLabelledBy: [{
            type: Input
        }], style: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], labelStyleClass: [{
            type: Input
        }], checkboxIcon: [{
            type: Input
        }], readonly: [{
            type: Input
        }], required: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], ngModel: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }] }); })();

class DsCheckboxModule {
}
DsCheckboxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsCheckboxModule });
DsCheckboxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsCheckboxModule_Factory(t) { return new (t || DsCheckboxModule)(); }, imports: [[
            CommonModule,
            CheckboxModule,
            ReactiveFormsModule,
            FormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsCheckboxModule, { declarations: function () { return [DsCheckboxComponent]; }, imports: function () { return [CommonModule,
        CheckboxModule,
        ReactiveFormsModule,
        FormsModule]; }, exports: function () { return [DsCheckboxComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsCheckboxModule, [{
        type: NgModule,
        args: [{
                declarations: [DsCheckboxComponent],
                imports: [
                    CommonModule,
                    CheckboxModule,
                    ReactiveFormsModule,
                    FormsModule
                ],
                exports: [
                    DsCheckboxComponent
                ]
            }]
    }], null, null); })();

class DsConfirmDialogComponent {
    constructor() {
        this.cancelLabel = 'Anuluj';
        this.okLabel = 'Potwierdzam';
        this.openDialogChange = new EventEmitter();
        this.closed = new EventEmitter();
    }
    close(accept) {
        this.openDialogChange.emit(false);
        this.closed.emit(accept);
    }
}
DsConfirmDialogComponent.ɵfac = function DsConfirmDialogComponent_Factory(t) { return new (t || DsConfirmDialogComponent)(); };
DsConfirmDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsConfirmDialogComponent, selectors: [["ds-confirm-dialog"]], inputs: { cancelLabel: "cancelLabel", okLabel: "okLabel", header: "header", icon: "icon", message: "message", width: "width", openDialog: "openDialog", appendTo: "appendTo", ariaLabel: "ariaLabel" }, outputs: { openDialogChange: "openDialogChange", closed: "closed" }, features: [ɵngcc0.ɵɵProvidersFeature([ConfirmationService])], decls: 6, vars: 17, consts: [[3, "header", "icon", "message", "visible", "closable", "appendTo"], ["severity", "border", 3, "label", "click"], ["severity", "primary", 3, "label", "click"]], template: function DsConfirmDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-confirmDialog", 0);
        ɵngcc0.ɵɵelementStart(1, "p-footer");
        ɵngcc0.ɵɵelementStart(2, "ds-button", 1);
        ɵngcc0.ɵɵlistener("click", function DsConfirmDialogComponent_Template_ds_button_click_2_listener() { return ctx.close(false); });
        ɵngcc0.ɵɵpipe(3, "transloco");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "ds-button", 2);
        ɵngcc0.ɵɵlistener("click", function DsConfirmDialogComponent_Template_ds_button_click_4_listener() { return ctx.close(true); });
        ɵngcc0.ɵɵpipe(5, "transloco");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction1(15, _c4, ctx.width));
        ɵngcc0.ɵɵproperty("header", ctx.header)("icon", "pi " + ctx.icon)("message", ctx.message)("visible", ctx.openDialog)("closable", false)("appendTo", ctx.appendTo);
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(3, 11, ctx.cancelLabel));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(5, 13, ctx.okLabel));
    } }, directives: [ɵngcc11.ConfirmDialog, ɵngcc8.Footer, DsButtonComponent], pipes: [ɵngcc7.TranslocoPipe], encapsulation: 2 });
DsConfirmDialogComponent.propDecorators = {
    header: [{ type: Input }],
    icon: [{ type: Input }],
    message: [{ type: Input }],
    width: [{ type: Input }],
    openDialog: [{ type: Input }],
    appendTo: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    cancelLabel: [{ type: Input }],
    okLabel: [{ type: Input }],
    openDialogChange: [{ type: Output }],
    closed: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsConfirmDialogComponent, [{
        type: Component,
        args: [{
                selector: 'ds-confirm-dialog',
                template: "<p-confirmDialog [style]=\"{ width: width }\" [header]=\"header\" [icon]=\"'pi ' + icon\" [message]=\"message\"\n    [visible]=\"openDialog\" [closable]=\"false\" [appendTo]=\"appendTo\" [attr.aria-label]=\"ariaLabel\">\n    <p-footer>\n        <ds-button severity=\"border\" label=\"{{ cancelLabel | transloco }}\"\n            (click)=\"close(false)\"></ds-button>\n        <ds-button severity=\"primary\" label=\"{{ okLabel | transloco }}\"\n            (click)=\"close(true)\"></ds-button>\n    </p-footer>\n</p-confirmDialog>",
                providers: [ConfirmationService]
            }]
    }], function () { return []; }, { cancelLabel: [{
            type: Input
        }], okLabel: [{
            type: Input
        }], openDialogChange: [{
            type: Output
        }], closed: [{
            type: Output
        }], header: [{
            type: Input
        }], icon: [{
            type: Input
        }], message: [{
            type: Input
        }], width: [{
            type: Input
        }], openDialog: [{
            type: Input
        }], appendTo: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }] }); })();

class DsConfirmDialogModule {
}
DsConfirmDialogModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsConfirmDialogModule });
DsConfirmDialogModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsConfirmDialogModule_Factory(t) { return new (t || DsConfirmDialogModule)(); }, imports: [[
            CommonModule,
            ConfirmDialogModule,
            DsButtonModule,
            TranslocoModule
        ], ConfirmDialogModule, DsButtonModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsConfirmDialogModule, { declarations: function () { return [DsConfirmDialogComponent]; }, imports: function () { return [CommonModule,
        ConfirmDialogModule, DsButtonModule, TranslocoModule]; }, exports: function () { return [DsConfirmDialogComponent, ConfirmDialogModule, DsButtonModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsConfirmDialogModule, [{
        type: NgModule,
        args: [{
                declarations: [DsConfirmDialogComponent],
                imports: [
                    CommonModule,
                    ConfirmDialogModule,
                    DsButtonModule,
                    TranslocoModule
                ],
                exports: [
                    DsConfirmDialogComponent,
                    ConfirmDialogModule,
                    DsButtonModule,
                ]
            }]
    }], null, null); })();

class DsDropdownComponent {
    constructor() {
        /**
         * Określa czy ma być wyświetlany input do filtrowania wartości
         * @type boolean
         * @default false
         */
        this.filter = false;
        /**
         * Kiedy właczone jest filtrowanie, decyduje według czego filtrować
         * @type string
         * @default 'label'
         */
        this.filterBy = 'label';
        /**
         * Określa w jaki sposób filtrowane są wartości.
         * Opcje to: 'contains', 'startsWith', 'endsWith', 'equals', 'notEquals', 'in', 'lt', 'lte', 'gt', 'gte'
         * @type string
         * @default 'contains'
         */
        this.filterMatchMode = 'contains';
        /**
         * Tekst placeholdera, który pokazuje się kiedy input filtra jest pusty
         * @type string
         * @default null
         */
        this.filterPlaceholder = null;
        /**
         * Określa jaka ikona ma być wyświetlana w dropdownie
         * @type string
         * @default 'pi pi-chevron-down'
         */
        this.dropdownIcon = 'pi pi-chevron-down';
        /**
         * Tekst, który wyświetla się kiedy filtrowanie nie zwróci żadnych wartości.
         * @type string
         * @default 'Nic nie znaleziono'
         */
        this.emptyFilterMessage = 'Nic nie znaleziono';
        /**
         * Określa czy wyświetlić opcje jako grupę kiedy są opcje zagnieżdżone
         * @type boolean
         * @default false
         */
        this.group = false;
        /**
         * Określa bazowy zIndex do użycia przy warstwowaniu
         * @type number
         * @default 0
         * */
        this.baseZIndex = 0;
        /**
         * Określa czy automatycznie zarządzać warstwowaniem
         * @type boolean
         * @default true
         * */
        this.autoZIndex = true;
        /**
         * Określa jaka animacja przejścia ma zadziałać przy wyświetlaniu się wiadomości
         * @type string
         * @default '225ms ease-out'
         * */
        this.showTransitionOptions = '225ms ease-out';
        /**
         * Określa jaka animacja przejścia ma zadziałać przy chowaniu się wiadomości
         * @type string
         * @default '195ms ease-in'
         * */
        this.hideTransitionOptions = '195ms ease-in';
        /**
         * Określa pozycje położenia okienka tooltip.
         * Opcje: 'top', 'left', 'right', 'bottom'
         * @type string
         * @default 'top'
         */
        this.tooltipPosition = 'top';
        /**
         * Określa pozycję okienka tooltip. Pozycje są z CSS
         * @type string
         * @default 'absolute'
         */
        this.tooltipPositionStyle = 'absolute';
        /**
         * Określa czy licznik znaków jest widoczny
         * @type boolean
         * @default false
         * */
        this.showCounter = false;
        /**
         * Określa, czy licznik znaków znajduje się wewnątrz textarea
         * @type boolean
         * @default false
         */
        this.counterInside = false;
        this.maxLength = '524288';
        this.scrollHeight = '200px';
        this.ngModelChange = new EventEmitter();
        this.onBlur = new EventEmitter();
        this.onChange = new EventEmitter();
        this.onClick = new EventEmitter();
        this.onFocus = new EventEmitter();
        this.onHide = new EventEmitter();
        this.onShow = new EventEmitter();
        this.disabled = false;
        this.valueLength = 0;
        this.onModelChange = () => {
        };
        this.onTouch = () => {
        };
    }
    ngOnInit() {
        if (this.inputId == undefined)
            this.inputId = Utils.wygenerujLosoweId();
    }
    writeValue(value) {
        this.ngModel = value;
    }
    setValueLength(value) {
        this.valueLength = value === null || value === void 0 ? void 0 : value.length;
    }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    onModelChangeWrapper($event) {
        if ($event && this.valueField && $event[this.valueField]) {
            this.onModelChange($event[this.valueField]);
            this.setValueLength($event[this.valueField]);
        }
        else {
            this.onModelChange($event);
            this.setValueLength($event);
        }
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
DsDropdownComponent.ɵfac = function DsDropdownComponent_Factory(t) { return new (t || DsDropdownComponent)(); };
DsDropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsDropdownComponent, selectors: [["ds-dropdown"]], hostAttrs: [1, "ds-dropdown"], inputs: { filter: "filter", filterBy: "filterBy", filterMatchMode: "filterMatchMode", filterPlaceholder: "filterPlaceholder", dropdownIcon: "dropdownIcon", emptyFilterMessage: "emptyFilterMessage", group: "group", baseZIndex: "baseZIndex", autoZIndex: "autoZIndex", showTransitionOptions: "showTransitionOptions", hideTransitionOptions: "hideTransitionOptions", tooltipPosition: "tooltipPosition", tooltipPositionStyle: "tooltipPositionStyle", showCounter: "showCounter", counterInside: "counterInside", maxLength: "maxLength", scrollHeight: "scrollHeight", disabled: "disabled", inputId: "inputId", ngModel: "ngModel", placeholder: "placeholder", label: "label", autoDisplayFirst: "autoDisplayFirst", valueField: "valueField", readonly: "readonly", showClear: "showClear", dataKey: "dataKey", name: "name", style: "style", panelStyle: "panelStyle", styleClass: "styleClass", panelStyleClass: "panelStyleClass", required: "required", ariaLabelledBy: "ariaLabelledBy", editable: "editable", maxlength: "maxlength", appendTo: "appendTo", tabindex: "tabindex", selectId: "selectId", autofocus: "autofocus", autofocusFilter: "autofocusFilter", resetFilterOnHide: "resetFilterOnHide", ariaFilterLabel: "ariaFilterLabel", tooltip: "tooltip", tooltipStyleClass: "tooltipStyleClass", optionLabel: "optionLabel", options: "options", ariaLabel: "ariaLabel", labelStyle: "labelStyle", filterLocale: "filterLocale", virtualScroll: "virtualScroll", itemSize: "itemSize" }, outputs: { ngModelChange: "ngModelChange", onBlur: "onBlur", onChange: "onChange", onClick: "onClick", onFocus: "onFocus", onHide: "onHide", onShow: "onShow" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DsDropdownComponent),
                multi: true
            }
        ])], decls: 6, vars: 48, consts: [[1, "ds-dropdown-label", 3, "ngStyle", "for"], [1, "ds-dropdown-wrapper"], [3, "ngModel", "placeholder", "optionLabel", "options", "autoDisplayFirst", "disabled", "inputId", "name", "readonly", "showClear", "dataKey", "panelStyle", "styleClass", "panelStyleClass", "filter", "filterBy", "filterMatchMode", "filterPlaceholder", "required", "ariaLabelledBy", "editable", "maxlength", "appendTo", "tabindex", "selectId", "autofocus", "autofocusFilter", "resetFilterOnHide", "dropdownIcon", "emptyFilterMessage", "group", "baseZIndex", "autoZIndex", "showTransitionOptions", "hideTransitionOptions", "ariaFilterLabel", "tooltip", "tooltipStyleClass", "tooltipPosition", "tooltipPositionStyle", "scrollHeight", "ngModelChange", "onBlur", "onChange", "onClick", "onFocus", "onHide", "onShow"], [1, "ds-dropdown-flex-wrapper"], ["class", "ds-dropdown-chars-counter", 3, "counter-inside", "visibility", 4, "ngIf"], [1, "ds-dropdown-chars-counter"]], template: function DsDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "p-dropdown", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsDropdownComponent_Template_p_dropdown_ngModelChange_3_listener($event) { return ctx.onModelChangeWrapper($event); })("onBlur", function DsDropdownComponent_Template_p_dropdown_onBlur_3_listener($event) { return ctx.onBlur.emit($event); })("onChange", function DsDropdownComponent_Template_p_dropdown_onChange_3_listener($event) { return ctx.onChange.emit($event); })("onClick", function DsDropdownComponent_Template_p_dropdown_onClick_3_listener($event) { return ctx.onClick.emit($event); })("onFocus", function DsDropdownComponent_Template_p_dropdown_onFocus_3_listener($event) { return ctx.onFocus.emit($event); })("onHide", function DsDropdownComponent_Template_p_dropdown_onHide_3_listener($event) { return ctx.onHide.emit($event); })("onShow", function DsDropdownComponent_Template_p_dropdown_onShow_3_listener($event) { return ctx.onShow.emit($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtemplate(5, DsDropdownComponent_span_5_Template, 2, 5, "span", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ctx.labelStyle)("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵproperty("ngModel", ctx.ngModel)("placeholder", ctx.placeholder)("optionLabel", ctx.optionLabel)("options", ctx.options)("autoDisplayFirst", ctx.autoDisplayFirst)("disabled", ctx.disabled)("inputId", ctx.inputId)("name", ctx.name)("readonly", ctx.readonly)("showClear", ctx.showClear)("dataKey", ctx.dataKey)("panelStyle", ctx.panelStyle)("styleClass", ctx.styleClass)("panelStyleClass", ctx.panelStyleClass)("filter", ctx.filter)("filterBy", ctx.filterBy)("filterMatchMode", ctx.filterMatchMode)("filterPlaceholder", ctx.filterPlaceholder)("required", ctx.required)("ariaLabelledBy", ctx.ariaLabelledBy)("editable", ctx.editable)("maxlength", ctx.maxlength)("appendTo", ctx.appendTo)("tabindex", ctx.tabindex)("selectId", ctx.selectId)("autofocus", ctx.autofocus)("autofocusFilter", ctx.autofocusFilter)("resetFilterOnHide", ctx.resetFilterOnHide)("dropdownIcon", ctx.dropdownIcon)("emptyFilterMessage", ctx.emptyFilterMessage)("group", ctx.group)("baseZIndex", ctx.baseZIndex)("autoZIndex", ctx.autoZIndex)("showTransitionOptions", ctx.showTransitionOptions)("hideTransitionOptions", ctx.hideTransitionOptions)("ariaFilterLabel", ctx.ariaFilterLabel)("tooltip", ctx.tooltip)("tooltipStyleClass", ctx.tooltipStyleClass)("tooltipPosition", ctx.tooltipPosition)("tooltipPositionStyle", ctx.tooltipPositionStyle)("scrollHeight", ctx.scrollHeight);
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCounter && !ctx.disabled && !ctx.readonly && ctx.maxLength);
    } }, directives: [ɵngcc2.NgStyle, ɵngcc12.Dropdown, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc4.RequiredValidator, ɵngcc4.MaxLengthValidator, ɵngcc2.NgIf], encapsulation: 2 });
DsDropdownComponent.ctorParameters = () => [];
DsDropdownComponent.propDecorators = {
    placeholder: [{ type: Input }],
    inputId: [{ type: Input }],
    label: [{ type: Input }],
    autoDisplayFirst: [{ type: Input }],
    valueField: [{ type: Input }],
    readonly: [{ type: Input }],
    showClear: [{ type: Input }],
    dataKey: [{ type: Input }],
    name: [{ type: Input }],
    style: [{ type: Input }],
    panelStyle: [{ type: Input }],
    styleClass: [{ type: Input }],
    panelStyleClass: [{ type: Input }],
    filter: [{ type: Input }],
    filterBy: [{ type: Input }],
    filterMatchMode: [{ type: Input }],
    filterPlaceholder: [{ type: Input }],
    required: [{ type: Input }],
    ariaLabelledBy: [{ type: Input }],
    editable: [{ type: Input }],
    maxlength: [{ type: Input }],
    appendTo: [{ type: Input }],
    tabindex: [{ type: Input }],
    selectId: [{ type: Input }],
    autofocus: [{ type: Input }],
    autofocusFilter: [{ type: Input }],
    resetFilterOnHide: [{ type: Input }],
    dropdownIcon: [{ type: Input }],
    emptyFilterMessage: [{ type: Input }],
    group: [{ type: Input }],
    baseZIndex: [{ type: Input }],
    autoZIndex: [{ type: Input }],
    showTransitionOptions: [{ type: Input }],
    hideTransitionOptions: [{ type: Input }],
    ariaFilterLabel: [{ type: Input }],
    tooltip: [{ type: Input }],
    tooltipStyleClass: [{ type: Input }],
    tooltipPosition: [{ type: Input }],
    tooltipPositionStyle: [{ type: Input }],
    optionLabel: [{ type: Input }],
    options: [{ type: Input }],
    showCounter: [{ type: Input }],
    counterInside: [{ type: Input }],
    maxLength: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    labelStyle: [{ type: Input }],
    scrollHeight: [{ type: Input }],
    filterLocale: [{ type: Input }],
    virtualScroll: [{ type: Input }],
    itemSize: [{ type: Input }],
    ngModel: [{ type: Input }],
    ngModelChange: [{ type: Output }],
    onBlur: [{ type: Output }],
    onChange: [{ type: Output }],
    onClick: [{ type: Output }],
    onFocus: [{ type: Output }],
    onHide: [{ type: Output }],
    onShow: [{ type: Output }],
    disabled: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'ds-dropdown',
                template: `
      <label class="ds-dropdown-label" [ngStyle]="labelStyle" [for]="inputId">{{label}}</label>
      <div class="ds-dropdown-wrapper">
          <p-dropdown
                  [ngModel]="ngModel"
                  (ngModelChange)="onModelChangeWrapper($event)"
                  [placeholder]="placeholder"
                  [optionLabel]="optionLabel"
                  [options]="options"
                  [autoDisplayFirst]="autoDisplayFirst"
                  [disabled]="disabled"
                  [inputId]="inputId"
                  [name]="name"
                  [readonly]="readonly"
                  [showClear]="showClear"
                  [dataKey]="dataKey"
                  [style]="style"
                  [panelStyle]="panelStyle"
                  [styleClass]="styleClass"
                  [panelStyleClass]="panelStyleClass"
                  [filter]="filter"
                  [filterBy]="filterBy"
                  [filterMatchMode]="filterMatchMode"
                  [filterPlaceholder]="filterPlaceholder"
                  [required]="required"
                  [ariaLabelledBy]="ariaLabelledBy"
                  [editable]="editable"
                  [maxlength]="maxlength"
                  [appendTo]="appendTo"
                  [tabindex]="tabindex"
                  [selectId]="selectId"
                  [autofocus]="autofocus"
                  [autofocusFilter]="autofocusFilter"
                  [resetFilterOnHide]="resetFilterOnHide"
                  [dropdownIcon]="dropdownIcon"
                  [emptyFilterMessage]="emptyFilterMessage"
                  [group]="group"
                  [baseZIndex]="baseZIndex"
                  [autoZIndex]="autoZIndex"
                  [showTransitionOptions]="showTransitionOptions"
                  [hideTransitionOptions]="hideTransitionOptions"
                  [ariaFilterLabel]="ariaFilterLabel"
                  [tooltip]="tooltip"
                  [tooltipStyleClass]="tooltipStyleClass"
                  [tooltipPosition]="tooltipPosition"
                  [tooltipPositionStyle]="tooltipPositionStyle"
                  [scrollHeight]="scrollHeight"
                  (onBlur)="onBlur.emit($event)"
                  (onChange)="onChange.emit($event)"
                  (onClick)="onClick.emit($event)"
                  (onFocus)="onFocus.emit($event)"
                  (onHide)="onHide.emit($event)"
                  (onShow)="onShow.emit($event)"
                  [attr.aria-label]="ariaLabel"
          >
          </p-dropdown>
          <div class="ds-dropdown-flex-wrapper">
            <span
              class="ds-dropdown-chars-counter" [class.counter-inside]="counterInside"
              *ngIf="showCounter && !disabled && !readonly && maxLength"
              [style.visibility]="'visible'"
            >
                {{ valueLength  + '/' + maxLength }}
              </span>
          </div>
      </div>
  `,
                host: {
                    'class': 'ds-dropdown'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DsDropdownComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return []; }, { filter: [{
            type: Input
        }], filterBy: [{
            type: Input
        }], filterMatchMode: [{
            type: Input
        }], filterPlaceholder: [{
            type: Input
        }], dropdownIcon: [{
            type: Input
        }], emptyFilterMessage: [{
            type: Input
        }], group: [{
            type: Input
        }], baseZIndex: [{
            type: Input
        }], autoZIndex: [{
            type: Input
        }], showTransitionOptions: [{
            type: Input
        }], hideTransitionOptions: [{
            type: Input
        }], tooltipPosition: [{
            type: Input
        }], tooltipPositionStyle: [{
            type: Input
        }], showCounter: [{
            type: Input
        }], counterInside: [{
            type: Input
        }], maxLength: [{
            type: Input
        }], scrollHeight: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], onBlur: [{
            type: Output
        }], onChange: [{
            type: Output
        }], onClick: [{
            type: Output
        }], onFocus: [{
            type: Output
        }], onHide: [{
            type: Output
        }], onShow: [{
            type: Output
        }], disabled: [{
            type: Input
        }], inputId: [{
            type: Input
        }], ngModel: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], autoDisplayFirst: [{
            type: Input
        }], valueField: [{
            type: Input
        }], readonly: [{
            type: Input
        }], showClear: [{
            type: Input
        }], dataKey: [{
            type: Input
        }], name: [{
            type: Input
        }], style: [{
            type: Input
        }], panelStyle: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], panelStyleClass: [{
            type: Input
        }], required: [{
            type: Input
        }], ariaLabelledBy: [{
            type: Input
        }], editable: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], appendTo: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], selectId: [{
            type: Input
        }], autofocus: [{
            type: Input
        }], autofocusFilter: [{
            type: Input
        }], resetFilterOnHide: [{
            type: Input
        }], ariaFilterLabel: [{
            type: Input
        }], tooltip: [{
            type: Input
        }], tooltipStyleClass: [{
            type: Input
        }], optionLabel: [{
            type: Input
        }], options: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], labelStyle: [{
            type: Input
        }], filterLocale: [{
            type: Input
        }], virtualScroll: [{
            type: Input
        }], itemSize: [{
            type: Input
        }] }); })();

class DsDropdownModule {
}
DsDropdownModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsDropdownModule });
DsDropdownModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsDropdownModule_Factory(t) { return new (t || DsDropdownModule)(); }, imports: [[
            DropdownModule,
            CommonModule,
            FormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsDropdownModule, { declarations: function () { return [DsDropdownComponent]; }, imports: function () { return [DropdownModule,
        CommonModule,
        FormsModule]; }, exports: function () { return [DsDropdownComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsDropdownModule, [{
        type: NgModule,
        args: [{
                declarations: [DsDropdownComponent],
                imports: [
                    DropdownModule,
                    CommonModule,
                    FormsModule
                ],
                exports: [DsDropdownComponent]
            }]
    }], null, null); })();

class DsInputComponent extends CustomValidatorUtils {
    constructor(renderer, sanitizer, customValidatorService) {
        super();
        this.renderer = renderer;
        this.sanitizer = sanitizer;
        /**
         * Etykieta znajdująca się nad inputem
         * @type string
         * @default empty string
         * */
        this.label = '';
        /**
         * Określa, czy input ma być tylko do odczytu
         * @type boolean
         * @default false
         * */
        this.readonly = false;
        /**
         * Określa minimalną ilość znaków jaką można wpisać do inputu
         * @type string
         * @default empty string
         * */
        this.minLength = '';
        /**
         * Określa maksymalną ilość znaków, którą można wpisać do inputu
         * @type string | number
         * @default '524288'
         * */
        this.maxLength = '524288';
        /**
         * Określa wzór znaków jaki można wpisać do inputu
         * np. '[A-Z]{3,5}' oznacza, że input przyjmuje tylko wielkie litery od A do Z i od 3 do 5 znaków
         * @type string
         * @default '.{0,}'
         * */
        this.pattern = '.{0,}';
        /**
         * Tekst, który jest pokazywany, kiedy kursor jest nad elementem.
         * @type string
         * @default empty string
         * */
        this.title = '';
        /**
         * Określa podpowiedź do tego jakiej wartości spodziewamy się w inpucie
         * @type string
         * @default empty string
         * */
        this.placeholder = '';
        /**
         * Określa wartość wpisaną do inputu przy jego wczytaniu na stronie
         * @type string
         * @default empty string
         * */
        this.value = '';
        /**
         * Klasa/klasy nadane wewnętrznemu elementowi <input>.
         * @type string
         * @default empty string
         * */
        this.styleClass = '';
        /**
         * Określa nazwę inputu
         * @type string
         * @default empty string
         * */
        this.name = '';
        /**
         * Określa jakie ID ma być nadane inputowi.
         * Jeśli zostawione puste to będzie nadane wygenerowane ID.
         * @type string
         * */
        this.id = undefined;
        /**
         * Wbudowany styl nadany elementowi.
         * @type string
         * @default null
         * */
        this.style = null;
        /**
         * Określa, czy w inpucie po prawej stronie ma być ikona X, która po kliknięciu usuwa tekst w inpucie
         * @type boolean
         * @default true
         * */
        this.showClear = false;
        /**
         * Określa czy licznik znaków jest widoczny
         * @type boolean
         * @default false
         * */
        this.showCounter = false;
        this._capitalize = false;
        /**
         * Określa czy uruchomić dodatkowy walidator
         * @type boolean
         * @default true
         */
        this.isCustomValidatorRun = true;
        this.ngModelChange = new EventEmitter();
        this.input = new EventEmitter();
        this.onClear = new EventEmitter();
        this.onChange = () => {
        };
        this.onTouch = () => {
        };
        this.customValidatorService = customValidatorService;
    }
    /**
     * Określa czy wszystkie wprowadzane wartości powinny być wielkimi literami
     * @type boolean
     * @default false
     */
    set capitalize(value) {
        this._capitalize = value;
        this.changeWrapper();
    }
    get capitalize() {
        return this._capitalize;
    }
    ngOnInit() {
        if (this.id == undefined)
            this.id = Utils.wygenerujLosoweId();
    }
    clear() {
        if (this.inputElement.nativeElement.disabled)
            return;
        this.value = null;
        this.onChange(null);
        this.ngModelChange.emit(null);
        this.input.next(null);
        this.inputElement.nativeElement.value = null;
        this.onClear.emit();
    }
    focus() {
        this.inputElement.nativeElement.focus();
    }
    writeValue(value) {
        this.ngModel = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
        this.renderer.setProperty(this.inputElement.nativeElement, 'disabled', isDisabled);
    }
    onChangeWrapper(inputValue) {
        this.changeWrapper();
    }
    changeWrapper() {
        const value = this.inputElement.nativeElement.value;
        if (this._capitalize && value) {
            const start = this.inputElement.nativeElement.selectionStart;
            const end = this.inputElement.nativeElement.selectionEnd;
            this.inputElement.nativeElement.value = Utils.normalizeToUpper(value);
            this.inputElement.nativeElement.setSelectionRange(start, end);
        }
        this.ngModel = this.inputElement.nativeElement.value;
        this.onChange(this.ngModel);
    }
    safeHtml(v) {
        return this.sanitizer.bypassSecurityTrustHtml(v);
    }
    validate(formControl) {
        if (this.isCustomValidatorRun === true && this.customValidatorService) {
            return this.executeValidate(this, formControl, this.customValidatorService);
        }
        return null;
    }
}
DsInputComponent.ɵfac = function DsInputComponent_Factory(t) { return new (t || DsInputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(DS_INPUT_COMPONENT_CUSTOM_VALIDATOR, 8)); };
DsInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsInputComponent, selectors: [["ds-input"]], viewQuery: function DsInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } }, hostAttrs: [1, "ds-input"], hostVars: 2, hostBindings: function DsInputComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly);
    } }, inputs: { label: "label", readonly: "readonly", minLength: "minLength", maxLength: "maxLength", pattern: "pattern", title: "title", placeholder: "placeholder", value: "value", styleClass: "styleClass", name: "name", id: "id", style: "style", showClear: "showClear", showCounter: "showCounter", isCustomValidatorRun: "isCustomValidatorRun", customValidatorService: "customValidatorService", capitalize: "capitalize", ngModel: "ngModel", spellcheck: "spellcheck", errorMessage: "errorMessage", iconRightTitle: "iconRightTitle", iconLeftTitle: "iconLeftTitle", iconLeft: "iconLeft", iconRight: "iconRight", ariaLabel: "ariaLabel" }, outputs: { ngModelChange: "ngModelChange", input: "input", onClear: "onClear" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => DsInputComponent)
            },
            {
                provide: NG_VALIDATORS,
                useExisting: DsInputComponent,
                multi: true
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 12, vars: 33, consts: [[1, "ds-input-label", 3, "for"], [1, "ds-input-wrapper"], [3, "title", "class", 4, "ngIf"], ["type", "text", "pInputText", "", 3, "readonly", "minLength", "maxLength", "pattern", "title", "placeholder", "spellcheck", "value", "name", "id", "ngModel", "ngModelChange", "blur", "focusin"], ["inputElement", ""], ["class", "pi pi-times ds-input-show-clear", 3, "tabindex", "icon-right", "is-disabled", "is-readonly", "click", "keydown.enter", 4, "ngIf"], [3, "class", "title", "click", 4, "ngIf"], [1, "ds-input-flex-wrapper"], ["class", "ds-input-error-message", 3, "innerHTML", 4, "ngIf"], ["class", "ds-input-chars-counter", 3, "visibility", 4, "ngIf"], [3, "title"], [1, "pi", "pi-times", "ds-input-show-clear", 3, "tabindex", "click", "keydown.enter"], [3, "title", "click"], [1, "ds-input-error-message", 3, "innerHTML"], [1, "ds-input-chars-counter"]], template: function DsInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DsInputComponent_i_3_Template, 1, 4, "i", 2);
        ɵngcc0.ɵɵelementStart(4, "input", 3, 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsInputComponent_Template_input_ngModelChange_4_listener($event) { return ctx.onChangeWrapper($event); })("blur", function DsInputComponent_Template_input_blur_4_listener() { return ctx.onTouch(); })("focusin", function DsInputComponent_Template_input_focusin_4_listener() { return ctx.isFocused = true; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DsInputComponent_i_6_Template, 1, 7, "i", 5);
        ɵngcc0.ɵɵtemplate(7, DsInputComponent_i_7_Template, 1, 4, "i", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵelementStart(9, "div");
        ɵngcc0.ɵɵtemplate(10, DsInputComponent_span_10_Template, 1, 1, "span", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, DsInputComponent_span_11_Template, 2, 3, "span", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵproperty("for", ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassMap(ctx.styleClass);
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly)("has-left-icon", ctx.iconLeft)("has-right-icon", ctx.iconRight)("has-clear-icon", ctx.showClear)("is-disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("readonly", ctx.readonly)("minLength", ctx.minLength)("maxLength", ctx.maxLength)("pattern", ctx.pattern)("title", ctx.title)("placeholder", ctx.placeholder)("spellcheck", ctx.spellcheck)("value", ctx.value)("name", ctx.name)("id", ctx.id)("ngModel", ctx.ngModel);
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorMessage && !_r1.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.maxLength && ctx.showCounter && !ctx.readonly && !ctx.isDisabled);
    } }, directives: [ɵngcc2.NgIf, ɵngcc4.DefaultValueAccessor, ɵngcc13.InputText, ɵngcc4.PatternValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], encapsulation: 2 });
DsInputComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: DomSanitizer },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_INPUT_COMPONENT_CUSTOM_VALIDATOR,] }] }
];
DsInputComponent.propDecorators = {
    label: [{ type: Input }],
    readonly: [{ type: Input }],
    minLength: [{ type: Input }],
    maxLength: [{ type: Input }],
    pattern: [{ type: Input }],
    title: [{ type: Input }],
    placeholder: [{ type: Input }],
    spellcheck: [{ type: Input }],
    value: [{ type: Input }],
    styleClass: [{ type: Input }],
    name: [{ type: Input }],
    id: [{ type: Input }],
    errorMessage: [{ type: Input }],
    style: [{ type: Input }],
    showClear: [{ type: Input }],
    iconRightTitle: [{ type: Input }],
    iconLeftTitle: [{ type: Input }],
    iconLeft: [{ type: Input }],
    iconRight: [{ type: Input }],
    showCounter: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    ngModel: [{ type: Input }],
    capitalize: [{ type: Input }],
    isCustomValidatorRun: [{ type: Input }],
    customValidatorService: [{ type: Input }],
    inputElement: [{ type: ViewChild, args: ['inputElement', { static: true },] }],
    ngModelChange: [{ type: Output }],
    input: [{ type: Output }],
    onClear: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsInputComponent, [{
        type: Component,
        args: [{
                selector: 'ds-input',
                template: `
      <label class="ds-input-label" [for]="id">{{label}}</label>
      <div class="ds-input-wrapper">
          <i
                  [title]="iconLeftTitle"
                  *ngIf="iconLeft"
                  class="pi {{iconLeft}} ds-input-icon-left"
          >
          </i>
          <input
                  type="text"
                  pInputText
                  [readonly]="readonly"
                  [minLength]="minLength"
                  [maxLength]="maxLength"
                  [pattern]="pattern"
                  [title]="title"
                  [placeholder]="placeholder"
                  [spellcheck]="spellcheck"
                  [value]="value"
                  [class]="styleClass"
                  [name]="name"
                  [id]="id"
                  [style]="style"
                  [ngModel]="ngModel"
                  (ngModelChange)="onChangeWrapper($event)"
                  (blur)="onTouch()"
                  (focusin)="this.isFocused = true"
                  [class.is-readonly]="readonly"
                  [class.has-left-icon]="iconLeft"
                  [class.has-right-icon]="iconRight"
                  [class.has-clear-icon]="showClear"
                  [class.is-disabled]="isDisabled"
                  [attr.aria-label]="ariaLabel"
                  #inputElement
          />
          <i
                  class="pi pi-times ds-input-show-clear"
                  tabindex="{{ isDisabled || readonly ? '-1' : '0' }}"
                  *ngIf="showClear"
                  (click)="clear()"
                  (keydown.enter)="clear()"
                  [class.icon-right]="iconRight"
                  [class.is-disabled]="isDisabled"
                  [class.is-readonly]="readonly"
          >
          </i>
          <i
                  *ngIf="iconRight"
                  class="pi {{iconRight}} ds-input-icon-right"
                  [title]="iconRightTitle"
                  (click)="focus()"
          >
          </i>
      </div>
      <div
              class="ds-input-flex-wrapper"
      >
          <div>
            <span
              class="ds-input-error-message"
              *ngIf="errorMessage && !inputElement.disabled"
              [innerHTML]="safeHtml(errorMessage)"
            >
            </span>
          </div>
          <span
            class="ds-input-chars-counter"
            *ngIf="maxLength && showCounter && !readonly && !isDisabled"
            [style.visibility]="isFocused ?  'visible' : 'hidden'"
          >
            {{ (ngModel ? ngModel.length : 0) + '/' + maxLength }}
        </span>
      </div>
  `,
                host: {
                    'class': 'ds-input',
                    '[class.is-readonly]': 'readonly'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => DsInputComponent)
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: DsInputComponent,
                        multi: true
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc5.DomSanitizer }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_INPUT_COMPONENT_CUSTOM_VALIDATOR]
            }] }]; }, { label: [{
            type: Input
        }], readonly: [{
            type: Input
        }], minLength: [{
            type: Input
        }], maxLength: [{
            type: Input
        }], pattern: [{
            type: Input
        }], title: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], value: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], name: [{
            type: Input
        }], id: [{
            type: Input
        }], style: [{
            type: Input
        }], showClear: [{
            type: Input
        }], showCounter: [{
            type: Input
        }], isCustomValidatorRun: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], input: [{
            type: Output
        }], onClear: [{
            type: Output
        }], customValidatorService: [{
            type: Input
        }], capitalize: [{
            type: Input
        }], ngModel: [{
            type: Input
        }], spellcheck: [{
            type: Input
        }], errorMessage: [{
            type: Input
        }], iconRightTitle: [{
            type: Input
        }], iconLeftTitle: [{
            type: Input
        }], iconLeft: [{
            type: Input
        }], iconRight: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], inputElement: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }] }); })();

class DsInputModule {
}
DsInputModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsInputModule });
DsInputModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsInputModule_Factory(t) { return new (t || DsInputModule)(); }, imports: [[
            CommonModule,
            InputTextModule,
            ReactiveFormsModule,
            FormsModule,
            ButtonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsInputModule, { declarations: function () { return [DsInputComponent]; }, imports: function () { return [CommonModule,
        InputTextModule,
        ReactiveFormsModule,
        FormsModule,
        ButtonModule]; }, exports: function () { return [DsInputComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsInputModule, [{
        type: NgModule,
        args: [{
                declarations: [DsInputComponent],
                imports: [
                    CommonModule,
                    InputTextModule,
                    ReactiveFormsModule,
                    FormsModule,
                    ButtonModule
                ],
                exports: [
                    DsInputComponent
                ]
            }]
    }], null, null); })();

class DsInputmaskComponent {
    constructor(renderer) {
        this.renderer = renderer;
        /**
         * Określa, czy input ma być tylko do odczytu
         * @type boolean
         * @default false
         * */
        this.readonly = false;
        /**
         * @type boolean
         * @default true
         */
        this.unmask = true;
        /**
         * Czy ma być włączona wbudowana walidacja
         * @type boolean
         * @default true
         * */
        this.walidacja = true;
        /**
         * Znak reprezentujący wolne miejsce w inpucie.
         * @type string
         * @default '_'
         * */
        this.slotChar = '_';
        /**
         * Określa czy źle wprowadzona wartość ma być usunięta
         * @type boolean
         * @default false
         * */
        this.autoClear = false;
        /** Maksymalna liczba znaków dozwolona w polu wejściowym.
         * @default null
         */
        this.maxlength = null;
        /**
         * Określa nazwę inputu
         * @type string
         * @default empty string
         * */
        this.name = '';
        /**
         * Określa jakie ID ma być nadane inputowi.
         * Jeśli zostawione puste to będzie nadane wygenerowane ID.
         * @type string
         * */
        this.inputId = undefined;
        /**
         * Określa, czy input ma dostać automatycznie focus po załadowaniu się strony
         * @type boolean
         * @default false
         * */
        this.autoFocus = false;
        /**
         * Tekst, który jest pokazywany, kiedy kursor jest nad elementem.
         * @type string
         * @default empty string
         * */
        this.title = '';
        /**
         * Określa, czy w inpucie po prawej stronie ma być ikona X, która po kliknięciu usuwa tekst w inpucie
         * @type boolean
         * @default true
         * */
        this.showClear = false;
        /**
         * Określa wzór znaków jaki można wpisać do inputu
         * @type string
         * @default null
         * */
        this.characterPattern = '[A-Za-z0-9]';
        /**
         * Określa czy wszystkie wprowadzane wartości powinny być wielkimi literami
         * @type boolean
         * @default false
         */
        this.capitalize = false;
        this.ngModelChange = new EventEmitter();
        this.onClear = new EventEmitter();
        this.isDisabled = false;
        this.onChange = () => {
        };
        this.onTouch = () => {
        };
    }
    ngOnInit() {
        if (this.inputId == undefined)
            this.inputId = Utils.wygenerujLosoweId();
    }
    clear() {
        if (this.isDisabled)
            return;
        this.ngModel = null;
        this.onChange(null);
        this.ngModelChange.emit(null);
        this.onClear.emit();
    }
    focus() {
        this.inputMaskComponent.focus();
    }
    writeValue(value) {
        this.ngModel = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    onChangeWrapper(inputValue) {
        if (this.capitalize) {
            inputValue = Utils.normalizeToUpper(inputValue);
            // nie dotykać bo utnę ręce
            const index = this.inputMaskComponent.buffer.join('').indexOf(this.slotChar);
            if (index > 0) {
                setTimeout(() => this.inputMaskComponent.inputViewChild.nativeElement.setSelectionRange(index + 1, index), 0);
            }
        }
        this.ngModel = inputValue;
        this.onChange(inputValue);
    }
}
DsInputmaskComponent.ɵfac = function DsInputmaskComponent_Factory(t) { return new (t || DsInputmaskComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
DsInputmaskComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsInputmaskComponent, selectors: [["ds-inputmask"]], viewQuery: function DsInputmaskComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputMaskComponent = _t.first);
    } }, hostAttrs: [1, "ds-input-mask"], hostVars: 2, hostBindings: function DsInputmaskComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly);
    } }, inputs: { readonly: "readonly", unmask: "unmask", walidacja: "walidacja", slotChar: "slotChar", autoClear: "autoClear", maxlength: "maxlength", name: "name", inputId: "inputId", autoFocus: "autoFocus", title: "title", showClear: "showClear", characterPattern: "characterPattern", capitalize: "capitalize", ngModel: "ngModel", placeholder: "placeholder", mask: "mask", label: "label", style: "style", styleClass: "styleClass", tabindex: "tabindex", autocomplete: "autocomplete", iconRightTitle: "iconRightTitle", iconLeftTitle: "iconLeftTitle", iconLeft: "iconLeft", iconRight: "iconRight", ariaLabel: "ariaLabel" }, outputs: { ngModelChange: "ngModelChange", onClear: "onClear" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => DsInputmaskComponent)
            }
        ])], decls: 9, vars: 36, consts: [[1, "ds-input-mask-label", 3, "for"], [1, "ds-input-mask-wrapper"], [3, "title", "class", 4, "ngIf"], [3, "mask", "unmask", "placeholder", "maxlength", "disabled", "readonly", "slotChar", "autoClear", "styleClass", "tabindex", "name", "inputId", "autoFocus", "autocomplete", "title", "ngModel", "characterPattern", "ariaLabel", "ngModelChange"], ["inputElement", ""], ["class", "pi pi-times ds-input-show-clear", 3, "tabindex", "icon-right", "is-disabled", "is-readonly", "click", "keydown.enter", 4, "ngIf"], [3, "class", "title", "click", 4, "ngIf"], ["class", "ds-input-mask-error-message", 4, "ngIf"], [3, "title"], [1, "pi", "pi-times", "ds-input-show-clear", 3, "tabindex", "click", "keydown.enter"], [3, "title", "click"], [1, "ds-input-mask-error-message"]], template: function DsInputmaskComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DsInputmaskComponent_i_3_Template, 1, 4, "i", 2);
        ɵngcc0.ɵɵelementStart(4, "p-inputMask", 3, 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsInputmaskComponent_Template_p_inputMask_ngModelChange_4_listener($event) { return ctx.onChangeWrapper($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DsInputmaskComponent_i_6_Template, 1, 7, "i", 5);
        ɵngcc0.ɵɵtemplate(7, DsInputmaskComponent_i_7_Template, 1, 4, "i", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, DsInputmaskComponent_span_8_Template, 3, 3, "span", 7);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly)("has-left-icon", ctx.iconLeft)("has-right-icon", ctx.iconRight)("has-clear-icon", ctx.showClear)("is-disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("mask", ctx.mask)("unmask", ctx.unmask)("placeholder", ctx.placeholder)("maxlength", ctx.maxlength)("disabled", ctx.isDisabled)("readonly", ctx.readonly)("slotChar", ctx.slotChar)("autoClear", ctx.autoClear)("styleClass", ctx.styleClass)("tabindex", ctx.tabindex)("name", ctx.name)("inputId", ctx.inputId)("autoFocus", ctx.autoFocus)("autocomplete", ctx.autocomplete)("title", ctx.title)("ngModel", ctx.ngModel)("characterPattern", ctx.characterPattern)("ariaLabel", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !_r1.disabled);
    } }, directives: [ɵngcc2.NgIf, ɵngcc14.InputMask, ɵngcc4.MaxLengthValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], pipes: [ɵngcc7.TranslocoPipe], encapsulation: 2 });
DsInputmaskComponent.ctorParameters = () => [
    { type: Renderer2 }
];
DsInputmaskComponent.propDecorators = {
    readonly: [{ type: Input }],
    placeholder: [{ type: Input }],
    mask: [{ type: Input }],
    unmask: [{ type: Input }],
    label: [{ type: Input }],
    walidacja: [{ type: Input }],
    slotChar: [{ type: Input }],
    autoClear: [{ type: Input }],
    style: [{ type: Input }],
    styleClass: [{ type: Input }],
    maxlength: [{ type: Input }],
    tabindex: [{ type: Input }],
    name: [{ type: Input }],
    inputId: [{ type: Input }],
    autoFocus: [{ type: Input }],
    autocomplete: [{ type: Input }],
    title: [{ type: Input }],
    showClear: [{ type: Input }],
    iconRightTitle: [{ type: Input }],
    iconLeftTitle: [{ type: Input }],
    iconLeft: [{ type: Input }],
    iconRight: [{ type: Input }],
    characterPattern: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    ngModel: [{ type: Input }],
    capitalize: [{ type: Input }],
    ngModelChange: [{ type: Output }],
    onClear: [{ type: Output }],
    inputMaskComponent: [{ type: ViewChild, args: ['inputElement', { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsInputmaskComponent, [{
        type: Component,
        args: [{
                selector: 'ds-inputmask',
                template: `
    <label class="ds-input-mask-label" [for]="inputId">{{label}}</label>
    <div class="ds-input-mask-wrapper">
        <i
                [title]="iconLeftTitle"
                *ngIf="iconLeft"
                class="pi {{iconLeft}} ds-input-icon-left"
        >
        </i>
        <p-inputMask
                [mask]="mask"
                [unmask]="unmask"
                [placeholder]="placeholder"
                [maxlength]="maxlength"
                [disabled]="isDisabled"
                [readonly]="readonly"
                [slotChar]="slotChar"
                [autoClear]="autoClear"
                [style]="style"
                [styleClass]="styleClass"
                [tabindex]="tabindex"
                [name]="name"
                [inputId]="inputId"
                [autoFocus]="autoFocus"
                [autocomplete]="autocomplete"
                [title]="title"
                [ngModel]="ngModel"
                (ngModelChange)="onChangeWrapper($event)"
                [class.is-readonly]="readonly"
                [class.has-left-icon]="iconLeft"
                [class.has-right-icon]="iconRight"
                [class.has-clear-icon]="showClear"
                [class.is-disabled]="isDisabled"
                [characterPattern]="characterPattern"
                [ariaLabel]="ariaLabel"
                #inputElement
        >
        </p-inputMask>
        <i
                class="pi pi-times ds-input-show-clear"
                tabindex="{{ isDisabled || readonly ? '-1' : '0' }}"
                *ngIf="showClear"
                (click)="clear()"
                (keydown.enter)="clear()"
                [class.icon-right]="iconRight"
                [class.is-disabled]="isDisabled"
                [class.is-readonly]="readonly"
        >
        </i>
        <i
                *ngIf="iconRight"
                class="pi {{iconRight}} ds-input-icon-right"
                [title]="iconRightTitle"
                (click)="focus()"
        >
        </i>
    </div>
    <span class="ds-input-mask-error-message" *ngIf="!inputElement.disabled">{{ errorMessage | transloco }}</span>
  `,
                host: {
                    'class': 'ds-input-mask',
                    '[class.is-readonly]': 'readonly'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => DsInputmaskComponent)
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }]; }, { readonly: [{
            type: Input
        }], unmask: [{
            type: Input
        }], walidacja: [{
            type: Input
        }], slotChar: [{
            type: Input
        }], autoClear: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], name: [{
            type: Input
        }], inputId: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], title: [{
            type: Input
        }], showClear: [{
            type: Input
        }], characterPattern: [{
            type: Input
        }], capitalize: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], onClear: [{
            type: Output
        }], ngModel: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], mask: [{
            type: Input
        }], label: [{
            type: Input
        }], style: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], iconRightTitle: [{
            type: Input
        }], iconLeftTitle: [{
            type: Input
        }], iconLeft: [{
            type: Input
        }], iconRight: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], inputMaskComponent: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }] }); })();

class DsInputmaskModule {
}
DsInputmaskModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsInputmaskModule });
DsInputmaskModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsInputmaskModule_Factory(t) { return new (t || DsInputmaskModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            InputMaskModule,
            TranslocoModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsInputmaskModule, { declarations: function () { return [DsInputmaskComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        InputMaskModule,
        TranslocoModule]; }, exports: function () { return [DsInputmaskComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsInputmaskModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DsInputmaskComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    InputMaskModule,
                    TranslocoModule
                ],
                exports: [
                    DsInputmaskComponent
                ]
            }]
    }], null, null); })();

class DsKontoBankoweComponent {
    constructor() {
        /**
         * Określa, czy input ma być tylko do odczytu
         * @type boolean
         * @default false
         * */
        this.readonly = false;
        /**
         * Czy ma być włączona wbudowana walidacja
         * Walidacja może być włączona tylko wtedy, kiedy [countryCode]="'PL'"
         * @type boolean
         * @default true
         * */
        this.walidacja = true;
        /**
         * Dwuznakowy kod kraju
         * @type string
         * @default 'PL'
         * */
        this.countryCode = 'PL';
        /**
         * Znak reprezentujący wolne miejsce w inpucie.
         * @type string
         * @default '_'
         * */
        this.slotChar = '_';
        /**
         * Określa czy źle wprowadzona wartość ma być usunięta
         * @type boolean
         * @default false
         * */
        this.autoClear = false;
        /**
         * Określa nazwę inputu
         * @type string
         * @default empty string
         * */
        this.name = '';
        /**
         * Tekst, który jest pokazywany, kiedy kursor jest nad elementem.
         * @type string
         * @default empty string
         * */
        this.title = '';
        /**
         * Określa, czy w inpucie po prawej stronie ma być ikona X, która po kliknięciu usuwa tekst w inpucie
         * @type boolean
         * @default true
         * */
        this.showClear = false;
        this.ngModelChange = new EventEmitter();
        this.onClear = new EventEmitter();
        this.isDisabled = false;
        this.onChange = () => {
        };
        this.onTouch = () => {
        };
        this.lettersDictionary = this.setLettersDictionary();
    }
    ngOnInit() {
        if (this.inputId == undefined)
            this.inputId = Utils.wygenerujLosoweId();
    }
    clear() {
        if (this.isDisabled)
            return;
        this.ngModel = null;
        this.onChange(null);
        this.ngModelChange.emit(null);
        this.onClear.emit();
    }
    focus() {
        this.inputMaskComponent.focus();
    }
    writeValue(value) {
        if (!value) {
            this.accountNumber = value;
            return;
        }
        if (value.value) { // jeśli jest obiektem to niech weźmie tylko wartość pod kluczem 'value'
            value = value.value;
        }
        value = value.replace(/\s/g, '');
        this.ngModel = value.replace(/[A-Z]/gi, '');
        const countryCode = (/[A-Z]{2}/i).exec(value);
        if (countryCode) {
            this.countryCode = Utils.normalizeToUpper(countryCode[0]);
        }
        this.accountNumber = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    // TODO refactor/remove ?
    filterLetters($event) {
        return /[A-Z]/i.test($event.key);
    }
    onCombinedChange($event) {
        this.accountNumber = $event;
        $event = Utils.normalizeToUpper(this.kodKrajuInput.nativeElement.value) + $event;
        this.onChange($event);
    }
    onCountryCodeChange($event) {
        $event = Utils.normalizeToUpper($event) + this.ngModel;
        this.onChange($event);
    }
    getKodKraju(literyKraju) {
        let litery;
        if (literyKraju) {
            litery = literyKraju.toLowerCase();
        }
        else {
            litery = this.countryCode.toLowerCase();
        }
        return this.lettersDictionary[litery[0]] + this.lettersDictionary[litery[1]];
    }
    validate({ value }) {
        if (!this.walidacja || this.countryCode.toUpperCase() != 'PL') {
            return null;
        }
        const isNotValid = !this.check(value);
        if (isNotValid) {
            if (!value) {
                this.errorMessage = "ds.nrKontaBankowego.empty";
            }
            else if (value.length < 28) {
                this.errorMessage = "ds.nrKontaBankowego.tooShort";
            }
            else {
                this.errorMessage = "ds.nrKontaBankowego.invalid";
            }
        }
        else {
            this.errorMessage = null;
        }
        return isNotValid && {
            invalid: true
        };
    }
    check(numer) {
        if (!numer) {
            return false;
        }
        if (numer.value) {
            numer = numer.value;
        }
        numer = numer.replace(/\s/g, '');
        let kodKraju = numer.substr(0, 2);
        numer = numer.replace(/[A-Z]/gi, ''); // aby pozbyć się kodu kraju
        if (isNaN(numer) || numer.length != 26) {
            return false;
        }
        if (!kodKraju.match(/^[A-Z]{2}$/i)) {
            kodKraju = this.getKodKraju();
        }
        else {
            kodKraju = this.getKodKraju(kodKraju);
        }
        numer = numer.substr(2, 25) + kodKraju + numer.substr(0, 2);
        let sumaKontrolna = this.modulo(numer, 97);
        return sumaKontrolna == 1;
    }
    modulo(dividend, divisor) {
        let partLength = 10;
        while (dividend.length > partLength) {
            let part = dividend.substring(0, partLength);
            dividend = (part % divisor) + dividend.substring(partLength);
        }
        return dividend % divisor;
    }
    setLettersDictionary() {
        return {
            'a': '10',
            'b': '11',
            'c': '12',
            'd': '13',
            'e': '14',
            'f': '15',
            'g': '16',
            'h': '17',
            'i': '18',
            'j': '19',
            'k': '20',
            'l': '21',
            'm': '22',
            'n': '23',
            'o': '24',
            'p': '25',
            'q': '26',
            'r': '27',
            's': '28',
            't': '29',
            'u': '30',
            'v': '31',
            'w': '32',
            'y': '33',
            'z': '34',
        };
    }
}
DsKontoBankoweComponent.ɵfac = function DsKontoBankoweComponent_Factory(t) { return new (t || DsKontoBankoweComponent)(); };
DsKontoBankoweComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsKontoBankoweComponent, selectors: [["ds-konto-bankowe"]], viewQuery: function DsKontoBankoweComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c6, true);
        ɵngcc0.ɵɵstaticViewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.kodKrajuInput = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputMaskComponent = _t.first);
    } }, hostAttrs: [1, "ds-konto-bankowe"], hostVars: 2, hostBindings: function DsKontoBankoweComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly);
    } }, inputs: { readonly: "readonly", walidacja: "walidacja", countryCode: "countryCode", slotChar: "slotChar", autoClear: "autoClear", name: "name", title: "title", showClear: "showClear", inputId: "inputId", ngModel: "ngModel", placeholder: "placeholder", label: "label", style: "style", styleClass: "styleClass", tabindex: "tabindex", autoFocus: "autoFocus", autocomplete: "autocomplete", iconRightTitle: "iconRightTitle", iconLeftTitle: "iconLeftTitle", iconLeft: "iconLeft", iconRight: "iconRight", ariaLabel: "ariaLabel" }, outputs: { ngModelChange: "ngModelChange", onClear: "onClear" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => DsKontoBankoweComponent)
            },
            {
                provide: NG_VALIDATORS,
                multi: true,
                useExisting: DsKontoBankoweComponent
            }
        ])], decls: 12, vars: 37, consts: [[1, "ds-konto-bankowe-label", 3, "for"], [1, "ds-konto-bankowe-wrapper"], ["type", "text", "maxlength", "2", 1, "ds-konto-bankowe-kod-kraju", 3, "disabled", "readonly", "ngModel", "ngModelChange", "keypress"], ["kodKrajuInput", ""], [1, "ds-konto-bankowe-input-wrapper"], [3, "title", "class", 4, "ngIf"], ["mask", "99 9999 9999 9999 9999 9999 9999", 3, "unmask", "placeholder", "maxlength", "disabled", "readonly", "slotChar", "autoClear", "styleClass", "tabindex", "name", "inputId", "autoFocus", "autocomplete", "title", "ngModel", "ariaLabel", "ngModelChange", "onBlur"], ["inputElement", ""], ["class", "pi pi-times ds-input-show-clear", 3, "tabindex", "icon-right", "is-disabled", "is-readonly", "click", "keydown.enter", 4, "ngIf"], [3, "class", "title", "click", 4, "ngIf"], ["class", "ds-konto-bankowe-error-message", 4, "ngIf"], [3, "title"], [1, "pi", "pi-times", "ds-input-show-clear", 3, "tabindex", "click", "keydown.enter"], [3, "title", "click"], [1, "ds-konto-bankowe-error-message"]], template: function DsKontoBankoweComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "input", 2, 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsKontoBankoweComponent_Template_input_ngModelChange_3_listener($event) { return ctx.onCountryCodeChange($event); })("keypress", function DsKontoBankoweComponent_Template_input_keypress_3_listener($event) { return ctx.filterLetters($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, DsKontoBankoweComponent_i_6_Template, 1, 4, "i", 5);
        ɵngcc0.ɵɵelementStart(7, "p-inputMask", 6, 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsKontoBankoweComponent_Template_p_inputMask_ngModelChange_7_listener($event) { return ctx.onCombinedChange($event); })("onBlur", function DsKontoBankoweComponent_Template_p_inputMask_onBlur_7_listener() { return ctx.onTouch(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, DsKontoBankoweComponent_i_9_Template, 1, 7, "i", 8);
        ɵngcc0.ɵɵtemplate(10, DsKontoBankoweComponent_i_10_Template, 1, 4, "i", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, DsKontoBankoweComponent_span_11_Template, 3, 3, "span", 10);
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(8);
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", ctx.isDisabled)("readonly", ctx.readonly)("ngModel", ctx.countryCode);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly)("has-left-icon", ctx.iconLeft)("has-right-icon", ctx.iconRight)("has-clear-icon", ctx.showClear)("is-disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("unmask", true)("placeholder", ctx.placeholder)("maxlength", 26)("disabled", ctx.isDisabled)("readonly", ctx.readonly)("slotChar", ctx.slotChar)("autoClear", ctx.autoClear)("styleClass", ctx.styleClass)("tabindex", ctx.tabindex)("name", ctx.name)("inputId", ctx.inputId)("autoFocus", ctx.autoFocus)("autocomplete", ctx.autocomplete)("title", ctx.title)("ngModel", ctx.ngModel)("ariaLabel", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorMessage && !_r2.disabled);
    } }, directives: [ɵngcc4.DefaultValueAccessor, ɵngcc4.MaxLengthValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc2.NgIf, ɵngcc14.InputMask], pipes: [ɵngcc7.TranslocoPipe], encapsulation: 2 });
DsKontoBankoweComponent.ctorParameters = () => [];
DsKontoBankoweComponent.propDecorators = {
    readonly: [{ type: Input }],
    placeholder: [{ type: Input }],
    label: [{ type: Input }],
    walidacja: [{ type: Input }],
    countryCode: [{ type: Input }],
    slotChar: [{ type: Input }],
    autoClear: [{ type: Input }],
    style: [{ type: Input }],
    styleClass: [{ type: Input }],
    tabindex: [{ type: Input }],
    name: [{ type: Input }],
    inputId: [{ type: Input }],
    autoFocus: [{ type: Input }],
    autocomplete: [{ type: Input }],
    title: [{ type: Input }],
    showClear: [{ type: Input }],
    iconRightTitle: [{ type: Input }],
    iconLeftTitle: [{ type: Input }],
    iconLeft: [{ type: Input }],
    iconRight: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    ngModel: [{ type: Input }],
    ngModelChange: [{ type: Output }],
    onClear: [{ type: Output }],
    kodKrajuInput: [{ type: ViewChild, args: ['kodKrajuInput', { static: true },] }],
    inputMaskComponent: [{ type: ViewChild, args: ['inputElement', { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsKontoBankoweComponent, [{
        type: Component,
        args: [{
                selector: 'ds-konto-bankowe',
                template: `
      <label class="ds-konto-bankowe-label" [for]="inputId">{{ label }}</label>
      <div class="ds-konto-bankowe-wrapper">
          <input
                  class="ds-konto-bankowe-kod-kraju"
                  type="text"
                  maxlength="2"
                  [disabled]="isDisabled"
                  [readonly]="readonly"
                  [ngModel]="countryCode"
                  (ngModelChange)="onCountryCodeChange($event)"
                  (keypress)="filterLetters($event)"
                  #kodKrajuInput
          >
          <div class="ds-konto-bankowe-input-wrapper">
              <i
                      [title]="iconLeftTitle"
                      *ngIf="iconLeft"
                      class="pi {{iconLeft}} ds-input-icon-left"
              >
              </i>
              <p-inputMask
                      mask="99 9999 9999 9999 9999 9999 9999"
                      [unmask]="true"
                      [placeholder]="placeholder"
                      [maxlength]="26"
                      [disabled]="isDisabled"
                      [readonly]="readonly"
                      [slotChar]="slotChar"
                      [autoClear]="autoClear"
                      [style]="style"
                      [styleClass]="styleClass"
                      [tabindex]="tabindex"
                      [name]="name"
                      [inputId]="inputId"
                      [autoFocus]="autoFocus"
                      [autocomplete]="autocomplete"
                      [title]="title"
                      [ngModel]="ngModel"
                      (ngModelChange)="onCombinedChange($event)"
                      (onBlur)="onTouch()"
                      [class.is-readonly]="readonly"
                      [class.has-left-icon]="iconLeft"
                      [class.has-right-icon]="iconRight"
                      [class.has-clear-icon]="showClear"
                      [class.is-disabled]="isDisabled"
                      [ariaLabel]="ariaLabel"
                      #inputElement
              ></p-inputMask>
              <i
                      class="pi pi-times ds-input-show-clear"
                      tabindex="{{ isDisabled || readonly ? '-1' : '0' }}"
                      *ngIf="showClear"
                      (click)="clear()"
                      (keydown.enter)="clear()"
                      [class.icon-right]="iconRight"
                      [class.is-disabled]="isDisabled"
                      [class.is-readonly]="readonly"
              >
              </i>
              <i
                      *ngIf="iconRight"
                      class="pi {{iconRight}} ds-input-icon-right"
                      [title]="iconRightTitle"
                      (click)="focus()"
              >
              </i>
          </div>
      </div>
      <span class="ds-konto-bankowe-error-message" *ngIf="errorMessage && !inputElement.disabled">{{ errorMessage | transloco }}</span>
  `,
                host: {
                    'class': 'ds-konto-bankowe',
                    '[class.is-readonly]': 'readonly'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => DsKontoBankoweComponent)
                    },
                    {
                        provide: NG_VALIDATORS,
                        multi: true,
                        useExisting: DsKontoBankoweComponent
                    }
                ]
            }]
    }], function () { return []; }, { readonly: [{
            type: Input
        }], walidacja: [{
            type: Input
        }], countryCode: [{
            type: Input
        }], slotChar: [{
            type: Input
        }], autoClear: [{
            type: Input
        }], name: [{
            type: Input
        }], title: [{
            type: Input
        }], showClear: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], onClear: [{
            type: Output
        }], inputId: [{
            type: Input
        }], ngModel: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], style: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], iconRightTitle: [{
            type: Input
        }], iconLeftTitle: [{
            type: Input
        }], iconLeft: [{
            type: Input
        }], iconRight: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], kodKrajuInput: [{
            type: ViewChild,
            args: ['kodKrajuInput', { static: true }]
        }], inputMaskComponent: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }] }); })();

class DsKontoBankoweModule {
}
DsKontoBankoweModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsKontoBankoweModule });
DsKontoBankoweModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsKontoBankoweModule_Factory(t) { return new (t || DsKontoBankoweModule)(); }, imports: [[
            CommonModule,
            InputMaskModule,
            FormsModule,
            TranslocoModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsKontoBankoweModule, { declarations: function () { return [DsKontoBankoweComponent]; }, imports: function () { return [CommonModule,
        InputMaskModule,
        FormsModule,
        TranslocoModule]; }, exports: function () { return [DsKontoBankoweComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsKontoBankoweModule, [{
        type: NgModule,
        args: [{
                declarations: [DsKontoBankoweComponent],
                imports: [
                    CommonModule,
                    InputMaskModule,
                    FormsModule,
                    TranslocoModule
                ],
                exports: [
                    DsKontoBankoweComponent
                ]
            }]
    }], null, null); })();

class DsKrsComponent {
    constructor() {
        /**
         * Określa, czy input ma być tylko do odczytu
         * @type boolean
         * @default false
         * */
        this.readonly = false;
        /**
         * Czy ma być włączona wbudowana walidacja
         * @type boolean
         * @default true
         * */
        this.walidacja = true;
        /**
         * Znak reprezentujący wolne miejsce w inpucie.
         * @type string
         * @default '_'
         * */
        this.slotChar = '_';
        /**
         * Określa czy źle wprowadzona wartość ma być usunięta
         * @type boolean
         * @default false
         * */
        this.autoClear = false;
        /**
         * Określa nazwę inputu
         * @type string
         * @default empty string
         * */
        this.name = '';
        /**
         * Tekst, który jest pokazywany, kiedy kursor jest nad elementem.
         * @type string
         * @default empty string
         * */
        this.title = '';
        /**
         * Określa, czy w inpucie po prawej stronie ma być ikona X, która po kliknięciu usuwa tekst w inpucie
         * @type boolean
         * @default true
         * */
        this.showClear = false;
        this.ngModelChange = new EventEmitter();
        this.onClear = new EventEmitter();
        this.isDisabled = false;
        this.onChange = () => {
        };
        this.onTouch = () => {
        };
    }
    ngOnInit() {
        if (this.inputId == undefined)
            this.inputId = Utils.wygenerujLosoweId();
    }
    clear() {
        if (this.isDisabled)
            return;
        this.ngModel = null;
        this.onChange(null);
        this.ngModelChange.emit(null);
        this.onClear.emit();
    }
    focus() {
        this.inputMaskComponent.focus();
    }
    writeValue(value) {
        this.ngModel = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
        this.errorMessage = null;
    }
    onChangeWrapper($event) {
        this.ngModel = $event;
        this.onChange($event);
    }
    validate({ value }) {
        if (!this.walidacja) {
            this.errorMessage = null;
            return null;
        }
        const isValid = this.validateKrs(value);
        if (!isValid) {
            if (!value) {
                this.errorMessage = 'ds.registry.empty';
            }
            else if (value.length < 10) {
                this.errorMessage = 'ds.registry.tooShort';
            }
            else {
                this.errorMessage = 'ds.registry.invalid';
            }
        }
        else {
            this.errorMessage = null;
        }
        return !isValid && {
            invalid: true
        };
    }
    validateKrs(krs) {
        return !isNaN(Number(krs)) && krs != null; // && krs.length === 10; // Wyłączam walidację do 10 znaków, bo funkcja format() i tak gwarantuje uzupełnienie do 10 znaków
    }
    format() {
        if (this.ngModel !== null && this.ngModel !== undefined && this.ngModel && !isNaN(this.ngModel)) {
            this.ngModel = this.ngModel.padStart(10, "0");
        }
    }
}
DsKrsComponent.ɵfac = function DsKrsComponent_Factory(t) { return new (t || DsKrsComponent)(); };
DsKrsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsKrsComponent, selectors: [["ds-krs"]], viewQuery: function DsKrsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputMaskComponent = _t.first);
    } }, hostAttrs: [1, "ds-krs"], hostVars: 2, hostBindings: function DsKrsComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly);
    } }, inputs: { readonly: "readonly", walidacja: "walidacja", slotChar: "slotChar", autoClear: "autoClear", name: "name", title: "title", showClear: "showClear", inputId: "inputId", ngModel: "ngModel", placeholder: "placeholder", label: "label", style: "style", styleClass: "styleClass", tabindex: "tabindex", autoFocus: "autoFocus", autocomplete: "autocomplete", iconRightTitle: "iconRightTitle", iconLeftTitle: "iconLeftTitle", iconLeft: "iconLeft", iconRight: "iconRight", ariaLabel: "ariaLabel" }, outputs: { ngModelChange: "ngModelChange", onClear: "onClear" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => DsKrsComponent)
            },
            {
                provide: NG_VALIDATORS,
                multi: true,
                useExisting: DsKrsComponent
            }
        ])], decls: 11, vars: 37, consts: [[1, "ds-krs-label", 3, "for"], [1, "ds-krs-wrapper"], [3, "title", "class", 4, "ngIf"], ["mask", "9999999999", 3, "unmask", "placeholder", "disabled", "readonly", "slotChar", "autoClear", "styleClass", "tabindex", "name", "inputId", "autoFocus", "autocomplete", "title", "ngModel", "ariaLabel", "ngModelChange", "onBlur", "focusout"], ["inputElement", ""], ["class", "pi pi-times ds-input-show-clear", 3, "tabindex", "icon-right", "is-disabled", "is-readonly", "click", "keydown.enter", 4, "ngIf"], [3, "class", "title", "click", 4, "ngIf"], [1, "ds-krs-error-message"], [3, "title"], [1, "pi", "pi-times", "ds-input-show-clear", 3, "tabindex", "click", "keydown.enter"], [3, "title", "click"]], template: function DsKrsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DsKrsComponent_i_3_Template, 1, 4, "i", 2);
        ɵngcc0.ɵɵelementStart(4, "p-inputMask", 3, 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsKrsComponent_Template_p_inputMask_ngModelChange_4_listener($event) { return ctx.onChangeWrapper($event); })("onBlur", function DsKrsComponent_Template_p_inputMask_onBlur_4_listener() { return ctx.onTouch(); })("focusout", function DsKrsComponent_Template_p_inputMask_focusout_4_listener() { return ctx.format(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DsKrsComponent_i_6_Template, 1, 7, "i", 5);
        ɵngcc0.ɵɵtemplate(7, DsKrsComponent_i_7_Template, 1, 4, "i", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "span", 7);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵpipe(10, "transloco");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly)("has-left-icon", ctx.iconLeft)("has-right-icon", ctx.iconRight)("has-clear-icon", ctx.showClear)("is-disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("unmask", true)("placeholder", ctx.placeholder)("disabled", ctx.isDisabled)("readonly", ctx.readonly)("slotChar", ctx.slotChar)("autoClear", ctx.autoClear)("styleClass", ctx.styleClass)("tabindex", ctx.tabindex)("name", ctx.name)("inputId", ctx.inputId)("autoFocus", ctx.autoFocus)("autocomplete", ctx.autocomplete)("title", ctx.title)("ngModel", ctx.ngModel)("ariaLabel", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(10, 33, ctx.errorMessage, ɵngcc0.ɵɵpureFunction0(36, _c7)));
    } }, directives: [ɵngcc2.NgIf, ɵngcc14.InputMask, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], pipes: [ɵngcc7.TranslocoPipe], encapsulation: 2 });
DsKrsComponent.ctorParameters = () => [];
DsKrsComponent.propDecorators = {
    readonly: [{ type: Input }],
    placeholder: [{ type: Input }],
    label: [{ type: Input }],
    walidacja: [{ type: Input }],
    slotChar: [{ type: Input }],
    autoClear: [{ type: Input }],
    style: [{ type: Input }],
    styleClass: [{ type: Input }],
    tabindex: [{ type: Input }],
    name: [{ type: Input }],
    inputId: [{ type: Input }],
    autoFocus: [{ type: Input }],
    autocomplete: [{ type: Input }],
    title: [{ type: Input }],
    showClear: [{ type: Input }],
    iconRightTitle: [{ type: Input }],
    iconLeftTitle: [{ type: Input }],
    iconLeft: [{ type: Input }],
    iconRight: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    ngModel: [{ type: Input }],
    ngModelChange: [{ type: Output }],
    onClear: [{ type: Output }],
    inputMaskComponent: [{ type: ViewChild, args: ['inputElement', { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsKrsComponent, [{
        type: Component,
        args: [{
                selector: 'ds-krs',
                template: `
    <label class="ds-krs-label" [for]="inputId">{{label}}</label>
    <div class="ds-krs-wrapper">
      <i
        [title]="iconLeftTitle"
        *ngIf="iconLeft"
        class="pi {{iconLeft}} ds-input-icon-left"
      >
      </i>
      <p-inputMask
        mask="9999999999"
        [unmask]="true"
        [placeholder]="placeholder"
        [disabled]="isDisabled"
        [readonly]="readonly"
        [slotChar]="slotChar"
        [autoClear]="autoClear"
        [style]="style"
        [styleClass]="styleClass"
        [tabindex]="tabindex"
        [name]="name"
        [inputId]="inputId"
        [autoFocus]="autoFocus"
        [autocomplete]="autocomplete"
        [title]="title"
        [ngModel]="ngModel"
        (ngModelChange)="onChangeWrapper($event)"
        (onBlur)="onTouch()"
        [class.is-readonly]="readonly"
        [class.has-left-icon]="iconLeft"
        [class.has-right-icon]="iconRight"
        [class.has-clear-icon]="showClear"
        [class.is-disabled]="isDisabled"
        (focusout)="format()"
        [ariaLabel]="ariaLabel"
        #inputElement
      >
      </p-inputMask>
      <i
        class="pi pi-times ds-input-show-clear"
        tabindex="{{ isDisabled || readonly ? '-1' : '0' }}"
        *ngIf="showClear"
        (click)="clear()"
        (keydown.enter)="clear()"
        [class.icon-right]="iconRight"
        [class.is-disabled]="isDisabled"
        [class.is-readonly]="readonly"
      >
      </i>
      <i
        *ngIf="iconRight"
        class="pi {{iconRight}} ds-input-icon-right"
        [title]="iconRightTitle"
        (click)="focus()"
      >
      </i>
    </div>
    <span class="ds-krs-error-message">{{errorMessage | transloco: {name: 'KRS', length: '10'} }}</span>
  `,
                host: {
                    'class': 'ds-krs',
                    '[class.is-readonly]': 'readonly'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => DsKrsComponent)
                    },
                    {
                        provide: NG_VALIDATORS,
                        multi: true,
                        useExisting: DsKrsComponent
                    }
                ]
            }]
    }], function () { return []; }, { readonly: [{
            type: Input
        }], walidacja: [{
            type: Input
        }], slotChar: [{
            type: Input
        }], autoClear: [{
            type: Input
        }], name: [{
            type: Input
        }], title: [{
            type: Input
        }], showClear: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], onClear: [{
            type: Output
        }], inputId: [{
            type: Input
        }], ngModel: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], style: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], iconRightTitle: [{
            type: Input
        }], iconLeftTitle: [{
            type: Input
        }], iconLeft: [{
            type: Input
        }], iconRight: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], inputMaskComponent: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }] }); })();

class DsKrsModule {
}
DsKrsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsKrsModule });
DsKrsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsKrsModule_Factory(t) { return new (t || DsKrsModule)(); }, imports: [[
            CommonModule,
            InputMaskModule,
            FormsModule,
            TranslocoModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsKrsModule, { declarations: function () { return [DsKrsComponent]; }, imports: function () { return [CommonModule,
        InputMaskModule,
        FormsModule,
        TranslocoModule]; }, exports: function () { return [DsKrsComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsKrsModule, [{
        type: NgModule,
        args: [{
                declarations: [DsKrsComponent],
                imports: [
                    CommonModule,
                    InputMaskModule,
                    FormsModule,
                    TranslocoModule
                ],
                exports: [DsKrsComponent]
            }]
    }], null, null); })();

class DsMenuItem {
    constructor() {
        /** Item is selected when partly or fully equal to the current url
         * @type {string} */
        this.pathMatch = 'full';
    }
    /**
     * @returns item parents in top-down order
     */
    static getParents(item) {
        const parents = [];
        let parent = item.parent;
        while (parent) {
            parents.unshift(parent);
            parent = parent.parent;
        }
        return parents;
    }
    static isParent(item, possibleChild) {
        return possibleChild.parent
            ? possibleChild.parent === item || this.isParent(item, possibleChild.parent)
            : false;
    }
}

function isUrlPathEqual(path, link) {
    const locationPath = getPathPartOfUrl(path);
    return link === locationPath;
}
function isUrlPathContain(path, link) {
    const locationPath = getPathPartOfUrl(path);
    const endOfUrlSegmentRegExp = /\/|^$/;
    return locationPath.startsWith(link) &&
        locationPath.slice(link.length).charAt(0).search(endOfUrlSegmentRegExp) !== -1;
}
function getPathPartOfUrl(url) {
    return url.match(/.*?(?=[?;#]|$)/)[0];
}
function getFragmentPartOfUrl(url) {
    const matched = url.match(/#(.+)/);
    return matched ? matched[1] : '';
}
function isFragmentEqual(path, fragment) {
    return getFragmentPartOfUrl(path) === fragment;
}
function isFragmentContain(path, fragment) {
    return getFragmentPartOfUrl(path).includes(fragment);
}

const collapseAll$ = new ReplaySubject(1);
const itemClick$ = new Subject();
const submenuToggle$ = new ReplaySubject(1);
const itemHover$ = new ReplaySubject(1);
const itemSelect$ = new ReplaySubject(1);
const getSelectedItem$ = new ReplaySubject(1);
class DsMenuInternalService {
    constructor(location) {
        this.location = location;
    }
    prepareItems(items) {
        const defaultItem = new DsMenuItem();
        items.forEach(i => {
            this.applyDefaults(i, defaultItem);
            this.setParent(i);
        });
    }
    selectFromUrl(items, tag, collapseOther = false) {
        const selectedItem = this.findItemByUrl(items);
        if (selectedItem) {
            this.selectItem(selectedItem, items, collapseOther, tag);
        }
    }
    selectItem(item, items, collapseOther = false, tag) {
        const unselectedItems = this.resetSelection(items);
        const collapsedItems = collapseOther ? this.collapseItems(items) : [];
        for (const parent of DsMenuItem.getParents(item)) {
            parent.selected = true;
            // emit event only for items that weren't selected before ('unselectedItems' contains items that were selected)
            if (!unselectedItems.includes(parent)) {
                this.itemSelect(parent, tag);
            }
            const wasNotExpanded = !parent.expanded;
            parent.expanded = true;
            const i = collapsedItems.indexOf(parent);
            // emit event only for items that weren't expanded before.
            // 'collapsedItems' contains items that were expanded, so no need to emit event.
            // in case 'collapseOther' is false, 'collapsedItems' will be empty,
            // so also check if item isn't expanded already ('wasNotExpanded').
            if (i === -1 && wasNotExpanded) {
                this.submenuToggle(parent, tag);
            }
            else {
                collapsedItems.splice(i, 1);
            }
        }
        item.selected = true;
        // emit event only for items that weren't selected before ('unselectedItems' contains items that were selected)
        if (!unselectedItems.includes(item)) {
            this.itemSelect(item, tag);
        }
        // remaining items which wasn't expanded back after expanding all currently selected items
        for (const collapsedItem of collapsedItems) {
            this.submenuToggle(collapsedItem, tag);
        }
    }
    collapseAll(items, tag, except) {
        const collapsedItems = this.collapseItems(items, except);
        for (const item of collapsedItems) {
            this.submenuToggle(item, tag);
        }
    }
    onCollapseAll() {
        return collapseAll$.pipe(share());
    }
    onGetSelectedItem() {
        return getSelectedItem$.pipe(share());
    }
    itemHover(item, tag) {
        itemHover$.next({ tag, item });
    }
    submenuToggle(item, tag) {
        submenuToggle$.next({ tag, item });
    }
    itemSelect(item, tag) {
        itemSelect$.next({ tag, item });
    }
    itemClick(item, tag) {
        itemClick$.next({ tag, item });
    }
    /**
     * Unselect all given items deeply.
     * @param items array of items to unselect.
     * @returns items which selected value was changed.
     */
    resetSelection(items) {
        const unselectedItems = [];
        for (const item of items) {
            if (item.selected) {
                unselectedItems.push(item);
            }
            item.selected = false;
            if (item.children) {
                unselectedItems.push(...this.resetSelection(item.children));
            }
        }
        return unselectedItems;
    }
    /**
     * Collapse all given items deeply.
     * @param items array of items to collapse.
     * @param except menu item which shouldn't be collapsed, also disables collapsing for parents of this item.
     * @returns items which expanded value was changed.
     */
    collapseItems(items, except) {
        const collapsedItems = [];
        for (const item of items) {
            if (except && (item === except || DsMenuItem.isParent(item, except))) {
                continue;
            }
            if (item.expanded) {
                collapsedItems.push(item);
            }
            item.expanded = false;
            if (item.children) {
                collapsedItems.push(...this.collapseItems(item.children));
            }
        }
        return collapsedItems;
    }
    applyDefaults(item, defaultItem) {
        const menuItem = Object.assign({}, item);
        Object.assign(item, defaultItem, menuItem);
        item.children && item.children.forEach(child => {
            this.applyDefaults(child, defaultItem);
        });
    }
    setParent(item) {
        item.children && item.children.forEach(child => {
            child.parent = item;
            this.setParent(child);
        });
    }
    /**
     * Find deepest item which link matches current URL path.
     * @param items array of items to search in.
     * @returns found item of undefined.
     */
    findItemByUrl(items) {
        let selectedItem = undefined;
        items.some(item => {
            if (item.children) {
                selectedItem = this.findItemByUrl(item.children);
            }
            if (!selectedItem && this.isSelectedInUrl(item)) {
                selectedItem = item;
            }
            return selectedItem;
        });
        return selectedItem;
    }
    isSelectedInUrl(item) {
        const exact = item.pathMatch === 'full';
        const link = item.link;
        const isSelectedInPath = exact
            ? isUrlPathEqual(this.location.path(), link)
            : isUrlPathContain(this.location.path(), link);
        if (isSelectedInPath && item.fragment != null) {
            return exact
                ? isFragmentEqual(this.location.path(true), item.fragment)
                : isFragmentContain(this.location.path(true), item.fragment);
        }
        return isSelectedInPath;
    }
}
DsMenuInternalService.ɵfac = function DsMenuInternalService_Factory(t) { return new (t || DsMenuInternalService)(ɵngcc0.ɵɵinject(ɵngcc2.Location)); };
DsMenuInternalService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DsMenuInternalService, factory: DsMenuInternalService.ɵfac });
DsMenuInternalService.ctorParameters = () => [
    { type: Location }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsMenuInternalService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.Location }]; }, null); })();

var DsToggleStates;
(function (DsToggleStates) {
    DsToggleStates["Expanded"] = "expanded";
    DsToggleStates["Collapsed"] = "collapsed";
})(DsToggleStates || (DsToggleStates = {}));
class DsMenuComponent {
    constructor(
    // @Inject(NB_WINDOW) protected window,
    // @Inject(PLATFORM_ID) protected platformId,
    menuInternalService, router) {
        this.menuInternalService = menuInternalService;
        this.router = router;
        this.autoCollapse = false;
        this.liTemplate = null;
        this.collapsed = false;
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        this.menuInternalService.prepareItems(this.items);
        this.menuInternalService
            .onGetSelectedItem()
            .pipe(filter((data) => this.compareTag(data.tag)), takeUntil(this.destroy$))
            .subscribe((data) => {
            data.listener.next({ tag: this.tag, item: this.getSelectedItem(this.items) });
        });
        this.menuInternalService
            .onCollapseAll()
            .pipe(filter((data) => this.compareTag(data.tag)), takeUntil(this.destroy$))
            .subscribe(() => this.collapseAll());
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd), takeUntil(this.destroy$))
            .subscribe(() => {
            this.menuInternalService.selectFromUrl(this.items, this.tag, this.autoCollapse);
        });
    }
    ngAfterViewInit() {
        setTimeout(() => this.menuInternalService.selectFromUrl(this.items, this.tag, this.autoCollapse));
    }
    onToggleSubMenu(item) {
        // if (this.autoCollapse) {
        //   this.menuInternalService.collapseAll(this.items, this.tag, item);
        // }
        item.expanded = !item.expanded;
        // this.menuInternalService.submenuToggle(item, this.tag);
    }
    onAddItem(data) {
        this.items.push(...data.items);
        this.menuInternalService.prepareItems(this.items);
        this.menuInternalService.selectFromUrl(this.items, this.tag, this.autoCollapse);
    }
    onHoverItem(item) {
        this.menuInternalService.itemHover(item, this.tag);
    }
    // TODO: is not fired on page reload
    onSelectItem(item) {
        this.menuInternalService.selectItem(item, this.items, this.autoCollapse, this.tag);
    }
    onItemClick(item) {
        this.menuInternalService.itemClick(item, this.tag);
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    collapseAll() {
        // this.menuInternalService.collapseAll(this.items, this.tag);
    }
    compareTag(tag) {
        return !tag || tag === this.tag;
    }
    getSelectedItem(items) {
        let selected = null;
        items.forEach((item) => {
            if (item.selected) {
                selected = item;
            }
            if (item.selected && item.children && item.children.length > 0) {
                selected = this.getSelectedItem(item.children);
            }
        });
        return selected;
    }
}
DsMenuComponent.ɵfac = function DsMenuComponent_Factory(t) { return new (t || DsMenuComponent)(ɵngcc0.ɵɵdirectiveInject(DsMenuInternalService), ɵngcc0.ɵɵdirectiveInject(ɵngcc15.Router)); };
DsMenuComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsMenuComponent, selectors: [["ds-menu"]], inputs: { autoCollapse: "autoCollapse", liTemplate: "liTemplate", collapsed: "collapsed", items: "items", tag: "tag", ariaLabel: "ariaLabel" }, decls: 2, vars: 1, consts: [[1, "menu-list"], [4, "ngFor", "ngForOf"], [4, "ngIf"], ["dsMenuItem", "", "class", "menu-item", 3, "menuItem", "menu-group", "hoverItem", "toggleSubMenu", "selectItem", "itemClick", 4, "ngIf"], ["dsMenuItem", "", 1, "menu-item", 3, "menuItem", "hoverItem", "toggleSubMenu", "selectItem", "itemClick"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function DsMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, DsMenuComponent_ng_container_1_Template, 3, 2, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: function () { return [ɵngcc2.NgForOf, ɵngcc2.NgIf, DsMenuItemComponent, ɵngcc2.NgTemplateOutlet]; }, encapsulation: 2 });
DsMenuComponent.ctorParameters = () => [
    { type: DsMenuInternalService },
    { type: Router }
];
DsMenuComponent.propDecorators = {
    items: [{ type: Input }],
    autoCollapse: [{ type: Input }],
    liTemplate: [{ type: Input, args: ["liTemplate",] }],
    collapsed: [{ type: Input }],
    tag: [{ type: Input }],
    ariaLabel: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsMenuComponent, [{
        type: Component,
        args: [{
                selector: 'ds-menu',
                template: `
    <ul class="menu-list">
      <ng-container *ngFor="let item of items">
        <ng-container  *ngIf="!liTemplate">
          <li dsMenuItem *ngIf="!item.hidden"
              [menuItem]="item"
              [class.menu-group]="item.group"
              (hoverItem)="onHoverItem($event)"
              (toggleSubMenu)="onToggleSubMenu($event)"
              (selectItem)="onSelectItem($event)"
              (itemClick)="onItemClick($event)"
              class="menu-item"
              [attr.aria-label]="ariaLabel"
          ></li>
        </ng-container>
        <ng-container *ngIf="liTemplate">
          <ng-container *ngTemplateOutlet="liTemplate; context: {$implicit: item }"></ng-container>
        </ng-container>
      </ng-container>
    </ul>
  `
            }]
    }], function () { return [{ type: DsMenuInternalService }, { type: ɵngcc15.Router }]; }, { autoCollapse: [{
            type: Input
        }], liTemplate: [{
            type: Input,
            args: ["liTemplate"]
        }], collapsed: [{
            type: Input
        }], items: [{
            type: Input
        }], tag: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }] }); })();

class DsMenuItemComponent {
    constructor() {
        this.menuItem = null;
        this.hoverItem = new EventEmitter();
        this.toggleSubMenu = new EventEmitter();
        this.selectItem = new EventEmitter();
        this.itemClick = new EventEmitter();
        this.destroy$ = new Subject();
        this.maxHeight = 0;
    }
    ngDoCheck() {
        this.toggleState = this.menuItem.expanded ? DsToggleStates.Expanded : DsToggleStates.Collapsed;
    }
    ngAfterViewInit() {
        if (this.container) {
            if (this.container.nativeElement.scrollHeight > this.maxHeight) {
                setTimeout(() => { this.maxHeight = this.container.nativeElement.scrollHeight; }, 0);
            }
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    onToggleSubMenu(item) {
        this.toggleSubMenu.emit(item);
        if (this.container) {
            if (this.container.nativeElement.scrollHeight > this.maxHeight) {
                this.maxHeight = this.container.nativeElement.scrollHeight;
            }
        }
    }
    onHoverItem(item) {
        this.hoverItem.emit(item);
    }
    onSelectItem(item) {
        this.selectItem.emit(item);
    }
    onItemClick(item) {
        this.itemClick.emit(item);
    }
    getExpandStateIcon() {
        if (this.menuItem.expanded) {
            return 'pi pi-chevron-up';
        }
        return 'pi pi-chevron-down';
    }
}
DsMenuItemComponent.ɵfac = function DsMenuItemComponent_Factory(t) { return new (t || DsMenuItemComponent)(); };
DsMenuItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsMenuItemComponent, selectors: [["", "dsMenuItem", ""]], viewQuery: function DsMenuItemComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c9, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
    } }, inputs: { menuItem: "menuItem" }, outputs: { hoverItem: "hoverItem", toggleSubMenu: "toggleSubMenu", selectItem: "selectItem", itemClick: "itemClick" }, attrs: _c10, decls: 6, vars: 7, consts: [["routerLinkActive", "active expanded", 1, "menu-item", 3, "routerLinkActiveOptions", "mouseenter"], ["href", "#", 3, "active", "click", 4, "ngIf"], [4, "ngIf"], ["menuItemContent", ""], ["class", "menu-list", 3, "ngStyle", "collapsed", "expanded", 4, "ngIf"], ["href", "#", 3, "click"], [3, "ngTemplateOutlet"], ["routerLinkActive", "active-link", 3, "routerLink", "routerLinkActiveOptions", "queryParams", "fragment", "skipLocationChange", "active", "click", 4, "ngIf"], [3, "active", "click", 4, "ngIf"], ["routerLinkActive", "active-link", 3, "routerLink", "routerLinkActiveOptions", "queryParams", "fragment", "skipLocationChange", "click"], [3, "click"], [1, "menu-item-icon", 3, "ngClass"], [1, "menu-title"], ["class", "expand-state", 3, "ngClass", 4, "ngIf"], [1, "expand-state", 3, "ngClass"], [1, "menu-list", 3, "ngStyle"], ["container", ""], [4, "ngFor", "ngForOf"], ["dsMenuItem", "", "class", "menu-item", 3, "menuItem", "menu-group", "hoverItem", "toggleSubMenu", "selectItem", "itemClick", 4, "ngIf"], ["dsMenuItem", "", 1, "menu-item", 3, "menuItem", "hoverItem", "toggleSubMenu", "selectItem", "itemClick"]], template: function DsMenuItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("mouseenter", function DsMenuItemComponent_Template_div_mouseenter_0_listener() { return ctx.onHoverItem(ctx.menuItem); });
        ɵngcc0.ɵɵtemplate(1, DsMenuItemComponent_a_1_Template, 2, 5, "a", 1);
        ɵngcc0.ɵɵtemplate(2, DsMenuItemComponent_ng_container_2_Template, 4, 3, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, DsMenuItemComponent_ng_template_3_Template, 4, 3, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, DsMenuItemComponent_ul_5_Template, 3, 8, "ul", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("expanded", ctx.menuItem.expanded);
        ɵngcc0.ɵɵproperty("routerLinkActiveOptions", ɵngcc0.ɵɵpureFunction0(6, _c11));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.menuItem.children);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.menuItem.children);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.menuItem.children);
    } }, directives: [ɵngcc15.RouterLinkActive, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc15.RouterLinkWithHref, ɵngcc2.NgClass, ɵngcc2.NgStyle, ɵngcc2.NgForOf, DsMenuItemComponent], encapsulation: 2 });
DsMenuItemComponent.ctorParameters = () => [];
DsMenuItemComponent.propDecorators = {
    menuItem: [{ type: Input }],
    hoverItem: [{ type: Output }],
    toggleSubMenu: [{ type: Output }],
    selectItem: [{ type: Output }],
    itemClick: [{ type: Output }],
    container: [{ type: ViewChild, args: ['container',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsMenuItemComponent, [{
        type: Component,
        args: [{
                selector: '[dsMenuItem]',
                template: "<div class=\"menu-item\"\n     (mouseenter)=\"onHoverItem(menuItem)\"\n     [class.expanded]=\"menuItem.expanded\"\n     routerLinkActive=\"active expanded\"\n     [routerLinkActiveOptions]=\"{ exact: true }\"\n>\n  <a *ngIf=\"menuItem.children\"\n     (click)=\"$event.preventDefault(); onToggleSubMenu(menuItem);\"\n     [attr.target]=\"menuItem.target\"\n     [attr.title]=\"menuItem.title\"\n     [class.active]=\"menuItem.selected\"\n     href=\"#\">\n    <ng-template [ngTemplateOutlet]=\"menuItemContent\"></ng-template>\n  </a>\n  <ng-container *ngIf=\"!menuItem.children\">\n    <a *ngIf=\"menuItem.link && !menuItem.url\"\n       [routerLink]=\"menuItem.link\"\n       routerLinkActive=\"active-link\"\n       [routerLinkActiveOptions]=\"{exact: true}\"\n       [queryParams]=\"menuItem.queryParams\"\n       [fragment]=\"menuItem.fragment\"\n       [skipLocationChange]=\"menuItem.skipLocationChange\"\n       [attr.target]=\"menuItem.target\"\n       [attr.title]=\"menuItem.tooltip ? menuItem.tooltip : menuItem.title\"\n       [class.active]=\"menuItem.selected\"\n       (click)=\"onItemClick(menuItem);\">\n      <ng-template [ngTemplateOutlet]=\"menuItemContent\"></ng-template>\n    </a>\n    <a *ngIf=\"menuItem.url && !menuItem.link\"\n       [attr.href]=\"menuItem.url\"\n       [attr.target]=\"menuItem.target\"\n       [attr.title]=\"menuItem.tooltip ? menuItem.tooltip : menuItem.title\"\n       [class.active]=\"menuItem.selected\"\n       (click)=\"onSelectItem(menuItem)\">\n      <ng-template [ngTemplateOutlet]=\"menuItemContent\"></ng-template>\n    </a>\n    <a *ngIf=\"!menuItem.link && !menuItem.url\"\n       [attr.target]=\"menuItem.target\"\n       [attr.title]=\"menuItem.tooltip ? menuItem.tooltip : menuItem.title\"\n       [class.active]=\"menuItem.selected\"\n       (click)=\"$event.preventDefault(); onItemClick(menuItem);\">\n      <ng-template [ngTemplateOutlet]=\"menuItemContent\"></ng-template>\n    </a>\n  </ng-container>\n</div>\n<ng-template #menuItemContent>\n  <i class=\"menu-item-icon\" [ngClass]=\"menuItem.icon\"></i>\n  <span class=\"menu-title\">{{ menuItem.title }}</span>\n  <i *ngIf=\"menuItem.children\" class=\"expand-state\" [ngClass]=\"getExpandStateIcon()\"></i>\n</ng-template>\n<ul *ngIf=\"menuItem.children\" #container [ngStyle]=\"{'height': (menuItem.expanded ? maxHeight : 0) + 'px'}\"\n    [class.collapsed]=\"!(menuItem.children && menuItem.expanded)\"\n    [class.expanded]=\"menuItem.expanded\" \n    class=\"menu-list\">\n  <ng-container *ngFor=\"let item of menuItem.children\">\n    <li dsMenuItem *ngIf=\"!item.hidden\"\n        [menuItem]=\"item\"\n        [class.menu-group]=\"item.group\"\n        (hoverItem)=\"onHoverItem($event)\"\n        (toggleSubMenu)=\"onToggleSubMenu($event)\"\n        (selectItem)=\"onSelectItem($event)\"\n        (itemClick)=\"onItemClick($event)\"\n        class=\"menu-item\">\n    </li>\n  </ng-container>\n</ul>\n"
            }]
    }], function () { return []; }, { menuItem: [{
            type: Input
        }], hoverItem: [{
            type: Output
        }], toggleSubMenu: [{
            type: Output
        }], selectItem: [{
            type: Output
        }], itemClick: [{
            type: Output
        }], container: [{
            type: ViewChild,
            args: ['container']
        }] }); })();

const dsMenuComponents = [DsMenuComponent, DsMenuItemComponent];
class DsMenuModule {
    static forRoot() {
        return {
            ngModule: DsMenuModule,
            providers: [
                DsMenuInternalService,
            ]
        };
    }
}
DsMenuModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsMenuModule });
DsMenuModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsMenuModule_Factory(t) { return new (t || DsMenuModule)(); }, imports: [[
            CommonModule,
            RouterModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsMenuModule, { declarations: function () { return [DsMenuComponent, DsMenuItemComponent]; }, imports: function () { return [CommonModule,
        RouterModule]; }, exports: function () { return [DsMenuComponent, DsMenuItemComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsMenuModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule
                ],
                declarations: [...dsMenuComponents],
                exports: [...dsMenuComponents]
            }]
    }], null, null); })();

class DsMultiselectComponent {
    constructor() {
        /**
         * Etykieta znajdująca się nad inputem.
         * @type string
         * @default empty string
         * */
        this.label = '';
        /**
         * Określa, czy input ma być tylko do odczytu
         * @type boolean
         * @default false
         * */
        this.readonly = false;
        /**
         * Określa maksymalną liczbę etykiet opcji, które mogą się wyświetlać.
         * Powyżej tej liczby będzie wyświetlony napis 'Wybrano {x} element(-y, ów)'.
         * @type number
         * @default 10
         */
        this.maxSelectedLabels = 10;
        /**
         * Czy pokazać pole wyboru w nagłówku, aby przełączyć wszystkie elementy na raz.
         * @type boolean
         * @default true
         */
        this.showToggleAll = true;
        /**
         * Określa, czy ma być wyświetlany input do filtrowania wartości
         * @type boolean
         * @default true
         */
        this.filter = true;
        /**
         * Kiedy właczone jest filtrowanie, decyduje według którego pola lub pól (rozdzielonych przecinkiem) filtrować.
         * @type string
         * @default 'label'
         */
        this.filterBy = 'label';
        /**
         * Definiuje w jaki sposób filtrowane są wartości.
         * Przyjmuje wartości: 'contains', 'startsWith', 'endsWith', 'equals', 'notEquals', 'in', 'lt', 'lte', 'gt', 'gte'.
         * @type string
         * @default 'contains'
         */
        this.filterMatchMode = 'contains';
        /**
         * Określa, czy input jest wymagany aby przesłać formularz
         * @type boolean
         * @default false
         */
        this.required = false;
        /**
         * Ustanawia relację między komponentem a etykietą(-ami). Ta wartość powinna być ID elementu
         * @type string
         * @default null
         */
        this.ariaLabelledBy = null;
        /**
         * Określa tab index elementu
         * @type number
         * @default null
         * */
        this.tabindex = null;
        /**
         * Określa czy focus ma być na elemencie do filtrowania
         * @type boolean
         * @default false
         */
        this.autofocusFilter = false;
        /**
         * Określa czy filtr ma być resetowany po schowaniu się dropdownu
         * @type boolean
         * @default false
         */
        this.resetFilterOnHide = false;
        /**
         * Określa jaka ikona ma być wyświetlana w dropdownie
         * @type string
         * @default 'pi pi-chevron-down'
         */
        this.dropdownIcon = 'pi pi-chevron-down';
        /**
         * Tekst, który wyświetla się kiedy filtrowanie nie zwróci żadnych wartości.
         * @type string
         * @default 'Nic nie znaleziono'
         */
        this.emptyFilterMessage = 'Nic nie znaleziono';
        /**
         * Określa czy wyświetlić opcje jako grupę kiedy są opcje zagnieżdżone
         * @type boolean
         * @default false
         */
        this.group = false;
        /**
         * Określa bazowy zIndex do użycia przy warstwowaniu
         * @type number
         * @default 0
         * */
        this.baseZIndex = 0;
        /**
         * Określa czy automatycznie zarządzać warstwowaniem
         * @type boolean
         * @default true
         * */
        this.autoZIndex = true;
        /**
         * Określa jaka animacja przejścia ma zadziałać przy wyświetlaniu się wiadomości
         * @type string
         * @default '225ms ease-out'
         * */
        this.showTransitionOptions = '225ms ease-out';
        /**
         * Określa jaka animacja przejścia ma zadziałać przy chowaniu się wiadomości
         * @type string
         * @default '195ms ease-in'
         * */
        this.hideTransitionOptions = '195ms ease-in';
        /**
         * Określa pozycje położenia okienka tooltip.
         * Opcje: 'top', 'left', 'right', 'bottom'
         * @type string
         * @default 'top'
         */
        this.tooltipPosition = 'top';
        /**
         * Określa pozycję okienka tooltip. Pozycje są z CSS
         * @type string
         * @default 'absolute'
         */
        this.tooltipPositionStyle = 'absolute';
        /**
         * Określa czy panel z opcjami ma być widoczny
         * @type boolean
         * @default false
         */
        this.overlayVisible = false;
        /**
         * Określa czy wyświetlić nazwy wybranych opcji czy wyświetlać defaultLabel
         * @type boolean
         * @default true
         */
        this.displaySelectedLabel = true;
        /**
         * Określa czy ma być wyświetlony nagłówek
         * @type boolean
         * @default false
         */
        this.showHeader = false;
        this.ngModelChange = new EventEmitter();
        this.onBlur = new EventEmitter();
        this.onChange = new EventEmitter();
        this.onClick = new EventEmitter();
        this.onFocus = new EventEmitter();
        this.onPanelHide = new EventEmitter();
        this.onPanelShow = new EventEmitter();
        this.disabled = false;
        this.onModelChange = () => {
        };
        this.onTouch = () => {
        };
    }
    /**
     * Określa tablicę objektów do wyświetlenia jako opcje
     * [options] musi być wprowadzona wcześniej/wyżej, niż [optionLabel] (właściwość Ivy)
     * @type array
     * @default null
     */
    get options() {
        return this._options;
    }
    set options(val) {
        this._options = this.optionLabel ? this.generateSelectItems(val, this.optionLabel) : val;
    }
    ngOnInit() {
        if (this.inputId == undefined)
            this.inputId = Utils.wygenerujLosoweId();
    }
    removeElement($event, element) {
        if (this.disabled) {
            return;
        }
        // @ts-ignore
        if (this.pMultiSelect.value) {
            // @ts-ignore
            this.pMultiSelect.value = this.pMultiSelect.value.filter((el) => {
                return JSON.stringify(el) != JSON.stringify(element);
            });
            // @ts-ignore
            this.onModelChange(this.pMultiSelect.value);
            // @ts-ignore
            this.ngModelChange.next(this.pMultiSelect.value);
            // @ts-ignore
            this.onChange.emit(this.pMultiSelect.value);
        }
        // @ts-ignore
        $event.stopPropagation();
    }
    writeValue(value) {
        this.ngModel = value;
    }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    onModelChangeWrapper($event) {
        if ($event && this.valueField) {
            const result = $event.map(element => {
                return element[this.valueField] || element;
            });
            this.onModelChange(result);
        }
        else {
            this.onModelChange($event);
        }
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    generateSelectItems(val, field) {
        let selectItems;
        if (val && val.length) {
            selectItems = [];
            for (let item of val) {
                selectItems.push({ label: ObjectUtils.resolveFieldData(item, field), value: item });
            }
        }
        return selectItems;
    }
}
DsMultiselectComponent.ɵfac = function DsMultiselectComponent_Factory(t) { return new (t || DsMultiselectComponent)(); };
DsMultiselectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsMultiselectComponent, selectors: [["ds-multiselect"]], viewQuery: function DsMultiselectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c13, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.pMultiSelect = _t.first);
    } }, hostAttrs: [1, "ds-multiselect"], inputs: { label: "label", readonly: "readonly", maxSelectedLabels: "maxSelectedLabels", showToggleAll: "showToggleAll", filter: "filter", filterBy: "filterBy", filterMatchMode: "filterMatchMode", required: "required", ariaLabelledBy: "ariaLabelledBy", tabindex: "tabindex", autofocusFilter: "autofocusFilter", resetFilterOnHide: "resetFilterOnHide", dropdownIcon: "dropdownIcon", emptyFilterMessage: "emptyFilterMessage", group: "group", baseZIndex: "baseZIndex", autoZIndex: "autoZIndex", showTransitionOptions: "showTransitionOptions", hideTransitionOptions: "hideTransitionOptions", tooltipPosition: "tooltipPosition", tooltipPositionStyle: "tooltipPositionStyle", overlayVisible: "overlayVisible", displaySelectedLabel: "displaySelectedLabel", showHeader: "showHeader", options: "options", inputId: "inputId", ngModel: "ngModel", optionLabel: "optionLabel", defaultLabel: "defaultLabel", valueField: "valueField", style: "style", panelStyle: "panelStyle", styleClass: "styleClass", panelStyleClass: "panelStyleClass", filterPlaceholder: "filterPlaceholder", editable: "editable", maxlength: "maxlength", appendTo: "appendTo", ariaFilterLabel: "ariaFilterLabel", tooltip: "tooltip", tooltipStyleClass: "tooltipStyleClass", dataKey: "dataKey", name: "name", selectionLimit: "selectionLimit", itemSize: "itemSize", virtualScroll: "virtualScroll", ariaLabel: "ariaLabel" }, outputs: { ngModelChange: "ngModelChange", onBlur: "onBlur", onChange: "onChange", onClick: "onClick", onFocus: "onFocus", onPanelHide: "onPanelHide", onPanelShow: "onPanelShow" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DsMultiselectComponent),
                multi: true
            }
        ])], decls: 5, vars: 41, consts: [[1, "ds-multiselect-label", 3, "for"], [3, "defaultLabel", "optionLabel", "inputId", "ngModel", "readonly", "disabled", "options", "panelStyle", "styleClass", "filter", "filterBy", "filterMatchMode", "ariaLabelledBy", "appendTo", "tabindex", "autofocusFilter", "resetFilterOnHide", "dropdownIcon", "baseZIndex", "autoZIndex", "showTransitionOptions", "hideTransitionOptions", "ariaFilterLabel", "tooltip", "tooltipStyleClass", "tooltipPosition", "tooltipPositionStyle", "overlayVisible", "dataKey", "name", "displaySelectedLabel", "showToggleAll", "showHeader", "selectionLimit", "itemSize", "virtualScroll", "ngModelChange", "onBlur", "onChange", "onClick", "onFocus", "onPanelHide", "onPanelShow"], ["pMultiSelect", ""], ["pTemplate", "selectedItems"], [4, "ngIf", "ngIfElse"], ["elseBlock", ""], ["class", "p-multiselected-item-token", 4, "ngFor", "ngForOf"], ["class", "p-multiselected-empty-token", 4, "ngIf"], [1, "p-multiselected-item-token"], [1, "pi", "pi-times", 3, "click"], [1, "p-multiselected-empty-token"]], template: function DsMultiselectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "p-multiSelect", 1, 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsMultiselectComponent_Template_p_multiSelect_ngModelChange_2_listener($event) { return ctx.onModelChangeWrapper($event); })("onBlur", function DsMultiselectComponent_Template_p_multiSelect_onBlur_2_listener($event) { return ctx.onBlur.emit($event); })("onChange", function DsMultiselectComponent_Template_p_multiSelect_onChange_2_listener($event) { return ctx.onChange.emit($event); })("onClick", function DsMultiselectComponent_Template_p_multiSelect_onClick_2_listener($event) { return ctx.onClick.emit($event); })("onFocus", function DsMultiselectComponent_Template_p_multiSelect_onFocus_2_listener($event) { return ctx.onFocus.emit($event); })("onPanelHide", function DsMultiselectComponent_Template_p_multiSelect_onPanelHide_2_listener($event) { return ctx.onPanelHide.emit($event); })("onPanelShow", function DsMultiselectComponent_Template_p_multiSelect_onPanelShow_2_listener($event) { return ctx.onPanelShow.emit($event); });
        ɵngcc0.ɵɵtemplate(4, DsMultiselectComponent_ng_template_4_Template, 3, 2, "ng-template", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵproperty("defaultLabel", ctx.defaultLabel)("optionLabel", ctx.optionLabel)("inputId", ctx.inputId)("ngModel", ctx.ngModel)("readonly", ctx.readonly)("disabled", ctx.disabled)("options", ctx.options)("panelStyle", ctx.panelStyle)("styleClass", ctx.styleClass)("filter", ctx.filter)("filterBy", ctx.filterBy)("filterMatchMode", ctx.filterMatchMode)("ariaLabelledBy", ctx.ariaLabelledBy)("appendTo", ctx.appendTo)("tabindex", ctx.tabindex)("autofocusFilter", ctx.autofocusFilter)("resetFilterOnHide", ctx.resetFilterOnHide)("dropdownIcon", ctx.dropdownIcon)("baseZIndex", ctx.baseZIndex)("autoZIndex", ctx.autoZIndex)("showTransitionOptions", ctx.showTransitionOptions)("hideTransitionOptions", ctx.hideTransitionOptions)("ariaFilterLabel", ctx.ariaFilterLabel)("tooltip", ctx.tooltip)("tooltipStyleClass", ctx.tooltipStyleClass)("tooltipPosition", ctx.tooltipPosition)("tooltipPositionStyle", ctx.tooltipPositionStyle)("overlayVisible", ctx.overlayVisible)("dataKey", ctx.dataKey)("name", ctx.name)("displaySelectedLabel", ctx.displaySelectedLabel)("showToggleAll", ctx.showToggleAll)("showHeader", ctx.showHeader)("selectionLimit", ctx.selectionLimit)("itemSize", ctx.itemSize)("virtualScroll", ctx.virtualScroll);
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
    } }, directives: [ɵngcc16.MultiSelect, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc8.PrimeTemplate, ɵngcc2.NgIf, ɵngcc2.NgForOf], encapsulation: 2 });
DsMultiselectComponent.ctorParameters = () => [];
DsMultiselectComponent.propDecorators = {
    optionLabel: [{ type: Input }],
    defaultLabel: [{ type: Input }],
    label: [{ type: Input }],
    inputId: [{ type: Input }],
    readonly: [{ type: Input }],
    valueField: [{ type: Input }],
    maxSelectedLabels: [{ type: Input }],
    showToggleAll: [{ type: Input }],
    style: [{ type: Input }],
    panelStyle: [{ type: Input }],
    styleClass: [{ type: Input }],
    panelStyleClass: [{ type: Input }],
    filter: [{ type: Input }],
    filterBy: [{ type: Input }],
    filterMatchMode: [{ type: Input }],
    filterPlaceholder: [{ type: Input }],
    required: [{ type: Input }],
    ariaLabelledBy: [{ type: Input }],
    editable: [{ type: Input }],
    maxlength: [{ type: Input }],
    appendTo: [{ type: Input }],
    tabindex: [{ type: Input }],
    autofocusFilter: [{ type: Input }],
    resetFilterOnHide: [{ type: Input }],
    dropdownIcon: [{ type: Input }],
    emptyFilterMessage: [{ type: Input }],
    group: [{ type: Input }],
    baseZIndex: [{ type: Input }],
    autoZIndex: [{ type: Input }],
    showTransitionOptions: [{ type: Input }],
    hideTransitionOptions: [{ type: Input }],
    ariaFilterLabel: [{ type: Input }],
    tooltip: [{ type: Input }],
    tooltipStyleClass: [{ type: Input }],
    tooltipPosition: [{ type: Input }],
    tooltipPositionStyle: [{ type: Input }],
    overlayVisible: [{ type: Input }],
    dataKey: [{ type: Input }],
    name: [{ type: Input }],
    displaySelectedLabel: [{ type: Input }],
    showHeader: [{ type: Input }],
    selectionLimit: [{ type: Input }],
    itemSize: [{ type: Input }],
    virtualScroll: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    ngModel: [{ type: Input }],
    options: [{ type: Input }],
    ngModelChange: [{ type: Output }],
    onBlur: [{ type: Output }],
    onChange: [{ type: Output }],
    onClick: [{ type: Output }],
    onFocus: [{ type: Output }],
    onPanelHide: [{ type: Output }],
    onPanelShow: [{ type: Output }],
    pMultiSelect: [{ type: ViewChild, args: ['pMultiSelect', { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsMultiselectComponent, [{
        type: Component,
        args: [{
                selector: 'ds-multiselect',
                template: `
    <label class="ds-multiselect-label" [for]="inputId">{{label}}</label>
    <p-multiSelect
      [defaultLabel]="defaultLabel"
      [optionLabel]="optionLabel"
      [inputId]="inputId"
      [ngModel]="ngModel"
      [readonly]="readonly"
      [disabled]="disabled"
      [options]="options"
      [style]="style"
      [panelStyle]="panelStyle"
      [styleClass]="styleClass"
      [filter]="filter"
      [filterBy]="filterBy"
      [filterMatchMode]="filterMatchMode"
      [ariaLabelledBy]="ariaLabelledBy"
      [appendTo]="appendTo"
      [tabindex]="tabindex"
      [autofocusFilter]="autofocusFilter"
      [resetFilterOnHide]="resetFilterOnHide"
      [dropdownIcon]="dropdownIcon"
      [baseZIndex]="baseZIndex"
      [autoZIndex]="autoZIndex"
      [showTransitionOptions]="showTransitionOptions"
      [hideTransitionOptions]="hideTransitionOptions"
      [ariaFilterLabel]="ariaFilterLabel"
      [tooltip]="tooltip"
      [tooltipStyleClass]="tooltipStyleClass"
      [tooltipPosition]="tooltipPosition"
      [tooltipPositionStyle]="tooltipPositionStyle"
      [overlayVisible]="overlayVisible"
      [dataKey]="dataKey"
      [name]="name"
      [displaySelectedLabel]="displaySelectedLabel"
      [showToggleAll]="showToggleAll"
      [showHeader]="showHeader"
      [selectionLimit]="selectionLimit"
      [itemSize]="itemSize"
      [virtualScroll]="virtualScroll"
      (ngModelChange)="onModelChangeWrapper($event)"
      (onBlur)="onBlur.emit($event)"
      (onChange)="onChange.emit($event)"
      (onClick)="onClick.emit($event)"
      (onFocus)="onFocus.emit($event)"
      (onPanelHide)="onPanelHide.emit($event)"
      (onPanelShow)="onPanelShow.emit($event)"
      [attr.aria-label]="ariaLabel"
      #pMultiSelect
    >
      <ng-template let-value pTemplate="selectedItems">
        <ng-container *ngIf="!value || value.length <= maxSelectedLabels; else elseBlock">
          <div *ngFor="let val of value" class="p-multiselected-item-token">
            <span>{{val[optionLabel] || val}} <i class="pi pi-times" (click)="removeElement($event, val)"></i></span>
          </div>
          <span *ngIf="!value || value.length === 0" class="p-multiselected-empty-token">{{defaultLabel}}</span>
        </ng-container>
        <ng-template #elseBlock>
          <span>{{'Wybrano ' + value.length + ' element' + (
            value.length >= 5 ? 'ów'
              : 2 <= value.length && value.length <= 4 ? 'y'
              : ''
          )}}</span>
        </ng-template>
      </ng-template>
    </p-multiSelect>
  `,
                host: {
                    'class': 'ds-multiselect'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DsMultiselectComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return []; }, { label: [{
            type: Input
        }], readonly: [{
            type: Input
        }], maxSelectedLabels: [{
            type: Input
        }], showToggleAll: [{
            type: Input
        }], filter: [{
            type: Input
        }], filterBy: [{
            type: Input
        }], filterMatchMode: [{
            type: Input
        }], required: [{
            type: Input
        }], ariaLabelledBy: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], autofocusFilter: [{
            type: Input
        }], resetFilterOnHide: [{
            type: Input
        }], dropdownIcon: [{
            type: Input
        }], emptyFilterMessage: [{
            type: Input
        }], group: [{
            type: Input
        }], baseZIndex: [{
            type: Input
        }], autoZIndex: [{
            type: Input
        }], showTransitionOptions: [{
            type: Input
        }], hideTransitionOptions: [{
            type: Input
        }], tooltipPosition: [{
            type: Input
        }], tooltipPositionStyle: [{
            type: Input
        }], overlayVisible: [{
            type: Input
        }], displaySelectedLabel: [{
            type: Input
        }], showHeader: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], onBlur: [{
            type: Output
        }], onChange: [{
            type: Output
        }], onClick: [{
            type: Output
        }], onFocus: [{
            type: Output
        }], onPanelHide: [{
            type: Output
        }], onPanelShow: [{
            type: Output
        }], options: [{
            type: Input
        }], inputId: [{
            type: Input
        }], ngModel: [{
            type: Input
        }], optionLabel: [{
            type: Input
        }], defaultLabel: [{
            type: Input
        }], valueField: [{
            type: Input
        }], style: [{
            type: Input
        }], panelStyle: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], panelStyleClass: [{
            type: Input
        }], filterPlaceholder: [{
            type: Input
        }], editable: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], appendTo: [{
            type: Input
        }], ariaFilterLabel: [{
            type: Input
        }], tooltip: [{
            type: Input
        }], tooltipStyleClass: [{
            type: Input
        }], dataKey: [{
            type: Input
        }], name: [{
            type: Input
        }], selectionLimit: [{
            type: Input
        }], itemSize: [{
            type: Input
        }], virtualScroll: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], pMultiSelect: [{
            type: ViewChild,
            args: ['pMultiSelect', { static: false }]
        }] }); })();

class DsMultiselectModule {
}
DsMultiselectModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsMultiselectModule });
DsMultiselectModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsMultiselectModule_Factory(t) { return new (t || DsMultiselectModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            MultiSelectModule,
            ReactiveFormsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsMultiselectModule, { declarations: function () { return [DsMultiselectComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        MultiSelectModule,
        ReactiveFormsModule]; }, exports: function () { return [DsMultiselectComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsMultiselectModule, [{
        type: NgModule,
        args: [{
                declarations: [DsMultiselectComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    MultiSelectModule,
                    ReactiveFormsModule,
                ],
                exports: [DsMultiselectComponent]
            }]
    }], null, null); })();

class DsNipComponent {
    constructor() {
        /**
         * Określa, czy input ma być tylko do odczytu
         * @type boolean
         * @default false
         * */
        this.readonly = false;
        /**
         * Czy ma być włączona wbudowana walidacja
         * @type boolean
         * @default true
         * */
        this.walidacja = true;
        /**
         * Wymagalność przy wbudowanej walidacji
         * @type boolean
         * @default false
         */
        this.optional = false;
        /**
         * Znak reprezentujący wolne miejsce w inpucie.
         * @type string
         * @default '_'
         * */
        this.slotChar = '_';
        /**
         * Określa czy źle wprowadzona wartość ma być usunięta
         * @type boolean
         * @default false
         * */
        this.autoClear = false;
        /**
         * Określa nazwę inputu
         * @type string
         * @default empty string
         * */
        this.name = '';
        /**
         * Określa jakie ID ma być nadane inputowi.
         * Jeśli zostawione puste to będzie nadane wygenerowane ID.
         * @type string
         * */
        this.inputId = undefined;
        /**
         * Określa, czy input ma dostać automatycznie focus po załadowaniu się strony
         * @type boolean
         * @default false
         * */
        this.autoFocus = false;
        /**
         * Tekst, który jest pokazywany, kiedy kursor jest nad elementem.
         * @type string
         * @default empty string
         * */
        this.title = '';
        /**
         * Określa, czy w inpucie po prawej stronie ma być ikona X, która po kliknięciu usuwa tekst w inpucie
         * @type boolean
         * @default true
         * */
        this.showClear = false;
        this.ngModelChange = new EventEmitter();
        this.onClear = new EventEmitter();
        this.onChange = () => {
        };
        this.onTouch = () => {
        };
    }
    ngOnInit() {
        if (this.inputId == undefined)
            this.inputId = Utils.wygenerujLosoweId();
    }
    clear() {
        if (this.isDisabled)
            return;
        this.ngModel = null;
        this.onChange(null);
        this.ngModelChange.emit(null);
        this.onClear.emit();
    }
    focus() {
        this.inputMaskComponent.focus();
    }
    writeValue(value) {
        this.ngModel = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
        this.errorMessage = null;
    }
    onChangeWrapper($event) {
        this.ngModel = $event;
        this.onChange($event);
    }
    validate({ value }) {
        if (!this.walidacja || (this.optional && !value)) {
            this.errorMessage = null;
            return null;
        }
        const isValid = this.validateNip(value);
        if (!isValid) {
            if (!value) {
                this.errorMessage = "ds.registry.empty";
            }
            else if (value.length < 10) {
                this.errorMessage = "ds.registry.tooShort";
            }
            else {
                this.errorMessage = "ds.registry.invalid";
            }
        }
        else {
            this.errorMessage = null;
        }
        return !isValid && {
            invalid: true
        };
    }
    validateNip(nip) {
        const wagi = [6, 5, 7, 2, 3, 4, 5, 6, 7];
        // @ts-ignore
        if (!isNaN(nip) && nip != null && nip.length === 10) {
            const nipDigits = nip.split('').map(element => parseInt(element));
            let sumaKontrolna = 0;
            for (let i = 0; i < wagi.length; i++) {
                sumaKontrolna += nipDigits[i] * wagi[i];
            }
            return sumaKontrolna % 11 === nipDigits[nipDigits.length - 1];
        }
        return false;
    }
}
DsNipComponent.ɵfac = function DsNipComponent_Factory(t) { return new (t || DsNipComponent)(); };
DsNipComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsNipComponent, selectors: [["ds-nip"]], viewQuery: function DsNipComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputMaskComponent = _t.first);
    } }, hostAttrs: [1, "ds-nip"], hostVars: 2, hostBindings: function DsNipComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly);
    } }, inputs: { readonly: "readonly", walidacja: "walidacja", optional: "optional", slotChar: "slotChar", autoClear: "autoClear", name: "name", inputId: "inputId", autoFocus: "autoFocus", title: "title", showClear: "showClear", ngModel: "ngModel", placeholder: "placeholder", label: "label", style: "style", styleClass: "styleClass", tabindex: "tabindex", autocomplete: "autocomplete", iconRightTitle: "iconRightTitle", iconLeftTitle: "iconLeftTitle", iconLeft: "iconLeft", iconRight: "iconRight", ariaLabel: "ariaLabel" }, outputs: { ngModelChange: "ngModelChange", onClear: "onClear" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => DsNipComponent)
            },
            {
                provide: NG_VALIDATORS,
                multi: true,
                useExisting: DsNipComponent
            }
        ])], decls: 11, vars: 38, consts: [[1, "ds-nip-label", 3, "for"], [1, "ds-nip-wrapper"], [3, "title", "class", 4, "ngIf"], ["mask", "9999999999", 3, "unmask", "placeholder", "maxlength", "disabled", "readonly", "slotChar", "autoClear", "styleClass", "tabindex", "name", "inputId", "autoFocus", "autocomplete", "title", "ngModel", "ariaLabel", "ngModelChange", "onBlur"], ["inputElement", ""], ["class", "pi pi-times ds-input-show-clear", 3, "tabindex", "icon-right", "is-disabled", "is-readonly", "click", "keydown.enter", 4, "ngIf"], [3, "class", "title", "click", 4, "ngIf"], [1, "ds-nip-error-message"], [3, "title"], [1, "pi", "pi-times", "ds-input-show-clear", 3, "tabindex", "click", "keydown.enter"], [3, "title", "click"]], template: function DsNipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DsNipComponent_i_3_Template, 1, 4, "i", 2);
        ɵngcc0.ɵɵelementStart(4, "p-inputMask", 3, 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsNipComponent_Template_p_inputMask_ngModelChange_4_listener($event) { return ctx.onChangeWrapper($event); })("onBlur", function DsNipComponent_Template_p_inputMask_onBlur_4_listener() { return ctx.onTouch(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DsNipComponent_i_6_Template, 1, 7, "i", 5);
        ɵngcc0.ɵɵtemplate(7, DsNipComponent_i_7_Template, 1, 4, "i", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "span", 7);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵpipe(10, "transloco");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly)("has-left-icon", ctx.iconLeft)("has-right-icon", ctx.iconRight)("has-clear-icon", ctx.showClear)("is-disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("unmask", true)("placeholder", ctx.placeholder)("maxlength", 10)("disabled", ctx.isDisabled)("readonly", ctx.readonly)("slotChar", ctx.slotChar)("autoClear", ctx.autoClear)("styleClass", ctx.styleClass)("tabindex", ctx.tabindex)("name", ctx.name)("inputId", ctx.inputId)("autoFocus", ctx.autoFocus)("autocomplete", ctx.autocomplete)("title", ctx.title)("ngModel", ctx.ngModel)("ariaLabel", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(10, 34, ctx.errorMessage, ɵngcc0.ɵɵpureFunction0(37, _c14)));
    } }, directives: [ɵngcc2.NgIf, ɵngcc14.InputMask, ɵngcc4.MaxLengthValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], pipes: [ɵngcc7.TranslocoPipe], encapsulation: 2 });
DsNipComponent.ctorParameters = () => [];
DsNipComponent.propDecorators = {
    readonly: [{ type: Input }],
    placeholder: [{ type: Input }],
    label: [{ type: Input }],
    walidacja: [{ type: Input }],
    optional: [{ type: Input }],
    slotChar: [{ type: Input }],
    autoClear: [{ type: Input }],
    style: [{ type: Input }],
    styleClass: [{ type: Input }],
    tabindex: [{ type: Input }],
    name: [{ type: Input }],
    inputId: [{ type: Input }],
    autoFocus: [{ type: Input }],
    autocomplete: [{ type: Input }],
    title: [{ type: Input }],
    showClear: [{ type: Input }],
    iconRightTitle: [{ type: Input }],
    iconLeftTitle: [{ type: Input }],
    iconLeft: [{ type: Input }],
    iconRight: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    ngModel: [{ type: Input }],
    ngModelChange: [{ type: Output }],
    onClear: [{ type: Output }],
    inputMaskComponent: [{ type: ViewChild, args: ['inputElement', { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsNipComponent, [{
        type: Component,
        args: [{
                selector: 'ds-nip',
                template: `
    <label class="ds-nip-label" [for]="inputId">{{label}}</label>
    <div class="ds-nip-wrapper">
      <i
        [title]="iconLeftTitle"
        *ngIf="iconLeft"
        class="pi {{iconLeft}} ds-input-icon-left"
      >
      </i>
      <p-inputMask
        mask="9999999999"
        [unmask]="true"
        [placeholder]="placeholder"
        [maxlength]="10"
        [disabled]="isDisabled"
        [readonly]="readonly"
        [slotChar]="slotChar"
        [autoClear]="autoClear"
        [style]="style"
        [styleClass]="styleClass"
        [tabindex]="tabindex"
        [name]="name"
        [inputId]="inputId"
        [autoFocus]="autoFocus"
        [autocomplete]="autocomplete"
        [title]="title"
        [ngModel]="ngModel"
        (ngModelChange)="onChangeWrapper($event)"
        (onBlur)="onTouch()"
        [class.is-readonly]="readonly"
        [class.has-left-icon]="iconLeft"
        [class.has-right-icon]="iconRight"
        [class.has-clear-icon]="showClear"
        [class.is-disabled]="isDisabled"
        [ariaLabel]="ariaLabel"
        #inputElement
      >
      </p-inputMask>
      <i
        class="pi pi-times ds-input-show-clear"
        tabindex="{{ isDisabled || readonly ? '-1' : '0' }}"
        *ngIf="showClear"
        (click)="clear()"
        (keydown.enter)="clear()"
        [class.icon-right]="iconRight"
        [class.is-disabled]="isDisabled"
        [class.is-readonly]="readonly"
      >
      </i>
      <i
        *ngIf="iconRight"
        class="pi {{iconRight}} ds-input-icon-right"
        [title]="iconRightTitle"
        (click)="focus()"
      >
      </i>
    </div>
    <span class="ds-nip-error-message">{{ errorMessage | transloco: {name: 'NIP', length: '10'} }}</span>
  `,
                host: {
                    'class': 'ds-nip',
                    '[class.is-readonly]': 'readonly'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => DsNipComponent)
                    },
                    {
                        provide: NG_VALIDATORS,
                        multi: true,
                        useExisting: DsNipComponent
                    }
                ]
            }]
    }], function () { return []; }, { readonly: [{
            type: Input
        }], walidacja: [{
            type: Input
        }], optional: [{
            type: Input
        }], slotChar: [{
            type: Input
        }], autoClear: [{
            type: Input
        }], name: [{
            type: Input
        }], inputId: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], title: [{
            type: Input
        }], showClear: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], onClear: [{
            type: Output
        }], ngModel: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], style: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], iconRightTitle: [{
            type: Input
        }], iconLeftTitle: [{
            type: Input
        }], iconLeft: [{
            type: Input
        }], iconRight: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], inputMaskComponent: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }] }); })();

class DsNipModule {
}
DsNipModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsNipModule });
DsNipModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsNipModule_Factory(t) { return new (t || DsNipModule)(); }, imports: [[
            CommonModule,
            InputMaskModule,
            FormsModule,
            TranslocoModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsNipModule, { declarations: function () { return [DsNipComponent]; }, imports: function () { return [CommonModule,
        InputMaskModule,
        FormsModule,
        TranslocoModule]; }, exports: function () { return [DsNipComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsNipModule, [{
        type: NgModule,
        args: [{
                declarations: [DsNipComponent],
                imports: [
                    CommonModule,
                    InputMaskModule,
                    FormsModule,
                    TranslocoModule
                ],
                exports: [DsNipComponent]
            }]
    }], null, null); })();

class NotificationService {
    constructor() {
        this.subject = new BehaviorSubject(null);
    }
    // convenience methods
    success(notification) {
        this.notification(Object.assign(Object.assign({}, notification), { severity: 'success' }));
    }
    info(notification) {
        this.notification(Object.assign(Object.assign({}, notification), { severity: 'info' }));
    }
    warn(notification) {
        this.notification(Object.assign(Object.assign({}, notification), { severity: 'warn' }));
    }
    error(notification) {
        this.notification(Object.assign(Object.assign({}, notification), { severity: 'error' }));
    }
    // main notification method
    notification(notification) {
        this.subject.next(notification);
    }
}
NotificationService.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(); };
NotificationService.ɵprov = ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(); }, token: NotificationService, providedIn: "root" });
NotificationService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class DsNotificationComponent {
    constructor(notificationService, messageService) {
        this.notificationService = notificationService;
        this.messageService = messageService;
        /**
         * Określa pozycje, w której ma się znajdować komponent.
         * Przyjmuje wartości 'top-right', 'top-left', 'bottom-right', 'bottom-left', 'top-center', 'bottom-center', 'center'
         * @type NotificationPosition
         * @default 'top-right'
         * */
        this.position = 'top-right';
        /**
         * Określa bazowy zIndex do użycia przy warstwowaniu
         * @type number
         * @default 0
         * */
        this.baseZIndex = 0;
        /**
         * Określa czy automatycznie zarządzać warstwowaniem
         * @type boolean
         * @default true
         * */
        this.autoZIndex = true;
        /**
         * Określa jaka animacja przejścia ma zadziałać przy wyświetlaniu się wiadomości
         * @type string
         * @default '300ms ease-out'
         * */
        this.showTransitionOptions = '300ms ease-out';
        /**
         * Określa jaka animacja przejścia ma zadziałać przy chowaniu się wiadomości
         * @type string
         * @default '250ms ease-in'
         * */
        this.hideTransitionOptions = '250ms ease-in';
        /**
         * Określa jaka animacja transformacji ma zadziałać przy wyświetlaniu się wiadomości
         * @type string
         * @default 'translateY(100%)'
         * */
        this.showTransformOptions = 'translateY(100%)';
        /**
         * Określa jaka animacja transformacji ma zadziałać przy chowaniu się wiadomości
         * @type string
         * @default 'translateY(-100%)'
         * */
        this.hideTransformOptions = 'translateY(-100%)';
        /**
         * Określa czy może pojawić się więcej wiadomości o tej samej treści.
         * @type boolean
         * @default false
         * */
        this.preventOpenDuplicates = false;
        /**
         * Określa czy można wyświetlić dwa razy taką samą wiadomość
         * @type boolean
         * @default false
         * */
        this.preventDuplicates = false;
        /**
         * Włącza przyciski akcji TAK - NIE
         * @type boolean
         * @default false
         * */
        this.actionButtons = false;
        this.onClose = new EventEmitter();
        this.onConfirm = new EventEmitter();
        this.onReject = new EventEmitter();
    }
    ngOnInit() {
        this.subscription = this.notificationService.subject.subscribe((notification) => {
            if (notification) {
                this.newNotification(notification);
            }
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    newNotification(notification) {
        this.messageService.add(Object.assign({}, notification));
    }
    confirm() {
        this.onConfirm.emit();
        this.messageService.clear(this.key);
    }
    reject() {
        this.onReject.emit();
        this.messageService.clear(this.key);
    }
}
DsNotificationComponent.ɵfac = function DsNotificationComponent_Factory(t) { return new (t || DsNotificationComponent)(ɵngcc0.ɵɵdirectiveInject(NotificationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc8.MessageService)); };
DsNotificationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsNotificationComponent, selectors: [["ds-notification"]], inputs: { position: "position", baseZIndex: "baseZIndex", autoZIndex: "autoZIndex", showTransitionOptions: "showTransitionOptions", hideTransitionOptions: "hideTransitionOptions", showTransformOptions: "showTransformOptions", hideTransformOptions: "hideTransformOptions", preventOpenDuplicates: "preventOpenDuplicates", preventDuplicates: "preventDuplicates", actionButtons: "actionButtons", key: "key", style: "style", styleClass: "styleClass", ariaLabel: "ariaLabel", icon: "icon" }, outputs: { onClose: "onClose", onConfirm: "onConfirm", onReject: "onReject" }, features: [ɵngcc0.ɵɵProvidersFeature([MessageService])], decls: 2, vars: 14, consts: [[3, "key", "autoZIndex", "baseZIndex", "styleClass", "position", "preventOpenDuplicates", "preventDuplicates", "showTransformOptions", "hideTransformOptions", "showTransitionOptions", "hideTransitionOptions", "onClose"], ["pTemplate", "message"], [1, "p-flex", "p-flex-column", "notification-content", 2, "flex", "1"], [1, "p-text-left"], ["class", "pi", "style", "font-size: 3rem", 3, "ngClass", 4, "ngIf"], [1, "title-font", 3, "innerHTML"], [1, "message-font", 3, "innerHTML"], ["class", "p-grid p-fluid p-mt-3", 4, "ngIf"], [1, "pi", 2, "font-size", "3rem", 3, "ngClass"], [1, "p-grid", "p-fluid", "p-mt-3"], [1, "p-col-6"], ["pButton", "", "label", "Tak", 1, "p-button-success", 3, "click"], ["pButton", "", "label", "Nie", 1, "p-button-secondary", 3, "click"]], template: function DsNotificationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-toast", 0);
        ɵngcc0.ɵɵlistener("onClose", function DsNotificationComponent_Template_p_toast_onClose_0_listener($event) { return ctx.onClose.emit($event); });
        ɵngcc0.ɵɵtemplate(1, DsNotificationComponent_ng_template_1_Template, 6, 4, "ng-template", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵproperty("key", ctx.key)("autoZIndex", ctx.autoZIndex)("baseZIndex", ctx.baseZIndex)("styleClass", ctx.styleClass)("position", ctx.position)("preventOpenDuplicates", ctx.preventOpenDuplicates)("preventDuplicates", ctx.preventDuplicates)("showTransformOptions", ctx.showTransformOptions)("hideTransformOptions", ctx.hideTransformOptions)("showTransitionOptions", ctx.showTransitionOptions)("hideTransitionOptions", ctx.hideTransitionOptions);
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
    } }, directives: [ɵngcc17.Toast, ɵngcc8.PrimeTemplate, ɵngcc2.NgIf, ɵngcc2.NgClass, DsButtonComponent], encapsulation: 2 });
DsNotificationComponent.ctorParameters = () => [
    { type: NotificationService },
    { type: MessageService }
];
DsNotificationComponent.propDecorators = {
    key: [{ type: Input }],
    style: [{ type: Input }],
    styleClass: [{ type: Input }],
    position: [{ type: Input }],
    baseZIndex: [{ type: Input }],
    autoZIndex: [{ type: Input }],
    showTransitionOptions: [{ type: Input }],
    hideTransitionOptions: [{ type: Input }],
    showTransformOptions: [{ type: Input }],
    hideTransformOptions: [{ type: Input }],
    preventOpenDuplicates: [{ type: Input }],
    preventDuplicates: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    icon: [{ type: Input }],
    actionButtons: [{ type: Input }],
    onClose: [{ type: Output }],
    onConfirm: [{ type: Output }],
    onReject: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsNotificationComponent, [{
        type: Component,
        args: [{
                selector: 'ds-notification',
                template: `
    <p-toast
      [key]="key"
      [autoZIndex]="autoZIndex"
      [baseZIndex]="baseZIndex"
      [style]="style"
      [styleClass]="styleClass"
      [position]="position"
      [preventOpenDuplicates]="preventOpenDuplicates"
      [preventDuplicates]="preventDuplicates"
      [showTransformOptions]="showTransformOptions"
      [hideTransformOptions]="hideTransformOptions"
      [showTransitionOptions]="showTransitionOptions"
      [hideTransitionOptions]="hideTransitionOptions"
      (onClose)="onClose.emit($event)"
      [attr.aria-label]="ariaLabel"
    >
      <ng-template let-message pTemplate="message">
        <div class="p-flex p-flex-column notification-content" style="flex: 1">
          <div class="p-text-left">
            <i *ngIf="icon" [ngClass]="icon" class="pi" style="font-size: 3rem"></i>
            <div class="title-font" [innerHTML]="message.summary"></div>
            <div class="message-font" [innerHTML]="message.detail"></div>
          </div>
          <div *ngIf="actionButtons" class="p-grid p-fluid p-mt-3">
            <div class="p-col-6">
              <ds-button pButton (click)="confirm()" label="Tak" class="p-button-success">Tak</ds-button>
            </div>
            <div class="p-col-6">
              <ds-button pButton (click)="reject()" label="Nie" class="p-button-secondary">Nie</ds-button>
            </div>
          </div>
        </div>
      </ng-template>
    </p-toast>
  `,
                providers: [MessageService]
            }]
    }], function () { return [{ type: NotificationService }, { type: ɵngcc8.MessageService }]; }, { position: [{
            type: Input
        }], baseZIndex: [{
            type: Input
        }], autoZIndex: [{
            type: Input
        }], showTransitionOptions: [{
            type: Input
        }], hideTransitionOptions: [{
            type: Input
        }], showTransformOptions: [{
            type: Input
        }], hideTransformOptions: [{
            type: Input
        }], preventOpenDuplicates: [{
            type: Input
        }], preventDuplicates: [{
            type: Input
        }], actionButtons: [{
            type: Input
        }], onClose: [{
            type: Output
        }], onConfirm: [{
            type: Output
        }], onReject: [{
            type: Output
        }], key: [{
            type: Input
        }], style: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], icon: [{
            type: Input
        }] }); })();

class DsNotification {
    constructor(notification) {
        this.closable = true; // When enabled, displays a close icon to hide a message manually.
        this.data = null; // Arbitrary object to associate with the message.
        this.detail = null; // Detail text of the message.
        this.id = null; // Identifier of the message.
        this.key = null; // Key of the message in case message is targeted to a specific toast component.
        this.life = 5000; // Number of time in milliseconds to wait before closing the message.
        this.severity = 'info'; // Severity level of the message.
        this.sticky = false; // Whether the message should be automatically closed based on life property or kept visible.
        this.summary = null; // Summary text of the message.
        this.closable = notification.closable;
        this.data = notification.data;
        this.detail = notification.detail;
        this.id = notification.id;
        this.key = notification.key;
        this.life = notification.life;
        this.severity = notification.severity;
        this.sticky = notification.sticky;
        this.summary = notification.summary;
    }
}

class DsNotificationModule {
}
DsNotificationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsNotificationModule });
DsNotificationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsNotificationModule_Factory(t) { return new (t || DsNotificationModule)(); }, providers: [MessageService], imports: [[CommonModule, SharedModule, ToastModule, DsButtonModule], DsButtonModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsNotificationModule, { declarations: function () { return [DsNotificationComponent]; }, imports: function () { return [CommonModule, SharedModule, ToastModule, DsButtonModule]; }, exports: function () { return [DsNotificationComponent, DsButtonModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsNotificationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, SharedModule, ToastModule, DsButtonModule],
                exports: [DsNotificationComponent, DsButtonModule],
                declarations: [DsNotificationComponent],
                providers: [MessageService]
            }]
    }], null, null); })();

class DsPeselComponent {
    constructor() {
        /**
         * Określa, czy input ma być tylko do odczytu
         * @type boolean
         * @default false
         * */
        this.readonly = false;
        /**
         * Czy ma być włączona wbudowana walidacja
         * @type boolean
         * @default true
         * */
        this.walidacja = true;
        /**
         * Wymagalność przy wbudowanej walidacji
         * @type boolean
         * @default false
         */
        this.optional = false;
        /**
         * Znak reprezentujący wolne miejsce w inpucie.
         * @type string
         * @default '_'
         * */
        this.slotChar = '_';
        /**
         * Określa czy źle wprowadzona wartość ma być usunięta
         * @type boolean
         * @default false
         * */
        this.autoClear = false;
        /**
         * Określa nazwę inputu
         * @type string
         * @default empty string
         * */
        this.name = '';
        /**
         * Określa jakie ID ma być nadane inputowi.
         * Jeśli zostawione puste to będzie nadane wygenerowane ID.
         * @type string
         * */
        this.inputId = undefined;
        /**
         * Określa, czy input ma dostać automatycznie focus po załadowaniu się strony
         * @type boolean
         * @default false
         * */
        this.autoFocus = false;
        /**
         * Tekst, który jest pokazywany, kiedy kursor jest nad elementem.
         * @type string
         * @default empty string
         * */
        this.title = '';
        /**
         * Określa, czy w inpucie po prawej stronie ma być ikona X, która po kliknięciu usuwa tekst w inpucie
         * @type boolean
         * @default true
         * */
        this.showClear = false;
        this.ngModelChange = new EventEmitter();
        this.onClear = new EventEmitter();
        this.onChange = () => {
        };
        this.onTouch = () => {
        };
    }
    ngOnInit() {
        if (this.inputId == undefined)
            this.inputId = Utils.wygenerujLosoweId();
    }
    clear() {
        if (this.isDisabled)
            return;
        this.ngModel = null;
        this.onChange(null);
        this.ngModelChange.emit(null);
        this.onClear.emit();
    }
    focus() {
        this.inputMaskComponent.focus();
        console.log(this.inputMaskComponent);
    }
    writeValue(value) {
        this.ngModel = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
        this.errorMessage = null;
    }
    onChangeWrapper($event) {
        this.ngModel = $event;
        this.onChange($event);
    }
    validate({ value }) {
        if (!this.walidacja || (this.optional && !value)) {
            this.errorMessage = null;
            return null;
        }
        const isNotValid = !this.check(value);
        if (isNotValid) {
            if (!value) {
                this.errorMessage = 'ds.registry.empty';
            }
            else if (value.length < 11) {
                this.errorMessage = 'ds.registry.tooShort';
            }
            else {
                this.errorMessage = 'ds.registry.invalid';
            }
        }
        else {
            this.errorMessage = null;
        }
        return isNotValid && {
            invalid: true
        };
    }
    check(pesel) {
        if (pesel === undefined || pesel === null || pesel === '') {
            return false;
        }
        if (pesel.length != 11) {
            return false;
        }
        var aInt = new Array();
        for (i = 0; i < 11; i++) {
            aInt[i] = parseInt(pesel.substring(i, i + 1));
            if (isNaN(aInt[i])) {
                return false;
            }
        }
        var wagi = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3, 1];
        var sum = 0;
        for (var i = 0; i < 11; i++) {
            sum += wagi[i] * aInt[i];
        }
        if ((sum % 10) != 0) {
            return false;
        }
        var rok = 1900 + aInt[0] * 10 + aInt[1];
        if (aInt[2] >= 2 && aInt[2] < 8) {
            rok += Math.floor(aInt[2] / 2) * 100;
        }
        if (aInt[2] >= 8) {
            rok -= 100;
        }
        var miesiac = (aInt[2] % 2) * 10 + aInt[3];
        var dzien = aInt[4] * 10 + aInt[5];
        if (!this.checkDate(dzien, miesiac, rok)) {
            return false;
        }
        return true;
    }
    checkDate(d, m, y) {
        var dt = new Date(y, m - 1, d);
        return dt.getDate() == d &&
            dt.getMonth() == m - 1 &&
            dt.getFullYear() == y;
    }
    onPaste(event) {
        var pasteText = event.clipboardData.getData('text');
        if (pasteText) {
            if (!isNaN(Number(pasteText))) {
                this.writeValue(pasteText);
            }
        }
    }
}
DsPeselComponent.ɵfac = function DsPeselComponent_Factory(t) { return new (t || DsPeselComponent)(); };
DsPeselComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsPeselComponent, selectors: [["ds-pesel"]], viewQuery: function DsPeselComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputMaskComponent = _t.first);
    } }, hostAttrs: [1, "ds-pesel"], hostVars: 2, hostBindings: function DsPeselComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly);
    } }, inputs: { readonly: "readonly", walidacja: "walidacja", optional: "optional", slotChar: "slotChar", autoClear: "autoClear", name: "name", inputId: "inputId", autoFocus: "autoFocus", title: "title", showClear: "showClear", ngModel: "ngModel", placeholder: "placeholder", label: "label", style: "style", styleClass: "styleClass", tabindex: "tabindex", autocomplete: "autocomplete", iconRightTitle: "iconRightTitle", iconLeftTitle: "iconLeftTitle", iconLeft: "iconLeft", iconRight: "iconRight", ariaLabel: "ariaLabel" }, outputs: { ngModelChange: "ngModelChange", onClear: "onClear" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => DsPeselComponent)
            },
            {
                provide: NG_VALIDATORS,
                multi: true,
                useExisting: DsPeselComponent
            }
        ])], decls: 9, vars: 34, consts: [[1, "ds-pesel-label", 3, "for"], [1, "ds-pesel-wrapper"], [3, "title", "class", 4, "ngIf"], ["mask", "99999999999", 3, "unmask", "placeholder", "maxlength", "disabled", "readonly", "slotChar", "autoClear", "styleClass", "tabindex", "name", "inputId", "autoFocus", "autocomplete", "title", "ngModel", "ariaLabel", "ngModelChange", "onBlur", "paste"], ["inputElement", ""], ["class", "pi pi-times ds-input-show-clear", 3, "tabindex", "icon-right", "is-disabled", "is-readonly", "click", "keydown.enter", 4, "ngIf"], [3, "class", "title", "click", 4, "ngIf"], ["class", "ds-pesel-error-message", 4, "ngIf"], [3, "title"], [1, "pi", "pi-times", "ds-input-show-clear", 3, "tabindex", "click", "keydown.enter"], [3, "title", "click"], [1, "ds-pesel-error-message"]], template: function DsPeselComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DsPeselComponent_i_3_Template, 1, 4, "i", 2);
        ɵngcc0.ɵɵelementStart(4, "p-inputMask", 3, 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsPeselComponent_Template_p_inputMask_ngModelChange_4_listener($event) { return ctx.onChangeWrapper($event); })("onBlur", function DsPeselComponent_Template_p_inputMask_onBlur_4_listener() { return ctx.onTouch(); })("paste", function DsPeselComponent_Template_p_inputMask_paste_4_listener($event) { return ctx.onPaste($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DsPeselComponent_i_6_Template, 1, 7, "i", 5);
        ɵngcc0.ɵɵtemplate(7, DsPeselComponent_i_7_Template, 1, 4, "i", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, DsPeselComponent_span_8_Template, 3, 5, "span", 7);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly)("has-left-icon", ctx.iconLeft)("has-right-icon", ctx.iconRight)("has-clear-icon", ctx.showClear)("is-disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("unmask", true)("placeholder", ctx.placeholder)("maxlength", 11)("disabled", ctx.isDisabled)("readonly", ctx.readonly)("slotChar", ctx.slotChar)("autoClear", ctx.autoClear)("styleClass", ctx.styleClass)("tabindex", ctx.tabindex)("name", ctx.name)("inputId", ctx.inputId)("autoFocus", ctx.autoFocus)("autocomplete", ctx.autocomplete)("title", ctx.title)("ngModel", ctx.ngModel)("ariaLabel", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorMessage && !ctx.inputMaskComponent.disabled);
    } }, directives: [ɵngcc2.NgIf, ɵngcc14.InputMask, ɵngcc4.MaxLengthValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], pipes: [ɵngcc7.TranslocoPipe], encapsulation: 2 });
DsPeselComponent.ctorParameters = () => [];
DsPeselComponent.propDecorators = {
    readonly: [{ type: Input }],
    placeholder: [{ type: Input }],
    label: [{ type: Input }],
    walidacja: [{ type: Input }],
    optional: [{ type: Input }],
    slotChar: [{ type: Input }],
    autoClear: [{ type: Input }],
    style: [{ type: Input }],
    styleClass: [{ type: Input }],
    tabindex: [{ type: Input }],
    name: [{ type: Input }],
    inputId: [{ type: Input }],
    autoFocus: [{ type: Input }],
    autocomplete: [{ type: Input }],
    title: [{ type: Input }],
    showClear: [{ type: Input }],
    iconRightTitle: [{ type: Input }],
    iconLeftTitle: [{ type: Input }],
    iconLeft: [{ type: Input }],
    iconRight: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    ngModel: [{ type: Input }],
    ngModelChange: [{ type: Output }],
    onClear: [{ type: Output }],
    inputMaskComponent: [{ type: ViewChild, args: ['inputElement', { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsPeselComponent, [{
        type: Component,
        args: [{
                selector: 'ds-pesel',
                template: `
    <label class="ds-pesel-label" [for]="inputId">{{label}}</label>
    <div class="ds-pesel-wrapper">
      <i
        [title]="iconLeftTitle"
        *ngIf="iconLeft"
        class="pi {{iconLeft}} ds-input-icon-left"
      >
      </i>
      <p-inputMask
        mask="99999999999"
        [unmask]="true"
        [placeholder]="placeholder"
        [maxlength]="11"
        [disabled]="isDisabled"
        [readonly]="readonly"
        [slotChar]="slotChar"
        [autoClear]="autoClear"
        [style]="style"
        [styleClass]="styleClass"
        [tabindex]="tabindex"
        [name]="name"
        [inputId]="inputId"
        [autoFocus]="autoFocus"
        [autocomplete]="autocomplete"
        [title]="title"
        [ngModel]="ngModel"
        (ngModelChange)="onChangeWrapper($event)"
        (onBlur)="onTouch()"
        (paste)="onPaste($event)"
        [class.is-readonly]="readonly"
        [class.has-left-icon]="iconLeft"
        [class.has-right-icon]="iconRight"
        [class.has-clear-icon]="showClear"
        [class.is-disabled]="isDisabled"
        [ariaLabel]="ariaLabel"
        #inputElement
      >
      </p-inputMask>
      <i
        class="pi pi-times ds-input-show-clear"
        tabindex="{{ isDisabled || readonly ? '-1' : '0' }}"
        *ngIf="showClear"
        (click)="clear()"
        (keydown.enter)="clear()"
        [class.icon-right]="iconRight"
        [class.is-disabled]="isDisabled"
        [class.is-readonly]="readonly"
      >
      </i>
      <i
        *ngIf="iconRight"
        class="pi {{iconRight}} ds-input-icon-right"
        [title]="iconRightTitle"
        (click)="focus()"
      >
      </i>
    </div>
    <span class="ds-pesel-error-message"
          *ngIf="errorMessage && !inputMaskComponent.disabled"
    >
          {{ errorMessage | transloco: {name: 'PESEL', length: '11'} }}
      </span>
  `,
                host: {
                    'class': 'ds-pesel',
                    '[class.is-readonly]': 'readonly'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => DsPeselComponent)
                    },
                    {
                        provide: NG_VALIDATORS,
                        multi: true,
                        useExisting: DsPeselComponent
                    }
                ]
            }]
    }], function () { return []; }, { readonly: [{
            type: Input
        }], walidacja: [{
            type: Input
        }], optional: [{
            type: Input
        }], slotChar: [{
            type: Input
        }], autoClear: [{
            type: Input
        }], name: [{
            type: Input
        }], inputId: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], title: [{
            type: Input
        }], showClear: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], onClear: [{
            type: Output
        }], ngModel: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], style: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], iconRightTitle: [{
            type: Input
        }], iconLeftTitle: [{
            type: Input
        }], iconLeft: [{
            type: Input
        }], iconRight: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], inputMaskComponent: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }] }); })();

class DsPeselModule {
}
DsPeselModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsPeselModule });
DsPeselModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsPeselModule_Factory(t) { return new (t || DsPeselModule)(); }, imports: [[
            CommonModule,
            InputMaskModule,
            FormsModule,
            TranslocoModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsPeselModule, { declarations: function () { return [DsPeselComponent]; }, imports: function () { return [CommonModule,
        InputMaskModule,
        FormsModule,
        TranslocoModule]; }, exports: function () { return [DsPeselComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsPeselModule, [{
        type: NgModule,
        args: [{
                declarations: [DsPeselComponent],
                imports: [
                    CommonModule,
                    InputMaskModule,
                    FormsModule,
                    TranslocoModule
                ],
                exports: [
                    DsPeselComponent
                ]
            }]
    }], null, null); })();

/*
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ds-radio',
  template: `
    <p-radioButton
      [name]="name"
      [value]="value"
      [label]="label"
      [disabled]="disabled"
      [tabindex]="tabindex"
      [inputId]="inputId"
      [ariaLabelledBy]="ariaLabelledBy"
      [style]="style"
      [styleClass]="styleClass"
      [labelStyleClass]="labelStyleClass"
      [ngModel]="ngModel"
      (ngModelChange)="onChange($event)"
    ></p-radioButton>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => DsRadioComponent),
    },
  ],
})
export class DsRadioComponent implements OnInit, ControlValueAccessor {

  /!**
   * Określa nazwę radio buttona
   * @type string
   * @default null
   * *!/
  @Input() name: string = null;
  /!**
   * Określa wartość radio buttona inputu przy jego wczytaniu na stronie
   * @type any
   * @default null
   * *!/
  @Input() value: any = null;
  /!**
   * Etykieta znajdująca się obok radio buttona
   * @type string
   * @default null
   * *!/
  @Input() label: string = null;
  /!**
   * Określa tab index elementu
   * @type number
   * @default null
   * *!/
  @Input() tabindex: number = null;
  /!**
   * ID elementu.
   * @type string
   * @default null
   * *!/
  @Input() inputId: string = null;
  /!**
   * Ustanawia relacje pomiędzy komponentem i etykietą(-ami), których wartość powinna być jednym lub kilkoma ID elementu.
   * @type string
   * @default null
   * *!/
  @Input() ariaLabelledBy: string = null;
  /!**
   * Wbudowany styl nadany elementowi.
   * @type string
   * @default null
   * *!/
  @Input() style: object = null;
  /!**
   * Określa klasę stylu dla elementu.
   * @type string
   * @default null
   * *!/
  @Input() styleClass: string = null;
  /!**
   * Określa klasę dla stylów dla label radio buttona
   * @type string
   * @default null
   * *!/
  @Input() labelStyleClass: string = null;
  @Input() ngModel: any;
  @Output() ngModelChange = new EventEmitter<any>();
  @Output() onClick = new EventEmitter<any>();
  @Output() onFocus = new EventEmitter<any>();
  @Output() onBlur = new EventEmitter<any>();

  disabled: boolean = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  onChange: any = () => {
  }

  onTouch: any = () => {
  }

  writeValue(value: any) {
    this.ngModel = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}
*/
/**
 * New
 */
const RADIO_GROUP_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DsRadioGroup),
    multi: true
};
class DsRadioChange {
    constructor(source, value) {
        this.source = source;
        this.value = value;
    }
}
let nextUniqueId = 0;
class DsRadioGroup {
    constructor() {
        this._value = null;
        this._selected = null;
        this._name = `ds-radio-group-${nextUniqueId++}`;
        this._disabled = false;
        this.onChange = new EventEmitter();
        /** The method to be called in order to update ngModel */
        this.controlValueAccessorChangeFn = () => { };
        this.onTouch = () => { };
    }
    get value() { return this._value; }
    set value(val) {
        if (this._value !== val) {
            this._value = val;
            if (this.selected == null) {
                this.updateSelectedRadioFromValue();
            }
        }
    }
    get name() { return this._name; }
    set name(value) {
        this._name = value;
        this.setRadioButtonNames();
    }
    get disabled() { return this._disabled; }
    set disabled(value) {
        this._disabled = value;
        if (this.radios) {
            this.radios.forEach(radio => {
                radio.disabled = value;
            });
        }
    }
    get selected() { return this._selected; }
    set selected(selected) {
        this._selected = selected;
        this.value = selected.value;
    }
    writeValue(value) {
        this.value = value;
    }
    registerOnChange(fn) {
        this.controlValueAccessorChangeFn = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    ngAfterContentInit() {
        this.setRadioButtonNames();
    }
    setRadioButtonNames() {
        if (this.radios) {
            this.radios.forEach(radio => {
                radio.name = this.name;
            });
        }
    }
    updateSelectedRadioFromValue() {
        const isSelected = this.selected !== null && this.selected.value === this.value;
        if (this.radios && !isSelected) {
            this.radios.forEach(radio => {
                radio.checked = this.value === radio.value;
                if (radio.checked) {
                    this.selected = radio;
                    this.value = radio.value;
                }
            });
        }
    }
    emitOnChangeEvent() {
        this.onChange.emit(new DsRadioChange(this.selected, this.value));
    }
}
DsRadioGroup.ɵfac = function DsRadioGroup_Factory(t) { return new (t || DsRadioGroup)(); };
DsRadioGroup.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DsRadioGroup, selectors: [["ds-radio-group"]], contentQueries: function DsRadioGroup_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DsRadioButton, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.radios = _t);
    } }, hostAttrs: ["role", "radiogroup"], inputs: { value: "value", name: "name", disabled: "disabled" }, outputs: { onChange: "onChange" }, features: [ɵngcc0.ɵɵProvidersFeature([RADIO_GROUP_VALUE_ACCESSOR])] });
DsRadioGroup.ctorParameters = () => [];
DsRadioGroup.propDecorators = {
    radios: [{ type: ContentChildren, args: [forwardRef(() => DsRadioButton),] }],
    value: [{ type: Input }],
    name: [{ type: Input }],
    disabled: [{ type: Input }],
    onChange: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsRadioGroup, [{
        type: Directive,
        args: [{
                selector: 'ds-radio-group',
                host: {
                    'role': 'radiogroup'
                },
                providers: [RADIO_GROUP_VALUE_ACCESSOR]
            }]
    }], function () { return []; }, { onChange: [{
            type: Output
        }], value: [{
            type: Input
        }], name: [{
            type: Input
        }], disabled: [{
            type: Input
        }], radios: [{
            type: ContentChildren,
            args: [forwardRef(() => DsRadioButton)]
        }] }); })();
class DsRadioButton {
    constructor(radioGroup, focusMonitor) {
        this.focusMonitor = focusMonitor;
        this.uniqueId = `ds-radio-${++nextUniqueId}`;
        this._checked = false;
        this.focused = false;
        this.disabled = false;
        this.id = this.uniqueId;
        this.radioGroup = radioGroup;
    }
    get inputId() { return `${this.id || this.uniqueId}-input`; }
    get checked() { return this._checked; }
    set checked(value) {
        if (this._checked != value) {
            this._checked = value;
            if (this.radioGroup.radios && value == true) {
                this.radioGroup.selected = this;
                this.radioGroup.radios.forEach(radio => {
                    if (radio.id != this.id) {
                        radio.checked = false;
                    }
                });
            }
        }
    }
    ngOnInit() {
        if (this.radioGroup) {
            // If the radio is inside a radio group, determine if it should be checked
            this.checked = this.radioGroup.value === this.value;
            this.disabled = this.radioGroup.disabled;
            if (this.checked) {
                this.radioGroup.selected = this;
            }
            // Copy name from parent radio group
            this.name = this.radioGroup.name;
        }
    }
    ngAfterViewInit() {
        this.focusMonitor
            .monitor(this.inputElement)
            .subscribe(focusOrigin => {
            if (focusOrigin) {
                this.focused = true;
            }
            if (!focusOrigin && this.radioGroup) {
                this.radioGroup.radios.forEach(radio => {
                    radio.focused = false;
                });
            }
        });
    }
    ngOnDestroy() {
        this.focusMonitor.stopMonitoring(this.inputElement);
    }
    onInputClick(event) {
        event.stopPropagation();
    }
    onInputChange(event) {
        event.stopPropagation();
        if (!this.checked) {
            this.checked = true;
            if (this.radioGroup) {
                this.radioGroup.controlValueAccessorChangeFn(this.value);
                this.radioGroup.emitOnChangeEvent();
            }
        }
    }
}
DsRadioButton.ɵfac = function DsRadioButton_Factory(t) { return new (t || DsRadioButton)(ɵngcc0.ɵɵdirectiveInject(DsRadioGroup), ɵngcc0.ɵɵdirectiveInject(ɵngcc18.FocusMonitor)); };
DsRadioButton.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsRadioButton, selectors: [["ds-radio-button"]], viewQuery: function DsRadioButton_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c16, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } }, hostAttrs: [1, "ds-radio-button"], inputs: { id: "id", name: "name", value: "value", ariaLabelledBy: "ariaLabelledBy", ariaLabel: "ariaLabel", tabindex: "tabindex" }, ngContentSelectors: _c2, decls: 8, vars: 19, consts: [[1, "ds-radio-label", 3, "ngClass"], [1, "ds-radio-container"], [1, "ds-radio-outer-circle", 3, "ngClass"], [1, "ds-radio-inner-circle", 3, "ngClass"], ["type", "radio", 1, "ds-visually-hidden", 3, "disabled", "checked", "change", "click"], ["input", ""], [1, "ds-radio-label-content"]], template: function DsRadioButton_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵelement(2, "span", 2);
        ɵngcc0.ɵɵelement(3, "span", 3);
        ɵngcc0.ɵɵelementStart(4, "input", 4, 5);
        ɵngcc0.ɵɵlistener("change", function DsRadioButton_Template_input_change_4_listener($event) { return ctx.onInputChange($event); })("click", function DsRadioButton_Template_input_click_4_listener($event) { return ctx.onInputClick($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "span", 6);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(12, _c17, ctx.disabled));
        ɵngcc0.ɵɵattribute("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(14, _c18, ctx.checked, ctx.focused && ctx.checked));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(17, _c19, ctx.checked));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("checked", ctx.checked);
        ɵngcc0.ɵɵattribute("id", ctx.inputId)("tabindex", ctx.tabindex)("name", ctx.name)("value", ctx.value)("aria-label", ctx.ariaLabel)("aria-labelledby", ctx.ariaLabelledBy);
    } }, directives: [ɵngcc2.NgClass], encapsulation: 2 });
DsRadioButton.ctorParameters = () => [
    { type: DsRadioGroup },
    { type: FocusMonitor }
];
DsRadioButton.propDecorators = {
    name: [{ type: Input }],
    id: [{ type: Input }],
    value: [{ type: Input }],
    ariaLabelledBy: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    tabindex: [{ type: Input }],
    inputElement: [{ type: ViewChild, args: ['input',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsRadioButton, [{
        type: Component,
        args: [{
                selector: 'ds-radio-button',
                template: `
    <label [attr.for]="inputId" class="ds-radio-label" [ngClass]="{'ds-radio-label--disabled':disabled}">
      <span class="ds-radio-container">
        <span class="ds-radio-outer-circle"
        [ngClass]="{'ds-radio-outer-circle--checked':checked, 'ds-radio-outer-circle--focused':focused&&checked}"></span>
        <span class="ds-radio-inner-circle"
        [ngClass]="{'ds-radio-inner-circle--checked':checked}"></span>
        <input #input type="radio" class="ds-visually-hidden"
        [disabled]="disabled"
        [attr.id]="inputId"
        [attr.tabindex]="tabindex" 
        [attr.name]="name"
        [attr.value]="value"
        [attr.aria-label]="ariaLabel"
        [attr.aria-labelledby]="ariaLabelledBy"
        [checked]="checked" 
        (change)="onInputChange($event)"
        (click)="onInputClick($event)">
      </span>
      <span class="ds-radio-label-content"><ng-content></ng-content></span>
    </label>
  `,
                host: {
                    'class': 'ds-radio-button'
                }
            }]
    }], function () { return [{ type: DsRadioGroup }, { type: ɵngcc18.FocusMonitor }]; }, { id: [{
            type: Input
        }], name: [{
            type: Input
        }], value: [{
            type: Input
        }], ariaLabelledBy: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], inputElement: [{
            type: ViewChild,
            args: ['input']
        }] }); })();
/**
 * Deprecated
 */
const RADIO_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DsRadioComponent),
    multi: true
};
/**
 * Internal class used by RadioButton to uncheck radio buttons with the matching name.
 */
class RadioControlRegistry {
    constructor() {
        this.accessors = [];
    }
    add(control, accessor) {
        this.accessors.push([control, accessor]);
    }
    remove(accessor) {
        this.accessors = this.accessors.filter((c) => {
            return c[1] !== accessor;
        });
    }
    select(accessor) {
        this.accessors.forEach((c) => {
            if (this.isSameGroup(c, accessor) && c[1] !== accessor) {
                c[1].writeValue(accessor.value);
            }
        });
    }
    isSameGroup(controlPair, accessor) {
        if (!controlPair[0].control) {
            return false;
        }
        return controlPair[0].control.root === accessor.control.control.root && controlPair[1].name === accessor.name;
    }
}
RadioControlRegistry.ɵfac = function RadioControlRegistry_Factory(t) { return new (t || RadioControlRegistry)(); };
RadioControlRegistry.ɵprov = ɵɵdefineInjectable({ factory: function RadioControlRegistry_Factory() { return new RadioControlRegistry(); }, token: RadioControlRegistry, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RadioControlRegistry, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
class DsRadioComponent {
    constructor(cd, injector, registry) {
        this.cd = cd;
        this.injector = injector;
        this.registry = registry;
        this.onPreChange = new EventEmitter();
        this.onClick = new EventEmitter();
        this.onFocus = new EventEmitter();
        this.onBlur = new EventEmitter();
        this.onModelChange = () => {
        };
        this.onModelTouched = () => {
        };
    }
    static logNameError() {
        if (isDevMode()) {
            console.warn(`
          If you define both a name and a formControlName attribute on your radio button, their values
          must match. Ex: <ds-radio formControlName="food" name="food"></ds-radio>
        `);
        }
    }
    ngOnInit() {
        this.control = this.injector.get(NgControl);
        this.checkName();
        this.registry.add(this.control, this);
        if (this.inputId == undefined)
            this.inputId = Utils.wygenerujLosoweId();
        if (this.label == null) {
            this.label = 'radio';
            this.labelStyleClass = this.labelStyleClass + ' p-radiobutton-label-display-none';
        }
    }
    ngOnDestroy() {
        this.registry.remove(this);
    }
    handleClick(event, radioButton, focus) {
        var _a, _b;
        event.preventDefault();
        if (this.disabled) {
            return;
        }
        if ((_b = (_a = this.onPreChange) === null || _a === void 0 ? void 0 : _a.observers) === null || _b === void 0 ? void 0 : _b.length) {
            const _this = this;
            const callBackChange = function () {
                _this.handleClickCore(event, radioButton, focus);
            };
            this.onPreChange.emit(callBackChange);
        }
        else {
            this.handleClickCore(event, radioButton, focus);
        }
    }
    handleClickCore(event, radioButton, focus) {
        this.selectCore(event, radioButton);
        if (focus) {
            radioButton.focus();
        }
    }
    select(event, radioButton) {
        var _a, _b;
        if (!this.disabled) {
            if ((_b = (_a = this.onPreChange) === null || _a === void 0 ? void 0 : _a.observers) === null || _b === void 0 ? void 0 : _b.length) {
                const _this = this;
                const callBackChange = function () {
                    _this.selectCore(event, radioButton);
                };
                this.onPreChange.emit(callBackChange);
            }
            else {
                this.selectCore(event, radioButton);
            }
        }
    }
    selectCore(event, radioButton) {
        if (!this.disabled) {
            this.inputViewChild.nativeElement.checked = true;
            this.checked = true;
            this.onModelChange(this.value);
            this.onClick.emit(event);
            this.registry.select(this);
            radioButton.focus();
        }
    }
    writeValue(value) {
        this.checked = (value == this.value);
        if (this.inputViewChild && this.inputViewChild.nativeElement) {
            this.inputViewChild.nativeElement.checked = this.checked;
        }
        this.cd.markForCheck();
    }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onModelTouched = fn;
    }
    setDisabledState(val) {
        this.disabled = val;
        this.cd.markForCheck();
    }
    onInputFocus(event) {
        this.focused = true;
        this.onFocus.emit(event);
    }
    onInputBlur(event) {
        this.focused = false;
        this.onModelTouched();
        this.onBlur.emit(event);
    }
    onChange(event, radioButton) {
        this.select(event, radioButton);
    }
    focus() {
        this.inputViewChild.nativeElement.focus();
    }
    checkName() {
        if (this.name && this.formControlName && this.name !== this.formControlName) {
            DsRadioComponent.logNameError();
        }
        if (!this.name && this.formControlName) {
            this.name = this.formControlName;
        }
    }
}
DsRadioComponent.ɵfac = function DsRadioComponent_Factory(t) { return new (t || DsRadioComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(RadioControlRegistry)); };
DsRadioComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsRadioComponent, selectors: [["ds-radio"]], viewQuery: function DsRadioComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c20, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputViewChild = _t.first);
    } }, hostAttrs: [1, "ds-radio"], inputs: { inputId: "inputId", label: "label", labelStyleClass: "labelStyleClass", disabled: "disabled", name: "name", value: "value", formControlName: "formControlName", tabindex: "tabindex", ariaLabelledBy: "ariaLabelledBy", style: "style", styleClass: "styleClass", ariaLabel: "ariaLabel" }, outputs: { onPreChange: "onPreChange", onClick: "onClick", onFocus: "onFocus", onBlur: "onBlur" }, features: [ɵngcc0.ɵɵProvidersFeature([RADIO_VALUE_ACCESSOR])], decls: 7, vars: 23, consts: [[3, "ngStyle", "ngClass"], [1, "p-hidden-accessible"], ["type", "radio", 3, "checked", "disabled", "change", "focus", "blur"], ["rb", ""], ["role", "radio", 3, "ngClass", "click"], [1, "p-radiobutton-icon"], [3, "class", "ngClass", "click", 4, "ngIf"], [3, "ngClass", "click"]], template: function DsRadioComponent_Template(rf, ctx) { if (rf & 1) {
        const _r4 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2, 3);
        ɵngcc0.ɵɵlistener("change", function DsRadioComponent_Template_input_change_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const _r0 = ɵngcc0.ɵɵreference(3); return ctx.onChange($event, _r0); })("focus", function DsRadioComponent_Template_input_focus_2_listener($event) { return ctx.onInputFocus($event); })("blur", function DsRadioComponent_Template_input_blur_2_listener($event) { return ctx.onInputBlur($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵlistener("click", function DsRadioComponent_Template_div_click_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const _r0 = ɵngcc0.ɵɵreference(3); return ctx.handleClick($event, _r0, true); });
        ɵngcc0.ɵɵelement(5, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DsRadioComponent_label_6_Template, 2, 9, "label", 6);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.styleClass);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.style)("ngClass", ɵngcc0.ɵɵpureFunction3(15, _c22, ctx.checked, ctx.disabled, ctx.focused));
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("checked", ctx.checked)("disabled", ctx.disabled);
        ɵngcc0.ɵɵattribute("id", ctx.inputId)("name", ctx.name)("value", ctx.value)("tabindex", ctx.tabindex)("aria-labelledby", ctx.ariaLabelledBy);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(19, _c23, ctx.checked, ctx.disabled, ctx.focused));
        ɵngcc0.ɵɵattribute("aria-checked", ctx.checked);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
    } }, directives: [ɵngcc2.NgStyle, ɵngcc2.NgClass, ɵngcc2.NgIf], encapsulation: 2, changeDetection: 0 });
DsRadioComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: Injector },
    { type: RadioControlRegistry }
];
DsRadioComponent.propDecorators = {
    value: [{ type: Input }],
    formControlName: [{ type: Input }],
    name: [{ type: Input }],
    disabled: [{ type: Input }],
    label: [{ type: Input }],
    tabindex: [{ type: Input }],
    inputId: [{ type: Input }],
    ariaLabelledBy: [{ type: Input }],
    style: [{ type: Input }],
    styleClass: [{ type: Input }],
    labelStyleClass: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    onPreChange: [{ type: Output }],
    onClick: [{ type: Output }],
    onFocus: [{ type: Output }],
    onBlur: [{ type: Output }],
    inputViewChild: [{ type: ViewChild, args: ['rb',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsRadioComponent, [{
        type: Component,
        args: [{
                selector: 'ds-radio',
                template: `
    <div [ngStyle]="style"
         [ngClass]="{'p-radiobutton p-component':true,'p-radiobutton-checked': checked, 'p-radiobutton-disabled': disabled, 'p-radiobutton-focused': focused}"
         [class]="styleClass"
         [attr.aria-label]="ariaLabel"
    >
      <div class="p-hidden-accessible">
        <input #rb type="radio" [attr.id]="inputId" [attr.name]="name" [attr.value]="value" [attr.tabindex]="tabindex"
               [attr.aria-labelledby]="ariaLabelledBy"
               [checked]="checked" (change)="onChange($event,rb)" (focus)="onInputFocus($event)" (blur)="onInputBlur($event)"
               [disabled]="disabled">
      </div>
      <div (click)="handleClick($event, rb, true)" role="radio" [attr.aria-checked]="checked"
           [ngClass]="{'p-radiobutton-box':true,
                'p-highlight': checked, 'p-disabled': disabled, 'p-focus': focused}">
        <span class="p-radiobutton-icon"></span>
      </div>
    </div>
    <label (click)="select($event,rb)" [class]="labelStyleClass"
           [ngClass]="{'p-radiobutton-label':true, 'p-radiobutton-label-active':rb.checked, 'p-disabled':disabled, 'p-radiobutton-label-focus':focused}"
           *ngIf="label" [attr.for]="inputId">{{label}}</label>
  `,
                providers: [RADIO_VALUE_ACCESSOR],
                host: {
                    'class': 'ds-radio'
                },
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.Injector }, { type: RadioControlRegistry }]; }, { onPreChange: [{
            type: Output
        }], onClick: [{
            type: Output
        }], onFocus: [{
            type: Output
        }], onBlur: [{
            type: Output
        }], inputId: [{
            type: Input
        }], label: [{
            type: Input
        }], labelStyleClass: [{
            type: Input
        }], disabled: [{
            type: Input
        }], name: [{
            type: Input
        }], value: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], ariaLabelledBy: [{
            type: Input
        }], style: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], inputViewChild: [{
            type: ViewChild,
            args: ['rb']
        }] }); })();

class DsRadioModule {
}
DsRadioModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsRadioModule });
DsRadioModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsRadioModule_Factory(t) { return new (t || DsRadioModule)(); }, imports: [[
            CommonModule,
            RadioButtonModule,
            ReactiveFormsModule,
            FormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsRadioModule, { declarations: function () { return [DsRadioComponent, DsRadioButton, DsRadioGroup]; }, imports: function () { return [CommonModule,
        RadioButtonModule,
        ReactiveFormsModule,
        FormsModule]; }, exports: function () { return [DsRadioComponent, DsRadioButton, DsRadioGroup]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsRadioModule, [{
        type: NgModule,
        args: [{
                declarations: [DsRadioComponent, DsRadioButton, DsRadioGroup],
                imports: [
                    CommonModule,
                    RadioButtonModule,
                    ReactiveFormsModule,
                    FormsModule
                ],
                exports: [
                    DsRadioComponent, DsRadioButton, DsRadioGroup
                ]
            }]
    }], null, null); })();

class DsRegonComponent {
    constructor() {
        /**
         * Określa, czy input ma być tylko do odczytu
         * @type boolean
         * @default false
         * */
        this.readonly = false;
        /**
         * Czy ma być włączona wbudowana walidacja
         * @type boolean
         * @default true
         * */
        this.walidacja = true;
        /**
         * Wymagalność przy wbudowanej walidacji
         * @type boolean
         * @default false
         */
        this.optional = false;
        /**
         * Znak reprezentujący wolne miejsce w inpucie.
         * @type string
         * @default '_'
         * */
        this.slotChar = '_';
        /**
         * Określa czy źle wprowadzona wartość ma być usunięta
         * @type boolean
         * @default false
         * */
        this.autoClear = false;
        /**
         * Określa, czy input ma dostać automatycznie focus po załadowaniu się strony
         * @type boolean
         * @default false
         * */
        this.autoFocus = false;
        /**
         * Tekst, który jest pokazywany, kiedy kursor jest nad elementem.
         * @type string
         * @default empty string
         * */
        this.title = '';
        /**
         * Określa, czy w inpucie po prawej stronie ma być ikona X, która po kliknięciu usuwa tekst w inpucie
         * @type boolean
         * @default true
         * */
        this.showClear = false;
        this.ngModelChange = new EventEmitter();
        this.onClear = new EventEmitter();
        this.onChange = () => {
        };
        this.onTouch = () => {
        };
    }
    ngOnInit() {
        if (this.inputId == undefined)
            this.inputId = Utils.wygenerujLosoweId();
    }
    clear() {
        if (this.isDisabled)
            return;
        this.ngModel = null;
        this.onChange(null);
        this.ngModelChange.emit(null);
        this.onClear.emit();
    }
    focus() {
        this.inputMaskComponent.focus();
    }
    writeValue(value) {
        this.ngModel = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
        this.errorMessage = null;
    }
    onChangeWrapper($event) {
        this.ngModel = $event;
        this.onChange($event);
    }
    validate({ value }) {
        if (!this.walidacja || (this.optional && !value)) {
            this.errorMessage = null;
            return null;
        }
        const isNotValid = !this.check(value);
        if (isNotValid) {
            if (!value) {
                this.errorMessage = 'ds.registry.empty';
            }
            else if (value.length < 9 || value.length < 14 && value.length != 9) {
                this.errorMessage = 'ds.registry.tooShort';
            }
            else {
                this.errorMessage = 'ds.registry.invalid';
            }
        }
        else {
            this.errorMessage = null;
        }
        return isNotValid && {
            invalid: true
        };
    }
    check(regon) {
        if (!regon || isNaN(regon)) {
            return false;
        }
        if (regon.length != 9 && regon.length != 14) {
            return false;
        }
        let wagi;
        if (regon.length == 9) {
            wagi = [8, 9, 2, 3, 4, 5, 6, 7];
        }
        else if (regon.length == 14) {
            wagi = [2, 4, 8, 5, 0, 9, 7, 3, 6, 1, 2, 4, 8];
        }
        let sumaKontrolna = 0;
        for (let i = 0; i < wagi.length; i++) {
            sumaKontrolna += Number(regon[i]) * wagi[i];
        }
        return sumaKontrolna % 11 % 10 == regon[regon.length - 1];
    }
    format() {
        // EKRS-1706
        /*
        if (this.ngModel !== null && this.ngModel !== undefined && this.ngModel && !isNaN(this.ngModel)) {
          if (this.ngModel.length === 9) {
            this.ngModel = this.ngModel.padEnd(14, "0");
          }
        }
        */
    }
}
DsRegonComponent.ɵfac = function DsRegonComponent_Factory(t) { return new (t || DsRegonComponent)(); };
DsRegonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsRegonComponent, selectors: [["ds-regon"]], viewQuery: function DsRegonComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputMaskComponent = _t.first);
    } }, hostAttrs: [1, "ds-regon"], hostVars: 2, hostBindings: function DsRegonComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly);
    } }, inputs: { readonly: "readonly", walidacja: "walidacja", optional: "optional", slotChar: "slotChar", autoClear: "autoClear", autoFocus: "autoFocus", title: "title", showClear: "showClear", inputId: "inputId", ngModel: "ngModel", placeholder: "placeholder", label: "label", style: "style", styleClass: "styleClass", tabindex: "tabindex", name: "name", autocomplete: "autocomplete", iconRightTitle: "iconRightTitle", iconLeftTitle: "iconLeftTitle", iconLeft: "iconLeft", iconRight: "iconRight", ariaLabel: "ariaLabel" }, outputs: { ngModelChange: "ngModelChange", onClear: "onClear" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => DsRegonComponent)
            },
            {
                provide: NG_VALIDATORS,
                multi: true,
                useExisting: DsRegonComponent
            }
        ])], decls: 11, vars: 38, consts: [[1, "ds-regon-label", 3, "for"], [1, "ds-regon-wrapper"], [3, "title", "class", 4, "ngIf"], ["mask", "999999999 ?99999", 3, "unmask", "placeholder", "maxlength", "disabled", "readonly", "slotChar", "autoClear", "styleClass", "tabindex", "name", "inputId", "autoFocus", "autocomplete", "title", "ngModel", "ariaLabel", "ngModelChange", "onBlur", "focusout"], ["inputElement", ""], ["class", "pi pi-times ds-input-show-clear", 3, "tabindex", "icon-right", "is-disabled", "is-readonly", "click", "keydown.enter", 4, "ngIf"], [3, "class", "title", "click", 4, "ngIf"], [1, "ds-regon-error-message"], [3, "title"], [1, "pi", "pi-times", "ds-input-show-clear", 3, "tabindex", "click", "keydown.enter"], [3, "title", "click"]], template: function DsRegonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DsRegonComponent_i_3_Template, 1, 4, "i", 2);
        ɵngcc0.ɵɵelementStart(4, "p-inputMask", 3, 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsRegonComponent_Template_p_inputMask_ngModelChange_4_listener($event) { return ctx.onChangeWrapper($event); })("onBlur", function DsRegonComponent_Template_p_inputMask_onBlur_4_listener() { return ctx.onTouch(); })("focusout", function DsRegonComponent_Template_p_inputMask_focusout_4_listener() { return ctx.format(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DsRegonComponent_i_6_Template, 1, 7, "i", 5);
        ɵngcc0.ɵɵtemplate(7, DsRegonComponent_i_7_Template, 1, 4, "i", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "span", 7);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵpipe(10, "transloco");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("for", ctx.inputId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly)("has-left-icon", ctx.iconLeft)("has-right-icon", ctx.iconRight)("has-clear-icon", ctx.showClear)("is-disabled", ctx.isDisabled);
        ɵngcc0.ɵɵproperty("unmask", true)("placeholder", ctx.placeholder)("maxlength", 14)("disabled", ctx.isDisabled)("readonly", ctx.readonly)("slotChar", ctx.slotChar)("autoClear", ctx.autoClear)("styleClass", ctx.styleClass)("tabindex", ctx.tabindex)("name", ctx.name)("inputId", ctx.inputId)("autoFocus", ctx.autoFocus)("autocomplete", ctx.autocomplete)("title", ctx.title)("ngModel", ctx.ngModel)("ariaLabel", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showClear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(10, 34, ctx.errorMessage, ɵngcc0.ɵɵpureFunction0(37, _c24)));
    } }, directives: [ɵngcc2.NgIf, ɵngcc14.InputMask, ɵngcc4.MaxLengthValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], pipes: [ɵngcc7.TranslocoPipe], encapsulation: 2 });
DsRegonComponent.ctorParameters = () => [];
DsRegonComponent.propDecorators = {
    readonly: [{ type: Input }],
    placeholder: [{ type: Input }],
    label: [{ type: Input }],
    walidacja: [{ type: Input }],
    optional: [{ type: Input }],
    slotChar: [{ type: Input }],
    autoClear: [{ type: Input }],
    style: [{ type: Input }],
    styleClass: [{ type: Input }],
    tabindex: [{ type: Input }],
    name: [{ type: Input }],
    inputId: [{ type: Input }],
    autoFocus: [{ type: Input }],
    autocomplete: [{ type: Input }],
    title: [{ type: Input }],
    showClear: [{ type: Input }],
    iconRightTitle: [{ type: Input }],
    iconLeftTitle: [{ type: Input }],
    iconLeft: [{ type: Input }],
    iconRight: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    ngModel: [{ type: Input }],
    ngModelChange: [{ type: Output }],
    onClear: [{ type: Output }],
    inputMaskComponent: [{ type: ViewChild, args: ['inputElement', { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsRegonComponent, [{
        type: Component,
        args: [{
                selector: 'ds-regon',
                template: `
    <label class="ds-regon-label" [for]="inputId">{{label}}</label>
    <div class="ds-regon-wrapper">
      <i
        [title]="iconLeftTitle"
        *ngIf="iconLeft"
        class="pi {{iconLeft}} ds-input-icon-left"
      >
      </i>
      <p-inputMask
        mask="999999999 ?99999"
        [unmask]="true"
        [placeholder]="placeholder"
        [maxlength]="14"
        [disabled]="isDisabled"
        [readonly]="readonly"
        [slotChar]="slotChar"
        [autoClear]="autoClear"
        [style]="style"
        [styleClass]="styleClass"
        [tabindex]="tabindex"
        [name]="name"
        [inputId]="inputId"
        [autoFocus]="autoFocus"
        [autocomplete]="autocomplete"
        [title]="title"
        [ngModel]="ngModel"
        (ngModelChange)="onChangeWrapper($event)"
        (onBlur)="onTouch()"
        [class.is-readonly]="readonly"
        [class.has-left-icon]="iconLeft"
        [class.has-right-icon]="iconRight"
        [class.has-clear-icon]="showClear"
        [class.is-disabled]="isDisabled"
        (focusout)="format()"
        [ariaLabel]="ariaLabel"
        #inputElement
      >
      </p-inputMask>
      <i
        class="pi pi-times ds-input-show-clear"
        tabindex="{{ isDisabled || readonly ? '-1' : '0' }}"
        *ngIf="showClear"
        (click)="clear()"
        (keydown.enter)="clear()"
        [class.icon-right]="iconRight"
        [class.is-disabled]="isDisabled"
        [class.is-readonly]="readonly"
      >
      </i>
      <i
        *ngIf="iconRight"
        class="pi {{iconRight}} ds-input-icon-right"
        [title]="iconRightTitle"
        (click)="focus()"
      >
      </i>
    </div>
    <span class="ds-regon-error-message">{{ errorMessage | transloco: {name: 'REGON', length: '9 lub 14'} }}</span>
  `,
                host: {
                    'class': 'ds-regon',
                    '[class.is-readonly]': 'readonly'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => DsRegonComponent)
                    },
                    {
                        provide: NG_VALIDATORS,
                        multi: true,
                        useExisting: DsRegonComponent
                    }
                ]
            }]
    }], function () { return []; }, { readonly: [{
            type: Input
        }], walidacja: [{
            type: Input
        }], optional: [{
            type: Input
        }], slotChar: [{
            type: Input
        }], autoClear: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], title: [{
            type: Input
        }], showClear: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], onClear: [{
            type: Output
        }], inputId: [{
            type: Input
        }], ngModel: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], style: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], name: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], iconRightTitle: [{
            type: Input
        }], iconLeftTitle: [{
            type: Input
        }], iconLeft: [{
            type: Input
        }], iconRight: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], inputMaskComponent: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }] }); })();

class DsRegonModule {
}
DsRegonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsRegonModule });
DsRegonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsRegonModule_Factory(t) { return new (t || DsRegonModule)(); }, imports: [[
            CommonModule,
            InputMaskModule,
            FormsModule,
            TranslocoModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsRegonModule, { declarations: function () { return [DsRegonComponent]; }, imports: function () { return [CommonModule,
        InputMaskModule,
        FormsModule,
        TranslocoModule]; }, exports: function () { return [DsRegonComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsRegonModule, [{
        type: NgModule,
        args: [{
                declarations: [DsRegonComponent],
                imports: [
                    CommonModule,
                    InputMaskModule,
                    FormsModule,
                    TranslocoModule
                ],
                exports: [
                    DsRegonComponent
                ]
            }]
    }], null, null); })();

/**
 * Przekształca wartość na napis 'Tak' lub 'Nie' w zależności od tego, czy wartość konwertuje się na booleana true lub false.
 */
class TakNiePipe {
    constructor() {
    }
    transform(value, ...args) {
        if (!!value) {
            if (typeof value == 'string' && value.toUpperCase() == 'NIE') {
                return 'Nie';
            }
            return 'Tak';
        }
        else {
            return 'Nie';
        }
    }
}
TakNiePipe.ɵfac = function TakNiePipe_Factory(t) { return new (t || TakNiePipe)(); };
TakNiePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "takNie", type: TakNiePipe, pure: true });
TakNiePipe.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TakNiePipe, [{
        type: Pipe,
        args: [{ name: 'takNie' }]
    }], function () { return []; }, null); })();

var KpiEnum;
(function (KpiEnum) {
    KpiEnum[KpiEnum["OK"] = 0] = "OK";
    KpiEnum[KpiEnum["WARNING"] = 1] = "WARNING";
    KpiEnum[KpiEnum["CRITICAL"] = 2] = "CRITICAL";
})(KpiEnum || (KpiEnum = {}));

class AutoFormatPipe {
    transform(value, dataType, placeholder, ...args) {
        if (value instanceof Date
            || dataType == 'date') {
            return AutoFormatPipe.datePipe.transform(value, 'yyyy-MM-dd');
        }
        switch (dataType) {
            case 'takNie':
                return AutoFormatPipe.takNiePipe.transform(value);
            case KpiEnum:
                return KpiEnum[value];
            case 'string':
                if (value) {
                    return value;
                }
                else {
                    return placeholder;
                }
            default:
                return value;
        }
    }
}
AutoFormatPipe.ɵfac = function AutoFormatPipe_Factory(t) { return new (t || AutoFormatPipe)(); };
AutoFormatPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "autoFormat", type: AutoFormatPipe, pure: true });
AutoFormatPipe.datePipe = new DatePipe('en-US'); // nie użyłem pl-PL, bo tylko en-US jest dostępne bez i18n
AutoFormatPipe.takNiePipe = new TakNiePipe();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AutoFormatPipe, [{
        type: Pipe,
        args: [{ name: 'autoFormat' }]
    }], null, null); })();

const DS_TABLE_COMPONENT_PDF_SERVICE = new InjectionToken('DS-TABLE-COMPONENT-PDF-SERVICE');
const DS_TABLE_COMPONENT_EXCEL_SERVICE = new InjectionToken('DS-TABLE-COMPONENT-EXCEL-SERVICE');

class DsTableComponent {
    constructor(filterService, ref, exportPdfService, exportExcelService) {
        this.filterService = filterService;
        this.ref = ref;
        this._model = [];
        this._emptyMessage = 'Brak danych';
        /**
         * The context of the template is rowData
         * @key kolumna (sterownik.columns.field), do której należy ten szablon
         * @value TemplateRef<any>
         */
        this.columnTemplates = {};
        /**
         * [Dokumentacja](https://primefaces.org/primeng/showcase/#/table/responsive)
         * @type boolean
         * @default true
         * */
        this.responsive = true;
        /**
         * Graficzna reprezentacja loadera w tabeli, wykorzystuje komponent ds-skeleton
         * @type boolean
         * @default false
         */
        this.loading = false;
        /**
         * Flaga mówiąca, czy korzystamy z listenera na double klik w wierszach tabeli
         * @type boolean
         * @default false
         */
        this.doubleClickActive = false;
        this._paginatorButtonsCount = 5;
        this.paginatorLastElems = 3;
        this.rowActionEmitter = new EventEmitter();
        this.tableActionEmitter = new EventEmitter();
        this.emitRowDbClick = new EventEmitter();
        this.columnResizeMode = 'fit';
        this.paginatorPages = [];
        this.expandedRowKeys = {};
        this.rowsMenuModel = {};
        this.filteredValues = [];
        this.lastSort = null;
        this.lastFilter = null;
        this.hidePagination = false;
        this.hideBtnSection = false;
        this.pageCount = 0;
        this.page = 1;
        this.onPageEmitter = new EventEmitter();
        this.exportPdfService = exportPdfService;
        this.exportExcelService = exportExcelService;
    }
    /**
     * Dane do wyświetlenia w tabeli
     * @type []
     * @default undefined
     * */
    get model() {
        return this._model;
    }
    set model(model) {
        this._model = model || [];
        this.updateRowsAndPagination();
    }
    /**
     * Informacja, która jest wyświetlana w przypadku braku danych w tabeli
     * @type string
     * @default 'Brak danych'
     */
    get emptyMessage() {
        return this._emptyMessage;
    }
    set emptyMessage(val) {
        this._emptyMessage = val;
        this.updateRowsAndPagination();
    }
    /**
     * Ilość przycisków w paginatorze. Minimalna ilość przycisków to 3.
     * @type number
     * @default 5
     */
    get paginatorButtonsCount() {
        return this._paginatorButtonsCount;
    }
    set paginatorButtonsCount(count) {
        if (count >= 3) {
            this._paginatorButtonsCount = count;
        }
        else {
            this._paginatorButtonsCount = 5;
        }
        this.paginatorLastElems = Math.round((this.paginatorButtonsCount + 1) / 2);
    }
    updateRowsAndPagination() {
        if (this.table) {
            let _first = this.sterownik.paginator && this.sterownik.paginator.first ? this.sterownik.paginator.first : 0;
            if (this.table.stateStorage !== null && this.table.stateStorage != undefined) {
                switch (this.table.stateStorage) {
                    case 'local': {
                        const _json = JSON.parse(localStorage.getItem(this.table.stateKey));
                        if (_json !== null && _json.first) {
                            _first = _json.first;
                        }
                        break;
                    }
                    case 'session': {
                        const _json = JSON.parse(sessionStorage.getItem(this.table.stateKey));
                        if (_json !== null && _json.first) {
                            _first = _json.first;
                        }
                        break;
                    }
                }
            }
            this.table._first = _first || 0;
            this.currentModel = [...this.model];
            this.onPage({ first: _first, rows: this.rows });
        }
    }
    ngOnInit() {
        this.initTable();
        // this.updateRowsAndPagination();
    }
    ngOnChanges(changes) {
        var _a, _b, _c, _d, _e;
        if (changes.loading && !changes.loading.currentValue
            || ((_a = changes.model) === null || _a === void 0 ? void 0 : _a.previousValue) && ((_c = (_b = changes.model) === null || _b === void 0 ? void 0 : _b.previousValue) === null || _c === void 0 ? void 0 : _c.length) !== ((_e = (_d = changes.model) === null || _d === void 0 ? void 0 : _d.currentValue) === null || _e === void 0 ? void 0 : _e.length)) {
            this.updateRowsAndPagination();
            this.initTable();
        }
    }
    initTable() {
        var _a, _b;
        this.currentModel = [...this.model];
        if (!this.sterownik.exportActions) {
            this.sterownik.exportActions = [];
        }
        if (!this.sterownik.tableActions) {
            this.sterownik.tableActions = [];
        }
        this.exportToCsv = this.sterownik.exportActions.includes('csv') || this.sterownik.exportActions.includes('all');
        this.exportToExcel = this.sterownik.exportActions.includes('excel') || this.sterownik.exportActions.includes('all');
        this.exportToPdf = this.sterownik.exportActions.includes('pdf') || this.sterownik.exportActions.includes('all');
        if (!this.sterownik.paginator || ((_b = (_a = this.sterownik) === null || _a === void 0 ? void 0 : _a.paginator) === null || _b === void 0 ? void 0 : _b.hide)) {
            // this.sterownik.paginator = {rows: this.model.length};
            this.rows = this.model.length;
            this.hidePagination = true;
        }
        if (this.sterownik.tableActions.length === 0 && this.sterownik.exportActions.length === 0) {
            this.hideBtnSection = true;
        }
        this.rows = this.sterownik.paginator && this.sterownik.paginator.rows ? this.sterownik.paginator.rows : this.model.length;
        this.currentPageReportTemplate = get(this.sterownik, 'paginator.currentPageReportTemplate');
        this.pageLinks = get(this.sterownik, 'paginator.pageLinks') || 5;
        this.rowsPerPageOptions = get(this.sterownik, 'paginator.rowsPerPageOptions');
        this.dataKey = get(this.sterownik, 'rowExpansion.dataKey');
        if (this.dataKey) {
            if (this.sterownik.rowExpansion.expandAll) {
                this.expandedRowKeys = this.getAllRowKeys();
            }
            else if (get(this.sterownik, 'rowExpansion.expandedRowKeys')) {
                this.expandedRowKeys = get(this.sterownik, 'rowExpansion.expandedRowKeys');
            }
        }
        this.rowExpansionColSpan = this.sterownik.columns.length + 1;
        if (this.sterownik.rowActions && this.sterownik.rowActions.length > 0) {
            this.rowExpansionColSpan++;
        }
        this.rowExpandMode = get(this.sterownik, 'rowExpansion.rowExpandMode');
        this.columnResizeMode = get(this.sterownik, 'resizableColumns.columnResizeMode');
        this.anyFilter = this.sterownik.columns.some(element => element.filter);
        this.first = get(this.sterownik, 'paginator.first') || 0;
        this.sterownik.stateStorage = get(this.sterownik, 'stateStorage') || 'session';
        this.sterownik.name = get(this.sterownik, 'name');
        if (this.rowsPerPageOptions && this.rowsPerPageOptions.length > 0) {
            this.rowsPerPageOptionsObjects = this.rowsPerPageOptions.map(item => {
                return { name: item, value: item };
            });
        }
        this.sterownik.columns.map(column => {
            if (['ds-multiselect', 'ds-dropdown'].includes(get(column, 'filter.type'))) {
                column.filter.options = this.distinctField(this.model, column.field);
            }
            return column;
        });
        if (!!this.sterownik.rowActions) {
            this.model.forEach(element => {
                this.rowsMenuModel[element[this.sterownik.key]] = [{
                        icon: 'pi pi-bars',
                        items: [...this.sterownik.rowActions.map(rowAction => (Object.assign(Object.assign({}, rowAction), { command: () => this.emitRowAction(rowAction.action, element[this.sterownik.key]) }))),
                        ],
                    }];
            });
        }
        if (this.sterownik.name && this.sterownik.stateStorage) {
            const storage = this.sterownik.stateStorage === 'session'
                ? sessionStorage.getItem(this.sterownik.name)
                : localStorage.getItem(this.sterownik.name);
            const tableStorage = JSON.parse(storage);
            this.first = (tableStorage === null || tableStorage === void 0 ? void 0 : tableStorage.first) || this.first;
            this.rows = (tableStorage === null || tableStorage === void 0 ? void 0 : tableStorage.rows) || this.rows;
        }
        if (this.sterownik.sort) {
            this.onSort(this.sterownik.sort);
        }
        this.onPage({ first: this.first, rows: this.rows });
        this.columnNames = this.sterownik.columns.map(c => c.field);
    }
    distinctField(model, field, sorted = true) {
        const distinctArray = [...new Set(model.map(element => element[field]))]
            .map(element => {
            return { label: element, value: element };
        });
        if (sorted) {
            distinctArray.sort((a, b) => a.label > b.label ? 1 : -1);
        }
        return distinctArray;
    }
    test($event) {
        console.log($event, '$event');
    }
    collectCurrentRows(target, source) {
        for (let j = 0; j < source.length; j++) {
            target.push(Object.values(source[j]));
        }
    }
    exportExcel() {
        var _a;
        if (this.exportExcelService) {
            this.exportExcelService.export(((_a = this.filteredValues) === null || _a === void 0 ? void 0 : _a.length) ? this.filteredValues : this.currentModel, this.sterownik.columns);
        }
        else {
            console.warn('Brak serwisu obsługi exportu do pdf (exportExcelService).');
        }
    }
    exportPdf() {
        var _a;
        if (this.exportPdfService) {
            this.exportPdfService.export(((_a = this.filteredValues) === null || _a === void 0 ? void 0 : _a.length) ? this.filteredValues : this.currentModel, this.sterownik.columns);
        }
        else {
            console.warn('Brak serwisu obsługi exportu do pdf (exportPdfService).');
        }
    }
    emitTableAction(action, disabled) {
        this.tableActionEmitter.emit({
            sterownik: this.sterownik,
            model: this.model,
            action,
            disabled
        });
    }
    emitRowAction(action, key) {
        this.rowActionEmitter.emit({
            action,
            key,
        });
    }
    onFilter(event) {
        let filter;
        let filterFunction;
        let dataToFilter = [...this.currentModel];
        this.lastFilter = event;
        const columns = keys(event.filters).filter(key => key !== 'undefined');
        if (columns.length) {
            columns.forEach(colName => {
                filter = event.filters[colName];
                switch (filter.matchMode) {
                    case 'equals':
                        filterFunction = (checkValue) => {
                            return this.filterService.filters.equals(checkValue, filter.value);
                        };
                        break;
                    case 'in':
                        filterFunction = (checkValue) => {
                            return this.filterService.filters.in(checkValue, filter.value);
                        };
                        break;
                    case 'contains':
                        filterFunction = (checkValue) => {
                            return this.filterService.filters.contains(checkValue, filter.value);
                        };
                        break;
                    case 'startsWith':
                        filterFunction = (checkValue) => {
                            return this.filterService.filters.startsWith(checkValue, filter.value);
                        };
                        break;
                }
                if (colName === 'global') {
                    const rows = [];
                    this.columnNames.forEach(name => {
                        rows.push(dataToFilter.filter(data => filterFunction(data[name])));
                    });
                    dataToFilter = union(flatten(rows));
                }
                else {
                    dataToFilter = dataToFilter.filter(data => filterFunction(data[colName]));
                }
            });
        }
        if (!isEqual(this.filteredValues, dataToFilter)) {
            this.filteredValues = dataToFilter;
            // @ts-ignore
            setTimeout(this.onPage({ rows: this.rows, first: this.first }), 0);
        }
    }
    getAllRowKeys() {
        const dataKey = get(this.sterownik, 'rowExpansion.dataKey');
        if (!dataKey) {
            return {};
        }
        const rowKeys = {};
        this.model.forEach(element => {
            rowKeys[element[dataKey]] = true;
        });
        return rowKeys;
    }
    onSort(event) {
        const newSort = event.multisortmeta ? event.multisortmeta : event;
        const colName = [];
        const colOrder = [];
        if (event.hasOwnProperty('multisortmeta')) {
            event.multisortmeta.forEach((sortMeta) => {
                colName.push(sortMeta.field);
                colOrder.push(sortMeta.order === 1 ? 'asc' : 'desc');
            });
        }
        else {
            colName.push(event.field);
            colOrder.push(event.order === 1 ? 'asc' : 'desc');
        }
        if (this.currentModel.length && (!this.lastSort || !isEqual(newSort, this.lastSort))) {
            this.lastSort = newSort;
            this.currentModel = orderBy(this.model, colName, colOrder);
            this.onPage({ rows: this.rows, first: this.first });
        }
    }
    onPage(event) {
        var _a;
        if (!event.rows) {
            event.rows = this.rows;
        }
        const data = this.lastFilter ? this.filteredValues : this.currentModel;
        this.rows = event.rows;
        this.first = data.length < this.rows ? 0 : event.first;
        this.pageCount = Math.ceil(data.length / this.rows);
        this.page = Math.ceil(this.first / this.rows);
        this.tableData = data.slice(this.first, this.first + this.rows);
        this.currentPageReportText = `${this.first + 1}-${this.first + this.rows >= data.length ? data.length : this.first + this.rows} z ${data.length}`;
        this.paginatorPages = this.createPaginatorPages();
        this.hidePagination = !this.sterownik.paginator || ((_a = this.sterownik.paginator) === null || _a === void 0 ? void 0 : _a.hide) ? true : this.tableData.length === 0;
        if (this.pageCount > 0) {
            event.lastPage = this.pageCount === this.page + 1;
            this.onPageEmitter.emit(event);
        }
        if (data.length) {
            this.saveToStorage();
        }
    }
    saveToStorage() {
        var _a, _b;
        if (((_a = this.table) === null || _a === void 0 ? void 0 : _a.stateStorage) != null && ((_b = this.table) === null || _b === void 0 ? void 0 : _b.stateKey) != null) {
            switch (this.table.stateStorage) {
                case 'local': {
                    const obj = JSON.parse(localStorage.getItem(this.table.stateKey)) || {};
                    obj.rows = this.rows;
                    obj.first = this.first;
                    localStorage.setItem(this.table.stateKey, JSON.stringify(obj));
                    break;
                }
                case 'session': {
                    const obj = JSON.parse(sessionStorage.getItem(this.table.stateKey)) || {};
                    obj.rows = this.rows;
                    obj.first = this.first;
                    sessionStorage.setItem(this.table.stateKey, JSON.stringify(obj));
                    break;
                }
            }
        }
    }
    changeDetection() {
        if (this.model.length !== this.currentModel.length) {
            const modelKeyMap = this.model.map(i => i[this.sterownik.key]);
            this.currentModel = this.currentModel.filter(item => modelKeyMap.indexOf(item[this.sterownik.key]) > -1);
            if (this.lastFilter) {
                this.onFilter(this.lastFilter);
            }
            this.onPage({ rows: this.rows, first: this.first });
            this.ref.detectChanges();
        }
        return true;
    }
    createPaginatorPages() {
        const pages = [];
        let startPage = 1;
        const activePage = this.page + 1;
        const lastPage = this.pageCount;
        let pagesToShow = 1;
        if (this.pageCount > this.paginatorButtonsCount + 1) {
            startPage = (activePage - Math.floor((this.paginatorButtonsCount - 1) / 2)) <= 0 ? 1 : activePage - Math.floor((this.paginatorButtonsCount - 1) / 2);
            if (lastPage - activePage < Math.round((this.paginatorButtonsCount - 1) / 2)) {
                startPage = lastPage - (this.paginatorButtonsCount - 1);
            }
            pagesToShow = startPage + this.paginatorButtonsCount;
        }
        else {
            pagesToShow = this.pageCount + 1;
        }
        for (let i = startPage; i < pagesToShow; i++) {
            pages.push({
                value: i
            });
        }
        return pages;
    }
}
DsTableComponent.ɵfac = function DsTableComponent_Factory(t) { return new (t || DsTableComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc8.FilterService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DS_TABLE_COMPONENT_PDF_SERVICE, 8), ɵngcc0.ɵɵdirectiveInject(DS_TABLE_COMPONENT_EXCEL_SERVICE, 8)); };
DsTableComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsTableComponent, selectors: [["ds-table"]], viewQuery: function DsTableComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c25, true);
        ɵngcc0.ɵɵviewQuery(_c26, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.table = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.export = _t.first);
    } }, inputs: { columnTemplates: "columnTemplates", responsive: "responsive", loading: "loading", doubleClickActive: "doubleClickActive", exportPdfService: "exportPdfService", exportExcelService: "exportExcelService", model: "model", emptyMessage: "emptyMessage", paginatorButtonsCount: "paginatorButtonsCount", first: "first", sterownik: "sterownik", rozwijakTemplate: ["rozwijak", "rozwijakTemplate"], stateStorage: "stateStorage", name: "name" }, outputs: { rowActionEmitter: "rowAction", tableActionEmitter: "tableAction", emitRowDbClick: "emitRowDbClick", onPageEmitter: "onPage" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 12, vars: 25, consts: [["table", ""], [3, "columnResizeMode", "columns", "currentPageReportTemplate", "dataKey", "expandedRowKeys", "autoLayout", "resizableColumns", "rows", "showCurrentPageReport", "value", "sortMode", "rowExpandMode", "pageLinks", "rowsPerPageOptions", "responsive", "multiSortMeta", "sortField", "sortOrder", "stateStorage", "stateKey", "globalFilterFields", "onFilter", "onSort"], ["dt", ""], [4, "ngIf"], ["pTemplate", "header"], ["pTemplate", "emptymessage"], ["pTemplate", "body"], ["pTemplate", "rowexpansion", 3, "ngIf"], ["class", "custom-table-footer", 4, "ngIf"], ["filters", ""], ["pTemplate", "caption"], [1, "p-d-flex"], [1, "p-input-icon-left", "p-ml-auto"], ["iconLeft", "pi pi-search", 3, "placeholder", "input"], [4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfElse"], ["notResizableMenuColumn", ""], ["notSortableColumn", ""], ["pResizableColumn", "", 3, "pSortableColumn", "width", "ngClass", 4, "ngIf", "ngIfElse"], ["notResizableColumn", ""], ["pResizableColumn", "", 3, "pSortableColumn", "width", "ngClass"], [3, "field", 4, "ngIf"], ["style", "display: none", 4, "ngIf"], ["display", "menu", 3, "showMatchModes", "showOperator", "showAddButton", 4, "ngIf"], [3, "field"], [2, "display", "none"], ["display", "menu", 3, "showMatchModes", "showOperator", "showAddButton"], ["pTemplate", "filter"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "pSortableColumn", "width", "ngClass"], ["pResizableColumn", "", 3, "width", "ngClass", 4, "ngIf", "ngIfElse"], ["pResizableColumn", "", 3, "width", "ngClass"], [3, "width", "ngClass"], ["style", "width: 3em", "pResizableColumn", "", 4, "ngIf"], ["pResizableColumn", "", "class", "button-action-header", 3, "ngClass", 4, "ngIf"], ["pResizableColumn", "", "class", "button-action-header", 3, "ngStyle", "ngClass", 4, "ngIf"], ["pResizableColumn", "", 1, "button-action-header", 3, "ngClass"], ["pResizableColumn", "", 1, "button-action-header", 3, "ngStyle", "ngClass"], ["pResizableColumn", "", 2, "width", "3em"], ["style", "width: 3em", 4, "ngIf"], ["class", "button-action-header", 3, "ngClass", 4, "ngIf"], ["class", "button-action-header", 3, "ngStyle", "ngClass", 4, "ngIf"], [1, "button-action-header", 3, "ngClass"], [1, "button-action-header", 3, "ngStyle", "ngClass"], [2, "width", "3em"], [1, "dataset-empty", 3, "innerHTML"], ["tabindex", "0", 1, "table-row", 3, "ngClass", "dblclick", "keyup.space"], ["class", "row-button-actions", 4, "ngIf"], ["class", "row-actions", 4, "ngIf"], ["style", "cursor: pointer;", "class", "p-p-0", 3, "pRowToggler", 4, "ngIf"], [1, "ds-column-title"], [1, "ds-column-value"], [1, "row-button-actions"], ["tooltipPosition", "top", "iconPos", "right", "class", "p-mr-2 ds-button-hidden", 3, "label", "icon", "styleClass", "severity", "pTooltip", "disabled", "readonly", "onClick", 4, "ngFor", "ngForOf"], ["class", "ds-button-action", 3, "label", "styleClass", "severity", "disabled", "readonly", "onClick", 4, "ngFor", "ngForOf"], ["tooltipPosition", "top", "iconPos", "right", 1, "p-mr-2", "ds-button-hidden", 3, "label", "icon", "styleClass", "severity", "pTooltip", "disabled", "readonly", "onClick"], [1, "ds-button-action", 3, "label", "styleClass", "severity", "disabled", "readonly", "onClick"], [1, "row-actions"], [3, "model"], [1, "p-p-0", 2, "cursor", "pointer", 3, "pRowToggler"], ["severity", "link", 1, "p-button-text", "p-button-rounded", "p-button-plain", "ds-hidden", 3, "icon", "label", "styleClass"], ["severity", "primary", 1, "ds-button-expansion", 3, "label"], [1, "custom-table-footer"], [1, "custom-btn-section"], ["class", "p-mr-3", "severity", "primary", "label", "CSV", 3, "click", 4, "ngIf"], ["class", "p-mr-3", "severity", "primary", "label", "Excel", 3, "click", 4, "ngIf"], ["class", "p-mr-3", "severity", "primary", "label", "PDF", 3, "click", 4, "ngIf"], ["class", "p-mr-3", 3, "severity", "label", "disabled", "styleClass", "style", "click", 4, "ngFor", "ngForOf"], ["class", "custom-paginator", 4, "ngIf"], ["severity", "primary", "label", "CSV", 1, "p-mr-3", 3, "click"], ["severity", "primary", "label", "Excel", 1, "p-mr-3", 3, "click"], ["severity", "primary", "label", "PDF", 1, "p-mr-3", 3, "click"], [1, "p-mr-3", 3, "severity", "label", "disabled", "styleClass", "click"], [1, "custom-paginator"], ["class", "p-paginator-current ng-star-inserted", 4, "ngIf"], ["type", "button", "pripple", "", "role", "button", "tabindex", "0", 1, "p-paginator-first", "p-paginator-element", "p-link", "p-ripple", "ng-star-inserted", 3, "ngClass", "disabled", "click"], [1, "p-paginator-icon", "pi", "pi-angle-double-left"], ["type", "button", "pripple", "", "role", "button", "tabindex", "0", 1, "p-paginator-prev", "p-paginator-element", "p-link", "p-ripple", 3, "ngClass", "disabled", "click"], [1, "p-paginator-icon", "pi", "pi-angle-left"], [1, "p-paginator-pages", "ng-star-inserted"], ["type", "button", "class", "p-paginator-page p-paginator-element", "role", "button", "tabindex", "0", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["type", "button", "pripple", "", "role", "button", "tabindex", "0", 1, "p-paginator-next", "p-paginator-element", "p-link", "p-ripple", 3, "ngClass", "disabled", "click"], [1, "p-paginator-icon", "pi", "pi-angle-right"], ["type", "button", "pripple", "", "role", "button", "tabindex", "0", 1, "p-paginator-last", "p-paginator-element", "p-link", "p-ripple", "ng-star-inserted", 3, "ngClass", "disabled", "click"], [1, "p-paginator-icon", "pi", "pi-angle-double-right"], ["aria-labelledby", "", "id", "paginationDropdown-2", "class", "p-paginator-rpp-options", "optionLabel", "name", "optionValue", "value", 3, "options", "ngModel", "ngModelChange", "keydown.enter", 4, "ngIf"], [1, "p-paginator-current", "ng-star-inserted"], ["type", "button", "role", "button", "tabindex", "0", 1, "p-paginator-page", "p-paginator-element", 3, "ngClass", "click"], ["type", "button", "disabled", "", "class", "p-link", 4, "ngIf"], ["role", "button", "tabindex", "0", 1, "p-paginator-page", "p-paginator-element", 3, "ngClass", "click"], ["type", "button", "disabled", "", 1, "p-link"], ["aria-labelledby", "", "id", "paginationDropdown-2", "optionLabel", "name", "optionValue", "value", 1, "p-paginator-rpp-options", 3, "options", "ngModel", "ngModelChange", "keydown.enter"], [3, "ngSwitch"], ["class", "p-column-filter", "optionLabel", "value", 3, "placeholder", "options", "ngModel", "autoDisplayFirst", "showClear", "filter", "onChange", 4, "ngSwitchCase"], ["class", "p-column-filter", 3, "filterPlaceholder", "ngModel", "options", "defaultLabel", "showHeader", "onChange", 4, "ngSwitchCase"], ["class", "p-column-filter", 3, "ngModel", "placeholder", "showClear", "input", 4, "ngSwitchDefault"], ["optionLabel", "value", 1, "p-column-filter", 3, "placeholder", "options", "ngModel", "autoDisplayFirst", "showClear", "filter", "onChange"], [1, "p-column-filter", 3, "filterPlaceholder", "ngModel", "options", "defaultLabel", "showHeader", "onChange"], [1, "p-column-filter", 3, "ngModel", "placeholder", "showClear", "input"]], template: function DsTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", null, 0);
        ɵngcc0.ɵɵelementStart(2, "p-table", 1, 2);
        ɵngcc0.ɵɵlistener("onFilter", function DsTableComponent_Template_p_table_onFilter_2_listener($event) { return ctx.onFilter($event); })("onSort", function DsTableComponent_Template_p_table_onSort_2_listener($event) { return ctx.onSort($event); });
        ɵngcc0.ɵɵtemplate(4, DsTableComponent_4_Template, 1, 0, undefined, 3);
        ɵngcc0.ɵɵtemplate(5, DsTableComponent_ng_template_5_Template, 6, 4, "ng-template", 4);
        ɵngcc0.ɵɵtemplate(6, DsTableComponent_ng_template_6_Template, 2, 2, "ng-template", 5);
        ɵngcc0.ɵɵtemplate(7, DsTableComponent_ng_template_7_Template, 5, 7, "ng-template", 6);
        ɵngcc0.ɵɵtemplate(8, DsTableComponent_ng_template_8_Template, 1, 8, "ng-template", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, DsTableComponent_div_9_Template, 7, 5, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, DsTableComponent_ng_template_10_Template, 4, 3, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("columnResizeMode", ctx.columnResizeMode)("columns", ctx.sterownik.columns)("currentPageReportTemplate", ctx.currentPageReportTemplate)("dataKey", ctx.dataKey)("expandedRowKeys", ctx.expandedRowKeys)("autoLayout", ctx.sterownik.autoLayout)("resizableColumns", !!ctx.sterownik.resizableColumns)("rows", ctx.rows)("showCurrentPageReport", !!ctx.currentPageReportTemplate)("value", ctx.tableData)("sortMode", ctx.sterownik.sortMode || "single")("rowExpandMode", ctx.rowExpandMode)("pageLinks", ctx.pageLinks)("rowsPerPageOptions", ctx.rowsPerPageOptions)("responsive", ctx.responsive)("multiSortMeta", ctx.sterownik.multiSortMeta)("sortField", ctx.sterownik.sort == null ? null : ctx.sterownik.sort.field)("sortOrder", ctx.sterownik.sort == null ? null : ctx.sterownik.sort.order)("stateStorage", ctx.sterownik.stateStorage || "session")("stateKey", ctx.sterownik.name)("globalFilterFields", ctx.columnNames);
        ɵngcc0.ɵɵattribute("hidePagination", ctx.hidePagination);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sterownik.globalSearch);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sterownik.rowExpansion);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.changeDetection() && !(ctx.hideBtnSection && ctx.hidePagination));
    } }, directives: function () { return [ɵngcc19.Table, ɵngcc2.NgIf, ɵngcc8.PrimeTemplate, DsInputComponent, ɵngcc2.NgForOf, ɵngcc19.ResizableColumn, ɵngcc19.SortableColumn, ɵngcc2.NgClass, ɵngcc19.SortIcon, ɵngcc19.ColumnFilter, ɵngcc2.NgTemplateOutlet, ɵngcc2.NgStyle, DsSkeletonComponent, DsButtonComponent, ɵngcc20.Tooltip, ɵngcc21.Menubar, ɵngcc19.RowToggler, ɵngcc12.Dropdown, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, ɵngcc2.NgSwitchDefault, DsDropdownComponent, DsMultiselectComponent]; }, pipes: function () { return [ɵngcc7.TranslocoPipe, AutoFormatPipe]; }, encapsulation: 2 });
DsTableComponent.ctorParameters = () => [
    { type: FilterService },
    { type: ChangeDetectorRef },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_TABLE_COMPONENT_PDF_SERVICE,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_TABLE_COMPONENT_EXCEL_SERVICE,] }] }
];
DsTableComponent.propDecorators = {
    model: [{ type: Input }],
    emptyMessage: [{ type: Input }],
    exportPdfService: [{ type: Input }],
    exportExcelService: [{ type: Input }],
    table: [{ type: ViewChild, args: ['dt',] }],
    sterownik: [{ type: Input }],
    rozwijakTemplate: [{ type: Input, args: ['rozwijak',] }],
    columnTemplates: [{ type: Input, args: ['columnTemplates',] }],
    responsive: [{ type: Input }],
    loading: [{ type: Input }],
    doubleClickActive: [{ type: Input }],
    paginatorButtonsCount: [{ type: Input }],
    export: [{ type: ViewChild, args: ['table', { static: false },] }],
    rowActionEmitter: [{ type: Output, args: ['rowAction',] }],
    tableActionEmitter: [{ type: Output, args: ['tableAction',] }],
    emitRowDbClick: [{ type: Output }],
    first: [{ type: Input }],
    stateStorage: [{ type: Input }],
    name: [{ type: Input }],
    onPageEmitter: [{ type: Output, args: ['onPage',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsTableComponent, [{
        type: Component,
        args: [{
                selector: 'ds-table',
                template: "<div #table>\n  <p-table\n    [columnResizeMode]=\"columnResizeMode\"\n    [columns]=\"sterownik.columns\"\n    [currentPageReportTemplate]=\"currentPageReportTemplate\"\n    [dataKey]=\"dataKey\"\n    [expandedRowKeys]=\"expandedRowKeys\"\n    [autoLayout]=\"sterownik.autoLayout\"\n    [resizableColumns]=\"!!sterownik.resizableColumns\"\n    [rows]=\"rows\"\n    [showCurrentPageReport]=\"!!currentPageReportTemplate\"\n    [value]=\"tableData\"\n    [sortMode]=\"sterownik.sortMode || 'single'\"\n    #dt\n    (onFilter)=\"onFilter($event)\"\n    (onSort)=\"onSort($event)\"\n    [rowExpandMode]=\"rowExpandMode\"\n    [attr.hidePagination]=\"hidePagination\"\n    [pageLinks]=\"pageLinks\"\n    [rowsPerPageOptions]=\"rowsPerPageOptions\"\n    [responsive]=\"responsive\"\n    [multiSortMeta]=\"sterownik.multiSortMeta\"\n    [sortField]=\"sterownik.sort?.field\"\n    [sortOrder]=\"sterownik.sort?.order\"\n    [stateStorage]=\"sterownik.stateStorage || 'session'\"\n    [stateKey]=\"sterownik.name\"\n    [globalFilterFields]=\"columnNames\"\n  >\n    <ng-template pTemplate=\"caption\" *ngIf=\"sterownik.globalSearch\">\n      <div class=\"p-d-flex\">\n\t\t\t  <span class=\"p-input-icon-left p-ml-auto\">\n          <ds-input\n            iconLeft=\"pi pi-search\"\n            [placeholder]=\"'wyszukaj'|transloco\"\n            (input)=\"dt.filterGlobal($event.target.value, 'contains')\"\n          ></ds-input>\n        </span>\n      </div>\n    </ng-template>\n    <ng-template pTemplate=\"header\" let-columns>\n      <tr>\n        <ng-container *ngFor=\"let col of columns\">\n          <ng-container *ngIf=\"col.sortable; else notSortableColumn\">\n            <th *ngIf=\"!!sterownik.resizableColumns; else notResizableColumn\" pResizableColumn\n                [pSortableColumn]=\"col.field\" [width]=\"col.width\" [ngClass]=\"col.cssClass\">\n              <p-sortIcon *ngIf=\"col.sortable\" [field]=\"col.field\"></p-sortIcon>\n              <span *ngIf=\"!col.header\" style=\"display: none\">.</span>\n              {{col.header | transloco}}\n              <p-columnFilter\n                *ngIf=\"col.filter?.mode == 'icon'\"\n                display=\"menu\"\n                [showMatchModes]=\"false\"\n                [showOperator]=\"false\"\n                [showAddButton]=\"false\"\n              >\n                <ng-template pTemplate=\"filter\">\n                  <ng-container *ngTemplateOutlet=\"filters; context: { col: col }\"></ng-container>\n                </ng-template>\n              </p-columnFilter>\n            </th>\n            <ng-template #notResizableColumn>\n              <th [pSortableColumn]=\"col.field\" [width]=\"col.width\" [ngClass]=\"col.cssClass\">\n                <p-sortIcon *ngIf=\"col.sortable\" [field]=\"col.field\"></p-sortIcon>\n                <span *ngIf=\"!col.header\" style=\"display: none\">.</span>\n                {{col.header | transloco}}\n                <p-columnFilter\n                  *ngIf=\"col.filter?.mode == 'icon'\"\n                  display=\"menu\"\n                  [showMatchModes]=\"false\"\n                  [showOperator]=\"false\"\n                  [showAddButton]=\"false\"\n                >\n                  <ng-template pTemplate=\"filter\">\n                    <ng-container *ngTemplateOutlet=\"filters; context: { col: col }\"></ng-container>\n                  </ng-template>\n                </p-columnFilter>\n              </th>\n            </ng-template>\n          </ng-container>\n          <ng-template #notSortableColumn>\n            <th *ngIf=\"!!sterownik.resizableColumns; else notResizableColumn\" pResizableColumn\n                [width]=\"col.width\" [ngClass]=\"col.cssClass\">\n              <p-sortIcon *ngIf=\"col.sortable\" [field]=\"col.field\"></p-sortIcon>\n              <span *ngIf=\"!col.header\" style=\"display: none\">.</span>\n              {{col.header | transloco}}\n              <p-columnFilter\n                *ngIf=\"col.filter?.mode == 'icon'\"\n                display=\"menu\"\n                [showMatchModes]=\"false\"\n                [showOperator]=\"false\"\n                [showAddButton]=\"false\"\n              >\n                <ng-template pTemplate=\"filter\">\n                  <ng-container *ngTemplateOutlet=\"filters; context: { col: col }\"></ng-container>\n                </ng-template>\n              </p-columnFilter>\n            </th>\n            <ng-template #notResizableColumn>\n              <th [width]=\"col.width\" [ngClass]=\"col.cssClass\">\n                <p-sortIcon *ngIf=\"col.sortable\" [field]=\"col.field\"></p-sortIcon>\n                <span *ngIf=\"!col.header\" style=\"display: none\">.</span>\n                {{col.header | transloco}}\n                <p-columnFilter\n                  *ngIf=\"col.filter?.mode == 'icon'\"\n                  display=\"menu\"\n                  [showMatchModes]=\"false\"\n                  [showOperator]=\"false\"\n                  [showAddButton]=\"false\"\n                >\n                  <ng-template pTemplate=\"filter\">\n                    <ng-container *ngTemplateOutlet=\"filters; context: { col: col }\"></ng-container>\n                  </ng-template>\n                </p-columnFilter>\n              </th>\n            </ng-template>\n          </ng-template>\n        </ng-container>\n        <ng-container *ngIf=\"!!sterownik.resizableColumns; else notResizableMenuColumn\">\n\n          <ng-container *ngIf=\"sterownik.rowButtonAction && sterownik.rowButtonAction.length\">\n\n            <th *ngIf=\"sterownik.rowButtonActionWidth === undefined\"\n                pResizableColumn\n                [ngClass]=\"sterownik?.rowButtonActionHeaderStyleClass || ''\"\n                class=\"button-action-header\"\n            >\n              {{ sterownik?.rowButtonActionHeader ? sterownik?.rowButtonActionHeader : 'Akcje' | transloco }}\n            </th>\n\n            <th *ngIf=\"sterownik.rowButtonActionWidth !== undefined\"\n                pResizableColumn\n                [ngStyle]=\"{ 'width': sterownik.rowButtonActionWidth }\"\n                [ngClass]=\"sterownik?.rowButtonActionHeaderStyleClass || ''\"\n                class=\"button-action-header\"\n            >\n              {{ sterownik.rowButtonActionHeader ? sterownik.rowButtonActionHeader : 'Akcje' | transloco }}\n            </th>\n\n          </ng-container>\n\n          <th *ngIf=\"sterownik.rowActions && sterownik.rowActions.length\" style=\"width: 3em\" pResizableColumn></th>\n          <th *ngIf=\"sterownik.rowExpansion\" style=\"width: 3em\" pResizableColumn><span style=\"display: none\">.</span></th>\n\n        </ng-container>\n        <ng-template #notResizableMenuColumn>\n\n          <ng-container *ngIf=\"sterownik.rowButtonAction && sterownik.rowButtonAction.length\">\n\n            <th *ngIf=\"sterownik.rowButtonActionWidth === undefined\"\n                [ngClass]=\"sterownik?.rowButtonActionHeaderStyleClass || ''\"\n                class=\"button-action-header\"\n            >\n              {{ sterownik.rowButtonActionHeader ? sterownik.rowButtonActionHeader : 'Akcje' | transloco }}\n            </th>\n\n            <th *ngIf=\"sterownik.rowButtonActionWidth !== undefined\"\n                [ngStyle]=\"{ 'width': sterownik.rowButtonActionWidth }\"\n                [ngClass]=\"sterownik?.rowButtonActionHeaderStyleClass || ''\"\n                class=\"button-action-header\"\n            >\n              {{ sterownik.rowButtonActionHeader ? sterownik.rowButtonActionHeader : 'Akcje' | transloco }}\n            </th>\n\n          </ng-container>\n\n          <th *ngIf=\"sterownik.rowActions && sterownik.rowActions.length\" style=\"width: 3em\"></th>\n          <th *ngIf=\"sterownik.rowExpansion\" style=\"width: 3em\"><span style=\"display: none\">.</span></th>\n        </ng-template>\n      </tr>\n      <tr *ngIf=\"anyFilter\">\n        <th *ngFor=\"let col of columns\">\n          <ng-container *ngIf=\"col.filter && (!col.filter.mode || col.filter.mode === 'bar')\">\n            <ng-container *ngTemplateOutlet=\"filters; context: { col: col }\"></ng-container>\n          </ng-container>\n        </th>\n        <th *ngIf=\"sterownik.rowButtonAction && sterownik.rowButtonAction.length\"></th>\n        <th *ngIf=\"sterownik.rowActions && sterownik.rowActions.length\" style=\"width: 3em\"></th>\n        <th *ngIf=\"sterownik.rowExpansion\" style=\"width: 3em\"><span style=\"display: none\">.</span></th>\n      </tr>\n    </ng-template>\n    <ng-template pTemplate=\"emptymessage\" let-columns>\n      <ng-container *ngIf=\"loading\">\n        <tr *ngFor=\"let i of [1, 2, 3]\">\n          <ng-container *ngFor=\"let col of columns; let i = index;\">\n            <td>\n              <ds-skeleton></ds-skeleton>\n            </td>\n          </ng-container>\n        </tr>\n      </ng-container>\n      <ng-container *ngIf=\"!loading\">\n        <tr>\n          <td [attr.colspan]=\"columns.length\" class=\"dataset-empty\" [innerHTML]=\"emptyMessage\"></td>\n        </tr>\n      </ng-container>\n    </ng-template>\n    <ng-template pTemplate=\"body\" let-rowData let-expanded=\"expanded\" let-columns=\"columns\">\n      <tr class=\"table-row\" [ngClass]=\"rowData['dsRowClassNames'] ? rowData['dsRowClassNames'] : ''\"\n          [class.dbl-click-listener]=\"doubleClickActive\"\n          (dblclick)=\"emitRowDbClick.emit(rowData)\"\n          (keyup.space)=\"emitRowDbClick.emit(rowData)\"\n          tabindex=\"0\">\n        <ng-container *ngFor=\"let col of columns; let i = index;\">\n          <td *ngIf=\"!columnTemplates[col.field]\">\n            <div class=\"ds-column-title\">{{col.header | transloco}}</div>\n            <div class=\"ds-column-value\">{{ rowData[col.field] | autoFormat:col.dataType:sterownik.placeholder }}</div>\n          </td>\n          <td *ngIf=\"columnTemplates[col.field]\">\n            <ng-container *ngTemplateOutlet=\"columnTemplates[col.field]; context: { $implicit: rowData }\">\n            </ng-container>\n          </td>\n        </ng-container>\n        <td *ngIf=\"sterownik.rowButtonAction && sterownik.rowButtonAction.length\" class=\"row-button-actions\">\n          <ds-button *ngFor=\"let action of sterownik.rowButtonAction\" [label]=\"action.label\" [icon]=\"action.icon\"\n                     [styleClass]=\"action.styleClass\" [severity]=\"action.severity\" [pTooltip]=\"action.tooltip | transloco\"\n                     tooltipPosition=\"top\" iconPos=\"right\" class=\"p-mr-2 ds-button-hidden\" (onClick)=\"emitRowAction(action.action, rowData)\"\n                     [disabled]=\"action.disabled ? action.disabled : false\"\n                     [readonly]=\"action.readonly ? action.readonly : false\"></ds-button>\n\n          <ds-button *ngFor=\"let action of sterownik.rowButtonAction\" [label]=\"action.tooltip\"\n                     [styleClass]=\"action.styleClass\" [severity]=\"'border'\"\n                     class=\"ds-button-action\" (onClick)=\"emitRowAction(action.action, rowData)\"\n                     [disabled]=\"action.disabled ? action.disabled : false\"\n                     [readonly]=\"action.readonly ? action.readonly : false\"></ds-button>\n\n        </td>\n        <td *ngIf=\"sterownik.rowActions && sterownik.rowActions.length\" class=\"row-actions\">\n          <p-menubar [model]=\"rowsMenuModel[rowData[sterownik.key]]\"></p-menubar>\n        </td>\n        <td *ngIf=\"sterownik.rowExpansion\" [pRowToggler]=\"rowData\" style=\"cursor: pointer;\" class=\"p-p-0\">\n            <ds-button severity=\"link\"\n                    class=\"p-button-text p-button-rounded p-button-plain ds-hidden\"\n                    [icon]=\"expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'\"\n                    [label]=\"'rozwi\u0144 zwi\u0144 wiersz'\"\n                    [styleClass]=\"'p-button-label-display-none'\">\n            </ds-button>\n            <ds-button class=\"ds-button-expansion\" severity=\"primary\" [label]=\"expanded ? 'Ukryj wszystkie odpowiedzi':'Pobierz wszystkie odpowiedzi'\"></ds-button>\n        </td>\n      </tr>\n    </ng-template>\n    <ng-template [ngIf]=\"sterownik.rowExpansion\" pTemplate=\"rowexpansion\" let-rowData>\n      <ng-container *ngTemplateOutlet=\"rozwijakTemplate;\n           context: {\n            $implicit: { 'rowData': rowData,\n                         'columns': sterownik.columns,\n                         'colSpan': rowExpansionColSpan }\n           }\">\n      </ng-container>\n    </ng-template>\n  </p-table>\n  <div class=\"custom-table-footer\" *ngIf=\"changeDetection() && !(hideBtnSection && hidePagination)\">\n    <div class=\"custom-btn-section\">\n      <ds-button *ngIf=\"exportToCsv\" class=\"p-mr-3\" severity=\"primary\" (click)=\"dt.exportCSV()\" label=\"CSV\"></ds-button>\n      <ds-button *ngIf=\"exportToExcel\" class=\"p-mr-3\" severity=\"primary\" (click)=\"exportExcel()\" label=\"Excel\"></ds-button>\n      <ds-button *ngIf=\"exportToPdf\" class=\"p-mr-3\" severity=\"primary\" (click)=\"exportPdf()\" label=\"PDF\"></ds-button>\n      <ds-button *ngFor=\"let action of sterownik.tableActions\"\n                 class=\"p-mr-3\"\n                 [severity]=\"action.severity ? action.severity : action.dsType\" [label]=\"action.label | transloco\"\n                 (click)=\"emitTableAction(action.action, action.disabled||false)\"\n                 [disabled]=\"action.disabled ? action.disabled : false\"\n                 [styleClass]=\"action.styleClass || ''\"\n                 [style]=\"action.style || {}\">\n      </ds-button>\n    </div>\n    <div class=\"custom-paginator\" *ngIf=\"!hidePagination && pageCount > 0\">\n        <span *ngIf=\"currentPageReportTemplate\" class=\"p-paginator-current ng-star-inserted\">\n          {{currentPageReportText}}\n        </span>\n\n      <button type=\"button\" pripple=\"\" class=\"p-paginator-first p-paginator-element p-link p-ripple ng-star-inserted\"\n              role=\"button\" tabindex=\"0\"\n              (click)=\"onPage({first: 0, rows: rows})\" [ngClass]=\"{'p-disabled':page===0}\" [disabled]=\"page===0\">\n        <span class=\"p-paginator-icon pi pi-angle-double-left\"><span style=\"display: none\">Pocz\u0105tek</span></span>\n      </button>\n      <button type=\"button\" pripple=\"\" class=\"p-paginator-prev p-paginator-element p-link p-ripple\"\n              role=\"button\" tabindex=\"0\"\n              (click)=\"onPage({first: first - rows, rows: rows})\" [ngClass]=\"{'p-disabled':page===0}\" [disabled]=\"page===0\">\n        <span class=\"p-paginator-icon pi pi-angle-left\"><span style=\"display: none\">Wstecz</span></span>\n      </button>\n\n      <span class=\"p-paginator-pages ng-star-inserted\">\n          <button *ngFor=\"let pageObj of paginatorPages; index as i\"\n                  type=\"button\"\n                  (click)=\"onPage({first: (pageObj.value - 1) * rows, rows: rows})\"\n                  [ngClass]=\"{'p-highlight': (pageObj.value - 1) === page}\"\n                  class=\"p-paginator-page p-paginator-element\"\n                  role=\"button\" tabindex=\"0\">\n            {{pageObj.value}}\n          </button>\n          <ng-container *ngIf=\"pageCount > paginatorButtonsCount + 1 && page < pageCount - paginatorLastElems\">\n            <button *ngIf=\"page < pageCount - (paginatorLastElems + 1)\" type=\"button\" disabled class=\"p-link\">\n            ...\n            </button>\n            <button (click)=\"onPage({first: (pageCount - 1) * rows, rows: rows})\"\n                    [ngClass]=\"{'p-highlight': pageCount === page}\"\n                    role=\"button\" tabindex=\"0\"\n                    class=\"p-paginator-page p-paginator-element\">\n            {{pageCount}}\n            </button>\n          </ng-container>\n        </span>\n\n      <button type=\"button\" pripple=\"\" class=\"p-paginator-next p-paginator-element p-link p-ripple\"\n              role=\"button\" tabindex=\"0\"\n              (click)=\"onPage({first: first + rows, rows: rows})\" [ngClass]=\"{'p-disabled': page+1===pageCount}\"\n              [disabled]=\"page+1===pageCount\">\n        <span class=\"p-paginator-icon pi pi-angle-right\"><span style=\"display: none\">Wprz\u00F3d</span></span>\n      </button>\n      <button type=\"button\" pripple=\"\" class=\"p-paginator-last p-paginator-element p-link p-ripple ng-star-inserted\"\n              role=\"button\" tabindex=\"0\"\n              (click)=\"onPage({first: (pageCount * rows) - rows, rows: rows})\"\n              [ngClass]=\"{'p-disabled': page+1===pageCount}\" [disabled]=\"page+1===pageCount\">\n        <span class=\"p-paginator-icon pi pi-angle-double-right\"><span style=\"display: none\">Koniec</span></span>\n      </button>\n\n      <p-dropdown *ngIf=\"sterownik.paginator?.rowsPerPageOptions\" aria-labelledby=\"\"\n                  id=\"paginationDropdown-2\" class=\"p-paginator-rpp-options\"\n                  [options]=\"rowsPerPageOptionsObjects\"\n                  [(ngModel)]=\"rows\"\n                  optionLabel=\"name\" optionValue=\"value\"\n                  (keydown.enter)=\"onPage({first: 0, rows: $event.value})\"\n                  (ngModelChange)=\"onPage({first: 0, rows: $event.value})\"\n                  >\n      </p-dropdown>\n    </div>\n  </div>\n</div>\n\n<ng-template #filters let-col=\"col\">\n  <ng-container [ngSwitch]=\"col.filter.type\">\n    <ds-dropdown\n      *ngSwitchCase=\"'ds-dropdown'\"\n      class=\"p-column-filter\"\n      optionLabel=\"value\"\n      [placeholder]=\"col.filter.placeholder || ''\"\n      [options]=\"col.filter.options\"\n      [ngModel]=\"dt.filters[col.field]?.value\"\n      [autoDisplayFirst]=\"false\"\n      [showClear]=\"col.filter.showClear\"\n      [filter]=\"col.filter.showFilter\"\n      (onChange)=\"dt.filter($event.value ? $event.value.value : null, col.field, col.filter.matchMode || 'equals')\"\n    ></ds-dropdown>\n    <ds-multiselect\n      *ngSwitchCase=\"'ds-multiselect'\"\n      class=\"p-column-filter\"\n      [filterPlaceholder]=\"col.filter.placeholder || ''\"\n      [ngModel]=\"dt.filters[col.field]?.value\"\n      [options]=\"col.filter.options\"\n      [defaultLabel]=\"col.filter.placeholder || ''\"\n      [showHeader]=\"col.filter.showFilter\"\n      (onChange)=\"dt.filter($event.value || $event, col.field, col.filter.matchMode || 'in')\"\n    ></ds-multiselect>\n    <ds-input\n      *ngSwitchDefault\n      class=\"p-column-filter\"\n      [ngModel]=\"dt.filters[col.field]?.value\"\n      [placeholder]=\"col.filter.placeholder || ''\"\n      [showClear]=\"col.filter.showClear\"\n      (input)=\"dt.filter($event?.target?.value, col.field,col.filter.matchMode || 'contains')\"\n    ></ds-input>\n  </ng-container>\n</ng-template>\n"
            }]
    }], function () { return [{ type: ɵngcc8.FilterService }, { type: ɵngcc0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_TABLE_COMPONENT_PDF_SERVICE]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_TABLE_COMPONENT_EXCEL_SERVICE]
            }] }]; }, { columnTemplates: [{
            type: Input,
            args: ['columnTemplates']
        }], responsive: [{
            type: Input
        }], loading: [{
            type: Input
        }], doubleClickActive: [{
            type: Input
        }], rowActionEmitter: [{
            type: Output,
            args: ['rowAction']
        }], tableActionEmitter: [{
            type: Output,
            args: ['tableAction']
        }], emitRowDbClick: [{
            type: Output
        }], onPageEmitter: [{
            type: Output,
            args: ['onPage']
        }], exportPdfService: [{
            type: Input
        }], exportExcelService: [{
            type: Input
        }], model: [{
            type: Input
        }], emptyMessage: [{
            type: Input
        }], paginatorButtonsCount: [{
            type: Input
        }], first: [{
            type: Input
        }], table: [{
            type: ViewChild,
            args: ['dt']
        }], sterownik: [{
            type: Input
        }], rozwijakTemplate: [{
            type: Input,
            args: ['rozwijak']
        }], export: [{
            type: ViewChild,
            args: ['table', { static: false }]
        }], stateStorage: [{
            type: Input
        }], name: [{
            type: Input
        }] }); })();

class DsSkeletonComponent {
    constructor() {
        this.width = '100%';
        this.height = '1rem';
    }
    ngOnInit() {
    }
}
DsSkeletonComponent.ɵfac = function DsSkeletonComponent_Factory(t) { return new (t || DsSkeletonComponent)(); };
DsSkeletonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsSkeletonComponent, selectors: [["ds-skeleton"]], inputs: { width: "width", height: "height", styleClass: "styleClass" }, decls: 1, vars: 3, consts: [[3, "styleClass", "width", "height"]], template: function DsSkeletonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "p-skeleton", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("styleClass", ctx.styleClass)("width", ctx.width)("height", ctx.height);
    } }, directives: [ɵngcc22.Skeleton], encapsulation: 2 });
DsSkeletonComponent.ctorParameters = () => [];
DsSkeletonComponent.propDecorators = {
    styleClass: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsSkeletonComponent, [{
        type: Component,
        args: [{
                selector: 'ds-skeleton',
                template: "<p-skeleton [styleClass]=\"styleClass\" [width]=\"width\" [height]=\"height\"></p-skeleton>"
            }]
    }], function () { return []; }, { width: [{
            type: Input
        }], height: [{
            type: Input
        }], styleClass: [{
            type: Input
        }] }); })();

class DsSkeletonModule {
}
DsSkeletonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsSkeletonModule });
DsSkeletonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsSkeletonModule_Factory(t) { return new (t || DsSkeletonModule)(); }, imports: [[
            CommonModule,
            SkeletonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsSkeletonModule, { declarations: function () { return [DsSkeletonComponent]; }, imports: function () { return [CommonModule,
        SkeletonModule]; }, exports: function () { return [DsSkeletonComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsSkeletonModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DsSkeletonComponent
                ],
                imports: [
                    CommonModule,
                    SkeletonModule
                ],
                exports: [
                    DsSkeletonComponent
                ]
            }]
    }], null, null); })();

class ResponsiveDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.firstStep = 568;
        this.secondStep = 1056;
        this.stepDelta = 98;
    }
    set responsivity(steps) {
        if (steps) {
            if (steps.firstStep) {
                this.firstStep = steps.firstStep;
            }
            if (steps.secondStep) {
                this.secondStep = steps.secondStep;
            }
        }
    }
    ngDoCheck() {
        this.doDecorate();
    }
    ngAfterViewInit() {
        this.div = this.el.nativeElement.children[0];
        this.doDecorate();
        this.resizeObservable = fromEvent(window, 'resize');
        this.resizeSubscription = this.resizeObservable.subscribe(evt => {
            this.doDecorate();
        });
    }
    ngOnDestroy() {
        this.resizeSubscription.unsubscribe();
    }
    doDecorate() {
        if (this.div) {
            const hostWidth = this.div.offsetWidth || (window.innerWidth - this.stepDelta);
            this.decorate(hostWidth);
        }
    }
    decorate(hostWidth) {
        if (hostWidth) {
            if (hostWidth <= this.firstStep) {
                this.renderer.addClass(this.el.nativeElement, "ds-responsive-mobile");
                this.renderer.addClass(this.el.nativeElement, "ds-responsive");
            }
            else if (hostWidth > this.firstStep && hostWidth <= this.secondStep) {
                this.renderer.addClass(this.el.nativeElement, "ds-responsive");
                this.renderer.removeClass(this.el.nativeElement, "ds-responsive-mobile");
            }
            else {
                this.renderer.removeClass(this.el.nativeElement, "ds-responsive");
                this.renderer.removeClass(this.el.nativeElement, "ds-responsive-mobile");
            }
            if (hostWidth <= 600) {
                this.renderer.addClass(this.el.nativeElement, "ds-responsive-footer");
            }
            else {
                this.renderer.removeClass(this.el.nativeElement, "ds-responsive-footer");
            }
        }
    }
}
ResponsiveDirective.ɵfac = function ResponsiveDirective_Factory(t) { return new (t || ResponsiveDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ResponsiveDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ResponsiveDirective, selectors: [["", "responsivity", ""]], inputs: { responsivity: "responsivity" } });
ResponsiveDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
ResponsiveDirective.propDecorators = {
    responsivity: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ResponsiveDirective, [{
        type: Directive,
        args: [{
                selector: '[responsivity]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { responsivity: [{
            type: Input
        }] }); })();

class DsTableModule {
}
DsTableModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsTableModule });
DsTableModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsTableModule_Factory(t) { return new (t || DsTableModule)(); }, providers: [
        HttpClient,
    ], imports: [[
            CalendarModule,
            CommonModule,
            DsButtonModule,
            DsDropdownModule,
            DsInputModule,
            DsMultiselectModule,
            HttpClientModule,
            MenubarModule,
            ProgressBarModule,
            TableModule,
            TranslocoModule,
            TooltipModule,
            DsSkeletonModule,
            DropdownModule,
            PaginatorModule,
            DsCalendarModule
        ], DsButtonModule, DsDropdownModule, DsInputModule, DsMultiselectModule, TooltipModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsTableModule, { declarations: function () { return [AutoFormatPipe, DsTableComponent, TakNiePipe, ResponsiveDirective]; }, imports: function () { return [CalendarModule,
        CommonModule, DsButtonModule, DsDropdownModule, DsInputModule, DsMultiselectModule, HttpClientModule,
        MenubarModule,
        ProgressBarModule,
        TableModule,
        TranslocoModule,
        TooltipModule, DsSkeletonModule, DropdownModule,
        PaginatorModule, DsCalendarModule]; }, exports: function () { return [AutoFormatPipe, DsButtonModule, DsDropdownModule, DsInputModule, DsMultiselectModule, DsTableComponent, TakNiePipe, TooltipModule, ResponsiveDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsTableModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AutoFormatPipe,
                    DsTableComponent,
                    TakNiePipe,
                    ResponsiveDirective
                ],
                imports: [
                    CalendarModule,
                    CommonModule,
                    DsButtonModule,
                    DsDropdownModule,
                    DsInputModule,
                    DsMultiselectModule,
                    HttpClientModule,
                    MenubarModule,
                    ProgressBarModule,
                    TableModule,
                    TranslocoModule,
                    TooltipModule,
                    DsSkeletonModule,
                    DropdownModule,
                    PaginatorModule,
                    DsCalendarModule
                ],
                exports: [
                    AutoFormatPipe,
                    DsButtonModule,
                    DsDropdownModule,
                    DsInputModule,
                    DsMultiselectModule,
                    DsTableComponent,
                    TakNiePipe,
                    TooltipModule,
                    ResponsiveDirective
                ],
                providers: [
                    HttpClient,
                ]
            }]
    }], null, null); })();

class DsTagComponent {
    constructor() {
        /**
         * Określa typ tagu
         * @type 'dot' | 'box' | 'box-border'
         * @default 'dot'
         * */
        this.type = 'dot';
        /**
         * Określa kolor tagu
         * @type 'info' | 'error' | 'warning' | 'success'
         * @default info
         * */
        this.color = 'info';
        this.disabled = false;
    }
    ngOnInit() {
    }
}
DsTagComponent.ɵfac = function DsTagComponent_Factory(t) { return new (t || DsTagComponent)(); };
DsTagComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsTagComponent, selectors: [["ds-tag"]], inputs: { type: "type", color: "color", disabled: "disabled", ariaLabel: "ariaLabel" }, ngContentSelectors: _c2, decls: 3, vars: 6, consts: [[4, "ngIf"]], template: function DsTagComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, DsTagComponent_span_1_Template, 1, 0, "span", 0);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate2("ds-tag ", ctx.type, " ", ctx.color, "");
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type == "dot");
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2 });
DsTagComponent.ctorParameters = () => [];
DsTagComponent.propDecorators = {
    type: [{ type: Input }],
    color: [{ type: Input }],
    disabled: [{ type: Input }],
    ariaLabel: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsTagComponent, [{
        type: Component,
        args: [{
                selector: 'ds-tag',
                template: `
    <div [attr.aria-label]="ariaLabel" class="ds-tag {{type}} {{color}}">
      <span *ngIf="type=='dot'"></span>
      <ng-content></ng-content>
    </div>
  `
            }]
    }], function () { return []; }, { type: [{
            type: Input
        }], color: [{
            type: Input
        }], disabled: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }] }); })();

class DsTagModule {
}
DsTagModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsTagModule });
DsTagModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsTagModule_Factory(t) { return new (t || DsTagModule)(); }, imports: [[
            CommonModule,
            ButtonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsTagModule, { declarations: function () { return [DsTagComponent]; }, imports: function () { return [CommonModule,
        ButtonModule]; }, exports: function () { return [DsTagComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsTagModule, [{
        type: NgModule,
        args: [{
                declarations: [DsTagComponent],
                imports: [
                    CommonModule,
                    ButtonModule
                ],
                exports: [
                    DsTagComponent
                ]
            }]
    }], null, null); })();

class DsTextareaComponent extends CustomValidatorUtils {
    constructor(sanitizer, customValidatorService) {
        super();
        this.sanitizer = sanitizer;
        /**
         * Etykieta znajdująca się nad inputem
         * @type string
         * @default empty string
         * */
        this.label = '';
        /**
         * Określa, czy input ma być tylko do odczytu
         * @type boolean
         * @default false
         * */
        this.readonly = false;
        /**
         * Określa klasę/klasy, które mają być nadane inputowi
         * @type string
         * @default empty string
         * */
        this.styleClass = '';
        /**
         * Określa jakie ID ma być nadane inputowi.
         * Jeśli zostawione puste to będzie nadane wygenerowane ID.
         * @type string
         * */
        this.id = undefined;
        /**
         * Określa podpowiedź do tego jakiej wartości spodziewamy się w inpucie
         * @type string
         * @default empty string
         * */
        this.placeholder = '';
        /**
         * Określa wartość wpisaną do inputu przy jego wczytaniu na stronie
         * @type string
         * @default empty string
         * */
        this.value = '';
        /**
         * Określa nazwę inputu
         * @type string
         * @default null
         * */
        this.name = null;
        /**
         * Określa ile rzędów tekstu ma być w inpucie
         * @type number
         * @default 1
         * */
        this.rows = 1;
        /**
         * Określa czy input ma automatycznie dodawać rzędy kiedy tekst nie mieści się w inpucie.
         * @type boolean
         * @default false
         * */
        this.autoResize = false;
        /**
         * Określa maksymalną ilość znaków, którą można wpisać do inputu
         * @type string | number
         * @default '524288'
         * */
        this.maxLength = '524288';
        /**
         * Określa czy licznik znaków jest widoczny
         * @type boolean
         * @default false
         * */
        this.showCounter = false;
        /**
         * Określa, czy licznik znaków znajduje się wewnątrz textarea
         * @type boolean
         * @default false
         */
        this.counterInside = false;
        /**
         * Określa, czy licznik znaków jest zawsze widoczny
         * @type boolean
         * @default false
         */
        this.counterAlwaysVisible = false;
        this._capitalize = false;
        /**
         * Określa czy uruchomić dodatkowy walidator
         * @type boolean
         * @default true
         */
        this.isCustomValidatorRun = true;
        this.ngModelChange = new EventEmitter();
        this.onResize = new EventEmitter();
        this.disabled = false;
        this.onChange = () => {
        };
        this.onTouch = () => {
        };
        this.customValidatorService = customValidatorService;
    }
    /**
     * Określa czy wszystkie wprowadzane wartości powinny być wielkimi literami
     * @type boolean
     * @default false
     */
    set capitalize(value) {
        this._capitalize = value;
        this.changeWrapper();
    }
    get capitalize() {
        return this._capitalize;
    }
    ngOnInit() {
        if (this.id == undefined)
            this.id = Utils.wygenerujLosoweId();
    }
    writeValue(value) {
        this.ngModel = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    onChangeWrapper(inputValue) {
        this.changeWrapper();
    }
    changeWrapper() {
        const value = this.inputElement.nativeElement.value;
        if (this._capitalize && value) {
            const start = this.inputElement.nativeElement.selectionStart;
            const end = this.inputElement.nativeElement.selectionEnd;
            this.inputElement.nativeElement.value = Utils.normalizeToUpper(value);
            this.inputElement.nativeElement.setSelectionRange(start, end);
        }
        this.ngModel = this.inputElement.nativeElement.value;
        this.onChange(this.ngModel);
    }
    safeHtml(v) {
        return this.sanitizer.bypassSecurityTrustHtml(v);
    }
    validate(formControl) {
        if (this.isCustomValidatorRun === true && this.customValidatorService) {
            return this.executeValidate(this, formControl, this.customValidatorService);
        }
        return null;
    }
}
DsTextareaComponent.ɵfac = function DsTextareaComponent_Factory(t) { return new (t || DsTextareaComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(DS_TEXTAREA_COMPONENT_CUSTOM_VALIDATOR, 8)); };
DsTextareaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsTextareaComponent, selectors: [["ds-textarea"]], viewQuery: function DsTextareaComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } }, hostAttrs: [1, "ds-textarea"], hostVars: 4, hostBindings: function DsTextareaComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-readonly", ctx.readonly)("is-disabled", ctx.disabled);
    } }, inputs: { label: "label", readonly: "readonly", styleClass: "styleClass", id: "id", placeholder: "placeholder", value: "value", name: "name", rows: "rows", autoResize: "autoResize", maxLength: "maxLength", showCounter: "showCounter", counterInside: "counterInside", counterAlwaysVisible: "counterAlwaysVisible", isCustomValidatorRun: "isCustomValidatorRun", customValidatorService: "customValidatorService", capitalize: "capitalize", ngModel: "ngModel", errorMessage: "errorMessage", cols: "cols", style: "style", ariaLabel: "ariaLabel" }, outputs: { ngModelChange: "ngModelChange", onResize: "onResize" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => DsTextareaComponent)
            },
            {
                provide: NG_VALIDATORS,
                useExisting: DsTextareaComponent,
                multi: true
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 9, vars: 19, consts: [[1, "ds-textarea-label", 3, "for"], ["pInputTextarea", "", 3, "readonly", "disabled", "classList", "id", "placeholder", "value", "name", "cols", "rows", "autoResize", "maxlength", "ngModel", "ngModelChange", "blur", "focusin"], ["inputElement", ""], [1, "ds-textarea-flex-wrapper"], ["class", "ds-textarea-error-message", 3, "innerHTML", 4, "ngIf"], ["class", "ds-textarea-chars-counter", 3, "counter-inside", "visibility", 4, "ngIf"], [1, "ds-textarea-error-message", 3, "innerHTML"], [1, "ds-textarea-chars-counter"]], template: function DsTextareaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "textarea", 1, 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DsTextareaComponent_Template_textarea_ngModelChange_2_listener($event) { return ctx.onChangeWrapper($event); })("blur", function DsTextareaComponent_Template_textarea_blur_2_listener() { return ctx.onTouch(); })("focusin", function DsTextareaComponent_Template_textarea_focusin_2_listener() { return ctx.isFocused = true; });
        ɵngcc0.ɵɵtext(4, "    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div");
        ɵngcc0.ɵɵtemplate(7, DsTextareaComponent_span_7_Template, 1, 1, "span", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, DsTextareaComponent_span_8_Template, 2, 5, "span", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵproperty("for", ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵproperty("readonly", ctx.readonly)("disabled", ctx.disabled)("classList", ctx.styleClass)("id", ctx.id)("placeholder", ctx.placeholder)("value", ctx.value)("name", ctx.name)("cols", ctx.cols)("rows", ctx.rows)("autoResize", ctx.autoResize)("maxlength", ctx.maxLength)("ngModel", ctx.ngModel);
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", !!ctx.errorMessage && !_r0.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCounter && !ctx.disabled && !ctx.readonly && ctx.maxLength);
    } }, directives: [ɵngcc4.DefaultValueAccessor, ɵngcc23.InputTextarea, ɵngcc4.MaxLengthValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc2.NgIf], encapsulation: 2 });
DsTextareaComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DS_TEXTAREA_COMPONENT_CUSTOM_VALIDATOR,] }] }
];
DsTextareaComponent.propDecorators = {
    label: [{ type: Input }],
    readonly: [{ type: Input }],
    styleClass: [{ type: Input }],
    id: [{ type: Input }],
    placeholder: [{ type: Input }],
    value: [{ type: Input }],
    errorMessage: [{ type: Input }],
    name: [{ type: Input }],
    rows: [{ type: Input }],
    cols: [{ type: Input }],
    autoResize: [{ type: Input }],
    maxLength: [{ type: Input }],
    style: [{ type: Input }],
    showCounter: [{ type: Input }],
    counterInside: [{ type: Input }],
    counterAlwaysVisible: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    capitalize: [{ type: Input }],
    isCustomValidatorRun: [{ type: Input }],
    customValidatorService: [{ type: Input }],
    ngModel: [{ type: Input }],
    ngModelChange: [{ type: Output }],
    onResize: [{ type: Output }],
    inputElement: [{ type: ViewChild, args: ['inputElement', { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsTextareaComponent, [{
        type: Component,
        args: [{
                selector: 'ds-textarea',
                template: `
      <label class="ds-textarea-label" [for]="id">{{label}}</label>
      <textarea pInputTextarea
                [readonly]="readonly"
                [disabled]="disabled"
                [classList]="styleClass"
                [id]="id"
                [placeholder]="placeholder"
                [value]="value"
                [name]="name"
                [cols]="cols"
                [rows]="rows"
                [autoResize]="autoResize"
                [maxlength]="maxLength"
                [style]="style"
                [ngModel]="ngModel"
                (ngModelChange)="onChangeWrapper($event)"
                (blur)="onTouch()"
                (focusin)="this.isFocused = true"
                [attr.aria-label]="ariaLabel"
                #inputElement
      >
    </textarea>
      <div class="ds-textarea-flex-wrapper">
          <div>
              <span class="ds-textarea-error-message"
                    *ngIf="!!errorMessage && !inputElement.disabled"
                    [innerHTML]="safeHtml(errorMessage)"
              >
              </span>
          </div>
          <span
                  class="ds-textarea-chars-counter" [class.counter-inside]="counterInside"
                  *ngIf="showCounter && !disabled && !readonly && maxLength"
                  [style.visibility]="counterAlwaysVisible ? 'visible' : isFocused ?  'visible' : 'hidden'"
          >
                {{ (ngModel ? ngModel.length : 0) + '/' + maxLength }}
            </span>
      </div>
  `,
                host: {
                    'class': 'ds-textarea',
                    '[class.is-readonly]': 'readonly',
                    '[class.is-disabled]': 'disabled'
                },
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: forwardRef(() => DsTextareaComponent)
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: DsTextareaComponent,
                        multi: true
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc5.DomSanitizer }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DS_TEXTAREA_COMPONENT_CUSTOM_VALIDATOR]
            }] }]; }, { label: [{
            type: Input
        }], readonly: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], id: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], value: [{
            type: Input
        }], name: [{
            type: Input
        }], rows: [{
            type: Input
        }], autoResize: [{
            type: Input
        }], maxLength: [{
            type: Input
        }], showCounter: [{
            type: Input
        }], counterInside: [{
            type: Input
        }], counterAlwaysVisible: [{
            type: Input
        }], isCustomValidatorRun: [{
            type: Input
        }], ngModelChange: [{
            type: Output
        }], onResize: [{
            type: Output
        }], customValidatorService: [{
            type: Input
        }], capitalize: [{
            type: Input
        }], ngModel: [{
            type: Input
        }], errorMessage: [{
            type: Input
        }], cols: [{
            type: Input
        }], style: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], inputElement: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }] }); })();

class DsTextareaModule {
}
DsTextareaModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsTextareaModule });
DsTextareaModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsTextareaModule_Factory(t) { return new (t || DsTextareaModule)(); }, imports: [[
            CommonModule,
            InputTextareaModule,
            FormsModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsTextareaModule, { declarations: function () { return [DsTextareaComponent]; }, imports: function () { return [CommonModule,
        InputTextareaModule,
        FormsModule,
        ReactiveFormsModule]; }, exports: function () { return [DsTextareaComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsTextareaModule, [{
        type: NgModule,
        args: [{
                declarations: [DsTextareaComponent],
                imports: [
                    CommonModule,
                    InputTextareaModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                exports: [
                    DsTextareaComponent
                ]
            }]
    }], null, null); })();

class PortalService {
    constructor() {
        this.targets = new Map();
    }
    addTarget(targetName, targetViewContainerRef) {
        this.targets.set(targetName, targetViewContainerRef);
    }
    clear(targetName) {
        var _a;
        (_a = this.getTarget(targetName)) === null || _a === void 0 ? void 0 : _a.clear();
    }
    attach(targetName, templateRef) {
        var _a;
        (_a = this.getTarget(targetName)) === null || _a === void 0 ? void 0 : _a.createEmbeddedView(templateRef);
    }
    getTarget(targetName) {
        return this.targets.has(targetName) ? this.targets.get(targetName) : null;
    }
}
PortalService.ɵfac = function PortalService_Factory(t) { return new (t || PortalService)(); };
PortalService.ɵprov = ɵɵdefineInjectable({ factory: function PortalService_Factory() { return new PortalService(); }, token: PortalService, providedIn: "root" });
PortalService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PortalService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class AddTargetDirective {
    constructor(portalService, viewContainerRef) {
        this.portalService = portalService;
        this.viewContainerRef = viewContainerRef;
    }
    ngOnInit() {
        this.portalService.addTarget(this.targetName, this.viewContainerRef);
    }
}
AddTargetDirective.ɵfac = function AddTargetDirective_Factory(t) { return new (t || AddTargetDirective)(ɵngcc0.ɵɵdirectiveInject(PortalService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
AddTargetDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AddTargetDirective, selectors: [["", "dsAddTarget", ""]], inputs: { targetName: ["dsAddTarget", "targetName"] } });
AddTargetDirective.ctorParameters = () => [
    { type: PortalService },
    { type: ViewContainerRef }
];
AddTargetDirective.propDecorators = {
    targetName: [{ type: Input, args: ['dsAddTarget',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AddTargetDirective, [{
        type: Directive,
        args: [{
                selector: '[dsAddTarget]'
            }]
    }], function () { return [{ type: PortalService }, { type: ɵngcc0.ViewContainerRef }]; }, { targetName: [{
            type: Input,
            args: ['dsAddTarget']
        }] }); })();

class AttachToDirective {
    constructor(portalService, templateRef) {
        this.portalService = portalService;
        this.templateRef = templateRef;
    }
    ngOnInit() {
        this.portalService.attach(this.targetName, this.templateRef);
    }
    ngOnDestroy() {
        this.portalService.clear(this.targetName);
    }
}
AttachToDirective.ɵfac = function AttachToDirective_Factory(t) { return new (t || AttachToDirective)(ɵngcc0.ɵɵdirectiveInject(PortalService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
AttachToDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AttachToDirective, selectors: [["", "dsAttachTo", ""]], inputs: { targetName: ["dsAttachTo", "targetName"] } });
AttachToDirective.ctorParameters = () => [
    { type: PortalService },
    { type: TemplateRef }
];
AttachToDirective.propDecorators = {
    targetName: [{ type: Input, args: ['dsAttachTo',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AttachToDirective, [{
        type: Directive,
        args: [{
                selector: '[dsAttachTo]'
            }]
    }], function () { return [{ type: PortalService }, { type: ɵngcc0.TemplateRef }]; }, { targetName: [{
            type: Input,
            args: ['dsAttachTo']
        }] }); })();

class DsPortalModule {
}
DsPortalModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsPortalModule });
DsPortalModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsPortalModule_Factory(t) { return new (t || DsPortalModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsPortalModule, { declarations: function () { return [AttachToDirective, AddTargetDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AttachToDirective, AddTargetDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsPortalModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AttachToDirective,
                    AddTargetDirective
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    AttachToDirective,
                    AddTargetDirective
                ]
            }]
    }], null, null); })();

class BreadcrumbService {
    constructor(router, activatedRoute) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.BREADCRUMB_KEY = 'breadcrumb';
        this.breadcrumbList = [];
        this.breadcrumbList$ = new BehaviorSubject([]);
        this.handleRouteChange();
    }
    updateBreadcrumbList(value) {
        this.breadcrumbList = value;
        this.breadcrumbList$.next(value);
    }
    getBreadcrumbList() {
        return this.breadcrumbList$.asObservable();
    }
    handleRouteChange() {
        this.router
            .events
            .pipe(filter(routerEvent => {
            return routerEvent instanceof NavigationEnd;
        }))
            .subscribe(() => {
            this.updateBreadcrumbList([]);
            this.createBreadcrumb(this.activatedRoute.root);
        });
    }
    createBreadcrumb(route) {
        const children = route.children;
        if (children.length === 0) {
            this.updateBreadcrumbList(this.breadcrumbList);
            return;
        }
        children.forEach(child => {
            if (this.getBreadcrumbFromRouting(child.snapshot)) {
                const breadcrumb = child.snapshot.data[this.BREADCRUMB_KEY];
                const path = breadcrumb.hasOwnProperty('path') ? breadcrumb.path : this.createBreadcrumbPath(child.snapshot.url);
                const label = this.createBreadcrumbLabel(child.snapshot, breadcrumb);
                this.breadcrumbList.push({
                    path,
                    label
                });
            }
            return this.createBreadcrumb(child);
        });
    }
    createBreadcrumbPath(urlSegment) {
        return './' + urlSegment
            .map(segment => segment.path)
            .join('/');
    }
    createBreadcrumbLabel(activatedRouteSnapshot, breadcrumb) {
        let label = breadcrumb.label;
        activatedRouteSnapshot.paramMap.keys
            .forEach(param => {
            const regExp = new RegExp(`{{${param}}}`, 'g');
            label = label.replace(regExp, param);
        });
        return label;
    }
    ;
    getBreadcrumbFromRouting(activatedRouteSnapshot) {
        return activatedRouteSnapshot.data.hasOwnProperty(this.BREADCRUMB_KEY) ? activatedRouteSnapshot.data[this.BREADCRUMB_KEY] : null;
    }
}
BreadcrumbService.ɵfac = function BreadcrumbService_Factory(t) { return new (t || BreadcrumbService)(ɵngcc0.ɵɵinject(ɵngcc15.Router), ɵngcc0.ɵɵinject(ɵngcc15.ActivatedRoute)); };
BreadcrumbService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BreadcrumbService, factory: BreadcrumbService.ɵfac });
BreadcrumbService.ctorParameters = () => [
    { type: Router },
    { type: ActivatedRoute }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc15.Router }, { type: ɵngcc15.ActivatedRoute }]; }, null); })();

class DsBreadcrumbComponent {
    constructor(breadcrumbService, router) {
        this.breadcrumbService = breadcrumbService;
        this.router = router;
        this.breadcrumbList$ = new Observable();
    }
    ngOnInit() {
        this.breadcrumbList$ = this.breadcrumbService.getBreadcrumbList();
    }
    navigateTo(url = '') {
        const isExternal = url.indexOf('http://') > -1 || url.indexOf('https://') > -1;
        if (isExternal) {
            window.location.href = url;
        }
        else {
            this.router.navigate([url]);
        }
    }
}
DsBreadcrumbComponent.ɵfac = function DsBreadcrumbComponent_Factory(t) { return new (t || DsBreadcrumbComponent)(ɵngcc0.ɵɵdirectiveInject(BreadcrumbService), ɵngcc0.ɵɵdirectiveInject(ɵngcc15.Router)); };
DsBreadcrumbComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsBreadcrumbComponent, selectors: [["ds-breadcrumb"]], decls: 4, vars: 3, consts: [[1, "ds-breadcrumb"], [1, "ds-breadcrumb-list"], [4, "ngFor", "ngForOf"], [1, "ds-breadcrumb-item"], ["class", "ds-breadcrumb-item-link", 3, "click", 4, "ngIf"], ["class", "ds-breadcrumb-item-label", 4, "ngIf"], ["class", "ds-breadcrumb-item-label-bold", 4, "ngIf"], [4, "ngIf"], [1, "ds-breadcrumb-item-link", 3, "click"], [1, "ds-breadcrumb-item-label"], [1, "ds-breadcrumb-item-label-bold"], [1, "pi", "pi-chevron-right"]], template: function DsBreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵelementStart(1, "ul", 1);
        ɵngcc0.ɵɵtemplate(2, DsBreadcrumbComponent_ng_container_2_Template, 6, 4, "ng-container", 2);
        ɵngcc0.ɵɵpipe(3, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(3, 1, ctx.breadcrumbList$));
    } }, directives: [ɵngcc2.NgForOf, ɵngcc2.NgIf], pipes: [ɵngcc2.AsyncPipe], encapsulation: 2 });
DsBreadcrumbComponent.ctorParameters = () => [
    { type: BreadcrumbService },
    { type: Router }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsBreadcrumbComponent, [{
        type: Component,
        args: [{
                selector: 'ds-breadcrumb',
                template: `
      <nav class="ds-breadcrumb">
          <ul class="ds-breadcrumb-list">
              <ng-container *ngFor="let item of breadcrumbList$ | async; let last = last">
                  <li class="ds-breadcrumb-item">
                      <a class="ds-breadcrumb-item-link" *ngIf="!last && item.path" (click)="navigateTo(item.path)"> {{ item.label }}</a>
                      <span class="ds-breadcrumb-item-label" *ngIf="!last && !item.path"> {{ item.label }}</span>
                      <span class="ds-breadcrumb-item-label-bold" *ngIf="last"> {{ item.label }}</span>
                  </li>
                  <li *ngIf="!last">
                    <span class="pi pi-chevron-right"></span>
                  </li>
              </ng-container>
          </ul>
      </nav>
  `
            }]
    }], function () { return [{ type: BreadcrumbService }, { type: ɵngcc15.Router }]; }, null); })();

class DsBreadcrumbModule {
}
DsBreadcrumbModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsBreadcrumbModule });
DsBreadcrumbModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsBreadcrumbModule_Factory(t) { return new (t || DsBreadcrumbModule)(); }, providers: [
        BreadcrumbService
    ], imports: [[
            CommonModule,
            RouterModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsBreadcrumbModule, { declarations: function () { return [DsBreadcrumbComponent]; }, imports: function () { return [CommonModule,
        RouterModule]; }, exports: function () { return [DsBreadcrumbComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsBreadcrumbModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DsBreadcrumbComponent
                ],
                imports: [
                    CommonModule,
                    RouterModule
                ],
                providers: [
                    BreadcrumbService
                ],
                exports: [
                    DsBreadcrumbComponent
                ]
            }]
    }], null, null); })();

class DsTranslocoModule {
}
DsTranslocoModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsTranslocoModule });
DsTranslocoModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsTranslocoModule_Factory(t) { return new (t || DsTranslocoModule)(); }, providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: 'ds'
        }
    ], imports: [[]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsTranslocoModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [],
                exports: [],
                providers: [
                    {
                        provide: TRANSLOCO_SCOPE,
                        useValue: 'ds'
                    }
                ]
            }]
    }], null, null); })();

class DsLayoutComponent {
    constructor() {
    }
    ngOnInit() {
    }
}
DsLayoutComponent.ɵfac = function DsLayoutComponent_Factory(t) { return new (t || DsLayoutComponent)(); };
DsLayoutComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsLayoutComponent, selectors: [["ds-layout"]], hostAttrs: [1, "ds-layout"], ngContentSelectors: _c34, decls: 9, vars: 0, consts: [[1, "layout"], [1, "layout-column"], [1, "layout-row"], [1, "main-content"]], template: function DsLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c33);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵprojection(3, 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵprojection(5, 2);
        ɵngcc0.ɵɵelementStart(6, "main", 3);
        ɵngcc0.ɵɵprojection(7, 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(8, 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
DsLayoutComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'ds-layout',
                template: `
      <div class="layout">
          <ng-content select="ds-layout-header"></ng-content>
          <div class="layout-column">
              <ng-content select="ds-layout-sidebar"></ng-content>
              <div class="layout-row">
                  <ng-content select="ds-layout-subheader"></ng-content>
                  <main class="main-content">
                      <ng-content select="ds-layout-content"></ng-content>
                  </main>
                  <ng-content select="ds-layout-footer"></ng-content>
              </div>
          </div>
      </div>
  `,
                host: {
                    'class': 'ds-layout'
                }
            }]
    }], function () { return []; }, null); })();
class DsLayoutHeaderComponent {
}
DsLayoutHeaderComponent.ɵfac = function DsLayoutHeaderComponent_Factory(t) { return new (t || DsLayoutHeaderComponent)(); };
DsLayoutHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsLayoutHeaderComponent, selectors: [["ds-layout-header"]], hostAttrs: [1, "ds-layout-header"], ngContentSelectors: _c2, decls: 1, vars: 0, template: function DsLayoutHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsLayoutHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'ds-layout-header',
                template: `
      <ng-content></ng-content>`,
                host: {
                    'class': 'ds-layout-header'
                }
            }]
    }], null, null); })();
class DsLayoutSubheaderComponent {
}
DsLayoutSubheaderComponent.ɵfac = function DsLayoutSubheaderComponent_Factory(t) { return new (t || DsLayoutSubheaderComponent)(); };
DsLayoutSubheaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsLayoutSubheaderComponent, selectors: [["ds-layout-subheader"]], hostAttrs: [1, "ds-layout-subheader"], ngContentSelectors: _c2, decls: 1, vars: 0, template: function DsLayoutSubheaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsLayoutSubheaderComponent, [{
        type: Component,
        args: [{
                selector: 'ds-layout-subheader',
                template: `
      <ng-content></ng-content>`,
                host: {
                    'class': 'ds-layout-subheader'
                }
            }]
    }], null, null); })();
class DsLayoutSidebarComponent {
    get isCollapsed() {
        return this.collapsed;
    }
}
DsLayoutSidebarComponent.ɵfac = function DsLayoutSidebarComponent_Factory(t) { return new (t || DsLayoutSidebarComponent)(); };
DsLayoutSidebarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsLayoutSidebarComponent, selectors: [["ds-layout-sidebar"]], hostAttrs: [1, "ds-layout-sidebar"], hostVars: 2, hostBindings: function DsLayoutSidebarComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("collapsed", ctx.isCollapsed);
    } }, inputs: { collapsed: "collapsed" }, ngContentSelectors: _c2, decls: 4, vars: 0, consts: [[1, "sidebar-wrapper"], [1, "scrollable"], [1, "collapsible"]], template: function DsLayoutSidebarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
DsLayoutSidebarComponent.propDecorators = {
    collapsed: [{ type: Input }],
    isCollapsed: [{ type: HostBinding, args: ['class.collapsed',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsLayoutSidebarComponent, [{
        type: Component,
        args: [{
                selector: 'ds-layout-sidebar',
                template: `
      <div class="sidebar-wrapper">
        <div class="scrollable">
          <div class="collapsible">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
  `,
                host: {
                    'class': 'ds-layout-sidebar'
                }
            }]
    }], null, { isCollapsed: [{
            type: HostBinding,
            args: ['class.collapsed']
        }], collapsed: [{
            type: Input
        }] }); })();
class DsLayoutContentComponent {
}
DsLayoutContentComponent.ɵfac = function DsLayoutContentComponent_Factory(t) { return new (t || DsLayoutContentComponent)(); };
DsLayoutContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsLayoutContentComponent, selectors: [["ds-layout-content"]], hostAttrs: [1, "ds-layout-content"], ngContentSelectors: _c2, decls: 1, vars: 0, template: function DsLayoutContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsLayoutContentComponent, [{
        type: Component,
        args: [{
                selector: 'ds-layout-content',
                template: `
      <ng-content></ng-content>`,
                host: {
                    'class': 'ds-layout-content'
                }
            }]
    }], null, null); })();
class DsLayoutFooterComponent {
}
DsLayoutFooterComponent.ɵfac = function DsLayoutFooterComponent_Factory(t) { return new (t || DsLayoutFooterComponent)(); };
DsLayoutFooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsLayoutFooterComponent, selectors: [["ds-layout-footer"]], hostAttrs: [1, "ds-layout-footer"], ngContentSelectors: _c2, decls: 1, vars: 0, template: function DsLayoutFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsLayoutFooterComponent, [{
        type: Component,
        args: [{
                selector: 'ds-layout-footer',
                template: `
      <ng-content></ng-content>`,
                host: {
                    'class': 'ds-layout-footer'
                }
            }]
    }], null, null); })();

const COMPONENTS$1 = [
    DsLayoutComponent,
    DsLayoutHeaderComponent,
    DsLayoutSubheaderComponent,
    DsLayoutSidebarComponent,
    DsLayoutContentComponent,
    DsLayoutFooterComponent
];
class DsLayoutModule {
}
DsLayoutModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsLayoutModule });
DsLayoutModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsLayoutModule_Factory(t) { return new (t || DsLayoutModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsLayoutModule, { declarations: function () { return [DsLayoutComponent, DsLayoutHeaderComponent, DsLayoutSubheaderComponent, DsLayoutSidebarComponent, DsLayoutContentComponent, DsLayoutFooterComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DsLayoutComponent, DsLayoutHeaderComponent, DsLayoutSubheaderComponent, DsLayoutSidebarComponent, DsLayoutContentComponent, DsLayoutFooterComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsLayoutModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ...COMPONENTS$1
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    ...COMPONENTS$1
                ]
            }]
    }], null, null); })();

class DsPanelHeaderComponent {
}
DsPanelHeaderComponent.ɵfac = function DsPanelHeaderComponent_Factory(t) { return new (t || DsPanelHeaderComponent)(); };
DsPanelHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsPanelHeaderComponent, selectors: [["ds-panel-header"]], hostAttrs: [1, "ds-panel-header"], ngContentSelectors: _c2, decls: 1, vars: 0, template: function DsPanelHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsPanelHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'ds-panel-header',
                template: `
      <ng-content></ng-content>
  `,
                host: {
                    'class': 'ds-panel-header'
                }
            }]
    }], null, null); })();
class DsPanelFooterComponent {
}
DsPanelFooterComponent.ɵfac = function DsPanelFooterComponent_Factory(t) { return new (t || DsPanelFooterComponent)(); };
DsPanelFooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsPanelFooterComponent, selectors: [["ds-panel-footer"]], hostAttrs: [1, "ds-panel-footer"], ngContentSelectors: _c2, decls: 1, vars: 0, template: function DsPanelFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsPanelFooterComponent, [{
        type: Component,
        args: [{
                selector: 'ds-panel-footer',
                template: `
      <ng-content></ng-content>
  `,
                host: {
                    'class': 'ds-panel-footer'
                }
            }]
    }], null, null); })();
class DsPanelButtonsComponent {
}
DsPanelButtonsComponent.ɵfac = function DsPanelButtonsComponent_Factory(t) { return new (t || DsPanelButtonsComponent)(); };
DsPanelButtonsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsPanelButtonsComponent, selectors: [["ds-panel-buttons"]], hostAttrs: [1, "ds-panel-buttons"], ngContentSelectors: _c2, decls: 1, vars: 0, template: function DsPanelButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsPanelButtonsComponent, [{
        type: Component,
        args: [{
                selector: 'ds-panel-buttons',
                template: `
      <ng-content></ng-content>
  `,
                host: {
                    'class': 'ds-panel-buttons'
                }
            }]
    }], null, null); })();
class DsPanelComponent {
    constructor() {
        this.header = null;
        this.toggleable = false;
        this.collapsed = false;
        this.expandIcon = 'pi pi-chevron-right';
        this.collapseIcon = 'pi pi-chevron-down';
        this.showHeader = true;
        this.toggler = 'icon';
        this.styleClass = '';
        this.onBeforeToggle = new EventEmitter();
        this.onAfterToggle = new EventEmitter();
        this.contentLength = 0;
    }
    ngOnInit() {
        if (!this.showHeader) {
            this.styleClass += ' p-panel-header-display-none';
        }
    }
    ngAfterContentChecked() {
        var _a;
        this.contentLength = (_a = this.panelContent) === null || _a === void 0 ? void 0 : _a.nativeElement.children.length;
    }
}
DsPanelComponent.ɵfac = function DsPanelComponent_Factory(t) { return new (t || DsPanelComponent)(); };
DsPanelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsPanelComponent, selectors: [["ds-panel"]], contentQueries: function DsPanelComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DsPanelHeaderComponent, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, DsPanelFooterComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panelHeader = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panelFooter = _t.first);
    } }, viewQuery: function DsPanelComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c35, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panelContent = _t.first);
    } }, hostAttrs: [1, "ds-panel"], inputs: { header: "header", toggleable: "toggleable", collapsed: "collapsed", expandIcon: "expandIcon", collapseIcon: "collapseIcon", showHeader: "showHeader", toggler: "toggler", styleClass: "styleClass", ariaLabel: "ariaLabel" }, outputs: { onBeforeToggle: "onBeforeToggle", onAfterToggle: "onAfterToggle" }, ngContentSelectors: _c38, decls: 7, vars: 14, consts: [[3, "header", "collapsed", "expandIcon", "collapseIcon", "showHeader", "toggler", "styleClass", "toggleable", "onAfterToggle", "onBeforeToggle"], ["pTemplate", "icons"], [4, "ngIf"], [3, "ngClass"], ["panelContent", ""]], template: function DsPanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c36);
        ɵngcc0.ɵɵelementStart(0, "p-panel", 0);
        ɵngcc0.ɵɵlistener("onAfterToggle", function DsPanelComponent_Template_p_panel_onAfterToggle_0_listener() { return ctx.onAfterToggle.emit(); })("onBeforeToggle", function DsPanelComponent_Template_p_panel_onBeforeToggle_0_listener() { return ctx.onBeforeToggle.emit(); });
        ɵngcc0.ɵɵtemplate(1, DsPanelComponent_ng_template_1_Template, 1, 0, "ng-template", 1);
        ɵngcc0.ɵɵtemplate(2, DsPanelComponent_p_header_2_Template, 2, 0, "p-header", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3, 4);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DsPanelComponent_p_footer_6_Template, 2, 0, "p-footer", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("header", ctx.header)("collapsed", ctx.collapsed)("expandIcon", ctx.expandIcon)("collapseIcon", ctx.collapseIcon)("showHeader", true)("toggler", ctx.toggler)("styleClass", ctx.styleClass)("toggleable", ctx.toggleable);
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.panelHeader);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(12, _c37, (ctx.panelHeader || ctx.header) && ctx.contentLength > 0));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.panelFooter);
    } }, directives: [ɵngcc24.Panel, ɵngcc8.PrimeTemplate, ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc8.Header, ɵngcc8.Footer], encapsulation: 2 });
DsPanelComponent.ctorParameters = () => [];
DsPanelComponent.propDecorators = {
    header: [{ type: Input }],
    toggleable: [{ type: Input }],
    collapsed: [{ type: Input }],
    expandIcon: [{ type: Input }],
    collapseIcon: [{ type: Input }],
    showHeader: [{ type: Input }],
    toggler: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    styleClass: [{ type: Input }],
    onBeforeToggle: [{ type: Output }],
    onAfterToggle: [{ type: Output }],
    panelHeader: [{ type: ContentChild, args: [DsPanelHeaderComponent,] }],
    panelFooter: [{ type: ContentChild, args: [DsPanelFooterComponent,] }],
    panelContent: [{ type: ViewChild, args: ['panelContent',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsPanelComponent, [{
        type: Component,
        args: [{
                selector: 'ds-panel',
                template: `
      <p-panel
              [header]="header"
              [collapsed]="collapsed"
              [expandIcon]="expandIcon"
              [collapseIcon]="collapseIcon"
              [showHeader]="true"
              [toggler]="toggler"
              (onAfterToggle)="onAfterToggle.emit()"
              (onBeforeToggle)="onBeforeToggle.emit()"
              [attr.aria-label]="ariaLabel"
              [styleClass]="styleClass"
              [toggleable]="toggleable"
      >
          <ng-template pTemplate="icons">
            <ng-content select="ds-panel-buttons"></ng-content>
          </ng-template>
          <p-header *ngIf="panelHeader">
              <ng-content select="ds-panel-header"></ng-content>
          </p-header>
          <div #panelContent [ngClass]="{ 'p-pt-3': (panelHeader || header) && contentLength > 0 }">
            <ng-content></ng-content>
          </div>
          <p-footer *ngIf="panelFooter">
              <ng-content select="ds-panel-footer"></ng-content>
          </p-footer>
      </p-panel>
  `,
                host: {
                    'class': 'ds-panel'
                }
            }]
    }], function () { return []; }, { header: [{
            type: Input
        }], toggleable: [{
            type: Input
        }], collapsed: [{
            type: Input
        }], expandIcon: [{
            type: Input
        }], collapseIcon: [{
            type: Input
        }], showHeader: [{
            type: Input
        }], toggler: [{
            type: Input
        }], styleClass: [{
            type: Input
        }], onBeforeToggle: [{
            type: Output
        }], onAfterToggle: [{
            type: Output
        }], ariaLabel: [{
            type: Input
        }], panelHeader: [{
            type: ContentChild,
            args: [DsPanelHeaderComponent]
        }], panelFooter: [{
            type: ContentChild,
            args: [DsPanelFooterComponent]
        }], panelContent: [{
            type: ViewChild,
            args: ['panelContent']
        }] }); })();

const COMPONENTS$2 = [
    DsPanelComponent,
    DsPanelHeaderComponent,
    DsPanelFooterComponent,
    DsPanelButtonsComponent
];
class DsPanelModule {
}
DsPanelModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsPanelModule });
DsPanelModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsPanelModule_Factory(t) { return new (t || DsPanelModule)(); }, imports: [[
            CommonModule,
            PanelModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsPanelModule, { declarations: function () { return [DsPanelComponent, DsPanelHeaderComponent, DsPanelFooterComponent, DsPanelButtonsComponent]; }, imports: function () { return [CommonModule,
        PanelModule]; }, exports: function () { return [DsPanelComponent, DsPanelHeaderComponent, DsPanelFooterComponent, DsPanelButtonsComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsPanelModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ...COMPONENTS$2
                ],
                imports: [
                    CommonModule,
                    PanelModule,
                ],
                exports: [
                    ...COMPONENTS$2
                ]
            }]
    }], null, null); })();

class DsTabLabelComponent {
    constructor() {
    }
}
DsTabLabelComponent.ɵfac = function DsTabLabelComponent_Factory(t) { return new (t || DsTabLabelComponent)(); };
DsTabLabelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsTabLabelComponent, selectors: [["ds-tab-label"]], viewQuery: function DsTabLabelComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabLabelContent = _t.first);
    } }, ngContentSelectors: _c2, decls: 1, vars: 0, template: function DsTabLabelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, DsTabLabelComponent_ng_template_0_Template, 1, 0, "ng-template");
    } }, encapsulation: 2 });
DsTabLabelComponent.ctorParameters = () => [];
DsTabLabelComponent.propDecorators = {
    tabLabelContent: [{ type: ViewChild, args: [TemplateRef,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsTabLabelComponent, [{
        type: Component,
        args: [{
                selector: 'ds-tab-label',
                template: `
      <ng-template>
          <ng-content></ng-content>
      </ng-template>
  `
            }]
    }], function () { return []; }, { tabLabelContent: [{
            type: ViewChild,
            args: [TemplateRef]
        }] }); })();
class DsTabBodyComponent {
    constructor() {
    }
}
DsTabBodyComponent.ɵfac = function DsTabBodyComponent_Factory(t) { return new (t || DsTabBodyComponent)(); };
DsTabBodyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsTabBodyComponent, selectors: [["ds-tab-body"]], viewQuery: function DsTabBodyComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabBodyContent = _t.first);
    } }, ngContentSelectors: _c2, decls: 1, vars: 0, template: function DsTabBodyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, DsTabBodyComponent_ng_template_0_Template, 1, 0, "ng-template");
    } }, encapsulation: 2 });
DsTabBodyComponent.ctorParameters = () => [];
DsTabBodyComponent.propDecorators = {
    tabBodyContent: [{ type: ViewChild, args: [TemplateRef,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsTabBodyComponent, [{
        type: Component,
        args: [{
                selector: 'ds-tab-body',
                template: `
      <ng-template>
          <ng-content></ng-content>
      </ng-template>
  `
            }]
    }], function () { return []; }, { tabBodyContent: [{
            type: ViewChild,
            args: [TemplateRef]
        }] }); })();
class DsTabPanelComponent {
    constructor() {
        this.labelSize = 'primary';
    }
}
DsTabPanelComponent.ɵfac = function DsTabPanelComponent_Factory(t) { return new (t || DsTabPanelComponent)(); };
DsTabPanelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsTabPanelComponent, selectors: [["ds-tab-panel"]], contentQueries: function DsTabPanelComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DsTabBodyComponent, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, DsTabLabelComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabBodyComponent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabLabelComponent = _t.first);
    } }, inputs: { labelSize: "labelSize", label: "label", isActive: "isActive", disabled: "disabled" }, ngContentSelectors: _c2, decls: 1, vars: 0, template: function DsTabPanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
DsTabPanelComponent.ctorParameters = () => [];
DsTabPanelComponent.propDecorators = {
    label: [{ type: Input }],
    labelSize: [{ type: Input }],
    isActive: [{ type: Input }],
    disabled: [{ type: Input }],
    tabBodyComponent: [{ type: ContentChild, args: [DsTabBodyComponent,] }],
    tabLabelComponent: [{ type: ContentChild, args: [DsTabLabelComponent,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsTabPanelComponent, [{
        type: Component,
        args: [{
                selector: 'ds-tab-panel',
                template: `
      <ng-content></ng-content>
  `
            }]
    }], function () { return []; }, { labelSize: [{
            type: Input
        }], label: [{
            type: Input
        }], isActive: [{
            type: Input
        }], disabled: [{
            type: Input
        }], tabBodyComponent: [{
            type: ContentChild,
            args: [DsTabBodyComponent]
        }], tabLabelComponent: [{
            type: ContentChild,
            args: [DsTabLabelComponent]
        }] }); })();
class DsTabViewComponent {
    constructor() {
        this.onSelectedIndex = new EventEmitter();
        this.tabItems = [];
    }
    set selectedIndex(index) {
        this.setActiveTabByIndex(index);
    }
    ngOnInit() { }
    ngAfterContentInit() {
        // TODO refactor
        setTimeout(() => {
            this.tabItems = this.tabPanelComponents.toArray();
            this.selectActiveTab();
        }, 0);
    }
    setActiveTab(tabComponent) {
        if (this.activeTab === tabComponent)
            return;
        this.activeTab.isActive = false;
        this.activeTab = tabComponent;
        this.activeTab.isActive = true;
        const index = this.tabItems.indexOf(this.activeTab);
        this.onSelectedIndex.emit(index);
    }
    setActiveTabByIndex(index) {
        const activeTabIndex = this.tabItems.indexOf(this.activeTab);
        if (activeTabIndex === -1 || activeTabIndex === index || index >= this.tabItems.length)
            return;
        const newActiveTab = this.tabItems[index];
        if (!newActiveTab || newActiveTab.disabled)
            return;
        this.activeTab.isActive = false;
        this.activeTab = newActiveTab;
        this.activeTab.isActive = true;
    }
    selectActiveTab() {
        const activeTab = this.tabItems.find(tabPanelComponent => tabPanelComponent.isActive && !(tabPanelComponent === null || tabPanelComponent === void 0 ? void 0 : tabPanelComponent.disabled));
        this.activeTab = activeTab ? activeTab : this.tabItems[0];
        this.activeTab.isActive = true;
    }
}
DsTabViewComponent.ɵfac = function DsTabViewComponent_Factory(t) { return new (t || DsTabViewComponent)(); };
DsTabViewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsTabViewComponent, selectors: [["ds-tab-view"]], contentQueries: function DsTabViewComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DsTabPanelComponent, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabPanelComponents = _t);
    } }, inputs: { selectedIndex: "selectedIndex", ariaLabel: "ariaLabel", actionSection: "actionSection", actionSectionTemplate: "actionSectionTemplate" }, outputs: { onSelectedIndex: "onSelectedIndex" }, decls: 5, vars: 3, consts: [[1, "tab-view-list"], ["class", "tab-view-list-item", "tabindex", "0", "role", "tab", 3, "is-active", "is-disabled", "primary", "secondary", "click", "keyup.space", 4, "ngFor", "ngForOf"], ["class", "tab-view-action-section", 4, "ngIf"], [1, "tab-view-body-wrapper"], [4, "ngFor", "ngForOf"], ["tabindex", "0", "role", "tab", 1, "tab-view-list-item", 3, "click", "keyup.space"], [4, "ngIf"], [4, "ngTemplateOutlet"], [1, "tab-view-action-section"], [1, "tab-view-body", 3, "hidden"]], template: function DsTabViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, DsTabViewComponent_li_1_Template, 3, 11, "li", 1);
        ɵngcc0.ɵɵtemplate(2, DsTabViewComponent_div_2_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtemplate(4, DsTabViewComponent_ng_container_4_Template, 3, 2, "ng-container", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tabItems);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionSection);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tabItems);
    } }, directives: [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet], encapsulation: 2 });
DsTabViewComponent.ctorParameters = () => [];
DsTabViewComponent.propDecorators = {
    tabPanelComponents: [{ type: ContentChildren, args: [DsTabPanelComponent,] }],
    selectedIndex: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    actionSection: [{ type: Input }],
    actionSectionTemplate: [{ type: Input }],
    onSelectedIndex: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsTabViewComponent, [{
        type: Component,
        args: [{
                selector: 'ds-tab-view',
                template: `
      <ul class="tab-view-list">
          <li
                  class="tab-view-list-item"
                  [class.is-active]="tabItem.isActive"
                  [class.is-disabled]="tabItem.disabled"
                  [class.primary]="tabItem.labelSize === 'primary'"
                  [class.secondary]="tabItem.labelSize === 'secondary'"
                  (click)="setActiveTab(tabItem)"
                  (keyup.space)="setActiveTab(tabItem)"
                  [attr.aria-label]="ariaLabel"
                  *ngFor="let tabItem of tabItems"
                  tabindex="0" role="tab"
          >
              <ng-container *ngIf="tabItem?.tabLabelComponent?.tabLabelContent">
                  <ng-container *ngTemplateOutlet="tabItem.tabLabelComponent.tabLabelContent"></ng-container>
              </ng-container>
              <ng-container *ngIf="!tabItem?.tabLabelComponent && tabItem.label"> {{ tabItem.label }} </ng-container>
          </li>

          <div
            *ngIf="actionSection"
            class="tab-view-action-section">
                <ng-container *ngTemplateOutlet="actionSectionTemplate"></ng-container>
          </div>
      </ul>

      <div class="tab-view-body-wrapper">
          <ng-container *ngFor="let tabItem of tabItems">
              <div class="tab-view-body" [hidden]="!tabItem.isActive">
                  <ng-container *ngTemplateOutlet="tabItem.tabBodyComponent.tabBodyContent"></ng-container>
              </div>
          </ng-container>
      </div>
  `
            }]
    }], function () { return []; }, { onSelectedIndex: [{
            type: Output
        }], selectedIndex: [{
            type: Input
        }], tabPanelComponents: [{
            type: ContentChildren,
            args: [DsTabPanelComponent]
        }], ariaLabel: [{
            type: Input
        }], actionSection: [{
            type: Input
        }], actionSectionTemplate: [{
            type: Input
        }] }); })();

const COMPONENTS$3 = [
    DsTabViewComponent,
    DsTabPanelComponent,
    DsTabBodyComponent,
    DsTabLabelComponent
];
class DsTabViewModule {
}
DsTabViewModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsTabViewModule });
DsTabViewModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsTabViewModule_Factory(t) { return new (t || DsTabViewModule)(); }, imports: [[
            CommonModule,
            TabViewModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsTabViewModule, { declarations: function () { return [DsTabViewComponent, DsTabPanelComponent, DsTabBodyComponent, DsTabLabelComponent]; }, imports: function () { return [CommonModule,
        TabViewModule]; }, exports: function () { return [DsTabViewComponent, DsTabPanelComponent, DsTabBodyComponent, DsTabLabelComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsTabViewModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ...COMPONENTS$3
                ],
                imports: [
                    CommonModule,
                    TabViewModule,
                ],
                exports: [
                    ...COMPONENTS$3
                ]
            }]
    }], null, null); })();

class DsStatusComponent {
    constructor() {
        this.severity = 'default';
    }
    ngOnInit() {
    }
}
DsStatusComponent.ɵfac = function DsStatusComponent_Factory(t) { return new (t || DsStatusComponent)(); };
DsStatusComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsStatusComponent, selectors: [["ds-status"]], inputs: { severity: "severity" }, ngContentSelectors: _c2, decls: 4, vars: 1, consts: [[1, "ds-status", 3, "ngClass"], [1, "dot"], [1, "caption"]], template: function DsStatusComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.severity);
    } }, directives: [ɵngcc2.NgClass], encapsulation: 2 });
DsStatusComponent.ctorParameters = () => [];
DsStatusComponent.propDecorators = {
    severity: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsStatusComponent, [{
        type: Component,
        args: [{
                selector: 'ds-status',
                template: "<div class=\"ds-status\" [ngClass]=\"severity\" >\r\n    <div class=\"dot\"></div>\r\n    <span class=\"caption\">\r\n        <ng-content></ng-content>\r\n    </span>\r\n</div>"
            }]
    }], function () { return []; }, { severity: [{
            type: Input
        }] }); })();

class DsStatusModule {
}
DsStatusModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsStatusModule });
DsStatusModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsStatusModule_Factory(t) { return new (t || DsStatusModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsStatusModule, { declarations: function () { return [DsStatusComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DsStatusComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsStatusModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DsStatusComponent
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    DsStatusComponent
                ]
            }]
    }], null, null); })();

class DsLoaderComponent {
    constructor() { }
    ngOnInit() {
    }
}
DsLoaderComponent.ɵfac = function DsLoaderComponent_Factory(t) { return new (t || DsLoaderComponent)(); };
DsLoaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsLoaderComponent, selectors: [["ds-loader"]], decls: 2, vars: 0, consts: [[1, "page-loader-wrapper"], [1, "page-loader"]], template: function DsLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
DsLoaderComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'ds-loader',
                template: "<div class=\"page-loader-wrapper\">\r\n    <div class=\"page-loader\"></div>\r\n</div>"
            }]
    }], function () { return []; }, null); })();

class DsLoaderModule {
}
DsLoaderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsLoaderModule });
DsLoaderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsLoaderModule_Factory(t) { return new (t || DsLoaderModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsLoaderModule, { declarations: function () { return [DsLoaderComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DsLoaderComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsLoaderModule, [{
        type: NgModule,
        args: [{
                declarations: [DsLoaderComponent],
                imports: [
                    CommonModule
                ],
                exports: [
                    DsLoaderComponent
                ]
            }]
    }], null, null); })();

class DsModalContentDirective {
    constructor(el) {
        this.element = el;
    }
}
DsModalContentDirective.ɵfac = function DsModalContentDirective_Factory(t) { return new (t || DsModalContentDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DsModalContentDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DsModalContentDirective, selectors: [["", "dsModalContent", ""]] });
DsModalContentDirective.ctorParameters = () => [
    { type: ElementRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsModalContentDirective, [{
        type: Directive,
        args: [{
                selector: '[dsModalContent]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();

class DsModalDateDirective {
    constructor(el) {
        this.element = el;
    }
}
DsModalDateDirective.ɵfac = function DsModalDateDirective_Factory(t) { return new (t || DsModalDateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DsModalDateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DsModalDateDirective, selectors: [["", "dsModalDate", ""]] });
DsModalDateDirective.ctorParameters = () => [
    { type: ElementRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsModalDateDirective, [{
        type: Directive,
        args: [{
                selector: '[dsModalDate]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();

class DsModalTitleDirective {
    constructor(el) {
        this.element = el;
    }
}
DsModalTitleDirective.ɵfac = function DsModalTitleDirective_Factory(t) { return new (t || DsModalTitleDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DsModalTitleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DsModalTitleDirective, selectors: [["", "dsModalTitle", ""]] });
DsModalTitleDirective.ctorParameters = () => [
    { type: ElementRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsModalTitleDirective, [{
        type: Directive,
        args: [{
                selector: '[dsModalTitle]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();

class DsModalComponent {
    constructor() {
        /**
         * Szerokość komponentu ds-modal, maksymalna wartość to 50%
         * @type string
         * @default '550px'
         */
        this.width = '550px';
        /***
         * Uniemożliwienie zamknięcia poprzez kliknięcie poza oknem
         * @type boolean
         */
        this.disableClose = false;
        this.onModalToggle = new EventEmitter();
        this.ngStyle = {
            width: this.width
        };
        this.modalContentStyle = {
            'overflow-y': 'none'
        };
        this.modalActive = false;
    }
    ngOnInit() {
    }
    ngAfterContentInit() {
        this.recalculateHeight();
    }
    ngOnChanges() {
        this.ngStyle = {
            width: this.width
        };
    }
    enableModal() {
        this.modalActive = true;
        this.recalculateHeight();
        this.onModalToggle.emit(true);
        this.lockMovement();
    }
    lockMovement() {
        const scrollY = window.scrollY;
        document.body.style.top = `-${scrollY}px`;
        document.body.style.position = 'fixed';
        setTimeout(() => {
            this.modalContainer.nativeElement.style.top = `${scrollY}px`;
        }, 0);
    }
    disableModal() {
        this.modalActive = false;
        this.onModalToggle.emit(false);
        this.unlockMovement();
    }
    unlockMovement() {
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
        this.modalActive = false;
    }
    toggle() {
        this.modalActive = !this.modalActive;
        if (this.modalActive) {
            this.enableModal();
        }
        else {
            this.disableModal();
        }
    }
    recalculateHeight() {
        var _a;
        const contentHeight = this.modalContent.element.nativeElement.offsetHeight;
        const containerHeight = (_a = this.modalContentContainer) === null || _a === void 0 ? void 0 : _a.nativeElement.offsetHeight;
        if (contentHeight && containerHeight) {
            if (contentHeight > containerHeight) {
                this.modalContentStyle['overflow-y'] = 'scroll';
            }
            else {
                this.modalContentStyle['overflow-y'] = 'none';
            }
        }
    }
    startAnimation(e) {
        this.recalculateHeight();
    }
    doneAnimation(e) {
        // ????
    }
    click(event) {
        if (!this.disableClose && event.composedPath().findIndex(x => { var _a; return (_a = x.classList) === null || _a === void 0 ? void 0 : _a.contains('modal-box'); }) === -1) {
            this.disableModal();
        }
    }
}
DsModalComponent.ɵfac = function DsModalComponent_Factory(t) { return new (t || DsModalComponent)(); };
DsModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsModalComponent, selectors: [["ds-modal"]], contentQueries: function DsModalComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DsModalDateDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, DsModalTitleDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, DsModalContentDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modalDate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modalTitle = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modalContent = _t.first);
    } }, viewQuery: function DsModalComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c39, true);
        ɵngcc0.ɵɵviewQuery(_c40, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modalContainer = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modalContentContainer = _t.first);
    } }, hostBindings: function DsModalComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function DsModalComponent_click_HostBindingHandler($event) { return ctx.click($event); });
    } }, inputs: { width: "width", disableClose: "disableClose" }, outputs: { onModalToggle: "onModalToggle" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c43, decls: 1, vars: 1, consts: [["class", "ds-modal", 4, "ngIf"], [1, "ds-modal"], ["modal", ""], [1, "modal-box", 3, "ngStyle"], ["styleClass", "p-p-4", 3, "showHeader"], [1, "close-modal", "pi", "pi-times", 3, "click"], ["class", "notification-date p-small", 4, "ngIf"], ["class", "notification-title h2", 4, "ngIf"], ["class", "notification-content p", 3, "ngClass", "ngStyle", 4, "ngIf"], [1, "notification-date", "p-small"], [1, "notification-title", "h2"], [1, "notification-content", "p", 3, "ngClass", "ngStyle"], ["modalContentContainer", ""]], template: function DsModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c42);
        ɵngcc0.ɵɵtemplate(0, DsModalComponent_div_0_Template, 8, 6, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.modalActive);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgStyle, DsPanelComponent, ɵngcc2.NgClass], encapsulation: 2, data: { animation: [
            trigger('showModal', [
                transition('* => void', [
                    animate('.1s linear', style({ opacity: 0 }))
                ]),
                transition('void => *', [
                    style({ opacity: 0 }),
                    animate('.12s cubic-bezier(0, 0, 0.2, 1)')
                ])
            ])
        ] } });
DsModalComponent.ctorParameters = () => [];
DsModalComponent.propDecorators = {
    modalDate: [{ type: ContentChild, args: [DsModalDateDirective,] }],
    modalTitle: [{ type: ContentChild, args: [DsModalTitleDirective,] }],
    modalContent: [{ type: ContentChild, args: [DsModalContentDirective,] }],
    modalContainer: [{ type: ViewChild, args: ['modal',] }],
    modalContentContainer: [{ type: ViewChild, args: ['modalContentContainer',] }],
    width: [{ type: Input }],
    disableClose: [{ type: Input }],
    onModalToggle: [{ type: Output }],
    click: [{ type: HostListener, args: ['click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsModalComponent, [{
        type: Component,
        args: [{
                selector: 'ds-modal',
                template: "<div [@showModal] (@showModal.start)=\"startAnimation($event)\" (@showModal.done)=\"doneAnimation($event)\" #modal\r\n    *ngIf=\"modalActive\" class=\"ds-modal\">\r\n    <div class=\"modal-box\" [ngStyle]=\"ngStyle\">\r\n        <ds-panel styleClass=\"p-p-4\" [showHeader]=\"false\">\r\n            <span (click)=\"disableModal()\" class=\"close-modal pi pi-times\"></span>\r\n            <div *ngIf=\"modalDate\" class=\"notification-date p-small\">\r\n                <ng-content select=\"[dsModalDate]\"></ng-content>\r\n            </div>\r\n            <div *ngIf=\"modalTitle\" class=\"notification-title h2\">\r\n                <ng-content select=\"[dsModalTitle]\"></ng-content>\r\n            </div>\r\n            <div #modalContentContainer *ngIf=\"modalContent\" [ngClass]=\"{ 'p-mt-3': modalDate || modalTitle }\" [ngStyle]=\"modalContentStyle\"\r\n                class=\"notification-content p\">\r\n                <ng-content select=\"[dsModalContent]\"></ng-content>\r\n            </div>\r\n        </ds-panel>\r\n    </div>\r\n</div>",
                animations: [
                    trigger('showModal', [
                        transition('* => void', [
                            animate('.1s linear', style({ opacity: 0 }))
                        ]),
                        transition('void => *', [
                            style({ opacity: 0 }),
                            animate('.12s cubic-bezier(0, 0, 0.2, 1)')
                        ])
                    ])
                ]
            }]
    }], function () { return []; }, { width: [{
            type: Input
        }], disableClose: [{
            type: Input
        }], onModalToggle: [{
            type: Output
        }], click: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], modalDate: [{
            type: ContentChild,
            args: [DsModalDateDirective]
        }], modalTitle: [{
            type: ContentChild,
            args: [DsModalTitleDirective]
        }], modalContent: [{
            type: ContentChild,
            args: [DsModalContentDirective]
        }], modalContainer: [{
            type: ViewChild,
            args: ['modal']
        }], modalContentContainer: [{
            type: ViewChild,
            args: ['modalContentContainer']
        }] }); })();

class DsModalModule {
}
DsModalModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsModalModule });
DsModalModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsModalModule_Factory(t) { return new (t || DsModalModule)(); }, imports: [[
            CommonModule,
            DsPanelModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsModalModule, { declarations: function () { return [DsModalComponent, DsModalDateDirective, DsModalTitleDirective, DsModalContentDirective]; }, imports: function () { return [CommonModule, DsPanelModule]; }, exports: function () { return [DsModalComponent, DsModalDateDirective, DsModalTitleDirective, DsModalContentDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsModalModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DsModalComponent,
                    DsModalDateDirective,
                    DsModalTitleDirective,
                    DsModalContentDirective
                ],
                imports: [
                    CommonModule,
                    DsPanelModule
                ],
                exports: [
                    DsModalComponent,
                    DsModalDateDirective,
                    DsModalTitleDirective,
                    DsModalContentDirective
                ]
            }]
    }], null, null); })();

class DsTooltipDirective extends Tooltip {
    constructor(el, zone) {
        super(el, zone);
        this.el = el;
        this.zone = zone;
        /**
         * Ikona z zestawu primeicons
         * @type string
         * @default 'exclamation-triangle'
         */
        this.icon = 'exclamation-triangle';
        /**
         * Czy wyświetlamy ikonę z lewej strony
         * @type boolean
         * @default false
         */
        this.showIcon = false;
        /**
         * Uninplemented
         */
        this.closeable = false;
        /**
         * Motyw kolorystyczny tooltipa
         * @type 'light'|'dark'
         * @default 'dark'
         */
        this.theme = 'dark';
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    get text() {
        return this._text;
    }
    set text(text) {
        this._text = text;
        if (this.active) {
            if (this._text) {
                if (this.container && this.container.offsetParent) {
                    this.updateText();
                    this.align();
                }
                else {
                    this.show();
                }
            }
            else {
                this.hide();
            }
        }
    }
    create() {
        if (this.container) {
            this.clearHideTimeout();
            this.remove();
        }
        this.container = document.createElement('div');
        let tooltipArrow = document.createElement('div');
        tooltipArrow.className = 'p-tooltip-arrow';
        this.container.appendChild(tooltipArrow);
        this.tooltipTextContainer = document.createElement('div');
        this.tooltipTextContainer.className = 'ds-tooltip-container';
        if (this.showIcon) {
            this.tooltipIcon = document.createElement('span');
            this.tooltipIcon.className = 'ds-tooltip-icon pi pi-' + this.icon;
            this.tooltipTextContainer.appendChild(this.tooltipIcon);
        }
        this.tooltipText = document.createElement('div');
        this.tooltipText.className = 'p-tooltip-text';
        this.tooltipTextContainer.appendChild(this.tooltipText);
        this.updateText();
        if (this.positionStyle) {
            this.container.style.position = this.positionStyle;
        }
        this.container.appendChild(this.tooltipTextContainer);
        if (this.appendTo === 'body')
            document.body.appendChild(this.container);
        else if (this.appendTo === 'target')
            DomHandler.appendChild(this.container, this.el.nativeElement);
        else
            DomHandler.appendChild(this.container, this.appendTo);
        this.container.style.display = 'inline-block';
    }
    preAlign(position) {
        this.container.style.left = -999 + 'px';
        this.container.style.top = -999 + 'px';
        const tooltipTheme = 'ds-tooltip-' + this.theme;
        let defaultClassName = `ds-tooltip ${tooltipTheme} p-tooltip p-component p-tooltip-${position}`;
        this.container.className = this.tooltipStyleClass ? defaultClassName + ' ' + this.tooltipStyleClass : defaultClassName;
    }
}
DsTooltipDirective.ɵfac = function DsTooltipDirective_Factory(t) { return new (t || DsTooltipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
DsTooltipDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DsTooltipDirective, selectors: [["", "dsTooltip", ""]], inputs: { icon: "icon", showIcon: ["dsTooltip-showIcon", "showIcon"], closeable: "closeable", theme: ["dsTooltip-theme", "theme"], text: ["dsTooltip", "text"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
DsTooltipDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone }
];
DsTooltipDirective.propDecorators = {
    icon: [{ type: Input }],
    showIcon: [{ type: Input, args: ['dsTooltip-showIcon',] }],
    closeable: [{ type: Input }],
    theme: [{ type: Input, args: ['dsTooltip-theme',] }],
    text: [{ type: Input, args: ['dsTooltip',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsTooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[dsTooltip]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, { icon: [{
            type: Input
        }], showIcon: [{
            type: Input,
            args: ['dsTooltip-showIcon']
        }], closeable: [{
            type: Input
        }], theme: [{
            type: Input,
            args: ['dsTooltip-theme']
        }], text: [{
            type: Input,
            args: ['dsTooltip']
        }] }); })();

class DsTooltipModule {
}
DsTooltipModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsTooltipModule });
DsTooltipModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsTooltipModule_Factory(t) { return new (t || DsTooltipModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsTooltipModule, { declarations: function () { return [DsTooltipDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DsTooltipDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsTooltipModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DsTooltipDirective
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    DsTooltipDirective
                ]
            }]
    }], null, null); })();

const INPUTSWITCH_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DsInputswitchComponent),
    multi: true
};
class DsInputswitchComponent extends InputSwitch {
    constructor(cd) {
        super(cd);
    }
}
DsInputswitchComponent.ɵfac = function DsInputswitchComponent_Factory(t) { return new (t || DsInputswitchComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DsInputswitchComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DsInputswitchComponent, selectors: [["ds-inputswitch"]], features: [ɵngcc0.ɵɵProvidersFeature([INPUTSWITCH_VALUE_ACCESSOR]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 15, consts: [[3, "ngClass", "ngStyle", "click"], [1, "p-hidden-accessible"], ["type", "checkbox", "role", "switch", 3, "checked", "disabled", "change", "focus", "blur"], ["cb", ""], [1, "p-inputswitch-slider"]], template: function DsInputswitchComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function DsInputswitchComponent_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r1); const _r0 = ɵngcc0.ɵɵreference(3); return ctx.onClick($event, _r0); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2, 3);
        ɵngcc0.ɵɵlistener("change", function DsInputswitchComponent_Template_input_change_2_listener($event) { return ctx.onInputChange($event); })("focus", function DsInputswitchComponent_Template_input_focus_2_listener($event) { return ctx.onFocus($event); })("blur", function DsInputswitchComponent_Template_input_blur_2_listener($event) { return ctx.onBlur($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "span", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.styleClass);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(11, _c44, ctx.checked, ctx.disabled, ctx.focused))("ngStyle", ctx.style);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("checked", ctx.checked)("disabled", ctx.disabled);
        ɵngcc0.ɵɵattribute("id", ctx.inputId)("name", ctx.name)("tabindex", ctx.tabindex)("aria-checked", ctx.checked)("aria-labelledby", ctx.ariaLabelledBy);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgStyle], encapsulation: 2, changeDetection: 0 });
DsInputswitchComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsInputswitchComponent, [{
        type: Component,
        args: [{
                selector: 'ds-inputswitch',
                providers: [INPUTSWITCH_VALUE_ACCESSOR],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                template: "<div [ngClass]=\"{'ds-inputswitch p-component': true, 'p-inputswitch-checked': checked, 'p-disabled': disabled, 'p-focus': focused}\"\n    [ngStyle]=\"style\" [class]=\"styleClass\" (click)=\"onClick($event, cb)\">\n    <div class=\"p-hidden-accessible\">\n        <input #cb type=\"checkbox\" [attr.id]=\"inputId\" [attr.name]=\"name\" [attr.tabindex]=\"tabindex\" [checked]=\"checked\"\n            (change)=\"onInputChange($event)\" (focus)=\"onFocus($event)\" (blur)=\"onBlur($event)\" [disabled]=\"disabled\"\n            role=\"switch\" [attr.aria-checked]=\"checked\" [attr.aria-labelledby]=\"ariaLabelledBy\" />\n    </div>\n    <span class=\"p-inputswitch-slider\"></span>\n</div>"
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

class DsInputswitchModule {
}
DsInputswitchModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DsInputswitchModule });
DsInputswitchModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DsInputswitchModule_Factory(t) { return new (t || DsInputswitchModule)(); }, imports: [[
            CommonModule,
            InputSwitchModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DsInputswitchModule, { declarations: function () { return [DsInputswitchComponent]; }, imports: function () { return [CommonModule,
        InputSwitchModule]; }, exports: function () { return [DsInputswitchComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DsInputswitchModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DsInputswitchComponent
                ],
                imports: [
                    CommonModule,
                    InputSwitchModule
                ],
                exports: [
                    DsInputswitchComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of design-system
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddTargetDirective, AdresService, AttachToDirective, AutoFormatPipe, AutocompleteUtils, BreadcrumbService, DS_AUTOCOMPLETE_COMPONENT_CUSTOM_VALIDATOR, DS_INPUT_COMPONENT_CUSTOM_VALIDATOR, DS_TABLE_COMPONENT_EXCEL_SERVICE, DS_TABLE_COMPONENT_PDF_SERVICE, DS_TEXTAREA_COMPONENT_CUSTOM_VALIDATOR, DsAdresModule, DsAlertComponent, DsAlertModule, DsAutocompleteComponent, DsAutocompleteModule, DsAutocompleteUpperDirective, DsBreadcrumbComponent, DsBreadcrumbModule, DsButtonComponent, DsButtonDirective, DsButtonModule, DsCalendarComponent, DsCalendarModule, DsCheckboxComponent, DsCheckboxModule, DsConfirmDialogComponent, DsConfirmDialogModule, DsDropdownComponent, DsDropdownModule, DsGminaComponent, DsInputComponent, DsInputModule, DsInputmaskComponent, DsInputmaskModule, DsInputswitchComponent, DsInputswitchModule, DsKodPocztowyComponent, DsKontoBankoweComponent, DsKontoBankoweModule, DsKrsComponent, DsKrsModule, DsLayoutComponent, DsLayoutContentComponent, DsLayoutFooterComponent, DsLayoutHeaderComponent, DsLayoutModule, DsLayoutSidebarComponent, DsLayoutSubheaderComponent, DsLoaderComponent, DsLoaderModule, DsMenuComponent, DsMenuItem, DsMenuItemComponent, DsMenuModule, DsMiastoComponent, DsModalComponent, DsModalContentDirective, DsModalDateDirective, DsModalModule, DsModalTitleDirective, DsMultiselectComponent, DsMultiselectModule, DsNipComponent, DsNipModule, DsNotification, DsNotificationComponent, DsNotificationModule, DsPanelButtonsComponent, DsPanelComponent, DsPanelFooterComponent, DsPanelHeaderComponent, DsPanelModule, DsPeselComponent, DsPeselModule, DsPortalModule, DsPowiatComponent, DsRadioButton, DsRadioChange, DsRadioComponent, DsRadioGroup, DsRadioModule, DsRegonComponent, DsRegonModule, DsSkeletonComponent, DsSkeletonModule, DsStatusComponent, DsStatusModule, DsTabBodyComponent, DsTabLabelComponent, DsTabPanelComponent, DsTabViewComponent, DsTabViewModule, DsTableComponent, DsTableModule, DsTagComponent, DsTagModule, DsTextareaComponent, DsTextareaModule, DsToggleStates, DsTooltipDirective, DsTooltipModule, DsTranslocoModule, DsUlicaComponent, DsWojewodztwoComponent, GMINA_VALUE_ACCESSOR, INPUTSWITCH_VALUE_ACCESSOR, KOD_POCZTOWY_VALUE_ACCESSOR, KpiEnum, MIASTO_VALUE_ACCESSOR, NotificationService, POWIAT_VALUE_ACCESSOR, RADIO_GROUP_VALUE_ACCESSOR, RADIO_VALUE_ACCESSOR, RadioControlRegistry, ResponsiveDirective, TakNiePipe, TranslocoHttpLoader, TranslocoRootModule, ULICA_VALUE_ACCESSOR, Utils, WOJEWODZTWO_VALUE_ACCESSOR, getFragmentPartOfUrl, getPathPartOfUrl, isFragmentContain, isFragmentEqual, isUrlPathContain, isUrlPathEqual, TERYT_API_URL as ɵa, AdresControlBase as ɵb, CustomValidatorUtils as ɵc, DsMenuInternalService as ɵd, PortalService as ɵe };

//# sourceMappingURL=design-system.js.map